var categoriesJSON = {
  DNA: [
    {
      title: "<i>Quick</i>-DNA Kits",
      subtitle: "DNA",
      description:
        "The Quick-DNA Plus Kits are the easiest DNA isolation kits for high yield DNA isolation from any cells, tissues, and biological fluids. Get free DNA isolation kits sample & shipping. ",
      handle: "/collections/quick-dna-extraction-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "ZymoPURE Plasmid Kits",
      subtitle: "Plasmid Purification",
      description:
        "ZymoPURE II Plasmid Kits provide the fastest, simplest method to isolate transfection quality DNA from E. coli. Free samples of plasmid kits get free shipping.",
      handle: "/collections/zymopure-plasmid-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA Clean & Concentrator Kits (DCC)",
      subtitle: "DNA",
      description:
        "DNA Clean & Concentrator Kits are PCR purification kits that provide purification of DNA from PCR and other enzymatic reactions in as little as 2 minutes. Free PCR purification kits sample.\n",
      handle: "/collections/dcc-pcr-purification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE 96 Plasmid Miniprep Kit",
      subtitle: "D4214, D4215",
      description:
        "High-throughput purification of transfection-grade plasmid DNA from up to 5 ml of overnight E. coli culture.",
      handle: "/products/zymopure-96-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4214_D4215_ZymoPURE_96_Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "MAGicBead™ cfDNA Isolation Kit",
      subtitle: "D4086",
      description:
        "Novel DNA binding chemistry enabling unparalleled cfDNA extraction performance",
      handle: "/products/magicbead-cfdna-isolation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4086_magicbead_cfdna_isolation_kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Load N’ Go Quick-DNA/RNA HT Kit",
      subtitle: "R2152",
      description:
        "Streamline your nucleic acid research with efficient DNA and RNA extraction from diverse samples.",
      handle: "/products/load-n-go-quick-dna-rna-ht-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2152-Load-N-Go-Quick-DNA-RNA-HT.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymoclean Gel DNA Recovery Kits",
      subtitle: "DNA",
      description:
        "Gel DNA extraction kits that provide highly efficient DNA purification from agarose gels. Get a free gel DNA extraction kits sample with free shipping.\n",
      handle: "/collections/zymoclean-gel-dna-recovery-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Zyppy Plasmid Kits",
      subtitle: "Plasmid Purification",
      description:
        "The Zyppy Plasmid Kits are plasmid DNA kits that provide pellet-free high-quality plasmid DNA in only 8 minutes. Get a free plasmid DNA kits sample with free shipping. ",
      handle: "/collections/zyppy-plasmid-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Genomic DNA Clean & Concentrator (gDCC)",
      subtitle: "DNA",
      description:
        "The Genomic DNA Clean & Concentrator kits are gDNA clean up kits that provide quick clean-up of large-sized DNA in just 5 minutes. Get free gDNA clean up kits sample today with free shipping.",
      handle: "/collections/genomic-dna-clean-concentrator-gdcc",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4011-Genomic-DNA-Clean-&-Concentrator-10.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Fecal/Soil Microbe kits are affordable fecal and soil DNA extraction kits for fast, easy isolation of inhibitor-free, PCR-quality host cell and microbial DNA from a variety of sample sources.",
      handle: "/collections/quick-dna-fecal-soil-microbe-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010_Quick-DNA-Fecal-Soil-Microbe-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "DNA",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>OneStep</i> PCR Inhibitor Removal Kits",
      subtitle: "DNA",
      description:
        "PCR inhibitor clean up kits that contain all the components needed for efficient removal of potent PCR inhibitors - all in one step. Free PCR inhibitor clean up kits sample with free shipping!",
      handle: "/collections/onestep-pcr-inhibitor-removal-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6035-OneStep-96-PCR-Inhibitor-Removal-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Select-a-Size DNA Clean & Concentrator Kits",
      subtitle: "DNA",
      description:
        "The fastest and easiest size selection DNA kits to purify specific ranges of DNA fragments from PCR, endonuclease digestions, ligations, library preparations, adapter removal, etc. Free size selection DNA kits sample. ",
      handle: "/collections/select-a-size-dna-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA HMW MagBead Kit",
      subtitle: "D6060",
      description:
        "Extract ultra-pure high molecular weight DNA up to 150 kb from any sample.",
      handle: "/products/quick-dna-hmw-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      subtitle: "D4076",
      description:
        "High efficiency recovery of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      handle: "/products/quick-cfdna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Plant/Seed Kits",
      subtitle: "DNA",
      description:
        "Simple, rapid isolation of inhibitor-free, PCR-quality DNA from a variety of plant sample sources.",
      handle: "/collections/quick-dna-plant-seed-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6020_Quick-DNA-Plant-Seed-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "Isolation of high quality genomic DNA and total RNA from cells, tissue, blood, biological fluids, etc. ",
      handle: "/collections/quick-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "ZR BAC DNA Miniprep Kit",
      subtitle: "D4048, D4049",
      description:
        "Quickly isolate large constructs (≤200 kb) from <i>E. coli</i> using a spin-column",
      handle: "/products/zr-bac-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep Yeast Plasmid Miniprep Kits",
      subtitle: "Yeast",
      description:
        "The fastest and simplest solutions for purifying the highest quality plasmid DNA from yeast.",
      handle: "/collections/zymoprep-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Urine Kit",
      subtitle: "D3061",
      description:
        "Extract high quality cell-free or cellular DNA from up to 40 ml of urine",
      handle: "/products/quick-dna-urine-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3061_Quick-DNA-Urine-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Viral Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Viral Kits are viral DNA purification kits that provide for the rapid isolation of high-quality viral DNA from a wide range of biological sources.",
      handle: "/collections/quick-dna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3015_Quick-DNA-Viral-DNA-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA FFPE Miniprep",
      subtitle: "D3067",
      description: "High-quality DNA from FFPE tissue",
      handle: "/products/quick-dna-ffpe-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3067_Quick-DNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pinpoint Slide DNA Isolation System",
      subtitle: "D3001",
      description:
        "Streamlined method for isolation of DNA from targeted areas of fresh and FFPE tissue slides",
      handle: "/products/pinpoint-slide-dna-isolation-system",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001_Pinpoint-Slide-DNA-Isolation-System-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Tissue/Insect Kits",
      subtitle: "DNA",
      description:
        "Simple and rapid isolation of DNA from fresh, frozen, or stored insect specimens.",
      handle: "/collections/quick-dna-tissue-insect-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6015_Quick-DNA-Tissue-Insect-Microprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNA Sequencing Clean-up Kits",
      subtitle: "DNA",
      description:
        "The ZR DNA & ZR-96 DNA Sequencing Clean-Up Kits provide simple and rapid (2 & 10 minute) methods for removal of post-cycle sequencing reaction contaminants from DNA extension products.",
      handle: "/collections/dna-sequencing-clean-up-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4050_ZR-DNA-Sequencing-Clean-Up-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Oligo Clean & Concentrator Kits",
      subtitle: "DNA",
      description:
        "The Oligo Clean & Concentrator provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
      handle: "/collections/oligo-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "ssDNA/RNA Clean & Concentrator",
      subtitle: "D7010, D7011",
      description:
        "Separation of single-stranded nucleic acids from double-stranded nucleic acids.",
      handle: "/products/ssdna-rna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Femto DNA Quantification Kits",
      subtitle: "DNA",
      description:
        "Detect and quantify human, bacterial, and fungal DNA with high specificity and sensitivity. ",
      handle: "/collections/femto-dna-quantification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2005_Femto-Human-DNA-Quantification-Kit.jpg",
      searchWeight: 3,
      tags: ["DRY ICE"],
    },
    {
      title: "MAGicBead™ cfDNA Elution Buffer",
      subtitle: "D4086-5-2",
      description:
        "A special elution buffer designed to work only with the MAGicBeads™ chemistry. It is validated on all sensitive downstream assays, such as NGS and RT-qPCR",
      handle: "/products/magicbead-cfdna-elution-buffer",
      image_url:
        "https://files.zymoresearch.com/images/zymo-product-placeholder.jpg",
      searchWeight: 3,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "MAGicBead™ cfDNA Digestion Buffer",
      subtitle: "D4086-1-25",
      description:
        "MAGicBead™ cfDNA Digestion Buffer is used for biofluid digestion and subsequent cfDNA extraction in the MAGicBead™ cfDNA Isolation Kit.",
      handle: "/products/magicbead-cfdna-digestion-buffer",
      image_url:
        "https://files.zymoresearch.com/images/zymo-product-placeholder.jpg",
      searchWeight: 3,
      ribbon: true,
      tags: [],
    },
    {
      title: "MAGicBead™ cfDNA Binding Buffer",
      subtitle: "D4086-2-25",
      description:
        "MAGicBead™ cfDNA Binding Buffer is used to promote cfDNA binding to MAGicBeads™ from digested biofluids in the MAGicBead™ cfDNA Isolation Kit.",
      handle: "/products/magicbead-cfdna-binding-buffer",
      image_url:
        "https://files.zymoresearch.com/images/zymo-product-placeholder.jpg",
      searchWeight: 3,
      ribbon: true,
      tags: [],
    },
    {
      title: "MAGicBead™ cfDNA Wash Buffer",
      subtitle: "D4086-4-70",
      description:
        "MAGicBead™ cfDNA Wash Buffer is used to remove contaminants/excess buffers following cfDNA binding to MAGicBeads™ from digested biofluids in the MAGicBead™ cfDNA Isolation Kit.",
      handle: "/products/magicbead-cfdna-wash-buffer",
      image_url:
        "https://files.zymoresearch.com/images/zymo-product-placeholder.jpg",
      searchWeight: 3,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq SPLAT DNA Library Kit",
      subtitle: "D5464",
      description:
        "Versatile and unique ssDNA library preparation solution for any DNA sample.",
      handle: "/products/zymo-seq-splat-dna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5464_zymo-seq_splat_dna_library_kit_(12_prep).jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
  ],
  "DNA Purification Kits": [
    {
      title: "<i>Quick</i>-DNA Kits",
      subtitle: "DNA",
      description:
        "The Quick-DNA Plus Kits are the easiest DNA isolation kits for high yield DNA isolation from any cells, tissues, and biological fluids. Get free DNA isolation kits sample & shipping. ",
      handle: "/collections/quick-dna-extraction-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "MAGicBead™ cfDNA Isolation Kit",
      subtitle: "D4086",
      description:
        "Novel DNA binding chemistry enabling unparalleled cfDNA extraction performance",
      handle: "/products/magicbead-cfdna-isolation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4086_magicbead_cfdna_isolation_kit.jpg",
      searchWeight: 2,
      tags: [],
      ribbon: true
    },
    {
      title: "Load N’ Go Quick-DNA/RNA HT Kit",
      subtitle: "R2152",
      description:
        "Streamline your nucleic acid research with efficient DNA and RNA extraction from diverse samples.",
      handle: "/products/load-n-go-quick-dna-rna-ht-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2152-Load-N-Go-Quick-DNA-RNA-HT.jpg",
      searchWeight: 2,
      tags: [],
      ribbon: true
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Fecal/Soil Microbe kits are affordable fecal and soil DNA extraction kits for fast, easy isolation of inhibitor-free, PCR-quality host cell and microbial DNA from a variety of sample sources.",
      handle: "/collections/quick-dna-fecal-soil-microbe-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010_Quick-DNA-Fecal-Soil-Microbe-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "DNA",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      subtitle: "D4076",
      description:
        "High efficiency recovery of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      handle: "/products/quick-cfdna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Plant/Seed Kits",
      subtitle: "DNA",
      description:
        "Simple, rapid isolation of inhibitor-free, PCR-quality DNA from a variety of plant sample sources.",
      handle: "/collections/quick-dna-plant-seed-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6020_Quick-DNA-Plant-Seed-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Urine Kit",
      subtitle: "D3061",
      description:
        "Extract high quality cell-free or cellular DNA from up to 40 ml of urine",
      handle: "/products/quick-dna-urine-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3061_Quick-DNA-Urine-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Viral Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Viral Kits are viral DNA purification kits that provide for the rapid isolation of high-quality viral DNA from a wide range of biological sources.",
      handle: "/collections/quick-dna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3015_Quick-DNA-Viral-DNA-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA FFPE Miniprep",
      subtitle: "D3067",
      description: "High-quality DNA from FFPE tissue",
      handle: "/products/quick-dna-ffpe-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3067_Quick-DNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pinpoint Slide DNA Isolation System",
      subtitle: "D3001",
      description:
        "Streamlined method for isolation of DNA from targeted areas of fresh and FFPE tissue slides",
      handle: "/products/pinpoint-slide-dna-isolation-system",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001_Pinpoint-Slide-DNA-Isolation-System-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Tissue/Insect Kits",
      subtitle: "DNA",
      description:
        "Simple and rapid isolation of DNA from fresh, frozen, or stored insect specimens.",
      handle: "/collections/quick-dna-tissue-insect-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6015_Quick-DNA-Tissue-Insect-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA HMW MagBead Kit",
      subtitle: "D6060",
      description:
        "Extract ultra-pure high molecular weight DNA up to 150 kb from any sample.",
      handle: "/products/quick-dna-hmw-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Plasmid Purification Kits": [
    {
      title: "ZymoPURE 96 Plasmid Miniprep Kit",
      subtitle: "D4214, D4215",
      description:
        "High-throughput purification of transfection-grade plasmid DNA from up to 5 ml of overnight E. coli culture.",
      handle: "/products/zymopure-96-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4214_D4215_ZymoPURE_96_Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoPURE Plasmid Kits",
      subtitle: "Plasmid Purification",
      description:
        "ZymoPURE II Plasmid Kits provide the fastest, simplest method to isolate transfection quality DNA from E. coli. Free samples of plasmid kits get free shipping.",
      handle: "/collections/zymopure-plasmid-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Zyppy Plasmid Kits",
      subtitle: "Plasmid Purification",
      description:
        "The Zyppy Plasmid Kits are plasmid DNA kits that provide pellet-free high-quality plasmid DNA in only 8 minutes. Get a free plasmid DNA kits sample with free shipping. ",
      handle: "/collections/zyppy-plasmid-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "ZR Plasmid Miniprep - Classic",
      subtitle: "D4015, D4016, D4054",
      description:
        "Easy traditional method for isolating high-quality plasmid DNA from <i>E. coli</i>",
      handle: "/products/zr-plasmid-miniprep-classic",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4015_ZR-Plasmid-Miniprep-Classic-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BAC DNA Miniprep Kit",
      subtitle: "D4048, D4049",
      description:
        "Quickly isolate large constructs (≤200 kb) from <i>E. coli</i> using a spin-column",
      handle: "/products/zr-bac-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep Yeast Plasmid Miniprep Kits",
      subtitle: "Yeast",
      description:
        "The fastest and simplest solutions for purifying the highest quality plasmid DNA from yeast.",
      handle: "/collections/zymoprep-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "DNA Clean-up and Concentration": [
    {
      title: "DNA Clean & Concentrator Kits (DCC)",
      subtitle: "DNA",
      description:
        "DNA Clean & Concentrator Kits are PCR purification kits that provide purification of DNA from PCR and other enzymatic reactions in as little as 2 minutes. Free PCR purification kits sample.\n",
      handle: "/collections/dcc-pcr-purification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Select-a-Size DNA Clean & Concentrator Kits",
      subtitle: "DNA",
      description:
        "The fastest and easiest size selection DNA kits to purify specific ranges of DNA fragments from PCR, endonuclease digestions, ligations, library preparations, adapter removal, etc. Free size selection DNA kits sample. ",
      handle: "/collections/select-a-size-dna-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zymoclean Gel DNA Recovery Kits",
      subtitle: "DNA",
      description:
        "Gel DNA extraction kits that provide highly efficient DNA purification from agarose gels. Get a free gel DNA extraction kits sample with free shipping.\n",
      handle: "/collections/zymoclean-gel-dna-recovery-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Genomic DNA Clean & Concentrator (gDCC)",
      subtitle: "DNA",
      description:
        "The Genomic DNA Clean & Concentrator kits are gDNA clean up kits that provide quick clean-up of large-sized DNA in just 5 minutes. Get free gDNA clean up kits sample today with free shipping.",
      handle: "/collections/genomic-dna-clean-concentrator-gdcc",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4011-Genomic-DNA-Clean-&-Concentrator-10.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>OneStep</i> PCR Inhibitor Removal Kits",
      subtitle: "DNA",
      description:
        "PCR inhibitor clean up kits that contain all the components needed for efficient removal of potent PCR inhibitors - all in one step. Free PCR inhibitor clean up kits sample with free shipping!",
      handle: "/collections/onestep-pcr-inhibitor-removal-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6035-OneStep-96-PCR-Inhibitor-Removal-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Oligo Clean & Concentrator Kits (OCC)",
      subtitle: "DNA",
      description:
        "The Oligo Clean & Concentrator provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
      handle: "/collections/oligo-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ssDNA/RNA Clean & Concentrator",
      subtitle: "D7010, D7011",
      description:
        "Separation of single-stranded nucleic acids from double-stranded nucleic acids.",
      handle: "/products/ssdna-rna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNA Sequencing Clean-up Kits",
      subtitle: "DNA",
      description:
        "The ZR DNA & ZR-96 DNA Sequencing Clean-Up Kits provide simple and rapid (2 & 10 minute) methods for removal of post-cycle sequencing reaction contaminants from DNA extension products.",
      handle: "/collections/dna-sequencing-clean-up-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4050_ZR-DNA-Sequencing-Clean-Up-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
  ],
  "DNA Automated/High-Throughput": [
    {
      title: "ZymoBIOMICS 96 DNA Kit",
      subtitle: "D4303, D4307, D4309",
      description:
        "Inhibitor-free microbial DNA from any sample validated for microbiome and metagenomic analyses",
      handle: "/products/zymobiomics-96-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Magbead Plus Kit",
      subtitle: "D4081, D4082",
      description:
        "Streamlined DNA isolation from any cells, tissues, and biological fluids (Proteinase K included).",
      handle: "/products/quick-dna-magbead-plus-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4081_Quick-DNA-Magbead-Plus-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA 96 Plus Kit",
      subtitle: "D4070, D4071",
      description:
        "Streamlined DNA isolation from any cells, tissues, and biological fluids (Proteinase K included).",
      handle: "/products/quick-dna-96-plus-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4071-Quick-DNA-96-Plus-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zyppy-96 Plasmid MagPrep Kit",
      subtitle: "D4100, D4101, D4102",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes",
      handle: "/products/zyppy-96-plasmid-magprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Select-a-Size DNA Clean & Concentrator MagBead Kit",
      subtitle: "D4084, D4084S, D4085",
      description: "Simple size selection for your DNA sample",
      handle: "/products/select-a-size-dna-clean-concentrator-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4084_Select-A-Size-DNA-Clean-and-Concentrator-MagBead-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>OneStep</i> PCR Inhibitor Removal Kits",
      subtitle: "D6031, D6035",
      description:
        "PCR inhibitor clean up kits that contain all the components needed for efficient removal of potent PCR inhibitors - all in one step. Free PCR inhibitor clean up kits sample with free shipping!",
      handle: "/collections/onestep-pcr-inhibitor-removal-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6035-OneStep-96-PCR-Inhibitor-Removal-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Kit",
      subtitle: "D6011",
      description:
        "Extract high quality, inhibitor-free DNA from feces, soil, water, etc.",
      handle: "/products/quick-dna-fecal-soil-microbe-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6011_Quick-DNA-Fecal-Soil-Microbe_96-Well.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zyppy-96 Plasmid Kit",
      subtitle: "D4041, D4042, D4043",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes",
      handle: "/products/zyppy-96-plasmid-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4041_Zyppy-96-Plasmid-Miniprep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS 96 MagBead Kit",
      subtitle: "D4302, D4306, D4308",
      description:
        "Inhibitor-free microbial DNA from any sample validated for microbiome and metagenomic analyses",
      handle: "/products/zymobiomics-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial 96 Kit",
      subtitle: "D6006",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/products/quick-dna-fungal-bacterial-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6006_Quick-DNA-Fungal-Bacterial-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep-96 Yeast Plasmid Miniprep",
      subtitle: "D2005, D2006, D2007",
      description:
        "The fastest and simplest high-throughput procedure for purifying the highest quality plasmid DNA from yeast.",
      handle: "/products/zymoprep-96-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA 96 Kit",
      subtitle: "D3010, D3011, D3012",
      description: "Rapid purification of DNA from cells and whole blood",
      handle: "/products/quick-dna-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3010_Quick-DNA-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Viral 96 Kit",
      subtitle: "D3017, D3018",
      description:
        "Efficient isolation of viral DNA from a wide range of biological sources.",
      handle: "/products/quick-dna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3017_ZR-96-Viral-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Magbead Kit",
      subtitle: "D6010-FM, D6011-FM, D6012-FM",
      description:
        "Extract high quality, inhibitor-free DNA from feces, soil, water, etc.",
      handle: "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010-FM_Quick-DNA-Fecal-Soil-Microbe_96-Magbead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 MagStand",
      subtitle: "P1005",
      description:
        "Separation of magnetic beads in standard 96-well format plates",
      handle: "/products/zr-96-magstand",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/p1005_ZR-96_MagStand.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
      subtitle: "D4066, D4067",
      description:
        "Purify high molecular weight DNA from enzymatic reactions and dilute samples.",
      handle: "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Tissue/Insect 96 Kit",
      subtitle: "D6017",
      description: "Isolate DNA from tough-to-lyse tissues and insects.",
      handle: "/products/quick-dna-tissue-insect-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6017_Quick-DNA-Tissue-Insect-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 Oligo Clean & Concentrator",
      subtitle: "D4062, D4063",
      description:
        "Clean any DNA and RNA oligos in high-throughput format and elute in 10 &micro;l",
      handle: "/products/oligo-clean-concentrator-zr96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Plant/Seed 96 Kit",
      subtitle: "D6021",
      description:
        "Inhibitor-free DNA isolated directly from plant and seed samples.",
      handle: "/products/quick-dna-plant-seed-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6021_Quick-DNA Plant Seed 96 Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 Zymoclean Gel DNA Recovery Kit",
      subtitle: "D4021, D4022",
      description: "Highly efficient DNA purification from agarose gels.",
      handle: "/products/zr-96-zymoclean-gel-dna-recovery-kitt",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral MagBead",
      subtitle: "R2140, R2141",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Load N’ Go DNA/RNA Viral Kit",
      subtitle: "R2143",
      description: "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      handle: "/products/load-n-go-dna-rna-viral-kit",
      isKit: true,
      ribbon: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      subtitle: "R2145, R2146",
      description:
        "Pathogen DNA/RNA isolation from vectors, tissue and biological samples.",
      handle: "/products/quick-dna-rna-pathogen-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 DNA Clean-Up Kit",
      subtitle: "D4017, D4018",
      description:
        "Clean-up PCR and other enzymatic reactions at large scale in as little as 20 minutes",
      handle: "/products/zr-96-dna-clean-up-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4017_ZR-96-DNA-Clean-up-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE 96 Plasmid Miniprep Kit",
      subtitle: "D4214, D4215",
      description:
        "High-throughput purification of transfection-grade plasmid DNA from up to 5 ml of overnight E. coli culture.",
      handle: "/products/zymopure-96-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4214_D4215_ZymoPURE_96_Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      "title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
      "subtitle": "D4023, D4024",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
      "image_url": "https://files.zymoresearch.com/product-images/D4023-ZR-96-DNA-Clean-_-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4012",
      "description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4012_DNA-Clean-%26-Concentrator-Magbead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "MAGicBead™ cfDNA Isolation Kit",
      "subtitle": "D4086",
      "description": "Novel DNA binding chemistry enabling unparalleled cfDNA extraction performance",
      "handle": "/products/magicbead-cfdna-isolation-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4086_magicbead_cfdna_isolation_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "Load N’ Go Quick-DNA/RNA HT Kit",
      subtitle: "R2152",
      description:
        "Streamline your nucleic acid research with efficient DNA and RNA extraction from diverse samples.",
      handle: "/products/load-n-go-quick-dna-rna-ht-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2152-Load-N-Go-Quick-DNA-RNA-HT.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA HMW MagBead Kit",
      subtitle: "D6060",
      description:
        "Extract ultra-pure high molecular weight DNA up to 150 kb from any sample.",
      handle: "/products/quick-dna-hmw-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 DNA Sequencing Clean-up Kit",
      subtitle: "D4052, D4053",
      description:
        "High-throughput and rapid clean up of dye terminator sequencing reactions prior to Sanger Sequencing.",
      handle: "/products/zr-96-dna-sequencing-clean-up-kit",
      isKit: true,
      image_url:
        "https://stage.zymoresearch.com/cdn/shop/products/D4052_ZR-96-DNA-Sequencing-Clean-up-Kit_600x.jpg?v=1628532398",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Magnetic Beads & Spin Columns": [
    {
      title: "ZymoPURE Filter Plate",
      subtitle: "C2022, C2022-1",
      description:
        "High-throughput clarification of bacterial lysates.",
      handle: "/products/zymopure-filter-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2022_ZymoPURE-Filter-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Spin P-96 Plate",
      subtitle: "C2023, C2023-1",
      description:
        "High-throughput plasmid DNA purification spin-plate.",
      handle: "/products/zymo-spin-p-96-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2023_Zymo-Spin-P-96-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Wash Plate",
      subtitle: "C2024, C2024-1",
      description:
        "96-well plate for minimizing cross-contamination during high-throughput processing.",
      handle: "/products/wash-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2024_Wash-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96-Well 2.0 mL Deep Well Plate",
      subtitle: "C2015, C2015-50",
      description:
        "96-Well Plate for Liquid Handling Robots",
      handle: "/products/96-well-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2015-2_96-Well-2.0-ml-Deep-Well-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Elution Plate (V-Bottom, 200 µL)",
      subtitle: "C1030, C1030-50",
      description:
        "96-Well Polypropylene Elution Plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-elution-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C1030_96_elution_plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Deep Well Plate (V-Bottom, 2.2ml)",
      subtitle: "C2018-5, C2018-50",
      description:
        "96-Well Polypropylene plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-deep-well-plate-v-bottom-2-2ml",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2018_ZRC_2164.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96 Tip Combs (For V-Bottom Deep Well Plate)",
      subtitle: "C2019, C2019-100",
      description:
        "96 Tip Comb for Magnetic Bead Moving Instruments",
      handle: "/products/96-tip-combs-for-v-bottom-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2019_ZRC_2146.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I Columns",
      subtitle: "C1003-250, C1003-50",
      description:
        "Uncapped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in &ge; 6 &micro;l.",
      handle: "/products/zymo-spin-i-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1003-Zymo-Spin-I.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC Columns",
      subtitle: "C1004-250, C1004-50",
      description:
        "Capped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in ≥ 6 &micro;l.",
      handle: "/products/zymo-spin-ic-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1004-Zymo-Spin-IC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XL",
      subtitle: "C1002-25, C1002-50",
      description:
        "Capped columns for the recovery of large-sized DNA in &ge; 10 &micro;l.",
      handle: "/products/zymo-spin-ic-xl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1002-50-Zymo-Spin-IC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XM Columns",
      subtitle: "C1103-50",
      description: "",
      handle: "/products/zymo-spin-ic-xm-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1103-50_Zymo-Spin IC-XM Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-S Columns",
      subtitle: "C1015-25, C1015-50",
      description:
        "The Zymo-Spin IC-S features durable polypropylene construction and contains a unique silica-based matrix that allows purification",
      handle: "/products/zymo-spin-ic-s-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1015-50-Zymo-Spin-IC-S.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB Columns",
      subtitle: "C1014-250, C1014-50",
      description: "Columns for nucleic acid purification and dye removal.",
      handle: "/products/zymo-spin-ib-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1014-Zymo-Spin-IB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin P1 Columns",
      subtitle: "P2003-1",
      description: "Columns for purification of His-tagged proteins.",
      handle: "/products/zymo-spin-p1-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zymo-spin_pi_c2003-1_.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II Columns",
      subtitle: "C1008-250, C1008-50",
      description:
        "Uncapped columns for the recovery of &le; 25 &micro;g  DNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-ii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1008-50-Zymo-Spin-II.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIC Columns",
      subtitle: "C1011-250, C1011-50",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iic-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1011-50-OPEN-CAP-Zymo-Spin-IIC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIN Columns",
      subtitle: "C1019-250, C1019-50",
      description:
        "Uncapped columns for the recovery of &le;  25 µg  DNA in &ge; 30 &micro;l.",
      handle: "/products/zymo-spin-iin-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1019-Zymo-Spin-IIN.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-µHRC Filters",
      subtitle: "C1059-50",
      description: "For use with Zymo Research products.",
      handle: "/products/zymo-spin-ii-µhrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1059_Zymo Spin II-HRC.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-P Columns",
      subtitle: "C1055-50",
      description: "",
      handle: "/products/zymo-spin-ii-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1055-50_Zymo-Spin II-P Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III Columns",
      subtitle: "C1005-250, C1005-50",
      description:
        "The Zymo-Spin III features durable polypropylene construction that allows purification of up to 25 &micro;g DNA or RNA in &ge; 35 &micro;l eluate.",
      handle: "/products/zymo-spin-iii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1005-Zymo-Spin-III.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIICG Columns",
      subtitle: "C1006-250-G, C1006-50-G",
      description: "",
      handle: "/products/zymo-spin-iiicg-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-G-Zymo-Spin-IIICG.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-F Filters",
      subtitle: "C1057-50",
      description: "For use in Zymo Research environmental purification kits.",
      handle: "/products/zymo-spin-iii-f-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1057-Zymo-Spin-III-F.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-HRC Filters",
      subtitle: "C1058-50",
      description: "",
      handle: "/products/zymo-spin-iii-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1058-Zymo-Spin-III-HRC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV-IR HRC Filters",
      subtitle: "C1010-50",
      description: "",
      handle: "/products/zymo-spin-iv-ir-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1010-50_Zymo-Spin-IV-IR-HRC-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "Zymo-Spin III-P Column Assembly w/ 15 ml and 50 ml Reservoir (5 Pack)",
      subtitle: "C1040-5",
      description: "",
      handle:
        "/products/zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1040-5-Zymo-Spin-III-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-S Columns w/ LuerLock Caps and 15 ml Reservoir",
      subtitle: "C1049-25",
      description: "",
      handle:
        "/products/zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/(3) Zymo Spin IIIS.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV Columns",
      subtitle: "C1007-250, C1007-50",
      description: "",
      handle: "/products/zymo-spin-iv-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/c1007-50-zymo-spin-iv.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns",
      subtitle: "C1012-25, C1012-50",
      description:
        "Column for purifying up to 100 &micro;g  DNA or RNA in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1012-25-Zymo-Spin-V.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns w/ Reservoir",
      subtitle: "C1016-25, C1016-50",
      description:
        "Assembly for purifying DNA/RNA from &le; 15 ml sample in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1016-25-Zymo-Spin-V-with-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-P Column Assembly w/ 15 ml and 50 ml Reservoir",
      subtitle: "C1042-5",
      description:
        "The Zymo-Spin V-P can be used in centrifuges or on-vacuum manifolds to purify plasmid DNA.",
      handle:
        "/products/zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1042-5--Zymo-Spin-V-P-with-15-ml-and-50-ml-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-E Columns",
      subtitle: "C1021-25, C1024-25, C1024-50, C1029-25",
      description:
        "The Zymo-Spin V-E columns can be used in microcentrifuges, centrifuges, or on vacuum manifolds",
      handle: "/products/zymo-spin-v-e-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1024-25-Zymo-Spin-VE.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns",
      subtitle: "C1013-10, C1013-20",
      description:
        "Column for recovery of up to 500 &micro;g  DNA or RNA in &ge; 2 ml.",
      handle: "/products/zymo-spin-vi-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1013-10-Zymo-Spin-VI.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Reservoir",
      subtitle: "C1018-10, C1018-20",
      description:
        "Column assembly for recovery of DNA/RNA from large volumes.",
      handle: "/products/zymo-spin-vi-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1018-Zymo-Spin-VI-with-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Zymo-Maxi Filter",
      subtitle: "C1017-10, C1017-20",
      description:
        "Column-filter assembly for purifying DNA/RNA from &le; 75 ml sample",
      handle: "/products/zymo-spin-vi-columns-w-zymo-maxi-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1017-10-Zymo-Spin-VI-with-maxi-filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI-P Columns",
      subtitle: "C1044-5",
      description:
        "Zymo-Spin VI-P can be used in centrifuges or on vacuum manifolds for the purification of plasmid DNA.",
      handle: "/products/zymo-spin-vi-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1044-5-Zymo-Spin-VI-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96 Plate",
      subtitle: "C2004, C2004-SW",
      description:
        "Deep-well (96) plate purification of DNA/RNA in &ge; 10 &micro;l elution.",
      handle: "/products/zymo-spin-i-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2004-Zymo-Spin-I-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96-XL Plates",
      subtitle: "C2010",
      description:
        "Deep-well (96) plate purification of large DNA in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-i-96-xl-plates",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2010-Zymo-Spin-III-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A Plate",
      subtitle: "C2001",
      description:
        "Shallow-well (96) plate purification of DNA/RNA in &ge; 30 &micro;l.",
      handle: "/products/silicon-a-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-Silicon-A-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB-96 Plate",
      subtitle: "C2006",
      description:
        "Deep-well (96) plate for DNA clean-up & dye removal in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-ib-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2006-Zymo-Spin-IB-96-plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A-HRC Plate",
      subtitle: "C2009",
      description: "",
      handle: "/products/silicon-a-hrc-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2009-Silicon-A-HRC-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Plate",
      subtitle: "C2002",
      description:
        "1.2 ml, round bottom, 96-well plate for use with spin plate.",
      handle: "/products/collection-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2002-Collection-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Elution Plate",
      subtitle: "C2003",
      description:
        "90 &micro;l, V-bottom, 96-well plate for use with spin plate.",
      handle: "/products/elution-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2003-Elution-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-1, S6002-96-2, S6002-96-3",
      description: "ZR BashingBeads in 96 impact resistant tube rack.",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6002-96-2-ZR-Bashing-Bead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block",
      subtitle: "P1001-10, P1001-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1001-2-96-well-block.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Conversion Plate w/ Cover Foil",
      subtitle: "C2005",
      description: "96-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/conversion-plate-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2005-C2008-96-Well-Conversion-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block w/ Cover Foil",
      subtitle: "P1002-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1002-2-96-Well-block-with-cover-foil.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Plate Cover Foil",
      subtitle: "C2007-12, C2007-2, C2007-24, C2007-4, C2007-6, C2007-8",
      description: "Pierceable aluminum foil with strong adhesive for sealing.",
      handle: "/products/96-well-plate-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2007_96-well Cover Foils.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MagBinding Beads",
      subtitle:
        "D4100-2-12, D4100-2-16, D4100-2-24, D4100-2-3, D4100-2-6, D4100-2-8",
      description:
        "For use with Zymo Research magnetic bead-based purification kits.",
      handle: "/products/magbinding-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Syringe Filters",
      subtitle: "C1036-5",
      description:
        "The ZymoPURE Syringe Filter features rapid clarification of up to 60 ml of neutralized lysate",
      handle: "/products/zymopure-syringe-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1036-5-Syringe-Filters.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Giga Filter",
      subtitle: "C1038-1",
      description: "",
      handle: "/products/zymopure-giga-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1038-1-ZymoPure-Giga-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Spin-Away Filters",
      subtitle: "C1006-250-F, C1006-50-F",
      description: "For use with Zymo Research purification kits",
      handle: "/products/spin-away-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-F-Spin-Away-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZRC GF Filter",
      subtitle: "C1009-20, C1009-50",
      description:
        "Filter for separating cellular components from biological fluids.",
      handle: "/products/zrc-gf-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1009-20-ZRC-GF-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "15 ml Conical Reservoir",
      subtitle: "C1031-25",
      description: "",
      handle: "/products/15-ml-conical-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/15ml reservoir.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "25 ml Reservoir for Spin-Away Filters and Zymo-Spin IIICG",
      subtitle: "C1039-25",
      description: "",
      handle:
        "/products/25-ml-reservoir-for-spin-away-filters-and-zymo-spin-iiicg",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1039-25_Reservoir - 25 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "50 ml Conical Reservoir",
      subtitle: "C1032-25",
      description:
        "The 50 ml Reservoir can be used with vacuum manifolds for the purification of DNA and/or RNA",
      handle: "/products/50-ml-conical-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1032-25-50ml-Conical-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "600 ml Reservoir",
      subtitle: "C1033-5",
      description:
        "The 600 ml Reservoir, used with vacuum manifolds for the purification of DNA/RNA",
      handle: "/products/600-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1033-5-600-ml-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Tubes",
      subtitle: "C1001-1000, C1001-50, C1001-500",
      description:
        "Durable polypropylene collection tubes used in conjunction with Zymo-Spin columns",
      handle: "/products/collection-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1001-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase/RNase-Free Tubes",
      subtitle: "C2001-100, C2001-50",
      description:
        "DNase/RNase-free 1.5 ml microcentrifuge tubes made of durable polypropylene construction.",
      handle: "/products/dnase-rnase-free-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-100-DNase-RNase-free-tubes.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Clear Tubes, with caps",
      subtitle: "C1025-50, C1025-500, C1027-50, C1027-500",
      description:
        "Clear 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-clear-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1025-Clear-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Amber Tubes, with caps",
      subtitle: "C1026-50, C1026-500, C1028-50, C1028-500",
      description:
        "Amber 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-amber-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1026-50-Amber-Tube-with-cap-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR Bashing Bead Lysis Tubes",
      subtitle: "S6003-50",
      description: "2.0 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashing-bead-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
      subtitle: "S6014-50",
      description: "",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zr_bashingbead_lysis_tubes_2.0_mm_s6003-50__1.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
      subtitle: "S6012-50",
      description:
        "0.1 & 0.5 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/S6012-50_ZR-BashingBead-Lysis-Tubes.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Squisher-Single",
      subtitle: "H1001, H1001-50",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-single",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/H1001-Squisher-Single.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Squisher-8 w/ 96-Well Block",
      subtitle: "H1002-5, H1002-20",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-8-w-96-well-block",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/H1002-5-Squisher-8.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Squisher-96 w/ 96-Well Block",
      subtitle: "H1004-2, H1004-5",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-96-w-96-well-block",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/H1004-2-Squisher-96.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zymo-Spin IICR Columns",
      subtitle: "C1078-50, C1078-250",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iicr-columns",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/C1078_Zymo-Spin IICR Columns.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-4, S6002-96-5",
      description:
        "96-well microbial cell lysis rack for high throughput/automated bead beating",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/s6002_96_lysis_rack.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Select-a-Size MagBead Set",
      subtitle: "D4084-10, D4084-50",
      description: "For use in Select-a-Size DNA Clean & Concentrator Magbead kit.",
      handle: "/products/select-a-size-magbead-set",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4084-1-50_Select-A-Size-MagBeads-50-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBinding Beads",
      subtitle: "D4302-6-12, D4302-6-6",
      description:
        "For use in ZymoBIOMICS magnetic bead-based purification kits.",
      handle: "/products/zymobiomics-magbinding-beads",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4302-6-12_ZymoBIOMICS-MagBinding-Beads-12-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-Methylation Magprep Beads",
      subtitle:
        "D4100-5-4, D4100-5-8, D4100-5-16",
      description:
        "For use in EZ-DNA Methylation Magprep bead-based purification kits.",
      handle: "/products/ez-methylation-magprep-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MagBead J",
      subtitle:
        "D4100-3-3, D4100-3-50, D4100-3-100",
      description:
        "Optimized for low reaction volume workflows and high-throughput automation.",
      handle: "/products/magbead-j",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "DNA Extraction": [
    {
      title: "<i>Quick</i>-DNA 96 Kit",
      subtitle: "D3010, D3011, D3012",
      description: "Rapid purification of DNA from cells and whole blood",
      handle: "/products/quick-dna-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3010_Quick-DNA-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {   
      title: "<i>Quick</i>-DNA 96 Plus Kit",
      subtitle: "D4070, D4071",
      description:
        "Streamlined DNA isolation from any cells, tissues, and biological fluids (Proteinase K included).",
      handle: "/products/quick-dna-96-plus-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4071-Quick-DNA-96-Plus-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Magbead Plus Kit",
      subtitle: "D4081, D4082",
      description:
        "Streamlined DNA isolation from any cells, tissues, and biological fluids (Proteinase K included).",
      handle: "/products/quick-dna-magbead-plus-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4081_Quick-DNA-Magbead-Plus-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS 96 MagBead Kit",
      subtitle: "D4302, D4306, D4308",
      description:
        "Inhibitor-free microbial DNA from any sample validated for microbiome and metagenomic analyses",
      handle: "/products/zymobiomics-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS 96 DNA Kit",
      subtitle: "D4303, D4307, D4309",
      description:
        "Inhibitor-free microbial DNA from any sample validated for microbiome and metagenomic analyses",
      handle: "/products/zymobiomics-96-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png",
      searchWeight: 0,
      tags: [],
    },
    {
      "title": "MAGicBead™ cfDNA Isolation Kit",
      "subtitle": "D4086",
      "description": "Novel DNA binding chemistry enabling unparalleled cfDNA extraction performance",
      "handle": "/products/magicbead-cfdna-isolation-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4086_magicbead_cfdna_isolation_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "Load N’ Go Quick-DNA/RNA HT Kit",
      subtitle: "R2152",
      description:
        "Streamline your nucleic acid research with efficient DNA and RNA extraction from diverse samples.",
      handle: "/products/load-n-go-quick-dna-rna-ht-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2152-Load-N-Go-Quick-DNA-RNA-HT.jpg",
      searchWeight: 2,
      tags: [],
      ribbon: true
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Kit",
      subtitle: "D6011",
      description:
        "Extract high quality, inhibitor-free DNA from feces, soil, water, etc.",
      handle: "/products/quick-dna-fecal-soil-microbe-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6011_Quick-DNA-Fecal-Soil-Microbe_96-Well.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Magbead Kit",
      subtitle: "D6010-FM, D6011-FM, D6012-FM",
      description:
        "Extract high quality, inhibitor-free DNA from feces, soil, water, etc.",
      handle: "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010-FM_Quick-DNA-Fecal-Soil-Microbe_96-Magbead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial 96 Kit",
      subtitle: "D6006",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/products/quick-dna-fungal-bacterial-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6006_Quick-DNA-Fungal-Bacterial-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA HMW MagBead Kit",
      subtitle: "D6060",
      description:
        "Extract ultra-pure high molecular weight DNA up to 150 kb from any sample.",
      handle: "/products/quick-dna-hmw-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Plant/Seed 96 Kit",
      subtitle: "D6021",
      description:
        "Inhibitor-free DNA isolated directly from plant and seed samples.",
      handle: "/products/quick-dna-plant-seed-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6021_Quick-DNA Plant Seed 96 Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {   
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Viral 96 Kit",
      subtitle: "D3017, D3018",
      description:
        "Efficient isolation of viral DNA from a wide range of biological sources.",
      handle: "/products/quick-dna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3017_ZR-96-Viral-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Tissue/Insect 96 Kit",
      subtitle: "D6017",
      description: "Isolate DNA from tough-to-lyse tissues and insects.",
      handle: "/products/quick-dna-tissue-insect-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6017_Quick-DNA-Tissue-Insect-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Plasmid Purification": [
    {
      title: "ZymoPURE 96 Plasmid Miniprep Kit",
      subtitle: "D4214, D4215",
      description:
        "High-throughput purification of transfection-grade plasmid DNA from up to 5 ml of overnight E. coli culture.",
      handle: "/products/zymopure-96-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4214_D4215_ZymoPURE_96_Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zyppy-96 Plasmid Kit",
      subtitle: "D4041, D4042, D4043",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes",
      handle: "/products/zyppy-96-plasmid-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4041_Zyppy-96-Plasmid-Miniprep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zyppy-96 Plasmid MagPrep Kit",
      subtitle: "D4100, D4101, D4102",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes",
      handle: "/products/zyppy-96-plasmid-magprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep-96 Yeast Plasmid Miniprep",
      subtitle: "D2005, D2006, D2007",
      description:
        "The fastest and simplest high-throughput procedure for purifying the highest quality plasmid DNA from yeast.",
      handle: "/products/zymoprep-96-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "DNA Analysis": [
    {
      title: "Femto DNA Quantification Kits",
      subtitle: "DNA",
      description:
        "Detect and quantify human, bacterial, and fungal DNA with high specificity and sensitivity. ",
      handle: "/collections/femto-dna-quantification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2005_Femto-Human-DNA-Quantification-Kit.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "ZR DNA Markers",
      subtitle: "DNA",
      description:
        "DNA size fragments encompassing a range of sizes from 50 bp up to 10 kb.",
      handle: "/collections/zr-dna-markers",
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/collections/M5001-200_ZR-50-bp-DNA-Marker-200-ug.jpg?v=1628532563",
      tags: [],
    },
    {
      title: "Zymo-Seq SPLAT DNA Library Kit",
      subtitle: "D5464",
      description:
        "Versatile and unique ssDNA library preparation solution for any DNA sample.",
      handle: "/products/zymo-seq-splat-dna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5464_zymo-seq_splat_dna_library_kit_(12_prep).jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
  ],
  RNA: [
    {
      title: "Direct-zol RNA Kits",
      subtitle: "RNA",
      description:
        "RNA purification kits that provide purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRIzol or Tri Reagent in 7 minutes. Get a free RNA purification kits sample with free shipping. ",
      handle: "/collections/direct-zol-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Kits",
      subtitle: "RNA",
      description:
        "The Quick-RNA kits are RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes. Get a free sample today with free shipping. ",
      handle: "/collections/quick-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator Kits (RCC)",
      subtitle: "RNA",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free (R1013, R1014) RNA. Get free RNA clean up kits sample. ",
      handle: "/collections/rna-clean-concentrator-kits-rcc",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral Kits",
      subtitle: "RNA",
      description:
        "The <i>Quick</i>- RNA Viral Kits are viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      handle: "/collections/quick-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fungal/Bacterial Kit",
      subtitle: "RNA",
      description:
        "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-rna-fungal-bacterial-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Plant Kit",
      subtitle: "R2024",
      description: "Isolate inhibitor-free RNA from plant and seed samples.",
      handle: "/products/quick-rna-plant-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2024_Quick-RNA-Plant-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
      subtitle: "R2040",
      description:
        "The Quick-RNA Fecal/Soil Microbe Microprep Kit is an affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
      handle: "/products/quick-rna-fecal-soil-microbe-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2040_Quick-RNA-Fecal-Soil-Microbe-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Tissue/Insect Kit",
      subtitle: "R2030",
      description: "Isolate RNA from tough-to-lyse tissue and insects",
      handle: "/products/quick-rna-tissue-insect-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2030_Quick-RNA-Tissue-Insect-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Whole Blood",
      subtitle: "R1201",
      description: "Isolate RNA and small/miRNA from whole blood.",
      handle: "/products/quick-rna-whole-blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1201_Quick-RNA-Whole-Blood-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA FFPE Miniprep",
      subtitle: "R1008",
      description: "Isolate RNA and small/miRNA from FFPE tissue.",
      handle: "/products/quick-rna-ffpe-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1008_Quick-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfRNA Serum & Plasma Kit",
      subtitle: "R1059",
      description: "Isolate cell-free RNA from biological fluid samples.",
      handle: "/products/quick-cfrna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1059_Quick-cfRNA-Serum-Plasma-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR Urine RNA Isolation Kit",
      subtitle: "R1038, R1039",
      description: "Isolate RNA from up to 30 ml of urine.",
      handle: "/products/zr-urine-rna-isolation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1038_ZR-Urine-RNA-Isolation-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pinpoint Slide RNA Isolation System",
      subtitle: "R1003, R1007",
      description: "RNA from tissue sections on glass slides",
      handle: "/products/pinpoint-slide-rna-isolation-system",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1003_Pinpoint-Slide-RNA-Isolation-System-I-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Load N’ Go DNA/RNA Viral Kit",
      subtitle: "R2143",
      description: "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      handle: "/products/load-n-go-dna-rna-viral-kit",
      isKit: true,
      ribbon: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral Kits",
      subtitle: "DNA/RNA Purification",
      description:
        "The Quick-DNA/RNA Viral kits are viral DNA/RNA purification kits that provide for rapid isolation of high-quality viral nucleic acids from a wide range of biological sources.",
      handle: "/collections/quick-dna-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "<i>Quick</i>-DNA/RNA Pathogen kits simplify purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      handle: "/collections/quick-dna-rna-pathogen-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      subtitle: "R1009",
      description: "DNA and RNA from FFPE tissue",
      handle: "/products/quick-dna-rna-ffpe-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoclean Gel RNA Recovery Kit",
      subtitle: "R1011",
      description:
        "The Zymoclean Gel RNA Recovery Kit provides a quick and efficient purification method for recovery of RNA fragments from agarose gels.",
      handle: "/products/zymoclean-gel-rna-recovery-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1011_Zymoclean-Gel-RNA-Recovery-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR small-RNA  PAGE Recovery Kit",
      subtitle: "R1070",
      description:
        "The ZR small-RNA PAGE Recovery Kit provides an easy and efficient method for the extraction of high quality small RNAs from polyacrylamide gels (native and/or denatured)",
      handle: "/products/zr-small-rna-page-recovery-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1070_ZR-small-RNA-PAGE-Recovery-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Oligo Clean & Concentrator Kits",
      subtitle: "DNA",
      description:
        "The Oligo Clean & Concentrator provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
      handle: "/collections/oligo-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "YeaStar RNA Kit",
      subtitle: "R1002",
      description:
        "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      handle: "/products/yeastar-rna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Water Kit",
      subtitle: "R2044",
      description: "ReThe Quick-DNA/RNA™ Water Kit efficiently isolates inhibitor-free nucleic acids from large water samples, ideal for sensitive applications like ddPCR, RT-qPCR, and NGS.",
      handle: "/products/quick-dna-rna-water-kit",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/R2044-quick-dna-rna-water-kit_600x.jpg?v=1720731203",
      searchWeight: 0,
      tags: [],
    },
  ],
  "RNA Isolation Kits": [
    {
      title: "Direct-zol RNA Kits",
      subtitle: "RNA",
      description:
        "RNA purification kits that provide purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRIzol or Tri Reagent in 7 minutes. Get a free RNA purification kits sample with free shipping. ",
      handle: "/collections/direct-zol-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Kits",
      subtitle: "RNA",
      description:
        "The Quick-RNA kits are RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes. Get a free sample today with free shipping. ",
      handle: "/collections/quick-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral Kits",
      subtitle: "RNA",
      description:
        "The <i>Quick</i>- RNA Viral Kits are viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      handle: "/collections/quick-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Whole Blood",
      subtitle: "R1201",
      description: "Isolate RNA and small/miRNA from whole blood.",
      handle: "/products/quick-rna-whole-blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1201_Quick-RNA-Whole-Blood-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA FFPE Miniprep",
      subtitle: "R1008",
      description: "Isolate RNA and small/miRNA from FFPE tissue.",
      handle: "/products/quick-rna-ffpe-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1008_Quick-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS RNA Kits",
      subtitle: "Microbiomics",
      description:
        "Purification of microbial RNA for microbiome or metagenome analysis.",
      handle: "/collections/zymobiomics-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit_1200x@2x.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Kits",
      subtitle: "Microbiomics",
      description:
        "Purification of microbial DNA and RNA for microbiome or metagenome analysis.",
      handle: "/collections/zymobiomics-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit_1200x@2x.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fungal/Bacterial Kit",
      subtitle: "RNA",
      description:
        "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-rna-fungal-bacterial-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Tissue/Insect Kit",
      subtitle: "R2030",
      description: "Isolate RNA from tough-to-lyse tissue and insects",
      handle: "/products/quick-rna-tissue-insect-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2030_Quick-RNA-Tissue-Insect-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
      subtitle: "R2040",
      description:
        "The Quick-RNA Fecal/Soil Microbe Microprep Kit is an affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
      handle: "/products/quick-rna-fecal-soil-microbe-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2040_Quick-RNA-Fecal-Soil-Microbe-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Plant Kit",
      subtitle: "R2024",
      description: "Isolate inhibitor-free RNA from plant and seed samples.",
      handle: "/products/quick-rna-plant-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2024_Quick-RNA-Plant-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfRNA Serum & Plasma Kit",
      subtitle: "R1059",
      description: "Isolate cell-free RNA from biological fluid samples.",
      handle: "/products/quick-cfrna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1059_Quick-cfRNA-Serum-Plasma-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR Urine RNA Isolation Kit",
      subtitle: "R1038, R1039",
      description: "Isolate RNA from up to 30 ml of urine.",
      handle: "/products/zr-urine-rna-isolation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1038_ZR-Urine-RNA-Isolation-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral Kits",
      subtitle: "DNA/RNA Purification",
      description:
        "The Quick-DNA/RNA Viral kits are viral DNA/RNA purification kits that provide for rapid isolation of high-quality viral nucleic acids from a wide range of biological sources.",
      handle: "/collections/quick-dna-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "<i>Quick</i>-DNA/RNA Pathogen kits simplify purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      handle: "/collections/quick-dna-rna-pathogen-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      subtitle: "R1009",
      description: "DNA and RNA from FFPE tissue",
      handle: "/products/quick-dna-rna-ffpe-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Blood Tube Kit",
      subtitle: "R1151",
      description:
        "Co-Purification from the DNA/RNA Shield Blood Collection Tube",
      handle: "/products/quick-dna-rna-blood-tube-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/r1151_quick-dna-rna-blood-tube-kit_1.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pinpoint Slide RNA Isolation System",
      subtitle: "R1003, R1007",
      description: "RNA from tissue sections on glass slides",
      handle: "/products/pinpoint-slide-rna-isolation-system",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1003_Pinpoint-Slide-RNA-Isolation-System-I-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "YeaStar RNA Kit",
      subtitle: "R1002",
      description:
        "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      handle: "/products/yeastar-rna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "RNA Clean Up Kits": [
    {
      title: "RNA Clean & Concentrator Kits (RCC)",
      subtitle: "RNA",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free (R1013, R1014) RNA. Get free RNA clean up kits sample. ",
      handle: "/collections/rna-clean-concentrator-kits-rcc",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Oligo Clean & Concentrator Kits",
      subtitle: "RNA",
      description:
        "The Oligo Clean & Concentrator provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
      handle: "/collections/oligo-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zymoclean Gel RNA Recovery Kit",
      subtitle: "R1011",
      description:
        "The Zymoclean Gel RNA Recovery Kit provides a quick and efficient purification method for recovery of RNA fragments from agarose gels.",
      handle: "/products/zymoclean-gel-rna-recovery-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1011_Zymoclean-Gel-RNA-Recovery-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR small-RNA  PAGE Recovery Kit",
      subtitle: "R1070",
      description:
        "The ZR small-RNA PAGE Recovery Kit provides an easy and efficient method for the extraction of high quality small RNAs from polyacrylamide gels (native and/or denatured)",
      handle: "/products/zr-small-rna-page-recovery-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1070_ZR-small-RNA-PAGE-Recovery-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ssDNA/RNA Clean & Concentrator",
      subtitle: "D7010, D7011",
      description:
        "Separation of single-stranded nucleic acids from double-stranded nucleic acids.",
      handle: "/products/ssdna-rna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "RNA High-Throughput/Automated": [
    {
      title: "Direct-zol-96 MagBead RNA",
      subtitle: "R2100, R2101, R2102, R2103, R2104, R2105",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 RNA Kits",
      subtitle: "R2054, R2055, R2056, R2057",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },

    {
      title: "<i>Quick</i>-RNA 96 Kit",
      subtitle: "R1052, R1053",
      description:
        "Isolate total RNA and small/miRNA from cells and soft tissue",
      handle: "/products/quick-rna-96-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-96",
      subtitle: "R1080",
      description: "RNA clean-up from any reaction",
      handle: "/products/rna-clean-concentrator-96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral 96 Kit",
      subtitle: "R1040, R1041",
      description: "Viral RNA from all biological fluids",
      handle: "/products/quick-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1040_Quick-RNA-Viral-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 Oligo Clean & Concentrator",
      subtitle: "D4062, D4063",
      description:
        "Clean any DNA and RNA oligos in high-throughput format and elute in 10 &micro;l",
      handle: "/products/oligo-clean-concentrator-zr96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 MagStand",
      subtitle: "P1005",
      description:
        "Separation of magnetic beads in standard 96-well format plates",
      handle: "/products/zr-96-magstand",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/p1005_ZR-96_MagStand.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "RNA Analysis": [
    {
      title: "Zymo-Seq SwitchFree 3′ mRNA Library Kit",
      subtitle: "R3008, R3009",
      description: "UMI-integrated, simple 3′ mRNA library preparation in ~4 hours with scalable sample multiplexing suitable for high-throughput protein coding gene counting.",
      handle: "/products/zymo-seq-switchfree-3-mrna-library-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3008_zymo_seq_switchfree_3_mrna_library_kit_2.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoScript One-Step RT-qPCR Kit",
      subtitle: "R3014",
      description: "ZymoScript One-Step RT-qPCR Kit is an optimized RT-qPCR kit that contains all the components for fast reverse transcription and robust qPCR amplification in a single tube. The One-Step RT-qPCR kit is compatible with both SYBR Green and TaqMan probe-based assays.",
      handle: "/products/zymoscript-one-step-rt-qpcr-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3014-zymoscript_onestep_rt_qpcr_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "ZymoScript RT PreMix Kit",
      subtitle: "R3012",
      description: "ZymoScript RT PreMix Kit is part of the ZymoScript family together with the ZymoScript OneStep RT-qPCR Kit (R3014). ZymoScript RT PreMix is an optimized reverse transcription kit containing all the necessary components for quick and efficient cDNA synthesis.",
      handle: "/products/zymoscript-rt-premix-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3012-zymoscript_rt_prexix_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>Quick</i> SARS-CoV-2 rRT-PCR Kit",
      subtitle: "R3011",
      description:
        "Simple and sensitive detection of SARS-CoV-2 from biological samples.",
      handle: "/products/quick-sars-cov-2-rrt-pcr-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3010-quick-sars-cov-s-rrt-pcr-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "Zymo-Seq RiboFree Total RNA Library Kit",
      subtitle: "R3000, R3003",
      description:
        "The fastest and easiest kit for stranded total RNA-seq libraries with RiboFree Universal Depletion for any sample and species",
      handle: "/products/zymo-seq-ribofree-total-rna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3000_zymo-seq_ribofree_tota_rna_library_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Universal cDNA Kit",
      subtitle: "R3001",
      description:
        "This universal rRNA and globin depletion kit is probe-free and produces RiboFree single-stranded cDNA with minimal hands-on time.",
      handle: "/products/zymo-seq-ribofree-universal-cdna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3001_zymo-seq_ribofree_universal_cdna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq UDI Primer Sets",
      subtitle: "D3008, D3096, D3097, D3098",
      description: "The Zymo-Seq UDI Primer Sets contain pre-mixed Unique Dual Index (UDI) primers that can be used to barcode any library containing TruSeq® adapters.",
      handle: "/products/zymo-seq-udi-primer-sets",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d3008_zymo-seq_udi_primer_set_Indexes_1-12.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZR small-RNA Ladder",
      subtitle: "R1090",
      description:
        "miRNA size marker for PAGE and small RNA size approximation",
      handle: "/products/zr-small-rna-ladder",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1090_ZR-Small-RNA-Ladder-10-ug.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "DNA/RNA Purification": [
    {
      title: "<i>Quick</i>-DNA/RNA Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "Isolation of high quality genomic DNA and total RNA from cells, tissue, blood, biological fluids, etc. ",
      handle: "/collections/quick-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Direct-zol DNA/RNA Miniprep",
      subtitle: "R2080, R2080T, R2081",
      description:
        "DNA & RNA isolation from any sample in TRIzol, TRI Reagent.",
      handle: "/products/direct-zol-dna-rna-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2080_Direct-zol-DNA-RNA-Miniprep-Kit_no-TRIzol.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral Kits",
      subtitle: "DNA/RNA Purification",
      description:
        "The Quick-DNA/RNA Viral kits are viral DNA/RNA purification kits that provide for rapid isolation of high-quality viral nucleic acids from a wide range of biological sources.",
      handle: "/collections/quick-dna-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Blood Collection",
      subtitle: "Sample Collection",
      description: "DNA/RNA transport medium for whole blood",
      handle: "/pages/sample-collection-kits?tags=blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Load N’ Go DNA/RNA Viral Kit",
      subtitle: "R2143",
      description: "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      handle: "/products/load-n-go-dna-rna-viral-kit",
      isKit: true,
      ribbon: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "<i>Quick</i>-DNA/RNA Pathogen kits simplify purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      handle: "/collections/quick-dna-rna-pathogen-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      subtitle: "R1072",
      description:
        "Isolate cfDNA and cfRNA efficiently and easily from biological fluids",
      handle: "/products/quick-cfdna-rna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Miniprep Kit",
      subtitle: "R2002",
      description:
        "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-dna-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      subtitle: "R1009",
      description: "DNA and RNA from FFPE tissue",
      handle: "/products/quick-dna-rna-ffpe-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ssDNA/RNA Clean & Concentrator",
      subtitle: "D7010, D7011",
      description:
        "Separation of single-stranded nucleic acids from double-stranded nucleic acids.",
      handle: "/products/ssdna-rna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Kits",
      subtitle: "Microbiomics",
      description:
        "Purification of microbial DNA and RNA for microbiome or metagenome analysis.",
      handle: "/collections/zymobiomics-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit_1200x@2x.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "BAC/PAC/YAC DNA": [
    {
      "title": "ZymoPURE II Plasmid Midiprep Kit",
      "subtitle": "D4200, D4201",
      "description": "Purify endotoxin-free plasmid DNA in less than 18 minutes.",
      "handle": "/products/zymopure-ii-plasmid-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "ZymoPURE 96 Plasmid Miniprep Kit",
      subtitle: "D4214, D4215",
      description:
        "High-throughput purification of transfection-grade plasmid DNA from up to 5 ml of overnight E. coli culture.",
      handle: "/products/zymopure-96-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4214_D4215_ZymoPURE_96_Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Maxiprep Kit",
      subtitle: "D4202, D4203",
      description: "Endotoxin-Free/Transfection-grade plasmid DNA in &le; 20 min.",
      handle: "/products/zymopure-ii-plasmid-maxiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Plasmid Miniprep Kit",
      subtitle: "D4208T, D4209, D4210, D4211, D4212",
      description:
        "Fastest and simplest method to isolate endotoxin-free plasmid DNA",
      handle: "/products/zymopure-ii-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Gigaprep Kit",
      subtitle: "D4204",
      description:
        "Large-Scale, vaccine/transfection grade plasmid DNA purification",
      handle: "/products/zymopure-ii-plasmid-gigaprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit-2.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE - Express Plasmid Midiprep Kit",
      subtitle: "D4213",
      description:
        "A fast, pellet-free method to isolate transfection-grade plasmid DNA. No large centrifuge required!",
      handle: "/products/zymopure-express-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4213_ZymoPURE%20Express%20Plasmid%20Midiprep%20Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BAC DNA Miniprep Kit",
      subtitle: "D4048, D4049",
      description:
        "Quickly isolate large constructs (≤200 kb) from <i>E. coli</i> using a spin-column",
      handle: "/products/zr-bac-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "DNA/RNA Methylation": [
    {
      title: "Zymo-Seq Trio WGBS Library Kit",
      subtitle: "D5462, D5463",
      description:
          "Provides a reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation.",
      handle: "/products/zymo-seq-trio-wgbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Lightning Kits",
      subtitle: "Epigenetics",
      description:
        "Discover citation-leading kits with the most efficient method for complete bisulfite conversion of DNA for methylation analysis. Get a free sample kit today with free shipping. ",
      handle: "/collections/ez-dna-methylation-lightning-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Direct Kits",
      subtitle: "Epigenetics",
      description:
        "Bisulfite conversion kits that feature complete DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. Get a free bisulfite conversion kits sample.",
      handle: "/collections/ez-dna-methylation-direct-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5020_EZ-DNA-Methylation-Direct-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation Kits",
      subtitle: "Epigenetics",
      description:
        "The EZ DNA Methylation&trade; Kits feature a simplified procedure that streamlines bisulfite treatment of DNA.",
      handle: "/collections/ez-dna-methylation-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Gold Kits",
      subtitle: "Epigenetics",
      description:
        "Consolidate DNA denaturation and bisulfite conversion processes into one step, resulting in a much faster bisulfite conversion",
      handle: "/collections/ez-dna-methylation-gold-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Startup Kit",
      subtitle: "D5024",
      description:
        "An all-inclusive kit for bisulfite conversion of DNA directly from blood, tissues, and cells, and PCR reagents and controls to assess conversion efficiency.",
      handle: "/products/ez-dna-methylation-startup-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5024_EZ DNA Methylation-Startup Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ RNA Methylation Kit",
      subtitle: "R5001, R5002",
      description:
        "Fast and reliable bisulfite conversion of RNA for methylation analysis.",
      handle: "/products/ez-rna-methylation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R5001_EZ-RNA-Methylation-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pico Methyl-Seq Library Prep Kit",
      subtitle: "D5455, D5456",
      description:
        "All-inclusive kit for bisulfite conversion followed by Whole Genome Bisulfite Sequencing (WGBS) library preparation.",
      handle: "/products/pico-methyl-seq-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d5456_pico-methyl-seq-library-prep-kit_1.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Zymo-Seq RRBS Library Kit",
      subtitle: "D5460, D5461",
      description:
        "The Zymo-Seq RRBS Library Kit is an all-inclusive library prep kit for low-input library preparation of Reduced Representation of Bisulfite Sequencing (RRBS) to profile genome-wide DNA methylation.",
      handle: "/products/zymo-seq-rrbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5460_ez_dna_methylation_rrbs_library_prep_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-mC DNA ELISA Kit",
      subtitle: "D5325, D5326",
      description: "Global 5-mC detection and quantitation.",
      handle: "/products/5-mc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5325_5-mC DNA ELISA Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "OneStep PLUS qMethyl PCR Kit",
      subtitle: "D5312",
      description:
        "Enzymatic Real-Time PCR for the detection of DNA methylation.",
      handle: "/products/onestep-plus-qmethyl-pcr-kit",
      isKit: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D5312-One-STEP-PLUS-qMethyl-PCR.jpg?v=1715298345",
      searchWeight: 0,
      tags: ["DRY ICE", "BLUE ICE"],
    },
    {
      title: "Methylated-DNA IP Kit",
      subtitle: "D5101",
      description:
        "Kit for immunoprecipitation of methylated DNA in only a few hours. Recovered DNA is suitable for microarray, PCR, bisulfite treatment, etc.",
      handle: "/products/methylated-dna-ip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5101_Methylated-DNA-IP-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)",
      subtitle: "A3002-15, A3002-200, A3002-30, A3002-50",
      description:
        "Anti-5mC antibody for immunoprecipitation of methylated DNA, ELISA, immunoblotting, immunofluorescence",
      handle: "/products/anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A3002-50_Anit Methylation - 1:2ul.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Universal Methylated DNA Standard",
      subtitle: "D5011, D5012",
      description:
        "Control DNA for bisulfite conversion and DNA methylation quantitation.",
      handle: "/products/universal-methylated-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5011_Universal-Methylated-Human-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Human Methylated & Non-Methylated (WGA) DNA Set",
      subtitle: "D5013, D5013-1, D5013-2",
      description:
        "This control set is generated from HCT116 DKO cell genomic DNA using whole-genome amplification (WGA) technology. This standard is ideal for studying loci with ultra-low methylation levels.",
      handle:
        "/products/human-methylated-non-methylated-wga-dna-set-dna-w-primers",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5013_Human-WGA-Methylated-and-Non-Methylated-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Human Methylated & Non-methylated DNA Set",
      subtitle: "D5014, D5014-1, D5014-2",
      description:
        "Methylated and non-methylated DNA controls with primer sets to assess bisulfite conversion efficiency and for DNA methylation quantification.",
      handle: "/products/human-methylated-non-methylated-dna-set-dna-w-primers",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5014_Human-Methylated-and-Non-Methylated-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Bisulfite-Converted Universal Methylated Human DNA Standard",
      subtitle: "D5015",
      description: "Control DNA for DNA methylation quantitation.",
      handle:
        "/products/bisulfite-converted-universal-methylated-human-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5015_Bisulfite-Converted-Universal-Methylated-HUman-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>E. coli</i> Non-Methylated Genomic DNA",
      subtitle: "D5016",
      description:
        "Control for bisulfite conversion and DNA methylation quantitation",
      handle: "/products/e-coli-non-methylated-genomic-dna",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5016_E-Coli-Non-Methylated-Genomic-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated & Non-methylated pUC19 DNA Set",
      subtitle: "D5017",
      description:
        "Control for bisulfite conversion and DNA methylation quantitation",
      handle: "/products/methylated-non-methylated-puc19-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5017_Methylated-and-Non-Methylated-pUC19-DNA-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Human Matched DNA Set",
      subtitle: "D5018, D5018-1, D5018-2",
      description:
        "Control for Bisulfite conversion and DNA methylation quantitation",
      handle: "/products/human-matched-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5018_Human-Matched-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Mouse 5-hmC & 5-mC DNA Set",
      subtitle: "D5019, D5019-1, D5019-2, D5019-3, D5019-4",
      description:
        "Mouse DNA controls for bisulfite conversion and DNA methylation and hydroxymethylation quantitation.",
      handle: "/products/mouse-5hmc-5mc-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5019_Mouse-hmC-and-5-mC-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set",
      subtitle: "D5405",
      description:
        "Ideal control for cytosine modification studies including HPLC; LC/MS; TLC",
      handle:
        "/products/5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5405_5-mC & 5-hmC DNA Standard Set.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Zymo-Seq Methyl Spike-in Control",
      subtitle: "D5500",
      description: "Standards for DNA methylation analysis workflows",
      handle: "/products/zymo-seq-methyl-spike-in-control",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/zymo-product-placeholder.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "DNA/RNA Isolation": [
    {
      title: "<i>Quick</i>-DNA/RNA Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "Isolation of high quality genomic DNA and total RNA from cells, tissue, blood, biological fluids, etc. ",
      handle: "/collections/quick-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "<i>Quick</i>-DNA/RNA Pathogen kits simplify purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      handle: "/collections/quick-dna-rna-pathogen-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      subtitle: "R1009",
      description: "DNA and RNA from FFPE tissue",
      handle: "/products/quick-dna-rna-ffpe-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral Kits",
      subtitle: "DNA/RNA Purification",
      description:
        "The Quick-DNA/RNA Viral kits are viral DNA/RNA purification kits that provide for rapid isolation of high-quality viral nucleic acids from a wide range of biological sources.",
      handle: "/collections/quick-dna-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Direct-zol RNA Kits",
      subtitle: "RNA",
      description:
        "RNA purification kits that provide purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRIzol or Tri Reagent in 7 minutes. Get a free RNA purification kits sample with free shipping. ",
      handle: "/collections/direct-zol-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Miniprep Kit",
      subtitle: "R2002",
      description:
        "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-dna-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "DNA/RNA Clean-Up": [
    {
      title: "ssDNA/RNA Clean & Concentrator",
      subtitle: "D7010, D7011",
      description:
        "Separation of single-stranded nucleic acids from double-stranded nucleic acids.",
      handle: "/products/ssdna-rna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "DNA/RNA Automated/High-Throughput": [
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      subtitle: "D7022, D7023",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral MagBead",
      subtitle: "R2140, R2141",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Load N’ Go DNA/RNA Viral Kit",
      subtitle: "R2143",
      description: "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      handle: "/products/load-n-go-dna-rna-viral-kit",
      isKit: true,
      ribbon: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      subtitle: "R2145, R2146",
      description:
        "Pathogen DNA/RNA isolation from vectors, tissue and biological samples.",
      handle: "/products/quick-dna-rna-pathogen-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 MagStand",
      subtitle: "P1005",
      description:
        "Separation of magnetic beads in standard 96-well format plates",
      handle: "/products/zr-96-magstand",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/p1005_ZR-96_MagStand.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Microbiomics: [
    {
        title: "<i>Quick</i>-16S  Full-Length Library Prep Kit",
        subtitle: "D6450-PS1 - D6450-PS4",
        description:
          "Delivers pooled and purified libraries ready for downstream sequencing on PacBio & Oxford Nanopore sequencing platforms in as little as 30 minutes of hands-on time",
        handle: "/products/quick-16s-full-length-library-prep-kit",
        isKit: true,
        image_url:
          "https://www.zymoresearch.com/cdn/shop/files/D6450-BQuick-16SFullLengthLibraryKit_1200x.webp?v=1735842064",
        searchWeight: 2,
        ribbon: true,
        tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3)",
        subtitle: "D6440-PS1",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v3",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6440-quick-16s_plus_ngs_library_prep_kit_v1-v3.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2)",
        subtitle: "D6434-PS1",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v2",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6434-quick-16S_plus_ngs_library_prep_kit_v1-v2.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
      subtitle: "D6421-PS1 - D6421-PS8",
      description:
        "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6421-quick_16s_plus_ngs_library_prep_kit_udi.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Microbial Community Standards",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS Microbial Community Standards are accurately characterized mock communities consisting of various bacteria and yeast used for microbiome/metagenome workflow optimization and as positive controls.",
      handle: "/collections/zymobiomics-microbial-community-standards",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6300_ZymoBIOMICS-Microbial-Community-Standard.jpg",
      searchWeight: 3,
      tags: ["DRY ICE"],
    },
    // {
    //   title: "Load N’ Go ZymoBIOMICS DNA MagBead Kit",
    //   subtitle: "D4311",
    //   description:
    //     "Streamline your microbiome studies with efficient DNA extraction using advanced pre-loaded plate technology.",
    //   handle: "/products/load-n-go-zymobiomics-dna-magbead-kit",
    //   isKit: true,
    //   image_url: "https://files.zymoresearch.com/product-images/D4311-Load-N-Go-ZymoBIOMICS-DNA-MagBead.jpg",
    //   searchWeight: 0,
    //   ribbon: true,
    //   tags: [],
    // },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V4)",
      subtitle: "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
      description:
        "Fastest, normalization-free 16S library prep",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v4",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Miniprep Kit",
      subtitle: "R2002",
      description:
        "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-dna-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS RNA Miniprep Kit",
      subtitle: "R2001",
      description:
        "Purification of microbial RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Femto DNA Quantification Kits",
      subtitle: "DNA",
      description:
        "Detect and quantify human, bacterial, and fungal DNA with high specificity and sensitivity. ",
      handle: "/collections/femto-dna-quantification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2005_Femto-Human-DNA-Quantification-Kit.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "ZymoBIOMICS Targeted Sequencing Service: 16S",
      subtitle: "Q2001, Q2012, Q2003, Q2013",
      description:
        "A complete solution for unbiased microbiome profiling with species-level resolution.",
      handle: "/products/zymobiomics-targeted-sequencing-service-16s",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/3_pages_report_example.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Oral Microbiome Standard",
      subtitle: "D6332",
      description:
        "The ZymoBIOMICS Oral Microbiome Standard is a mixture of 12 bacterial strains in staggered abundances to mimic a true oral microbiome.",
      handle: "/products/zymobiomics-oral-microbiome-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_d6332_zymobiomics_oral_microbiome_standard.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Microbial Sample Collection": [
    {
      title: "Fecal Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "/pages/sample-collection-kits?tags=feces",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      searchWeight: 2,
      ids: "35,37,38",
      tags: [],
    },
    {
      title: "DNA/RNA Shield Collection Tube w/ Swab",
      subtitle: "R1106, R1107, R1108, R1109",
      description:
        "Swab collection tube and transport medium for proper sample collection and stabilization",
      handle: "/products/dna-rna-shield-collection-tube-w-swab",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1106_DNA-RNA-Shield-Swab-Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield Lysis & Collection Tubes",
      subtitle: "R1102, R1103, R1104, R1105",
      description:
        "DNA/RNA transport tubes for any sample ready for homogenization.",
      handle: "/products/dna-rna-shield-lysis-and-collection-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1103-DNA-RNA-Shield-Lysis-Tube-(Microbe).jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield",
      subtitle: "R1100-25, R1100-50, R1100-125, R1100-250",
      description: "DNA/RNA transport medium for any sample",
      handle: "/products/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield Saliva Collection Kit",
      subtitle: "R1210",
      description: "DNA/RNA transport medium for saliva",
      handle: "/products/dna-rna-shield-saliva-collection-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1210_DNA-RNA-Shield-Saliva-Collection-Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Urine Conditioning Buffer",
      subtitle: "D3061-1-140",
      description: "Sample transport medium for urine",
      handle: "/products/urine-conditioning-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D3061-1-140-UCB-Bottle-140ml.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Microbial Standards": [
    {
      title: "ZymoBIOMICS Microbial Community Standards",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS Microbial Community Standards are accurately characterized mock communities consisting of various bacteria and yeast used for microbiome/metagenome workflow optimization and as positive controls.",
      handle: "/collections/zymobiomics-microbial-community-standards",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6300_ZymoBIOMICS-Microbial-Community-Standard.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
  ],
  "Microbial DNA Isolation": [
    {
      title: "ZymoBIOMICS DNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "HostZERO Microbial DNA Kit",
      subtitle: "Microbiomics",
      description:
        "Streamlined host depletion and bacterial DNA isolation from mammalian samples.",
      handle: "/products/hostzero-sup-trade-sup-microbial-dna-kit-microprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4310-A_HostZERO-Microbial-DNA-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
  ],
  "Microbial RNA Isolation": [
    {
      title: "ZymoBIOMICS RNA Miniprep Kit",
      subtitle: "R2001",
      description:
        "Purification of microbial RNA for microbiome or metagenome analyses.",
      handle: "/products/zymobiomics-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead RNA",
      subtitle: "R2137, R2138",
      description:
        "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
      handle: "/products/zymobiomics-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2137_zymobiomics-magbead-rna-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Microbial DNA/RNA Co-Purification": [
    {
      title: "ZymoBIOMICS DNA/RNA Miniprep Kit",
      subtitle: "R2002",
      description:
        "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-dna-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "<i>E. coli</i>": [
    {
      title:
        "<I>Mix &amp; Go!</i> <i>E. coli</i> Transformation Kit and Buffer Set",
      subtitle: "T3001, T3002",
      description:
        "Reagents for preparing your own <i>Mix &amp; Go!</i> Competent <i>E. coli</i> cells (chemically competent cells).",
      handle: "/products/mix-and-go-e-coli-transformation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3002_Mix-and-Go-E-Coli-Transformation-Buffer-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Mix & Go</i> Competent Cells",
      subtitle: "<i>E. coli</i>",
      description:
        "<i>Mix & Go</i> Competent Cells are chemically competent cells for simple, high-efficiency transformations without heat shock and lengthy incubations.",
      handle: "/collections/mix-go-competent-cells",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3013_Mix-and-Go-Competent-Cells-HB101.jpg",
      searchWeight: 3,
      tags: ["DRY ICE"],
    },
    {
      title: "XJ Autolysis <i>E. coli</i> strains",
      subtitle: "<i>E. coli</i>",
      description:
        "Chemically competent cells that offer a new alternative for bacterial transformation and lysis that simplify protein expression and purification.",
      handle: "/collections/xj-autolysis-e-coli-strains",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3051_XJb DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 3,
      tags: ["DRY ICE"],
    },
    {
      title: "Rattler Plating Beads",
      subtitle: "S1001, S1001-5, S1001-B",
      description: "4.5 mm glass plating beads for spreading inocula",
      handle: "/products/rattler-plating-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S1001-Rattler-Plating-Beads.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBroth",
      subtitle: "M3015-100, M3015-500",
      description:
        "Uniquely formulated growth medium for the preparation of highly competent <i>E. coli</i> cells.",
      handle: "/products/zymobroth",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3015-100-ZymoBroth.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Dual Media Set",
      subtitle: "M3011",
      description:
        "Simple, reliable method for high level recombinant protein expression in <i>E. coli</i>.",
      handle: "/products/dual-media-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3011_Dual-Media-Set-100-mL-EB-500-mL-OB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Ampicillin Sodium Solution",
      subtitle: "A1001-25, A1001-5",
      description: "Ready-to-use 100 mg/ml Ampicillin Sodium Solution",
      handle: "/products/ampicillin-sodium-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1001-5_Ampicilin - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Kanamycin Sulfate Solution",
      subtitle: "A1003-25, A1003-5",
      description: "Ready-to-use 35 mg/ml Kanamycin Sulfate Solution",
      handle: "/products/kanamycin-sulfate-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1003-5_Kanamycin Sulfate - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Chloramphenicol Solution",
      subtitle: "A1002-25, A1002-5",
      description: "Ready-to-use 10 mg/ml Chloramphenicol Solution",
      handle: "/products/chloramphenicol-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1002-5_Chloramphenicol - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "X-GAL (5-bromo-4-chloro-3-indolyl &beta;-D-galactopyranoside)",
      subtitle: "X1001-25, X1001-5",
      description:
        "Ready-to-use sterile solution for detecting β-galactosidase activity.",
      handle:
        "/products/x-gal-5-bromo-4-chloro-3-indolyl-beta-d-galactopyranoside",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/X1001-5_X-Gal-20-mG.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "500x L-Arabinose Solution",
      subtitle: "A2001-1, A2001-10",
      description:
        "Premade concentrated arabinose solution for induction of XJ Autolysis <i>E. coli</i> strains.",
      handle: "/products/l-arabinose-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A2001-1_Arabinose.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Tetracycline Hydrochloride Solution - Reagent Grade",
      subtitle: "A1004-25, A1004-5",
      description: "Ready-to-use 10 mg/ml Tetracycline Hydrochloride Solution",
      handle: "/products/tetracycline-hydrochloride-solution-reagent-grade",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/a1004-5_tetracycline_hydrochloride-5ml.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "IPTG (Isopropyl-&beta;-D-thiogalactopyranoside)",
      subtitle: "I1001-25, I1001-5",
      description:
        "0.5 M Premade sterile solution for induction of gene expression under control of the lac operon.",
      handle: "/products/iptg-isopropyl-b-d-thiogalactopyranoside",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/I1001-5_IPTG 5 ml.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Expansion Broth (EB)",
      subtitle: "M3012-100, M3012-500",
      description:
        "Unique growth medium designed to repress recombinant protein expression during cell expansion.",
      handle: "/products/expansion-broth-eb",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3012-100_Expansion-Broth-100-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Overexpression Broth(OB)",
      subtitle: "M3013-100, M3013-500",
      description:
        "Unique overexpression medium for high level recombinant protein expression.",
      handle: "/products/overexpression-broth-ob",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3013-100_Overexpression-Broth-100-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Chemically Competent Cells": [
    {
      title:
        "<I>Mix &amp; Go!</i> <i>E. coli</i> Transformation Kit and Buffer Set",
      subtitle: "T3001, T3002",
      description:
        "Reagents for preparing your own <i>Mix &amp; Go!</i> Competent <i>E. coli</i> cells (chemically competent cells).",
      handle: "/products/mix-and-go-e-coli-transformation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3002_Mix-and-Go-E-Coli-Transformation-Buffer-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Mix & Go</i> Competent Cells",
      subtitle: "<i>E. coli</i>",
      description:
        "<i>Mix & Go</i> Competent Cells are chemically competent cells for simple, high-efficiency transformations without heat shock and lengthy incubations.",
      handle: "/collections/mix-go-competent-cells",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3013_Mix-and-Go-Competent-Cells-HB101.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "XJ Autolysis <i>E. coli</i> strains",
      subtitle: "<i>E. coli</i>",
      description:
        "Chemically competent cells that offer a new alternative for bacterial transformation and lysis that simplify protein expression and purification.",
      handle: "/collections/xj-autolysis-e-coli-strains",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3051_XJb DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
  ],
  "Culture Media": [
    {
      title: "ZymoBroth",
      subtitle: "M3015-100, M3015-500",
      description:
        "Uniquely formulated growth medium for the preparation of highly competent <i>E. coli</i> cells.",
      handle: "/products/zymobroth",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3015-100-ZymoBroth.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Dual Media Set",
      subtitle: "M3011",
      description:
        "Simple, reliable method for high level recombinant protein expression in <i>E. coli</i>.",
      handle: "/products/dual-media-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3011_Dual-Media-Set-100-mL-EB-500-mL-OB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Expansion Broth (EB)",
      subtitle: "M3012-100, M3012-500",
      description:
        "Unique growth medium designed to repress recombinant protein expression during cell expansion.",
      handle: "/products/expansion-broth-eb",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/M3012-100_Expansion-Broth-100-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Overexpression Broth(OB)",
      subtitle: "M3013-100, M3013-500",
      description:
        "Unique overexpression medium for high level recombinant protein expression.",
      handle: "/products/overexpression-broth-ob",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/M3013-100_Overexpression-Broth-100-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Antibiotics & Chemicals": [
    {
      title: "Ampicillin Sodium Solution",
      subtitle: "A1001-25, A1001-5",
      description: "Ready-to-use 100 mg/ml Ampicillin Sodium Solution",
      handle: "/products/ampicillin-sodium-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1001-5_Ampicilin - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Kanamycin Sulfate Solution",
      subtitle: "A1003-25, A1003-5",
      description: "Ready-to-use 35 mg/ml Kanamycin Sulfate Solution",
      handle: "/products/kanamycin-sulfate-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1003-5_Kanamycin Sulfate - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Chloramphenicol Solution",
      subtitle: "A1002-25, A1002-5",
      description: "Ready-to-use 10 mg/ml Chloramphenicol Solution",
      handle: "/products/chloramphenicol-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1002-5_Chloramphenicol - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Tetracycline Hydrochloride Solution - Reagent Grade",
      subtitle: "A1004-25, A1004-5",
      description: "Ready-to-use 10 mg/ml Tetracycline Hydrochloride Solution",
      handle: "/products/tetracycline-hydrochloride-solution-reagent-grade",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/a1004-5_tetracycline_hydrochloride-5ml.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "X-GAL (5-bromo-4-chloro-3-indolyl &beta;-D-galactopyranoside)",
      subtitle: "X1001-25, X1001-5",
      description:
        "Ready-to-use sterile solution for detecting β-galactosidase activity.",
      handle:
        "/products/x-gal-5-bromo-4-chloro-3-indolyl-beta-d-galactopyranoside",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/X1001-5_X-Gal-20-mG.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "IPTG (Isopropyl-&beta;-D-thiogalactopyranoside)",
      subtitle: "I1001-25, I1001-5",
      description:
        "0.5 M Premade sterile solution for induction of gene expression under control of the lac operon.",
      handle: "/products/iptg-isopropyl-b-d-thiogalactopyranoside",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/I1001-5_IPTG 5 ml.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "500x L-Arabinose Solution",
      subtitle: "A2001-1, A2001-10",
      description:
        "Premade concentrated arabinose solution for induction of XJ Autolysis <i>E. coli</i> strains.",
      handle: "/products/l-arabinose-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A2001-1_Arabinose.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "PCR Reagents & DNA Ladders": [
    {
      title: "ZymoTaq Polymerase",
      subtitle: "Buffers",
      description:
        "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
      handle: "/collections/zymotaq-polymerase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2001_ZymoTaq-Polymerase.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "ZymoScript One-Step RT-qPCR Kit",
      subtitle: "R3014",
      description: "ZymoScript One-Step RT-qPCR Kit is an optimized RT-qPCR kit that contains all the components for fast reverse transcription and robust qPCR amplification in a single tube. The One-Step RT-qPCR kit is compatible with both SYBR Green and TaqMan probe-based assays.",
      handle: "/products/zymoscript-one-step-rt-qpcr-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3014-zymoscript_onestep_rt_qpcr_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "ZymoScript RT PreMix Kit",
      subtitle: "R3012",
      description: "ZymoScript RT PreMix Kit is part of the ZymoScript family together with the ZymoScript OneStep RT-qPCR Kit (R3014). ZymoScript RT PreMix is an optimized reverse transcription kit containing all the necessary components for quick and efficient cDNA synthesis.",
      handle: "/products/zymoscript-rt-premix-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3012-zymoscript_rt_prexix_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "dNTP Mix",
      subtitle: "D1000, D1000-1",
      description:
        "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/dntp-mix",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1000_dNTPs.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dCTP",
      subtitle: "D1020",
      description: "PCR nucleotides and mix",
      handle: "/products/dctp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1020_dCTP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dATP",
      subtitle: "D1005",
      description:
        "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/datp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1005_dATP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dTTP",
      subtitle: "D1010",
      description:
        "dTTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/dttp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1010_dTTP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dGTP",
      subtitle: "D1015",
      description:
        "dGTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/dgtp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1015_dGTP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "ZR 50 bp DNA Marker",
      subtitle: "M5001-50, M5001-200, M5004-50",
      description:
        "The 50 bp DNA marker consists of plasmid DNA that has been digested with endonucleases to yield 12 defined fragments.",
      handle: "/products/zr-50-bp-dna-marker",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M5001-50_ZR-50-bp-DNA-Marker-50-ug.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR 100 bp DNA Marker",
      subtitle: "M5002-50, M5002-200, M5005-50",
      description:
        "The 100 bp DNA marker consists of plasmid DNA that has been digested with endonucleases to yield 12 defined fragments.",
      handle: "/products/zr-50-bp-dna-marker",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M5002-200_ZR_20100_20bp_20DNA_20Marker_20-_20200_20ug.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR 1 kb DNA Marker",
      subtitle: "M5003-50, M5003-200, M5006-50",
      description:
        "The 1 kb DNA marker consists of plasmid DNA that has been digested with endonucleases to yield 10 defined fragments.",
      handle: "/products/zr-50-bp-dna-marker",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M5003-50_ZR-1-kb-DNA-Marker-50-ug.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  Yeast: [
    {
      title: "Zymolyase",
      subtitle: "E1004, E1005, E1006",
      description:
        "Yeast lytic enzyme for simple and effective digestion of fungal cell walls.",
      handle: "/products/zymolyase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1005_Zymolayse-2000-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep Yeast Plasmid Miniprep Kits",
      subtitle: "Yeast",
      description:
        "The fastest and simplest solutions for purifying the highest quality plasmid DNA from yeast.",
      handle: "/collections/zymoprep-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Frozen-EZ Yeast Transformation II Kit",
      subtitle: "T2001",
      description:
        "Quickly and simply make competent yeast cells for highly efficient transformations.",
      handle: "/products/frozen-ez-yeast-transformation-ii-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T2001_Frozen-EZ-Yeast-Transformation-II-Kit.jpg",
      searchWeight: 0,
      tags: ["No Ground Shipping"],
    },
    {
      title: "YPD Plus",
      subtitle: "Y1003-100, Y1003-50",
      description:
        "Specialized medium for yeast outgrowth to increase yeast transformation efficiencies.",
      handle: "/products/ypd-plus",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Y1003-50-YPD-Plus.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "YeaStar RNA Kit",
      subtitle: "R1002",
      description:
        "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      handle: "/products/yeastar-rna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Alpha-Factor Mating Pheromone",
      subtitle: "Y1001",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle.",
      handle: "/products/alpha-factor-mating-pheromone",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1001_Alpha-Factor-Mating-Pheromone.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "a-Factor Mating Pheromone",
      subtitle: "Y1004-500",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle. Opposite to the alpha-factor mating pheromone.",
      handle: "/products/a-factor-mating-pheromone",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1004_a-Factor-Mating-Pheromone-A-Factor-500-ul.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Yeast Protein Kit",
      subtitle: "Y1002",
      description:
        "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
      handle: "/products/yeast-protein-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "DNA",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "5-Fluoroorotic Acid (5-FOA)",
      subtitle: "F9001-1, F9001-5, F9003",
      description: "Convenient yeast genetic counter-selection agent.",
      handle: "/products/5-fluoroorotic-acid",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/F9001-1_5-Fluoroorotic-Acid-1-g.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Yeast DNA Isolation": [
    {
      title: "Zymoprep Yeast Plasmid Miniprep Kits",
      subtitle: "Yeast",
      description:
        "The fastest and simplest solutions for purifying the highest quality plasmid DNA from yeast.",
      handle: "/collections/zymoprep-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "DNA",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Yeast RNA Isolation": [
    {
      title: "YeaStar RNA Kit",
      subtitle: "R1002",
      description:
        "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      handle: "/products/yeastar-rna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Yeast Protein Isolation": [
    {
      title: "Yeast Protein Kit",
      subtitle: "Y1002",
      description:
        "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
      handle: "/products/yeast-protein-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Yeast Transformation": [
    {
      title: "Frozen-EZ Yeast Transformation II Kit",
      subtitle: "T2001",
      description:
        "Quickly and simply make competent yeast cells for highly efficient transformations.",
      handle: "/products/frozen-ez-yeast-transformation-ii-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T2001_Frozen-EZ-Yeast-Transformation-II-Kit.jpg",
      searchWeight: 0,
      tags: ["No Ground Shipping"],
    },
    {
      title: "YPD Plus",
      subtitle: "Y1003-100, Y1003-50",
      description:
        "Specialized medium for yeast outgrowth to increase yeast transformation efficiencies.",
      handle: "/products/ypd-plus",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Y1003-50-YPD-Plus.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Yeast Reagents and Enzymes": [
    {
      title: "Zymolyase Ultra",
      subtitle: "E1007T, E1007-2, E1007-10",
      description: "Ultra fast & Ultra clean.",
      handle: "/products/zymolyase-ultra",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1007T-Zymolyase-Ultra-100-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymolyase",
      subtitle: "E1004, E1005, E1006",
      description:
        "Yeast lytic enzyme for simple and effective digestion of fungal cell walls.",
      handle: "/products/zymolyase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1005_Zymolayse-2000-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-Fluoroorotic Acid (5-FOA)",
      subtitle: "F9001-1, F9001-5, F9003",
      description: "Convenient yeast genetic counter-selection agent.",
      handle: "/products/5-fluoroorotic-acid",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/F9001-1_5-Fluoroorotic-Acid-1-g.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Alpha-Factor Mating Pheromone",
      subtitle: "Y1001",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle.",
      handle: "/products/alpha-factor-mating-pheromone",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1001_Alpha-Factor-Mating-Pheromone.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "a-Factor Mating Pheromone",
      subtitle: "Y1004-500",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle. Opposite to the alpha-factor mating pheromone.",
      handle: "/products/a-factor-mating-pheromone",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1004_a-Factor-Mating-Pheromone-A-Factor-500-ul.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "YPD Plus",
      subtitle: "Y1003-100, Y1003-50",
      description:
        "Specialized medium for yeast outgrowth to increase yeast transformation efficiencies.",
      handle: "/products/ypd-plus",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Y1003-50-YPD-Plus.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Protein & Enzymes": [
    {
      title: "Endura Tn5 Transposase",
      subtitle: "E1024-20, E1024-100, E1024-4-5, E1025-20, E1025-100",
      description: "Highly Stable & Compatible with Any Adapter.",
      handle: "/products/endura-tn5-transposase-unloaded",
      isKit: false,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/photo1_600x.webp?v=1750810168",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymolyase Ultra",
      subtitle: "E1007T, E1007-2, E1007-10",
      description: "Ultra fast & Ultra clean.",
      handle: "/products/zymolyase-ultra",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1007T-Zymolyase-Ultra-100-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "PureRec Duplex-Specific Nuclease (DSN)",
      subtitle: "E1020-200, E1020-1000",
      description: "Highly selective for dsDNA. RNase-free and protease-free.",
      handle: "/products/purerec-duplex-specific-nuclease-dsn",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/e1020-200_9182b.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "PureRec RNase A (Recombinant)",
      subtitle: "E1019T, E1019-5, E1019-20",
      description: "Recombinant, DNase-free & Animal-free.",
      handle: "/products/purerec-rnase-a-recombinant",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1019T_purerec_rnase_a_1mg.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "XJ Autolysis <i>E. coli</i> strains",
      subtitle: "<i>E. coli</i>",
      description:
        "Chemically competent cells that offer a new alternative for bacterial transformation and lysis that simplify protein expression and purification.",
      handle: "/collections/xj-autolysis-e-coli-strains",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3051_XJb DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "His-Spin Protein Miniprep",
      subtitle: "P2001, P2002",
      description:
        "Fast and simple spin-column method for purifying His-tagged proteins from cell lysates.",
      handle: "/products/his-spin-protein-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P2002_His-Spin-Protein-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Yeast Protein Kit",
      subtitle: "Y1002",
      description:
        "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
      handle: "/products/yeast-protein-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymolyase",
      subtitle: "E1004, E1005, E1006",
      description:
        "Yeast lytic enzyme for simple and effective digestion of fungal cell walls.",
      handle: "/products/zymolyase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1005_Zymolayse-2000-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase I Set",
      subtitle: "E1010",
      description:
        "Enzyme and digestion buffer used for cutting both double stranded and single-stranded DNA.",
      handle: "/products/dnase-i-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E1010_DNase-I-Set-lyophilized.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoTaq Polymerase",
      subtitle: "Buffers",
      description:
        "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
      handle: "/collections/zymotaq-polymerase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2001_ZymoTaq-Polymerase.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase Plus",
      subtitle: "E2020, E2021",
      description: "Complete digestion of DNA into individual nucleosides.",
      handle: "/products/dna-degradase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2020_DNA-Degradase-Plus.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Dual Media Set",
      subtitle: "M3011",
      description:
        "Simple, reliable method for high level recombinant protein expression in <i>E. coli</i>.",
      handle: "/products/dual-media-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3011_Dual-Media-Set-100-mL-EB-500-mL-OB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "dsDNA Shearase Plus",
      subtitle: "E2018-200, E2018-50",
      description:
        "Simply control fragment size of dsDNA by adjusting the concentration of dsDNA Shearase Plus.",
      handle: "/products/dsdna-shearase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2018-50_dsDNA-Shearase-Plus-50-U.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "RNase A",
      subtitle: "E1008-24, E1008-30, E1008-8",
      description:
        "Used for RNA hydrolysis and compatible with a variety of applications.",
      handle: "/products/rnase-a",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1008-8-RNase A - 8 mg.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "CpG Methylase (M. Sssl)",
      subtitle: "E2010, E2011",
      description:
        "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
      handle: "/products/cpg-methylase-m-sssl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2010_CpG-Methylase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Atlantis dsDNase",
      subtitle: "E2030",
      description:
        "Atlantis dsDNase ensures digestion of dsDNA to yield homogeneous populations of core nucleosomes.",
      handle: "/products/atlantis-ds-dnase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030_Atlantis-dsDNase-12.5-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Proteinase K w/ Storage Buffer Set",
      subtitle: "D3001-2-20, D3001-2-5",
      description:
        "Proteinase K is used in molecular biology applications to digest unwanted proteins such as nuclease",
      handle: "/products/proteinase-k-w-storage-buffer-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001-2-20_Proteinase-K-lyophilized-20-mg.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-hmC Glucosyltransferase",
      subtitle: "E2026, E2027",
      description: "5-hmC detection; 5-hmC enrichment",
      handle: "/products/5-hmc-glucosyltransferase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2026_5-hmC-Glucosyltransferase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Micrococcal Nuclease",
      subtitle: "D5220-1",
      description: "Cleaves single-stranded and double-stranded DNA and RNA. Complete digestion with Micrococcal Nuclease yields mono- and oligonucleotides with 3'-phosphates.",
      handle: "/products/micrococcal-nuclease",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5220-1_Micrococcal-Nuclease.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase",
      subtitle: "E2016, E2017",
      description: "Complete digestion of DNA into individual nucleotides",
      handle: "/products/dna-degradase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2016_DNA-Degradase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  Enzymes: [
    {
      title: "Endura Tn5 Transposase",
      subtitle: "E1024-20, E1024-100, E1024-4-5, E1025-20, E1025-100",
      description: "Highly Stable & Compatible with Any Adapter.",
      handle: "/products/endura-tn5-transposase-unloaded",
      isKit: false,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/photo1_600x.webp?v=1750810168",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymolyase Ultra",
      subtitle: "E1007T, E1007-2, E1007-10",
      description: "Ultra fast & Ultra clean.",
      handle: "/products/zymolyase-ultra",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1007T-Zymolyase-Ultra-100-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "PureRec Duplex-Specific Nuclease (DSN)",
      subtitle: "E1020-200, E1020-1000",
      description: "Highly selective for dsDNA. RNase-free and protease-free.",
      handle: "/products/purerec-duplex-specific-nuclease-dsn",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/e1020-200_9182b.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "PureRec RNase A (Recombinant)",
      subtitle: "E1019T, E1019-5, E1019-20",
      description: "Recombinant, DNase-free & Animal-free.",
      handle: "/products/purerec-rnase-a-recombinant",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1019T_purerec_rnase_a_1mg.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymolyase",
      subtitle: "E1004, E1005, E1006",
      description:
        "Yeast lytic enzyme for simple and effective digestion of fungal cell walls.",
      handle: "/products/zymolyase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1005_Zymolayse-2000-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase I Set",
      subtitle: "E1010",
      description:
        "Enzyme and digestion buffer used for cutting both double stranded and single-stranded DNA.",
      handle: "/products/dnase-i-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E1010_DNase-I-Set-lyophilized.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoTaq Polymerase",
      subtitle: "Buffers",
      description:
        "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
      handle: "/collections/zymotaq-polymerase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2001_ZymoTaq-Polymerase.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase Plus",
      subtitle: "E2020, E2021",
      description: "Complete digestion of DNA into individual nucleosides.",
      handle: "/products/dna-degradase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2020_DNA-Degradase-Plus.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dsDNA Shearase Plus",
      subtitle: "E2018-200, E2018-50",
      description:
        "Simply control fragment size of dsDNA by adjusting the concentration of dsDNA Shearase Plus.",
      handle: "/products/dsdna-shearase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2018-50_dsDNA-Shearase-Plus-50-U.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "RNase A",
      subtitle: "E1008-24, E1008-30, E1008-8",
      description:
        "Used for RNA hydrolysis and compatible with a variety of applications.",
      handle: "/products/rnase-a",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1008-8-RNase A - 8 mg.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "CpG Methylase (M. Sssl)",
      subtitle: "E2010, E2011",
      description:
        "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
      handle: "/products/cpg-methylase-m-sssl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2010_CpG-Methylase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Atlantis dsDNase",
      subtitle: "E2030",
      description:
        "Atlantis dsDNase ensures digestion of dsDNA to yield homogeneous populations of core nucleosomes.",
      handle: "/products/atlantis-ds-dnase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030_Atlantis-dsDNase-12.5-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Proteinase K w/ Storage Buffer Set",
      subtitle: "D3001-2-20, D3001-2-5",
      description:
        "Proteinase K is used in molecular biology applications to digest unwanted proteins such as nuclease",
      handle: "/products/proteinase-k-w-storage-buffer-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001-2-20_Proteinase-K-lyophilized-20-mg.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-hmC Glucosyltransferase",
      subtitle: "E2026, E2027",
      description: "5-hmC detection; 5-hmC enrichment",
      handle: "/products/5-hmc-glucosyltransferase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2026_5-hmC-Glucosyltransferase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase",
      subtitle: "E2016, E2017",
      description: "Complete digestion of DNA into individual nucleotides",
      handle: "/products/dna-degradase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2016_DNA-Degradase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Micrococcal Nuclease",
      subtitle: "D5220-1",
      description: "Cleaves single-stranded and double-stranded DNA and RNA. Complete digestion with Micrococcal Nuclease yields mono- and oligonucleotides with 3'-phosphates.",
      handle: "/products/micrococcal-nuclease",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5220-1_Micrococcal-Nuclease.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Lytic Enzymes": [
    {
      title: "Zymolyase Ultra",
      subtitle: "E1007T, E1007-2, E1007-10",
      description: "Ultra fast & Ultra clean.",
      handle: "/products/zymolyase-ultra",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1007T-Zymolyase-Ultra-100-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymolyase",
      subtitle: "E1004, E1005, E1006",
      description:
        "Yeast lytic enzyme for simple and effective digestion of fungal cell walls.",
      handle: "/products/zymolyase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1005_Zymolayse-2000-U.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Proteases": [
    {
      title: "Proteinase K w/ Storage Buffer Set",
      subtitle: "D3001-2-20, D3001-2-5",
      description:
        "Proteinase K is used in molecular biology applications to digest unwanted proteins such as nuclease",
      handle: "/products/proteinase-k-w-storage-buffer-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001-2-20_Proteinase-K-lyophilized-20-mg.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Bacterial Expression Strains": [
    {
      title: "XJ Autolysis <i>E. coli</i> strains",
      subtitle: "<i>E. coli</i>",
      description:
        "Chemically competent cells that offer a new alternative for bacterial transformation and lysis that simplify protein expression and purification.",
      handle: "/collections/xj-autolysis-e-coli-strains",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3051_XJb DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Culture Media for Protein Expression": [
    {
      title: "Dual Media Set",
      subtitle: "M3011",
      description:
        "Simple, reliable method for high level recombinant protein expression in <i>E. coli</i>.",
      handle: "/products/dual-media-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3011_Dual-Media-Set-100-mL-EB-500-mL-OB.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Tagged Protein Purification": [
    {
      title: "His-Spin Protein Miniprep",
      subtitle: "P2001, P2002",
      description:
        "Fast and simple spin-column method for purifying His-tagged proteins from cell lysates.",
      handle: "/products/his-spin-protein-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P2002_His-Spin-Protein-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Purification: [
    {
      title: "Zymolyase",
      subtitle: "E1004, E1005, E1006",
      description:
        "Yeast lytic enzyme for simple and effective digestion of fungal cell walls.",
      handle: "/products/zymolyase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1005_Zymolayse-2000-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase I Set",
      subtitle: "E1010",
      description:
        "Enzyme and digestion buffer used for cutting both double stranded and single-stranded DNA.",
      handle: "/products/dnase-i-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E1010_DNase-I-Set-lyophilized.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RNase A",
      subtitle: "E1008-24, E1008-30, E1008-8",
      description:
        "Used for RNA hydrolysis and compatible with a variety of applications.",
      handle: "/products/rnase-a",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1008-8-RNase A - 8 mg.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Proteinase K w/ Storage Buffer Set",
      subtitle: "D3001-2-20, D3001-2-5",
      description:
        "Proteinase K is used in molecular biology applications to digest unwanted proteins such as nuclease",
      handle: "/products/proteinase-k-w-storage-buffer-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001-2-20_Proteinase-K-lyophilized-20-mg.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Sample Collection Kits and Devices": [
    {
      title: "DNA/RNA Shield",
      subtitle: "Reagent Sample Transport Medium",
      description: "DNA/RNA Shield reagent is a nucleic acid transport and storage medium for any sample. Free sample available for validation with free shipping.",
      handle: "/collections/dna-rna-shield",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.jpg",
      image_alt: "DNA/RNA Shield Reagent Sample Transport Medium",
      searchWeight: 2,
      tags: []
    },
    {
      title: "Swab Collection",
      subtitle: "Kits and Individual Swabs",
      description: "Swab sample collection kits with stabilizing medium and individually wrapped sterile swabs.",
      handle: "/pages/sample-collection-kits?tags=mouth-nose-and-throat",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r1107-dna-rna-shield-collection-tube-with-swab-fda-eua-ce-ivd.jpg",
      image_alt: "Swab Sample Collection Kit for Diagnostic Use",
      searchWeight: 2,
      tags: []
    },
    {
      title: "Saliva Collection",
      subtitle: "Kits for Research and Diagnostic Uses",
      description: "Saliva microbial sample collection kits designed for the collection and preservation of nucleic acids from spit samples.",
      handle: "/pages/sample-collection-kits?tags=saliva",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r1210-dna-rna-shield-saliva-collection-kit-ce-ivd.jpg",
      image_alt: "Saliva Sample Collection Kits for Research and Diagnostic Uses",
      searchWeight: 0,
      tags: []
    },
    {
      title: "Fecal Collection",
      subtitle: "Sample Collection Kits and Devices",
      description: "Devices and kits for sample collection and analysis of stool samples for research and diagnostic use. Reagent included.",
      handle: "/pages/sample-collection-kits?tags=feces",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r1101-dna-rna-shield-fecal-collection-tube-ce-ivd.png",
      image_alt: "Fecal sample collection device",
      searchWeight: 2,
      tags: []
    },
    {
      title: "Blood Collection",
      subtitle: "Sample Collection Kits and Devices",
      description: "Sample collection tubes and kits for the collection and analysis of whole blood samples. Kits allow for simple preparation and isolation.",
      handle: "/pages/sample-collection-kits?tags=blood",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      image_alt: "Blood sample collection tube",
      searchWeight: 3,
      tags: []
    },
    {
      title: "Urine Collection",
      subtitle: "Sample Collection Kits and Devices",
      description: "Devices and buffer for the collection of urine samples. Buffer allows stabilization of DNA and RNA during transport or storage.",
      handle: "pages/sample-collection-kits?tags=urine",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/D3062-1_Urine-Collection-Cup.jpg",
      image_alt: "Urine sample collection device",
      searchWeight: 3,
      tags: []
    },
    {
      title: "Environmental/Vector Collection",
      subtitle: "Sample Collection Devices and Tubes",
      description: "Collection tubes and reagents for the collection and stabilization of environmental samples, including insects, etc.",
      handle: "/pages/sample-collection-kits?tags=environmental-vector",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/R1103-DNA-RNA-Shield-Lysis-Tube-(Microbe).jpg",
      image_alt: "Environmental sample collection lysis tube",
      searchWeight: 3,
      tags: []
    },
    {
      title: "Tissue Collection",
      subtitle: "Sample Collection Devices and Tubes",
      description: "Devices for the collection of tissue samples. DNA and RNA integrity remains unchanged without the need for cold-chain.",
      handle: "/pages/sample-collection-kits?tags=tissue",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg",
      image_alt: "Tissue sample collection lysis tube",
      searchWeight: 3,
      tags: []
    },
    {
      title: "Bulk Reagents",
      subtitle: "Volume Order Discounts",
      description: "Bulk reagent cost savings, quick-access and reliability for long term projects.",
      handle: "/collections/bulk-reagents",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.jpg",
      image_alt: "DNA/RNA Shield and Other Reagents Available for Bulk Orders",
      searchWeight: 2,
      tags: []
    },
    {
      title: "Biohazard Bags",
      subtitle: "Sample Collection Kits and Devices",
      description: "Biohazard Bags that feature a reclosable zipper made of Clear polyethylene with three-wall construction and large printed biohazard graphic.",
      handle: "/products/biohazard-bags",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/p3000_1_10_biohazard_bag_with_absorbant_pad_10_pack.jpg",
      image_alt: "Pack of 10 Biohazard Bags",
      searchWeight: 2,
      tags: []
    }
  ],
  "Bulk Reagent": [
    {
      title: "DNA/RNA Shield",
      subtitle: "Sample Collection",
      description:
        "DNA/RNA Shield products are DNA and RNA transport and storage mediums for any biological samples. Get free samples with free shipping.",
      handle: "/collections/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Urine Conditioning Buffer",
      subtitle: "D3061-1-8, D3061-1-140",
      description: "Sample transport medium for urine",
      handle: "/products/urine-conditioning-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D3061-1-140-UCB-Bottle-140ml.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Fecal Collection": [
    {
      title: "DNA/RNA Shield Fecal Collection Tube",
      subtitle: "R1101",
      description: "DNA/RNA transport medium for stool samples",
      handle: "/products/dna-rna-shield-fecal-collection-tube",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Feces Catcher",
      subtitle: "R1101-1-10",
      description: "Easy and hygienic collection of human fecal samples.",
      handle: "/products/feces-catcher",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/r1101-1-10_feces_catcher.png",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Blood Collection": [
    {
      title: "DNA/RNA Shield Blood Collection Tube",
      subtitle: "R1150",
      description: "DNA/RNA transport medium for whole blood",
      handle: "/products/dna-rna-shield-blood-collection-tube",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Swab Collection": [
    {
      title: "Zymo Collection Swab",
      subtitle: "C1052-50, C1053-50",
      description:
        "The Zymo Collection Swab allows the collection of samples from the mouth, nose, and throat. Samples can also be collected where a swab may be deemed appropriate per application",
      handle: "/products/sterile-collection-swab",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/c1052-50_zymo_collection_swab.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield Collection Tube w/ Swab",
      subtitle: "R1106, R1107, R1108, R1109",
      description:
        "Swab collection tube and transport medium for proper sample collection and stabilization",
      handle: "/products/dna-rna-shield-collection-tube-w-swab",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1106_DNA-RNA-Shield-Swab-Tube.png",
      searchWeight: 2,
      tags: [],
    }
  ],
  "Lysis Tubes": [
    {
      title: "DNA/RNA Shield Lysis & Collection Tubes",
      subtitle: "R1102, R1103, R1104, R1105",
      description:
        "DNA/RNA transport tubes for any sample ready for homogenization.",
      handle: "/products/dna-rna-shield-lysis-and-collection-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1103-DNA-RNA-Shield-Lysis-Tube-(Microbe).jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (2 mm)",
      subtitle: "S6003-50",
      description: "2.0 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashing-bead-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
      subtitle: "S6012-50",
      description:
        "0.1 & 0.5 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/S6012-50_ZR-BashingBead-Lysis-Tubes.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
      subtitle: "S6014-50",
      description:
        "0.1 & 2.0 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zr_bashingbead_lysis_tubes_2.0_mm_s6003-50__1.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Saliva Collection": [
    {
      title: "DNA/RNA Shield Saliva Collection Kit",
      subtitle: "R1210",
      description: "DNA/RNA transport medium for saliva",
      handle: "/products/dna-rna-shield-saliva-collection-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1210_DNA-RNA-Shield-Saliva-Collection-Kit.png",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Urine Collection": [
    {
      title: "Urine Collection Kit",
      subtitle: "D3062",
      description:
        "Kit for the collection and preservation of DNA and RNA in urine.",
      handle: "/products/urine-collection-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3062_Urine-Collection-Kit-with-Urine-Conditioning-Buffer.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Urine Conditioning Buffer",
      subtitle: "D3061-1-8, D3061-1-140",
      description: "Sample transport medium for urine",
      handle: "/products/urine-conditioning-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D3061-1-140-UCB-Bottle-140ml.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Urine Collection Cup",
      subtitle: "D3062-1",
      description: "Plastic urine collection cup for collecting urine.",
      handle: "/products/urine-collection-cup",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D3062-1_Urine-Collection-Cup.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Columns & Plastics": [
    {
      title: "ZymoPURE Filter Plate",
      subtitle: "C2022, C2022-1",
      description:
        "High-throughput clarification of bacterial lysates.",
      handle: "/products/zymopure-filter-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2022_ZymoPURE-Filter-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Spin P-96 Plate",
      subtitle: "C2023, C2023-1",
      description:
        "High-throughput plasmid DNA purification spin-plate.",
      handle: "/products/zymo-spin-p-96-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2023_Zymo-Spin-P-96-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Wash Plate",
      subtitle: "C2024, C2024-1",
      description:
        "96-well plate for minimizing cross-contamination during high-throughput processing.",
      handle: "/products/wash-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2024_Wash-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96-Well 2.0 mL Deep Well Plate",
      subtitle: "C2015, C2015-50",
      description:
        "96-Well Plate for Liquid Handling Robots",
      handle: "/products/96-well-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2015-2_96-Well-2.0-ml-Deep-Well-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Elution Plate (V-Bottom, 200 µL)",
      subtitle: "C1030, C1030-50",
      description:
        "96-Well Polypropylene Elution Plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-elution-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C1030_96_elution_plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Deep Well Plate (V-Bottom, 2.2ml)",
      subtitle: "C2018-5, C2018-50",
      description:
        "96-Well Polypropylene plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-deep-well-plate-v-bottom-2-2ml",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2018_ZRC_2164.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96 Tip Combs (For V-Bottom Deep Well Plate)",
      subtitle: "C2019, C2019-100",
      description:
        "96 Tip Comb for Magnetic Bead Moving Instruments",
      handle: "/products/96-tip-combs-for-v-bottom-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2019_ZRC_2146.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I Columns",
      subtitle: "C1003-250, C1003-50",
      description:
        "Uncapped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in &ge; 6 &micro;l.",
      handle: "/products/zymo-spin-i-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1003-Zymo-Spin-I.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC Columns",
      subtitle: "C1004-250, C1004-50",
      description:
        "Capped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in ≥ 6 &micro;l.",
      handle: "/products/zymo-spin-ic-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1004-Zymo-Spin-IC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XL",
      subtitle: "C1002-25, C1002-50",
      description:
        "Capped columns for the recovery of large-sized DNA in &ge; 10 &micro;l.",
      handle: "/products/zymo-spin-ic-xl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1002-50-Zymo-Spin-IC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XM Columns",
      subtitle: "C1103-50",
      description: "",
      handle: "/products/zymo-spin-ic-xm-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1103-50_Zymo-Spin IC-XM Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-S Columns",
      subtitle: "C1015-25, C1015-50",
      description:
        "The Zymo-Spin IC-S features durable polypropylene construction and contains a unique silica-based matrix that allows purification",
      handle: "/products/zymo-spin-ic-s-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1015-50-Zymo-Spin-IC-S.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB Columns",
      subtitle: "C1014-250, C1014-50",
      description: "Columns for nucleic acid purification and dye removal.",
      handle: "/products/zymo-spin-ib-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1014-Zymo-Spin-IB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin P1 Columns",
      subtitle: "P2003-1",
      description: "Columns for purification of His-tagged proteins.",
      handle: "/products/zymo-spin-p1-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zymo-spin_pi_c2003-1_.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II Columns",
      subtitle: "C1008-250, C1008-50",
      description:
        "Uncapped columns for the recovery of &le; 25 &micro;g  DNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-ii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1008-50-Zymo-Spin-II.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIC Columns",
      subtitle: "C1011-250, C1011-50",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iic-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1011-50-OPEN-CAP-Zymo-Spin-IIC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIN Columns",
      subtitle: "C1019-250, C1019-50",
      description:
        "Uncapped columns for the recovery of &le;  25 µg  DNA in &ge; 30 &micro;l.",
      handle: "/products/zymo-spin-iin-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1019-Zymo-Spin-IIN.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-µHRC Filters",
      subtitle: "C1059-50",
      description: "For use with Zymo Research products.",
      handle: "/products/zymo-spin-ii-µhrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1059_Zymo Spin II-HRC.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-P Columns",
      subtitle: "C1055-50",
      description: "",
      handle: "/products/zymo-spin-ii-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1055-50_Zymo-Spin II-P Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III Columns",
      subtitle: "C1005-250, C1005-50",
      description:
        "The Zymo-Spin III features durable polypropylene construction that allows purification of up to 25 &micro;g DNA or RNA in &ge; 35 &micro;l eluate.",
      handle: "/products/zymo-spin-iii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1005-Zymo-Spin-III.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIICG Columns",
      subtitle: "C1006-250-G, C1006-50-G",
      description: "",
      handle: "/products/zymo-spin-iiicg-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-G-Zymo-Spin-IIICG.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-F Filters",
      subtitle: "C1057-50",
      description: "For use in Zymo Research environmental purification kits.",
      handle: "/products/zymo-spin-iii-f-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1057-Zymo-Spin-III-F.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-HRC Filters",
      subtitle: "C1058-50",
      description: "",
      handle: "/products/zymo-spin-iii-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1058-Zymo-Spin-III-HRC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV-IR HRC Filters",
      subtitle: "C1010-50",
      description: "",
      handle: "/products/zymo-spin-iv-ir-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1010-50_Zymo-Spin-IV-IR-HRC-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "Zymo-Spin III-P Column Assembly w/ 15 ml and 50 ml Reservoir (5 Pack)",
      subtitle: "C1040-5",
      description: "",
      handle:
        "/products/zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1040-5-Zymo-Spin-III-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-S Columns w/ LuerLock Caps and 15 ml Reservoir",
      subtitle: "C1049-25",
      description: "",
      handle:
        "/products/zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/(3) Zymo Spin IIIS.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV Columns",
      subtitle: "C1007-250, C1007-50",
      description: "",
      handle: "/products/zymo-spin-iv-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/c1007-50-zymo-spin-iv.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns",
      subtitle: "C1012-25, C1012-50",
      description:
        "Column for purifying up to 100 &micro;g  DNA or RNA in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1012-25-Zymo-Spin-V.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns w/ Reservoir",
      subtitle: "C1016-25, C1016-50",
      description:
        "Assembly for purifying DNA/RNA from &le; 15 ml sample in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1016-25-Zymo-Spin-V-with-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-P Column Assembly w/ 15 ml and 50 ml Reservoir",
      subtitle: "C1042-5",
      description:
        "The Zymo-Spin V-P can be used in centrifuges or on-vacuum manifolds to purify plasmid DNA.",
      handle:
        "/products/zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1042-5--Zymo-Spin-V-P-with-15-ml-and-50-ml-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-E Columns",
      subtitle: "C1021-25, C1024-25, C1024-50, C1029-25",
      description:
        "The Zymo-Spin V-E columns can be used in microcentrifuges, centrifuges, or on vacuum manifolds",
      handle: "/products/zymo-spin-v-e-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1024-25-Zymo-Spin-VE.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns",
      subtitle: "C1013-10, C1013-20",
      description:
        "Column for recovery of up to 500 &micro;g  DNA or RNA in &ge; 2 ml.",
      handle: "/products/zymo-spin-vi-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1013-10-Zymo-Spin-VI.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Reservoir",
      subtitle: "C1018-10, C1018-20",
      description:
        "Column assembly for recovery of DNA/RNA from large volumes.",
      handle: "/products/zymo-spin-vi-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1018-Zymo-Spin-VI-with-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Zymo-Maxi Filter",
      subtitle: "C1017-10, C1017-20",
      description:
        "Column-filter assembly for purifying DNA/RNA from &le; 75 ml sample",
      handle: "/products/zymo-spin-vi-columns-w-zymo-maxi-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1017-10-Zymo-Spin-VI-with-maxi-filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI-P Columns",
      subtitle: "C1044-5",
      description:
        "Zymo-Spin VI-P can be used in centrifuges or on vacuum manifolds for the purification of plasmid DNA.",
      handle: "/products/zymo-spin-vi-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1044-5-Zymo-Spin-VI-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96 Plate",
      subtitle: "C2004, C2004-SW",
      description:
        "Deep-well (96) plate purification of DNA/RNA in &ge; 10 &micro;l elution.",
      handle: "/products/zymo-spin-i-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2004-Zymo-Spin-I-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96-XL Plates",
      subtitle: "C2010",
      description:
        "Deep-well (96) plate purification of large DNA in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-i-96-xl-plates",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2010-Zymo-Spin-III-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A Plate",
      subtitle: "C2001",
      description:
        "Shallow-well (96) plate purification of DNA/RNA in &ge; 30 &micro;l.",
      handle: "/products/silicon-a-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-Silicon-A-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB-96 Plate",
      subtitle: "C2006",
      description:
        "Deep-well (96) plate for DNA clean-up & dye removal in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-ib-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2006-Zymo-Spin-IB-96-plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A-HRC Plate",
      subtitle: "C2009",
      description: "",
      handle: "/products/silicon-a-hrc-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2009-Silicon-A-HRC-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Plate",
      subtitle: "C2002",
      description:
        "1.2 ml, round bottom, 96-well plate for use with spin plate.",
      handle: "/products/collection-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2002-Collection-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Elution Plate",
      subtitle: "C2003",
      description:
        "90 &micro;l, V-bottom, 96-well plate for use with spin plate.",
      handle: "/products/elution-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2003-Elution-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-1, S6002-96-2, S6002-96-3",
      description: "ZR BashingBeads in 96 impact resistant tube rack.",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6002-96-2-ZR-Bashing-Bead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block",
      subtitle: "P1001-10, P1001-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1001-2-96-well-block.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Conversion Plate w/ Cover Foil",
      subtitle: "C2005",
      description: "96-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/conversion-plate-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2005-C2008-96-Well-Conversion-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block w/ Cover Foil",
      subtitle: "P1002-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1002-2-96-Well-block-with-cover-foil.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Plate Cover Foil",
      subtitle: "C2007-12, C2007-2, C2007-24, C2007-4, C2007-6, C2007-8",
      description: "Pierceable aluminum foil with strong adhesive for sealing.",
      handle: "/products/96-well-plate-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2007_96-well Cover Foils.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MagBinding Beads",
      subtitle:
        "D4100-2-12, D4100-2-16, D4100-2-24, D4100-2-3, D4100-2-6, D4100-2-8",
      description:
        "For use with Zymo Research magnetic bead-based purification kits.",
      handle: "/products/magbinding-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Syringe Filters",
      subtitle: "C1036-5",
      description:
        "The ZymoPURE Syringe Filter features rapid clarification of up to 60 ml of neutralized lysate",
      handle: "/products/zymopure-syringe-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1036-5-Syringe-Filters.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Giga Filter",
      subtitle: "C1038-1",
      description: "",
      handle: "/products/zymopure-giga-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1038-1-ZymoPure-Giga-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Spin-Away Filters",
      subtitle: "C1006-250-F, C1006-50-F",
      description: "For use with Zymo Research purification kits",
      handle: "/products/spin-away-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-F-Spin-Away-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZRC GF Filter",
      subtitle: "C1009-20, C1009-50",
      description:
        "Filter for separating cellular components from biological fluids.",
      handle: "/products/zrc-gf-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1009-20-ZRC-GF-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "15 ml Conical Reservoir",
      subtitle: "C1031-25",
      description: "",
      handle: "/products/15-ml-conical-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/15ml reservoir.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "25 ml Reservoir for Spin-Away Filters and Zymo-Spin IIICG",
      subtitle: "C1039-25",
      description: "",
      handle:
        "/products/25-ml-reservoir-for-spin-away-filters-and-zymo-spin-iiicg",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1039-25_Reservoir - 25 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "50 ml Conical Reservoir",
      subtitle: "C1032-25",
      description:
        "The 50 ml Reservoir can be used with vacuum manifolds for the purification of DNA and/or RNA",
      handle: "/products/50-ml-conical-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1032-25-50ml-Conical-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "600 ml Reservoir",
      subtitle: "C1033-5",
      description:
        "The 600 ml Reservoir, used with vacuum manifolds for the purification of DNA/RNA",
      handle: "/products/600-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1033-5-600-ml-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Tubes",
      subtitle: "C1001-1000, C1001-50, C1001-500",
      description:
        "Durable polypropylene collection tubes used in conjunction with Zymo-Spin columns",
      handle: "/products/collection-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1001-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase/RNase-Free Tubes",
      subtitle: "C2001-100, C2001-50",
      description:
        "DNase/RNase-free 1.5 ml microcentrifuge tubes made of durable polypropylene construction.",
      handle: "/products/dnase-rnase-free-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-100-DNase-RNase-free-tubes.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Clear Tubes, with caps",
      subtitle: "C1025-50, C1025-500, C1027-50, C1027-500",
      description:
        "Clear 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-clear-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1025-Clear-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Amber Tubes, with caps",
      subtitle: "C1026-50, C1026-500, C1028-50, C1028-500",
      description:
        "Amber 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-amber-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1026-50-Amber-Tube-with-cap-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR Bashing Bead Lysis Tubes",
      subtitle: "S6003-50",
      description: "2.0 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashing-bead-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
      subtitle: "S6014-50",
      description: "",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zr_bashingbead_lysis_tubes_2.0_mm_s6003-50__1.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
      subtitle: "S6012-50",
      description:
        "0.1 & 0.5 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/S6012-50_ZR-BashingBead-Lysis-Tubes.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Squisher-Single",
      subtitle: "H1001, H1001-50",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-single",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/H1001-Squisher-Single.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Squisher-8 w/ 96-Well Block",
      subtitle: "H1002-5, H1002-20",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-8-w-96-well-block",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/H1002-5-Squisher-8.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Squisher-96 w/ 96-Well Block",
      subtitle: "H1004-2, H1004-5",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-96-w-96-well-block",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/H1004-2-Squisher-96.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zymo-Spin IICR Columns",
      subtitle: "C1078-50, C1078-250",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iicr-columns",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/C1078_Zymo-Spin IICR Columns.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-4, S6002-96-5",
      description:
        "96-well microbial cell lysis rack for high throughput/automated bead beating",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/s6002_96_lysis_rack.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "DNA Clean-Up & Concentration": [
    {
      "title": "DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4012",
      "description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4012_DNA-Clean-%26-Concentrator-Magbead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 DNA Clean-Up Kit",
      "subtitle": "D4017, D4018",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-up-kit",
      "image_url": "https://files.zymoresearch.com/images/D4017_ZR-96-DNA-Clean-up-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
      "subtitle": "D4023, D4024",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
      "image_url": "https://files.zymoresearch.com/product-images/D4023-ZR-96-DNA-Clean-_-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Select-a-Size DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4084, D4085",
      "description": "Consistently purify a specific range of DNA fragment sizes from library preps, PCR, ligations and other sources using magnetic beads. ",
      "handle": "/products/select-a-size-dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/images/D4084_Select-A-Size-DNA-Clean-and-Concentrator-MagBead-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4021, D4022",
      "description": "Convenient high-throughput purification of ultra-pure DNA from agarose gels.",
      "handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
      "subtitle": "D4066, D4067",
      "description": "Simple hight-throughput method for purifying high molecular weight DNA from any enzymatic reaction or impure preparation.",
      "handle": "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
      "image_url": "https://files.zymoresearch.com/images/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>OneStep</i> PCR Inhibitor Removal Kits",
      "subtitle": "DNA",
      "description": "PCR inhibitor clean up kits that contain all the components needed for efficient removal of potent PCR inhibitors - all in one step. Free PCR inhibitor clean up kits sample with free shipping!",
      "handle": "/collections/onestep-pcr-inhibitor-removal-kits",
      "image_url": "https://files.zymoresearch.com/images/D6035-OneStep-96-PCR-Inhibitor-Removal-Kit.jpg",
      "tags": [],
      "isKit": true,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Oligo Clean & Concentrator",
      "subtitle": "D4062, D4063",
      "description": "Streamlined high-throughput method for cleaning-up and concentrating oligonucleotides.",
      "handle": "/products/oligo-clean-concentrator-zr96",
      "image_url": "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "ZR-96 DNA Sequencing Clean-up Kit",
      subtitle: "D4052, D4053",
      description:
        "High-throughput and rapid clean up of dye terminator sequencing reactions prior to Sanger Sequencing.",
      handle: "/products/zr-96-dna-sequencing-clean-up-kit",
      isKit: true,
      image_url:
        "https://stage.zymoresearch.com/cdn/shop/products/D4052_ZR-96-DNA-Sequencing-Clean-up-Kit_600x.jpg?v=1628532398",
      searchWeight: 0,
      tags: [],
    },
  ],
  Columns: [
    {
      title: "Zymo-Spin I Columns",
      subtitle: "C1003-250, C1003-50",
      description:
        "Uncapped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in &ge; 6 &micro;l.",
      handle: "/products/zymo-spin-i-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1003-Zymo-Spin-I.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC Columns",
      subtitle: "C1004-250, C1004-50",
      description:
        "Capped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in ≥ 6 &micro;l.",
      handle: "/products/zymo-spin-ic-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1004-Zymo-Spin-IC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XL",
      subtitle: "C1002-25, C1002-50",
      description:
        "Capped columns for the recovery of large-sized DNA in &ge; 10 &micro;l.",
      handle: "/products/zymo-spin-ic-xl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1002-50-Zymo-Spin-IC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XM Columns",
      subtitle: "C1103-50",
      description: "",
      handle: "/products/zymo-spin-ic-xm-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1103-50_Zymo-Spin IC-XM Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-S Columns",
      subtitle: "C1015-25, C1015-50",
      description:
        "The Zymo-Spin IC-S features durable polypropylene construction and contains a unique silica-based matrix that allows purification",
      handle: "/products/zymo-spin-ic-s-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1015-50-Zymo-Spin-IC-S.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB Columns",
      subtitle: "C1014-250, C1014-50",
      description: "Columns for nucleic acid purification and dye removal.",
      handle: "/products/zymo-spin-ib-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1014-Zymo-Spin-IB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin P1 Columns",
      subtitle: "P2003-1",
      description: "Columns for purification of His-tagged proteins.",
      handle: "/products/zymo-spin-p1-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zymo-spin_pi_c2003-1_.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II Columns",
      subtitle: "C1008-250, C1008-50",
      description:
        "Uncapped columns for the recovery of &le; 25 &micro;g  DNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-ii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1008-50-Zymo-Spin-II.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIC Columns",
      subtitle: "C1011-250, C1011-50",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iic-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1011-50-OPEN-CAP-Zymo-Spin-IIC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIN Columns",
      subtitle: "C1019-250, C1019-50",
      description:
        "Uncapped columns for the recovery of &le;  25 µg  DNA in &ge; 30 &micro;l.",
      handle: "/products/zymo-spin-iin-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1019-Zymo-Spin-IIN.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-µHRC Filters",
      subtitle: "C1059-50",
      description: "For use with Zymo Research products.",
      handle: "/products/zymo-spin-ii-µhrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1059_Zymo Spin II-HRC.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-P Columns",
      subtitle: "C1055-50",
      description: "",
      handle: "/products/zymo-spin-ii-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1055-50_Zymo-Spin II-P Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III Columns",
      subtitle: "C1005-250, C1005-50",
      description:
        "The Zymo-Spin III features durable polypropylene construction that allows purification of up to 25 &micro;g DNA or RNA in &ge; 35 &micro;l eluate.",
      handle: "/products/zymo-spin-iii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1005-Zymo-Spin-III.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIICG Columns",
      subtitle: "C1006-250-G, C1006-50-G",
      description: "",
      handle: "/products/zymo-spin-iiicg-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-G-Zymo-Spin-IIICG.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-F Filters",
      subtitle: "C1057-50",
      description: "For use in Zymo Research environmental purification kits.",
      handle: "/products/zymo-spin-iii-f-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1057-Zymo-Spin-III-F.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-HRC Filters",
      subtitle: "C1058-50",
      description: "",
      handle: "/products/zymo-spin-iii-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1058-Zymo-Spin-III-HRC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV-IR HRC Filters",
      subtitle: "C1010-50",
      description: "",
      handle: "/products/zymo-spin-iv-ir-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1010-50_Zymo-Spin-IV-IR-HRC-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "Zymo-Spin III-P Column Assembly w/ 15 ml and 50 ml Reservoir (5 Pack)",
      subtitle: "C1040-5",
      description: "",
      handle:
        "/products/zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1040-5-Zymo-Spin-III-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-S Columns w/ LuerLock Caps and 15 ml Reservoir",
      subtitle: "C1049-25",
      description: "",
      handle:
        "/products/zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/(3) Zymo Spin IIIS.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV Columns",
      subtitle: "C1007-250, C1007-50",
      description: "",
      handle: "/products/zymo-spin-iv-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/c1007-50-zymo-spin-iv.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns",
      subtitle: "C1012-25, C1012-50",
      description:
        "Column for purifying up to 100 &micro;g  DNA or RNA in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1012-25-Zymo-Spin-V.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns w/ Reservoir",
      subtitle: "C1016-25, C1016-50",
      description:
        "Assembly for purifying DNA/RNA from &le; 15 ml sample in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1016-25-Zymo-Spin-V-with-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-P Column Assembly w/ 15 ml and 50 ml Reservoir",
      subtitle: "C1042-5",
      description:
        "The Zymo-Spin V-P can be used in centrifuges or on-vacuum manifolds to purify plasmid DNA.",
      handle:
        "/products/zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1042-5--Zymo-Spin-V-P-with-15-ml-and-50-ml-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-E Columns",
      subtitle: "C1021-25, C1024-25, C1024-50, C1029-25",
      description:
        "The Zymo-Spin V-E columns can be used in microcentrifuges, centrifuges, or on vacuum manifolds",
      handle: "/products/zymo-spin-v-e-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1024-25-Zymo-Spin-VE.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns",
      subtitle: "C1013-10, C1013-20",
      description:
        "Column for recovery of up to 500 &micro;g  DNA or RNA in &ge; 2 ml.",
      handle: "/products/zymo-spin-vi-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1013-10-Zymo-Spin-VI.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Reservoir",
      subtitle: "C1018-10, C1018-20",
      description:
        "Column assembly for recovery of DNA/RNA from large volumes.",
      handle: "/products/zymo-spin-vi-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1018-Zymo-Spin-VI-with-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Zymo-Maxi Filter",
      subtitle: "C1017-10, C1017-20",
      description:
        "Column-filter assembly for purifying DNA/RNA from &le; 75 ml sample",
      handle: "/products/zymo-spin-vi-columns-w-zymo-maxi-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1017-10-Zymo-Spin-VI-with-maxi-filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI-P Columns",
      subtitle: "C1044-5",
      description:
        "Zymo-Spin VI-P can be used in centrifuges or on vacuum manifolds for the purification of plasmid DNA.",
      handle: "/products/zymo-spin-vi-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1044-5-Zymo-Spin-VI-P.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "96-Well Plates": [
    {
      title: "96-Well 2.0 mL Deep Well Plate",
      subtitle: "C2015, C2015-50",
      description:
        "96-Well Plate for Liquid Handling Robots",
      handle: "/products/96-well-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2015-2_96-Well-2.0-ml-Deep-Well-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Elution Plate (V-Bottom, 200 µL)",
      subtitle: "C1030, C1030-50",
      description:
        "96-Well Polypropylene Elution Plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-elution-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C1030_96_elution_plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Deep Well Plate (V-Bottom, 2.2ml)",
      subtitle: "C2018-5, C2018-50",
      description:
        "96-Well Polypropylene plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-deep-well-plate-v-bottom-2-2ml",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2018_ZRC_2164.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96 Tip Combs (For V-Bottom Deep Well Plate)",
      subtitle: "C2019, C2019-100",
      description:
        "96 Tip Comb for Magnetic Bead Moving Instruments",
      handle: "/products/96-tip-combs-for-v-bottom-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2019_ZRC_2146.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Plate",
      subtitle: "C2002",
      description:
        "1.2 ml, round bottom, 96-well plate for use with spin plate.",
      handle: "/products/collection-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2002-Collection-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Elution Plate",
      subtitle: "C2003",
      description:
        "90 &micro;l, V-bottom, 96-well plate for use with spin plate.",
      handle: "/products/elution-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2003-Elution-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-1, S6002-96-2, S6002-96-3",
      description: "ZR BashingBeads in 96 impact resistant tube rack.",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6002-96-2-ZR-Bashing-Bead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block",
      subtitle: "P1001-10, P1001-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1001-2-96-well-block.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Conversion Plate w/ Cover Foil",
      subtitle: "C2005",
      description: "96-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/conversion-plate-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2005-C2008-96-Well-Conversion-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block w/ Cover Foil",
      subtitle: "P1002-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1002-2-96-Well-block-with-cover-foil.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Plate Cover Foil",
      subtitle: "C2007-12, C2007-2, C2007-24, C2007-4, C2007-6, C2007-8",
      description: "Pierceable aluminum foil with strong adhesive for sealing.",
      handle: "/products/96-well-plate-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2007_96-well Cover Foils.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well PCR Conversion Plate",
      subtitle: "C2008",
      description: "6-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/96-well-pcr-conversion-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2008-96-well_pcr_conversion_plate.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Squisher-8 w/ 96-Well Block",
      subtitle: "H1002-20, H1002-5",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-8-w-96-well-block",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/H1002-5-Squisher-8.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Squisher-96 w/ 96-Well Block",
      subtitle: "H1004-2, H1004-5",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-96-w-96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/H1004-2-Squisher-96.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well ELISA Plate",
      subtitle: "C2020",
      description: "For use with 5-mC and Quest-5hmC ELISA kits.",
      handle: "/products/96-well-elisa-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2020_96-well ELISA Plate.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  Magbeads: [
    {
      title: "MagBinding Beads",
      subtitle:
        "D4100-2-12, D4100-2-16, D4100-2-24, D4100-2-3, D4100-2-6, D4100-2-8",
      description:
      "For use in Quick-DNA/RNA magnetic bead-based purification kits.",
      handle: "/products/magbinding-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Select-a-Size MagBead Set",
      subtitle: "D4084-10, D4084-50",
      description: "For use in Select-a-Size DNA Clean & Concentrator Magbead kit.",
      handle: "/products/select-a-size-magbead-set",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4084-1-50_Select-A-Size-MagBeads-50-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBinding Beads",
      subtitle: "D4302-6-12, D4302-6-6",
      description:
        "For use in ZymoBIOMICS magnetic bead-based purification kits.",
      handle: "/products/zymobiomics-magbinding-beads",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4302-6-12_ZymoBIOMICS-MagBinding-Beads-12-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-Methylation Magprep Beads",
      subtitle:
        "D4100-5-4, D4100-5-8, D4100-5-16",
      description:
        "For use in EZ-DNA Methylation Magprep bead-based purification kits.",
      handle: "/products/ez-methylation-magprep-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MagBead J",
      subtitle:
        "D4100-3-3, D4100-3-50, D4100-3-100",
      description:
        "Optimized for low reaction volume workflows and high-throughput automation.",
      handle: "/products/magbead-j",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    }
  ],
  "Filter-Magbeads>Quick_DNA_RNA": [
      {
        title: "MagBinding Beads",
        subtitle:
          "D4100-2-12, D4100-2-16, D4100-2-24, D4100-2-3, D4100-2-6, D4100-2-8",
        description:
          "For use with Zymo Research magnetic bead-based purification kits.",
        handle: "/products/magbinding-beads",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
        searchWeight: 0,
        tags: [],
      },
    ],
    "Filter-Magbeads>Select-a-Size": [
      {
        title: "Select-a-Size MagBead Set",
        subtitle: "D4084-10, D4084-50",
        description: "Magnetic Beads Only",
        handle: "/products/select-a-size-magbead-set",
        isKit: false,
        image_url:
          "https://files.zymoresearch.com/images/D4084-1-50_Select-A-Size-MagBeads-50-mL.jpg",
        searchWeight: 0,
        tags: [],
      },
    ],
    "Filter-Magbeads>ZymoBIOMICS": [
      {
        title: "ZymoBIOMICS MagBinding Beads",
        subtitle: "D4302-6-12, D4302-6-6",
        description:
          "For use in ZymoBIOMICS  magenetic bead-based purification kits.",
        handle: "/products/zymobiomics-magbinding-beads",
        isKit: false,
        image_url:
          "https://files.zymoresearch.com/images/D4302-6-12_ZymoBIOMICS-MagBinding-Beads-12-ml.jpg",
        searchWeight: 0,
        tags: [],
      },
    ],
  "Filter-Magbeads>EZ-DNA_Methylation_Magprep": [
    {
      title: "EZ-Methylation Magprep Beads",
      subtitle:
        "D4100-5-4, D4100-5-8, D4100-5-16",
      description:
        "For use in EZ-DNA Methylation Magprep bead-based purification kits.",
      handle: "/products/ez-methylation-magprep-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Filters: [
    {
      title: "ZymoPURE Syringe Filters",
      subtitle: "C1036-5",
      description:
        "The ZymoPURE Syringe Filter features rapid clarification of up to 60 ml of neutralized lysate",
      handle: "/products/zymopure-syringe-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1036-5-Syringe-Filters.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Giga Filter",
      subtitle: "C1038-1",
      description: "",
      handle: "/products/zymopure-giga-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1038-1-ZymoPure-Giga-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-F Filters",
      subtitle: "C1057-50",
      description: "For use in Zymo Research environmental purification kits.",
      handle: "/products/zymo-spin-iii-f-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1057-Zymo-Spin-III-F.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Spin-Away Filters",
      subtitle: "C1006-250-F, C1006-50-F",
      description: "For use with Zymo Research purification kits",
      handle: "/products/spin-away-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-F-Spin-Away-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZRC GF Filter",
      subtitle: "C1009-20, C1009-50",
      description:
        "Filter for separating cellular components from biological fluids.",
      handle: "/products/zrc-gf-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1009-20-ZRC-GF-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Reservoirs: [
    {
      title: "15 ml Conical Reservoir",
      subtitle: "C1031-25",
      description: "",
      handle: "/products/15-ml-conical-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/15ml reservoir.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "25 ml Reservoir for Spin-Away Filters and Zymo-Spin IIICG",
      subtitle: "C1039-25",
      description: "",
      handle:
        "/products/25-ml-reservoir-for-spin-away-filters-and-zymo-spin-iiicg",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1039-25_Reservoir - 25 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "50 ml Conical Reservoir",
      subtitle: "C1032-25",
      description:
        "The 50 ml Reservoir can be used with vacuum manifolds for the purification of DNA and/or RNA",
      handle: "/products/50-ml-conical-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1032-25-50ml-Conical-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "600 ml Reservoir",
      subtitle: "C1033-5",
      description:
        "The 600 ml Reservoir, used with vacuum manifolds for the purification of DNA/RNA",
      handle: "/products/600-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1033-5-600-ml-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Manual Homogenizers": [
    {
      title: "Squisher-Single",
      subtitle: "H1001, H1001-50",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-single",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/H1001-Squisher-Single.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Squisher-8 w/ 96-Well Block",
      subtitle: "H1002-5, H1002-20",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-8-w-96-well-block",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/H1002-5-Squisher-8.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Squisher-96 w/ 96-Well Block",
      subtitle: "H1004-2, H1004-5",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-96-w-96-well-block",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/H1004-2-Squisher-96.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  Devices: [
    {
      title: "EZ-Vac Vacuum Manifold",
      subtitle: "S7000",
      description:
        "The EZ-Vac Vacuum Manifold is capable of processing up to 20 samples using vacuum pressure.",
      handle: "/products/ez-vac-vacuum-manifold",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S7000-Vacuum-Manifold.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Vortex-Genie<sup>&reg;</sup> 2",
      subtitle: "S5001, S5002",
      description:
        "Offers variable speed for precise mixing from gentle to vigorous has hands-free or touch-on control",
      handle: "/products/vortex-genie-2",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/vortex-genie-2_1_1.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Digital Vortex-Genie<sup>&reg;</sup> 2",
      subtitle: "S5003, S5004",
      description:
        "The Digital Vortex Genie 2 offers variable speed for precise mixing from gentle to vigorous .",
      handle: "/products/digital-vortex-genie-2",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Digital Vortex-Genie.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "FastPrep<sup>&reg;</sup> 24",
      subtitle: "S6005, S6005-1, S6005-2, S6005-3, S6005-4, S6005-5, S6005-6",
      description:
        "High-speed benchtop homogenizer that employs a powerful proprietary technology",
      handle: "/products/fastprep-24",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6005ll.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "FastPrep-96",
      subtitle: "S6008",
      description: "",
      handle: "/products/fastprep-96",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6008.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MagStir Genie<sup>&reg;</sup>",
      subtitle: "S5009, S5010",
      description:
        "The MagStir Genie<sup>&reg;</sup> allows programmable high/low speed stirring.",
      handle: "/products/magstir-genie-sup-reg-sup",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s5009l.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RotaPrep MonoLyser",
      subtitle: "S6021",
      description:
        "Homogenization and grinding system for life sciences applications",
      handle: "/products/rotaprep-monolyser",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/RotaPrep MonoLyser.jpg",
      searchWeight: 0,
      tags: [],
    },
    // {
    //   title: "Precellys® Evolution",
    //   subtitle: "S6009-3",
    //   description:
    //     "The Precellys® Evolution is a high-throughput homogenizer capable of processing up to 24 samples in as little as 30 seconds. Designed to be used with 6 different tube sizes.",
    //   handle: "/products/precellys-evolution",
    //   isKit: false,
    //   image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-3_600x.jpg?v=1660255305",
    //   searchWeight: 0,
    //   tags: [],
    // },
    {
      title: "Precellys® 24 Touch",
      subtitle: "S6009-4",
      description:
        "The Precellys® 24 Touch is a high-throughput tissue homogenizer capable of processing up to 24 samples in as little as 30 seconds. Designed to be used with 0.5 ml or 2.0 mL microtubes.",
      handle: "/products/precellys-24-touch",
      isKit: false,
      image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-4_600x.jpg?v=1660254499",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Cryolys® Evolution",
      subtitle: "S6009-5",
      description:
        "The Cryolys® Evolution unit is designed to be used with the Precellys® Evolution (Cat. No. S6004-3) to keep the temperature of samples between 0 °C and 10 °C during homogenization. Works with dry ice.",
      handle: "/products/cryolys-evolution",
      isKit: false,
      image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-5_600x.jpg?v=1660255702",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Digital MicroPlate Genie<sup>&reg;</sup> Pulse",
      subtitle: "S5012, S5013",
      description: "Exclusive precise vortex orbit guarantees true vortexing action in each well of the microplate, at all times.",
      handle: "/products/microplate-genie-pulse",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/s5012-digital_microplate_genie_pulse.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Roto-Shake Genie<sup>&reg;</sup>",
      subtitle: "S5007, S5008",
      description:
        "Combines rotating and rocking in one compact unit, the magnetic platform.",
      handle: "/products/roto-shake-genie",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Roto-Shake Genie.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2010 Geno/Grinder",
      subtitle: "S6006",
      description: "",
      handle: "/products/2010-geno-grinder",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6006l.jpg",
      searchWeight: 0,
      tags: ["US Only"],
    },
  ],
  "Vacuum Manifold": [
    {
      title: "EZ-Vac Vacuum Manifold",
      subtitle: "S7000",
      description:
        "The EZ-Vac Vacuum Manifold is capable of processing up to 20 samples using vacuum pressure.",
      handle: "/products/ez-vac-vacuum-manifold",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S7000-Vacuum-Manifold.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Vortexers: [
    {
      title: "Vortex-Genie<sup>&reg;</sup> 2",
      subtitle: "S5001, S5002",
      description:
        "Offers variable speed for precise mixing from gentle to vigorous has hands-free or touch-on control",
      handle: "/products/vortex-genie-2",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/vortex-genie-2_1_1.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Digital Vortex-Genie<sup>&reg;</sup> 2",
      subtitle: "S5003, S5004",
      description:
        "The Digital Vortex Genie 2 offers variable speed for precise mixing from gentle to vigorous .",
      handle: "/products/digital-vortex-genie-2",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Digital Vortex-Genie.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Microtube Foam Inserts",
      subtitle: "S5001-1",
      description: "Vortex-Genie Family Accessories, Foam Inserts",
      handle: "/products/microtube-foam-inserts",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Microtube%20Foam%20Inserts.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Microplate Foam Inserts",
      subtitle: "S5001-2",
      description: "Vortex-Genie Family Accessories, Foam Inserts",
      handle: "/products/microplate-foam-inserts",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Microplate%20Foam%20Inserts.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Tube Foam Inserts",
      subtitle: "S5001-3, S5001-8, S5001-9",
      description:
        "Vortex-Genie<sup>&reg;</sup> Family Accessories, Foam Inserts",
      handle: "/products/tube-foam-inserts",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Tube%20Foam%20Inserts.jpeg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pop-off Cup",
      subtitle: "S5001-4",
      description: "Mixing and vortexing in single tubes",
      handle: "/products/pop-off-cup",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Pop-off%20Cup.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Horizontal Microtube Holder",
      subtitle: "S5001-5, S5001-6, S5001-7",
      description: "Use with any Vortex-Genie<sup>&reg;</sup> 2.",
      handle: "/products/horizontal-microtube-holder",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/horizontal-plastic-microtub.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Cell-free DNA": [
    {
      title: "MAGicBead cfDNA Isolation Kit",
      subtitle: "D4086",
      description:
        "Novel DNA binding chemistry enabling unparalleled cfDNA extraction performance",
      handle: "/products/magicbead-cfdna-isolation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4086_magicbead_cfdna_isolation_kit.jpg",
      searchWeight: 2,
      ribbon: false,
      tags: [],
    },
    {
      "title": "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      "subtitle": "D4076",
      "description": "Highly efficient isolation of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      "handle": "/products/quick-cfdna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
  ],
  "Collection Devices": [
    {
      "title": "DNA/RNA Shield Blood Collection Tube",
      "subtitle": "R1150",
      "description": "Ready-to-use tubes for collecting and preserving DNA and RNA in whole blood at ambient temperatures. ",
      "handle": "/products/dna-rna-shield-blood-collection-tube",
      "image_url": "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Collection Tube w/ Swab",
      "subtitle": "R1106, R1107, R1107-E, R1108, R1109, R1109-E",
      "description": "Complete solution for collecting and preserving nucleic acids from a variety of sample types at ambient temperatures using swabs.",
      "handle": "/products/dna-rna-shield-collection-tube-w-swab",
      "image_url": "https://files.zymoresearch.com/images/R1106_DNA-RNA-Shield-Swab-Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Fecal Collection Tube",
      "subtitle": "R1101, R1137",
      "description": "Collect & preserve nucleic acids from stool specimens at ambient temperatures.",
      "handle": "/products/dna-rna-shield-fecal-collection-tube",
      "image_url": "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Fecal Collection Tube - DX",
      "subtitle": "R1101-E",
      "description": "Specimen receptacle medical device for collecting and preserving nucleic acids from feces for molecular-based in vitro diagnostic",
      "handle": "/products/dna-rna-shield-fecal-collection-tube-dx",
      "image_url": "https://files.zymoresearch.com/product-images/R1101_DNA+RNA+Shield+Fecal+Collection+Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Lysis & Collection Tubes",
      "subtitle": "R1102, R1103, R1104, R1105",
      "description": "All-in-one tube for the collection, preservation, and homogenization of a variety of sample types for DNA and RNA purificaiton. ",
      "handle": "/products/dna-rna-shield-lysis-and-collection-tubes",
      "image_url": "https://files.zymoresearch.com/images/R1103-DNA-RNA-Shield-Lysis-Tube-(Microbe).jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield SafeCollect Saliva Collection Kit",
      "subtitle": "R1211, R1211-E, R1211-10, R1211-50",
      "description": "User friendly device for collecting and preserving nucleic acids from saliva and sputum samples at ambient temperatures. ",
      "handle": "/products/dna-rna-shield-safecollect-saliva-collection-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1211-dna_rna_shield_safecollect_saliva_collection_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "DNA/RNA Shield SafeCollect Swab Collection Kit",
      subtitle: "R1160, R1161, R1160-E, R1161-E, R1160-10, R1161-10, R1160-50, R1161-50",
      description:
        "User-friendly swab self-collection with unique design to prevent spillage. Collect and transport at ambient temperature, anywhere.",
      handle: "/products/dna-rna-shield-safecollect-swab-collection-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r1160-dna_rna_shield_safecollect_swab_collection_kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      "title": "DNA/RNA Shield Saliva Sputum Collection Kit - DX",
      "description": "The DNA/RNA Shield Saliva/Sputum Collection Kit is a collection kit for DNA and RNA transport and stabilization for saliva/sputum samples.",
      "handle": "/products/dna-rna-shield-saliva-sputum-collection-kit-dx-r1210-e",
      "isKit": true,
      "image_url": "https://cdn.shopify.com/s/files/1/0016/3731/8726/products/R1210-E_DNA_RNA_Shield_Saliva_Collection_Kit_CE-IVD_1.png?v=1642526486",
      "subtitle": "R1210-E",
      "ribbon": false,
      "searchWeight": 0,
      "tags": "isKit, no-index, Pathogenic Sample Collection, Sample Collection, Sample Storage, Sample Transport, volume_pricing_link"
    },
    {
      title: "Urine Collection Cup",
      subtitle: "D3062-1",
      description: "Plastic urine collection cup for collecting urine.",
      handle: "/products/urine-collection-cup",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D3062-1_Urine-Collection-Cup.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Wastewater Sample Collection Bottle",
      subtitle: "R1503, R1503-8",
      description: "The Wastewater Sample Collection Bottles are designed as an all-in-one solution for safely collecting, transporting, and storing wastewater samples.",
      handle: "/products/wastewater-sample-collection-bottle",
      isKit: false,
      image_url:
        "https://cdn.shopify.com/s/files/1/0016/3731/8726/files/r1503_wastewater_sample_collection_bottle.webp",
      searchWeight: 0,
      tags: [],
    },
  ],
  Homogenizers: [
    {
      title: "FastPrep<sup>&reg;</sup> 24",
      subtitle: "S6005, S6005-1, S6005-2, S6005-3, S6005-4, S6005-5, S6005-6",
      description:
        "High-speed benchtop homogenizer that employs a powerful proprietary technology",
      handle: "/products/fastprep-24",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6005ll.png",
      searchWeight: 0,
      ids: null,
      tags: [],
    },
    {
      title: "FastPrep-96",
      subtitle: "S6008",
      description: "",
      handle: "/products/fastprep-96",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6008.jpg",
      searchWeight: 0,
      ids: null,
      tags: [],
    },
    {
      title: "RotaPrep MonoLyser",
      subtitle: "S6021",
      description:
        "Homogenization and grinding system for life sciences applications",
      handle: "/products/rotaprep-monolyser",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/RotaPrep MonoLyser.jpg",
      searchWeight: 0,
      ids: null,
      tags: [],
    },
    // {
    //   title: "Precellys® Evolution",
    //   subtitle: "S6009-3",
    //   description:
    //     "The Precellys® Evolution is a high-throughput homogenizer capable of processing up to 24 samples in as little as 30 seconds. Designed to be used with 6 different tube sizes.",
    //   handle: "/products/precellys-evolution",
    //   isKit: false,
    //   image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-3_600x.jpg?v=1660255305",
    //   searchWeight: 0,
    //   tags: [],
    // },
    {
      title: "Precellys® 24 Touch",
      subtitle: "S6009-4",
      description:
        "The Precellys® 24 Touch is a high-throughput tissue homogenizer capable of processing up to 24 samples in as little as 30 seconds. Designed to be used with 0.5 ml or 2.0 mL microtubes.",
      handle: "/products/precellys-24-touch",
      isKit: false,
      image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-4_600x.jpg?v=1660254499",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Cryolys® Evolution",
      subtitle: "S6009-5",
      description:
        "The Cryolys® Evolution unit is designed to be used with the Precellys® Evolution (Cat. No. S6004-3) to keep the temperature of samples between 0 °C and 10 °C during homogenization. Works with dry ice.",
      handle: "/products/cryolys-evolution",
      isKit: false,
      image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-5_600x.jpg?v=1660255702",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Digital MicroPlate Genie<sup>&reg;</sup> Pulse",
      subtitle: "S5012, S5013",
      description: "Exclusive precise vortex orbit guarantees true vortexing action in each well of the microplate, at all times.",
      handle: "/products/microplate-genie-pulse",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/s5012-digital_microplate_genie_pulse.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Roto-Shake Genie<sup>&reg;</sup>",
      subtitle: "S5007, S5008",
      description:
        "Combines rotating and rocking in one compact unit, the magnetic platform.",
      handle: "/products/roto-shake-genie",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Roto-Shake Genie.jpg",
      searchWeight: 0,
      ids: null,
      tags: [],
    },
    {
      title: "2010 Geno/Grinder",
      subtitle: "S6006",
      description: "",
      handle: "/products/2010-geno-grinder",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6006l.jpg",
      searchWeight: 0,
      ids: null,
      tags: ["US Only"],
    },
  ],
  "Genomic DNA Purification Kits": [
    {
      title: "<i>Quick</i>-DNA Kits",
      subtitle: "DNA",
      description:
        "The Quick-DNA Plus Kits are the easiest DNA isolation kits for high yield DNA isolation from any cells, tissues, and biological fluids. Get free DNA isolation kits sample & shipping. ",
      handle: "/collections/quick-dna-extraction-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Viral Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Viral Kits are viral DNA purification kits that provide for the rapid isolation of high-quality viral DNA from a wide range of biological sources.",
      handle: "/collections/quick-dna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3015_Quick-DNA-Viral-DNA-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      subtitle: "R1072",
      description:
        "Isolate cfDNA and cfRNA efficiently and easily from biological fluids",
      handle: "/products/quick-cfdna-rna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Urine Kit",
      subtitle: "D3061",
      description:
        "Extract high quality cell-free or cellular DNA from up to 40 ml of urine",
      handle: "/products/quick-dna-urine-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3061_Quick-DNA-Urine-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA FFPE Miniprep",
      subtitle: "D3067",
      description: "High-quality DNA from FFPE tissue",
      handle: "/products/quick-dna-ffpe-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3067_Quick-DNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      subtitle: "D4076",
      description:
        "High efficiency recovery of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      handle: "/products/quick-cfdna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Blood Tube Kit",
      subtitle: "R1151",
      description:
        "Co-Purification from the DNA/RNA Shield Blood Collection Tube",
      handle: "/products/quick-dna-rna-blood-tube-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/r1151_quick-dna-rna-blood-tube-kit_1.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA HMW MagBead Kit",
      subtitle: "D6060",
      description:
        "Extract ultra-pure high molecular weight DNA up to 150 kb from any sample.",
      handle: "/products/quick-dna-hmw-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "DNA Isolation": [
    {
      title: "Quick-DNA Environmental Kits",
      subtitle: "DNA",
      description:
        "Isolation technologies for inhibitor-free DNA from a wide range of samples including bacteria, fungus, plant, feces, soil, and other environment-derived materials.",
      handle: "/pages/quick-dna-environmental-kits",
      isKit: true,
      image_url:
        "http://files.zymoresearch.com/images/D6110_Quick-DNA-Fecal-Soil-Microbe_Midiprep.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Genomic DNA Clean & Concentrator (gDCC)",
      subtitle: "DNA",
      description:
        "The Genomic DNA Clean & Concentrator kits are gDNA clean up kits that provide quick clean-up of large-sized DNA in just 5 minutes. Get free gDNA clean up kits sample today with free shipping.",
      handle: "/collections/genomic-dna-clean-concentrator-gdcc",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4011-Genomic-DNA-Clean-&-Concentrator-10.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Kits",
      subtitle: "DNA",
      description:
        "The Quick-DNA Plus Kits are the easiest DNA isolation kits for high yield DNA isolation from any cells, tissues, and biological fluids. Get free DNA isolation kits sample & shipping. ",
      handle: "/collections/quick-dna-extraction-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "DNA",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Fecal/Soil Microbe kits are affordable fecal and soil DNA extraction kits for fast, easy isolation of inhibitor-free, PCR-quality host cell and microbial DNA from a variety of sample sources.",
      handle: "/collections/quick-dna-fecal-soil-microbe-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010_Quick-DNA-Fecal-Soil-Microbe-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Tissue/Insect Kits",
      subtitle: "DNA",
      description:
        "Simple and rapid isolation of DNA from fresh, frozen, or stored insect specimens.",
      handle: "/collections/quick-dna-tissue-insect-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6015_Quick-DNA-Tissue-Insect-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Plant/Seed Kits",
      subtitle: "DNA",
      description:
        "Simple, rapid isolation of inhibitor-free, PCR-quality DNA from a variety of plant sample sources.",
      handle: "/collections/quick-dna-plant-seed-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6020_Quick-DNA-Plant-Seed-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Femto DNA Quantification Kits",
      subtitle: "DNA",
      description:
        "Detect and quantify human, bacterial, and fungal DNA with high specificity and sensitivity. ",
      handle: "/collections/femto-dna-quantification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2005_Femto-Human-DNA-Quantification-Kit.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>Quick</i>-DNA Viral Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Viral Kits are viral DNA purification kits that provide for the rapid isolation of high-quality viral DNA from a wide range of biological sources.",
      handle: "/collections/quick-dna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3015_Quick-DNA-Viral-DNA-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      subtitle: "R1072",
      description:
        "Isolate cfDNA and cfRNA efficiently and easily from biological fluids",
      handle: "/products/quick-cfdna-rna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pinpoint Slide DNA Isolation System",
      subtitle: "D3001",
      description:
        "Streamlined method for isolation of DNA from targeted areas of fresh and FFPE tissue slides",
      handle: "/products/pinpoint-slide-dna-isolation-system",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001_Pinpoint-Slide-DNA-Isolation-System-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Urine Kit",
      subtitle: "D3061",
      description:
        "Extract high quality cell-free or cellular DNA from up to 40 ml of urine",
      handle: "/products/quick-dna-urine-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3061_Quick-DNA-Urine-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA FFPE Miniprep",
      subtitle: "D3067",
      description: "High-quality DNA from FFPE tissue",
      handle: "/products/quick-dna-ffpe-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3067_Quick-DNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Lab Essentials Pack",
      subtitle: "D4000-LE",
      description: "DNA clean-up and purification value set",
      handle: "/products/lab-essentials-pack",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D4000-LE4.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      subtitle: "D4076",
      description:
        "High efficiency recovery of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      handle: "/products/quick-cfdna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Viral RNA": [
    {
      title: "<i>Quick</i>-RNA Viral Kits",
      subtitle: "RNA",
      description:
        "The <i>Quick</i>- RNA Viral Kits are viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      handle: "/collections/quick-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral Kits",
      subtitle: "DNA/RNA Purification",
      description:
        "The Quick-DNA/RNA Viral kits are viral DNA/RNA purification kits that provide for rapid isolation of high-quality viral nucleic acids from a wide range of biological sources.",
      handle: "/collections/quick-dna-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "<i>Quick</i>-DNA/RNA Pathogen kits simplify purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      handle: "/collections/quick-dna-rna-pathogen-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Small & microRNA Isolation": [],
  "Non-coding RNA": [
    {
      title: "<i>Quick</i>-RNA Kits",
      subtitle: "RNA",
      description:
        "The Quick-RNA kits are RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes. Get a free sample today with free shipping. ",
      handle: "/collections/quick-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Direct-zol RNA Kits",
      subtitle: "RNA",
      description:
        "RNA purification kits that provide purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRIzol or Tri Reagent in 7 minutes. Get a free RNA purification kits sample with free shipping. ",
      handle: "/collections/direct-zol-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  miRNA: [
    {
      title: "<i>Quick</i>-RNA Kits",
      subtitle: "RNA",
      description:
        "The Quick-RNA kits are RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes. Get a free sample today with free shipping. ",
      handle: "/collections/quick-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Direct-zol RNA Kits",
      subtitle: "RNA",
      description:
        "RNA purification kits that provide purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRIzol or Tri Reagent in 7 minutes. Get a free RNA purification kits sample with free shipping. ",
      handle: "/collections/direct-zol-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "RNA Automated/High-Throughput": [
    {
      title: "Direct-zol-96 MagBead RNA",
      subtitle: "R2100, R2101, R2102, R2103, R2104, R2105",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral MagBead",
      subtitle: "R2140, R2141",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Load N’ Go DNA/RNA Viral Kit",
      subtitle: "R2143",
      description: "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      handle: "/products/load-n-go-dna-rna-viral-kit",
      isKit: true,
      ribbon: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      subtitle: "R2145, R2146",
      description:
        "Pathogen DNA/RNA isolation from vectors, tissue and biological samples.",
      handle: "/products/quick-dna-rna-pathogen-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 RNA Kits",
      subtitle: "R2054, R2055, R2056, R2057",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA 96 Kit",
      subtitle: "R1052, R1053",
      description:
        "Isolate total RNA and small/miRNA from cells and soft tissue",
      handle: "/products/quick-rna-96-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral 96 Kit",
      subtitle: "R1040, R1041",
      description: "Viral RNA from all biological fluids",
      handle: "/products/quick-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1040_Quick-RNA-Viral-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      subtitle: "D7022, D7023",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA MagBead",
      subtitle: "R2132, R2133",
      description:
        "High-throughput, magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
      handle: "/products/quick-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2132_quick-rna-magbead-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead RNA",
      subtitle: "R2137, R2138",
      description:
        "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
      handle: "/products/zymobiomics-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2137_zymobiomics-magbead-rna-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator MagBead",
      subtitle: "R1081, R1082",
      description:
        "The RNA Clean & Concentrator kits are RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality NGS and RT-qPCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1082_RNA-Clean-and-Concentrator-Magbead-Kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "RNA High-Throughput/Automated Isolation": [
    {
      title: "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      subtitle: "D7022, D7023",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral 96 Kit",
      subtitle: "R1040, R1041",
      description: "Viral RNA from all biological fluids",
      handle: "/products/quick-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1040_Quick-RNA-Viral-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA 96 Kit",
      subtitle: "R1052, R1053",
      description:
        "Isolate total RNA and small/miRNA from cells and soft tissue",
      handle: "/products/quick-rna-96-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 RNA Kits",
      subtitle: "R2054, R2055, R2056, R2057",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral MagBead",
      subtitle: "R2140, R2141",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Load N’ Go DNA/RNA Viral Kit",
      subtitle: "R2143",
      description: "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      handle: "/products/load-n-go-dna-rna-viral-kit",
      isKit: true,
      ribbon: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      subtitle: "R2145, R2146",
      description:
        "Pathogen DNA/RNA isolation from vectors, tissue and biological samples.",
      handle: "/products/quick-dna-rna-pathogen-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 MagBead RNA",
      subtitle: "R2100, R2101, R2102, R2103, R2104, R2105",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA MagBead",
      subtitle: "R2132, R2133",
      description:
        "High-throughput, magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
      handle: "/products/quick-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2132_quick-rna-magbead-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead RNA",
      subtitle: "R2137, R2138",
      description:
        "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
      handle: "/products/zymobiomics-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2137_zymobiomics-magbead-rna-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "RNA 96-well Spin Plate Isolation": [
    {
      title: "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      subtitle: "D7022, D7023",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral 96 Kit",
      subtitle: "R1040, R1041",
      description: "Viral RNA from all biological fluids",
      handle: "/products/quick-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1040_Quick-RNA-Viral-96-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA 96 Kit",
      subtitle: "R1052, R1053",
      description:
        "Isolate total RNA and small/miRNA from cells and soft tissue",
      handle: "/products/quick-rna-96-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 RNA Kits",
      subtitle: "R2054, R2055, R2056, R2057",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "RNA 96-well Magnetic Bead Isolation": [
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral MagBead",
      subtitle: "R2140, R2141",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      subtitle: "R2145, R2146",
      description:
        "Pathogen DNA/RNA isolation from vectors, tissue and biological samples.",
      handle: "/products/quick-dna-rna-pathogen-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 MagBead RNA",
      subtitle: "R2100, R2101, R2102, R2103, R2104, R2105",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA MagBead",
      subtitle: "R2132, R2133",
      description:
        "High-throughput, magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
      handle: "/products/quick-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2132_quick-rna-magbead-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead RNA",
      subtitle: "R2137, R2138",
      description:
        "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
      handle: "/products/zymobiomics-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2137_zymobiomics-magbead-rna-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "RNA High-Throughput/Automated Clean-Up": [
    {
      title: "RNA Clean & Concentrator-96",
      subtitle: "R1080",
      description: "RNA clean-up from any reaction",
      handle: "/products/rna-clean-concentrator-96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 Oligo Clean & Concentrator",
      subtitle: "D4062, D4063",
      description:
        "Clean any DNA and RNA oligos in high-throughput format and elute in 10 &micro;l",
      handle: "/products/oligo-clean-concentrator-zr96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator MagBead",
      subtitle: "R1081, R1082",
      description:
        "The RNA Clean & Concentrator kits are RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality NGS and RT-qPCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1082_RNA-Clean-and-Concentrator-Magbead-Kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "RNA 96-well Spin Plate Clean-Up": [
    {
      title: "RNA Clean & Concentrator-96",
      subtitle: "R1080",
      description: "RNA clean-up from any reaction",
      handle: "/products/rna-clean-concentrator-96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 Oligo Clean & Concentrator",
      subtitle: "D4062, D4063",
      description:
        "Clean any DNA and RNA oligos in high-throughput format and elute in 10 &micro;l",
      handle: "/products/oligo-clean-concentrator-zr96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "RNA 96-well Magnetic Bead Clean-Up": [
    {
      title: "RNA Clean & Concentrator MagBead",
      subtitle: "R1081, R1082",
      description:
        "The RNA Clean & Concentrator kits are RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality NGS and RT-qPCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1082_RNA-Clean-and-Concentrator-Magbead-Kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Soil, Fecal & Plant RNA": [
    {
      title: "Direct-zol RNA Miniprep & Lysis Tubes",
      subtitle: "R2050, R2051, S6003-50, S6012-50, S6014-50",
      description:
        "Use ZR BashingBead Lysis Tubes for tough-to-lyse samples in TRIzol prior to purifying with the Direct-zol RNA kit.",
      handle: "/products/direct-zol-rna-miniprep-and-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS RNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS RNA Kits are designed for the purification of microbial RNA (including small/miRNAs) from any sample input.",
      handle: "/collections/zymobiomics-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA/RNA Kits are designed for the purification of inhibitor-free microbial DNA and total RNA (including small/miRNAs) from any sample input.",
      handle: "/collections/zymobiomics-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
      subtitle: "R2040",
      description:
        "The Quick-RNA Fecal/Soil Microbe Microprep Kit is an affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
      handle: "/products/quick-rna-fecal-soil-microbe-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2040_Quick-RNA-Fecal-Soil-Microbe-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Plant Kit",
      subtitle: "R2024",
      description: "Isolate inhibitor-free RNA from plant and seed samples.",
      handle: "/products/quick-rna-plant-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2024_Quick-RNA-Plant-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Blood, Serum, Plasma & Body Fluid RNA": [
    {
      title: "<i>Quick</i>-RNA Whole Blood",
      subtitle: "R1201",
      description: "Isolate RNA and small/miRNA from whole blood.",
      handle: "/products/quick-rna-whole-blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1201_Quick-RNA-Whole-Blood-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfRNA Serum & Plasma Kit",
      subtitle: "R1059",
      description: "Isolate cell-free RNA from biological fluid samples.",
      handle: "/products/quick-cfrna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1059_Quick-cfRNA-Serum-Plasma-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      subtitle: "R1072",
      description:
        "Isolate cfDNA and cfRNA efficiently and easily from biological fluids",
      handle: "/products/quick-cfdna-rna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Blood Collection",
      subtitle: "Sample Collection",
      description: "DNA/RNA transport medium for whole blood",
      handle: "/pages/sample-collection-kits?tags=blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "DNA/RNA Shield",
      subtitle: "Sample Collection",
      description:
        "DNA/RNA Shield products are DNA and RNA transport and storage mediums for any biological samples. Get free samples with free shipping.",
      handle: "/collections/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR Urine RNA Isolation Kit",
      subtitle: "R1038, R1039",
      description: "Isolate RNA from up to 30 ml of urine.",
      handle: "/products/zr-urine-rna-isolation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1038_ZR-Urine-RNA-Isolation-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Bacteria, Yeast & Fungi": [
    {
      title: "ZymoBIOMICS RNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS RNA Kits are designed for the purification of microbial RNA (including small/miRNAs) from any sample input.",
      handle: "/collections/zymobiomics-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA/RNA Kits are designed for the purification of inhibitor-free microbial DNA and total RNA (including small/miRNAs) from any sample input.",
      handle: "/collections/zymobiomics-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep & Lysis Tubes",
      subtitle: "R2050, R2051, S6003-50, S6012-50, S6014-50",
      description:
        "Use ZR BashingBead Lysis Tubes for tough-to-lyse samples in TRIzol prior to purifying with the Direct-zol RNA kit.",
      handle: "/products/direct-zol-rna-miniprep-and-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "YeaStar RNA Kit",
      subtitle: "R1002",
      description:
        "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      handle: "/products/yeastar-rna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fungal/Bacterial Kit",
      subtitle: "R2010",
      description:
        "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      handle: "/products/quick-rna-fungal-bacterial-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fungal/Bacterial Miniprep Kit",
      subtitle: "R2014",
      description:
        "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      handle: "/products/quick-rna-fungal-bacterial-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2014_Quick-RNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "DNA Isolation & RNA Isolation": [
    {
      "title": "<i>Quick</i>-DNA HMW MagBead Kit",
      "subtitle": "D6060",
      "description": "Extract ultra-pure high molecular weight DNA from any sample. ",
      "handle": "/products/quick-dna-hmw-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "HostZERO Microbial DNA Kit",
      subtitle: "D4310",
      description:
        "Streamlined host depletion and bacterial DNA isolation from mammalian samples.",
      handle: "/products/hostzero-sup-trade-sup-microbial-dna-kit-microprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4310-A_HostZERO-Microbial-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS RNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS RNA Kits are designed for the purification of microbial RNA (including small/miRNAs) from any sample input.",
      handle: "/collections/zymobiomics-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA/RNA Kits are designed for the purification of inhibitor-free microbial DNA and total RNA (including small/miRNAs) from any sample input.",
      handle: "/collections/zymobiomics-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
  ],
  "Nucleic Acid Clean-Up & Concentration": [
    {
      title: "DNA Clean & Concentrator Kits (DCC)",
      subtitle: "DNA",
      description:
        "DNA Clean & Concentrator Kits are PCR purification kits that provide purification of DNA from PCR and other enzymatic reactions in as little as 2 minutes. Free PCR purification kits sample.\n",
      handle: "/collections/dcc-pcr-purification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Genomic DNA Clean & Concentrator (gDCC)",
      subtitle: "DNA",
      description:
        "The Genomic DNA Clean & Concentrator kits are gDNA clean up kits that provide quick clean-up of large-sized DNA in just 5 minutes. Get free gDNA clean up kits sample today with free shipping.",
      handle: "/collections/genomic-dna-clean-concentrator-gdcc",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4011-Genomic-DNA-Clean-&-Concentrator-10.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator Kits (RCC)",
      subtitle: "RNA",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free (R1013, R1014) RNA. Get free RNA clean up kits sample. ",
      handle: "/collections/rna-clean-concentrator-kits-rcc",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Select-a-Size DNA Clean & Concentrator Kits",
      subtitle: "DNA",
      description:
        "The fastest and easiest size selection DNA kits to purify specific ranges of DNA fragments from PCR, endonuclease digestions, ligations, library preparations, adapter removal, etc. Free size selection DNA kits sample. ",
      handle: "/collections/select-a-size-dna-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Oligo Clean & Concentrator Kits (OCC)",
      subtitle: "DNA",
      description:
        "The Oligo Clean & Concentrator provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
      handle: "/collections/oligo-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zymoclean Gel DNA Recovery Kits",
      subtitle: "DNA",
      description:
        "Gel DNA extraction kits that provide highly efficient DNA purification from agarose gels. Get a free gel DNA extraction kits sample with free shipping.\n",
      handle: "/collections/zymoclean-gel-dna-recovery-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
  ],
  "Microbial Analysis": [
    {
      title: "ZymoBIOMICS DNA/RNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA/RNA Kits are designed for the purification of inhibitor-free microbial DNA and total RNA (including small/miRNAs) from any sample input.",
      handle: "/collections/zymobiomics-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Blood Sample Collection": [
    {
      title: "DNA/RNA Shield",
      subtitle: "Sample Collection",
      description:
        "DNA/RNA Shield products are DNA and RNA transport and storage mediums for any biological samples. Get free samples with free shipping.",
      handle: "/collections/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Blood Collection",
      subtitle: "Sample Collection",
      description: "DNA/RNA transport medium for whole blood",
      handle: "/pages/sample-collection-kits?tags=blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Environmental Sample Collection": [
    {
      title: "DNA/RNA Shield",
      subtitle: "Sample Collection",
      description:
        "DNA/RNA Shield products are DNA and RNA transport and storage mediums for any biological samples. Get free samples with free shipping.",
      handle: "/collections/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Fecal Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "/pages/sample-collection-kits?tags=feces",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Blood Collection",
      subtitle: "Sample Collection",
      description: "DNA/RNA transport medium for whole blood",
      handle: "/pages/sample-collection-kits?tags=blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Saliva Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "/pages/sample-collection-kits?tags=saliva",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1210_DNA-RNA-Shield-Saliva-Collection-Kit.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Vector and Environmental Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "/pages/sample-collection-kits?tags=environmental-vector",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1103-DNA-RNA-Shield-Lysis-Tube-(Microbe).jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Tissue Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "/pages/sample-collection-kits?tags=tissue",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Pathogenic Sample Collection": [
    {
      title: "DNA/RNA Shield",
      subtitle: "Sample Collection",
      description:
        "DNA/RNA Shield products are DNA and RNA transport and storage mediums for any biological samples. Get free samples with free shipping.",
      handle: "/collections/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Fecal Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "/pages/sample-collection-kits?tags=feces",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Blood Collection",
      subtitle: "Sample Collection",
      description: "DNA/RNA transport medium for whole blood",
      handle: "/pages/sample-collection-kits?tags=blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Saliva Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "/pages/sample-collection-kits?tags=saliva",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1210_DNA-RNA-Shield-Saliva-Collection-Kit.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Vector and Environmental Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "/pages/sample-collection-kits?tags=environmental-vector",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1103-DNA-RNA-Shield-Lysis-Tube-(Microbe).jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Tissue Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "/pages/sample-collection-kits?tags=tissue",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Bacterial Plasmid": [
    {
      title: "ZymoPURE Plasmid Kits",
      subtitle: "Plasmid Purification",
      description:
        "ZymoPURE II Plasmid Kits provide the fastest, simplest method to isolate transfection quality DNA from E. coli. Free samples of plasmid kits get free shipping.",
      handle: "/collections/zymopure-plasmid-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zyppy Plasmid Kits",
      subtitle: "Plasmid Purification",
      description:
        "The Zyppy Plasmid Kits are plasmid DNA kits that provide pellet-free high-quality plasmid DNA in only 8 minutes. Get a free plasmid DNA kits sample with free shipping. ",
      handle: "/collections/zyppy-plasmid-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR BAC DNA Miniprep Kit",
      subtitle: "D4048, D4049",
      description:
        "Quickly isolate large constructs (≤200 kb) from <i>E. coli</i> using a spin-column",
      handle: "/products/zr-bac-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Yeast: [
    {
      title: "Zymolyase Ultra",
      subtitle: "E1007T, E1007-2, E1007-10",
      description: "Ultra fast & Ultra clean.",
      handle: "/products/zymolyase-ultra",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1007T-Zymolyase-Ultra-100-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
        title: "Frozen-EZ Yeast Transformation II Kit",
        subtitle: "T2001",
        description:
          "Quickly and simply make competent yeast cells for highly efficient transformations.",
        handle: "/products/frozen-ez-yeast-transformation-ii-kit",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/T2001_Frozen-EZ-Yeast-Transformation-II-Kit.jpg",
        searchWeight: 13,
        tags: ["No Ground Shipping"],
      },
      {
        title: "Zymolyase",
        subtitle: "E1004, E1005, E1006",
        description:
          "Yeast lytic enzyme for simple and effective digestion of fungal cell walls.",
        handle: "/products/zymolyase",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/E1005_Zymolayse-2000-U.jpg",
        searchWeight: 12,
        tags: [],
      },
      {
        title: "Zymoprep Yeast Plasmid Miniprep Kits",
        subtitle: "D2001, D2004, D2005, D2006, D2007",
        description:
          "The fastest and simplest solutions for purifying the highest quality plasmid DNA from yeast.",
        handle: "/collections/zymoprep-yeast-plasmid-miniprep",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
        searchWeight: 11,
        tags: [],
      },
      {
        title: "YeaStar Genomic DNA Kit",
        subtitle: "D2002",
        description:
          "Simple total DNA purification from a broad spectrum of fungal species.",
        handle: "/products/yeastar-genomic-dna-kit",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
        searchWeight: 10,
        tags: [],
      },
      {
        title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
        subtitle: "D6007, D6005, D6105, D6006",
        description:
          "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
        handle: "/collections/quick-dna-fungal-bacterial-kits",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
        searchWeight: 9,
        tags: [],
      },
      {
        title: "YeaStar RNA Kit",
        subtitle: "R1002",
        description:
          "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
        handle: "/products/yeastar-rna-kit",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
        searchWeight: 8,
        tags: [],
      },
      {
        title: "<i>Quick</i>-RNA Fungal/Bacterial Kits",
        subtitle: "R2010, R2014",
        description:
          "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
        handle: "/collections/quick-rna-fungal-bacterial-kit",
        isKit: false,
        image_url:
          "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
        searchWeight: 7,
        tags: [],
      },
      {
        title: "Yeast Protein Kit",
        subtitle: "Y1002",
        description:
          "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
        handle: "/products/yeast-protein-kit",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
        searchWeight: 6,
        tags: [],
      },
      {
        title: "YPD Plus",
        subtitle: "Y1003-100, Y1003-50",
        description:
          "Specialized medium for yeast outgrowth to increase yeast transformation efficiencies.",
        handle: "/products/ypd-plus",
        isKit: true,
        image_url: "https://files.zymoresearch.com/images/Y1003-50-YPD-Plus.jpg",
        searchWeight: 5,
        tags: [],
      },
      {
        title: "Alpha-Factor Mating Pheromone",
        subtitle: "Y1001",
        description:
          "Convenient aqueous solution for arresting yeast in G1 of the cell cycle.",
        handle: "/products/alpha-factor-mating-pheromone",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/Y1001_Alpha-Factor-Mating-Pheromone.jpg",
        searchWeight: 4,
        tags: ["DRY ICE"],
      },
      {
        title: "a-Factor Mating Pheromone",
        subtitle: "Y1004-500",
        description:
          "Convenient aqueous solution for arresting yeast in G1 of the cell cycle. Opposite to the alpha-factor mating pheromone.",
        handle: "/products/a-factor-mating-pheromone",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/Y1004_a-Factor-Mating-Pheromone-A-Factor-500-ul.jpg",
        searchWeight: 3,
        tags: ["DRY ICE"],
      },
      {
        title: "5-Fluoroorotic Acid (5-FOA)",
        subtitle: "F9001-1, F9001-5, F9003",
        description: "Convenient yeast genetic counter-selection agent.",
        handle: "/products/5-fluoroorotic-acid",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/F9001-1_5-Fluoroorotic-Acid-1-g.jpg",
        searchWeight: 2,
        tags: ["DRY ICE"],
      },
      {
        title: "Frozen-EZ Yeast Solution",
        subtitle: "T2002, T2003, T2004",
        description:
          "Frozen-EZ Yeast Transformation II Kit for yeast transformations",
        handle: "/products/frozen-ez-yeast-solution",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/images/T2002_Frozen-EZ-Solution-1.jpg",
        searchWeight: 1,
        tags: ["No Ground Shipping"],
      }
  ],
  "Yeast Mating Pheromones": [
    {
      title: "Alpha-Factor Mating Pheromone",
      subtitle: "Y1001",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle.",
      handle: "/products/alpha-factor-mating-pheromone",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1001_Alpha-Factor-Mating-Pheromone.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "a-Factor Mating Pheromone",
      subtitle: "Y1004-500",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle. Opposite to the alpha-factor mating pheromone.",
      handle: "/products/a-factor-mating-pheromone",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1004_a-Factor-Mating-Pheromone-A-Factor-500-ul.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  
  "Laboratory Equipment & Supplies": [
    {
      title: "DNA Purification",
      subtitle: "DNA",
      description: "Choose from a variety of high-throughput products, kits and free samples for automated DNA isolation and clean-up.",
      handle: "/pages/dna-automated-high-throughput",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RNA Purification",
      subtitle: "RNA",
      description: "Choose from a variety of high-throughput products, kits and free samples for automated RNA isolation and clean-up.",
      handle: "/pages/rna-extraction-kits?tags=high-throughput",
      isKit: false,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/products/R2054_Direct-zol-96-RNA_No-TRI-Reagent_600x.jpg?v=1588502264",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Total Nucleic Acid Purification",
      subtitle: "Nucleic Acid",
      description: "Choose from a variety of high-throughput products, kits and free samples for automated Nucleic Acid isolation and clean-up.",
      handle: "/pages/dna-rna-co-extraction-kits?tags=high-throughput",
      isKit: false,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/products/R2054_Direct-zol-96-RNA_No-TRI-Reagent_600x.jpg?v=1588502264",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Bisulfite Conversion",
      subtitle: "Epigenetics",
      description: "High throughput epigenetics kits for fast, easy automated bisulfite conversion. Try a kit today.",
      handle: "/pages/epigenetics-high-throughput-automated-isolation",
      isKit: false,
      image_url:
        "https://stage.zymoresearch.com/cdn/shop/products/D5003-EZ-96-DNA-Methylation-Kit---shallow-well_600x.png?v=1628532406",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "NGS Library Preparation",
      subtitle: "Epigenetics",
      description: "Simple NGS Library Prep Kits. Zymo Research's unique NGS library prep kits feature easy-to-use, streamlined workflows to generate ready-to-sequence libraries.",
      handle: "/pages/ngs-library-prep-kits",
      isKit: false,
      image_url:
        "https://stage.zymoresearch.com/cdn/shop/products/D5458-Zymo-Seq-ATAC-Library-Kit_2365_002_ProductPhoto_600x.jpg?v=1677624838",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Filter Plate",
      subtitle: "C2022, C2022-1",
      description:
        "High-throughput clarification of bacterial lysates.",
      handle: "/products/zymopure-filter-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2022_ZymoPURE-Filter-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Spin P-96 Plate",
      subtitle: "C2023, C2023-1",
      description:
        "High-throughput plasmid DNA purification spin-plate.",
      handle: "/products/zymo-spin-p-96-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2023_Zymo-Spin-P-96-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Wash Plate",
      subtitle: "C2024, C2024-1",
      description:
        "96-well plate for minimizing cross-contamination during high-throughput processing.",
      handle: "/products/wash-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2024_Wash-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96-Well 2.0 mL Deep Well Plate",
      subtitle: "C2015, C2015-50",
      description:
        "96-Well Plate for Liquid Handling Robots",
      handle: "/products/96-well-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2015-2_96-Well-2.0-ml-Deep-Well-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Elution Plate (V-Bottom, 200 µL)",
      subtitle: "C1030, C1030-50",
      description:
        "96-Well Polypropylene Elution Plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-elution-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C1030_96_elution_plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Deep Well Plate (V-Bottom, 2.2ml)",
      subtitle: "C2018-5, C2018-50",
      description:
        "96-Well Polypropylene plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-deep-well-plate-v-bottom-2-2ml",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2018_ZRC_2164.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96 Tip Combs (For V-Bottom Deep Well Plate)",
      subtitle: "C2019, C2019-100",
      description:
        "96 Tip Comb for Magnetic Bead Moving Instruments",
      handle: "/products/96-tip-combs-for-v-bottom-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2019_ZRC_2146.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I Columns",
      subtitle: "C1003-250, C1003-50",
      description:
        "Uncapped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in &ge; 6 &micro;l.",
      handle: "/products/zymo-spin-i-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1003-Zymo-Spin-I.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC Columns",
      subtitle: "C1004-250, C1004-50",
      description:
        "Capped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in ≥ 6 &micro;l.",
      handle: "/products/zymo-spin-ic-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1004-Zymo-Spin-IC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XL",
      subtitle: "C1002-25, C1002-50",
      description:
        "Capped columns for the recovery of large-sized DNA in &ge; 10 &micro;l.",
      handle: "/products/zymo-spin-ic-xl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1002-50-Zymo-Spin-IC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XM Columns",
      subtitle: "C1103-50",
      description: "",
      handle: "/products/zymo-spin-ic-xm-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1103-50_Zymo-Spin IC-XM Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-S Columns",
      subtitle: "C1015-25, C1015-50",
      description:
        "The Zymo-Spin IC-S features durable polypropylene construction and contains a unique silica-based matrix that allows purification",
      handle: "/products/zymo-spin-ic-s-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1015-50-Zymo-Spin-IC-S.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB Columns",
      subtitle: "C1014-250, C1014-50",
      description: "Columns for nucleic acid purification and dye removal.",
      handle: "/products/zymo-spin-ib-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1014-Zymo-Spin-IB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin P1 Columns",
      subtitle: "P2003-1",
      description: "Columns for purification of His-tagged proteins.",
      handle: "/products/zymo-spin-p1-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zymo-spin_pi_c2003-1_.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II Columns",
      subtitle: "C1008-250, C1008-50",
      description:
        "Uncapped columns for the recovery of &le; 25 &micro;g  DNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-ii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1008-50-Zymo-Spin-II.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIC Columns",
      subtitle: "C1011-250, C1011-50",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iic-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1011-50-OPEN-CAP-Zymo-Spin-IIC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIN Columns",
      subtitle: "C1019-250, C1019-50",
      description:
        "Uncapped columns for the recovery of &le;  25 µg  DNA in &ge; 30 &micro;l.",
      handle: "/products/zymo-spin-iin-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1019-Zymo-Spin-IIN.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-µHRC Filters",
      subtitle: "C1059-50",
      description: "For use with Zymo Research products.",
      handle: "/products/zymo-spin-ii-µhrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1059_Zymo Spin II-HRC.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-P Columns",
      subtitle: "C1055-50",
      description: "",
      handle: "/products/zymo-spin-ii-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1055-50_Zymo-Spin II-P Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III Columns",
      subtitle: "C1005-250, C1005-50",
      description:
        "The Zymo-Spin III features durable polypropylene construction that allows purification of up to 25 &micro;g DNA or RNA in &ge; 35 &micro;l eluate.",
      handle: "/products/zymo-spin-iii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1005-Zymo-Spin-III.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIICG Columns",
      subtitle: "C1006-250-G, C1006-50-G",
      description: "",
      handle: "/products/zymo-spin-iiicg-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-G-Zymo-Spin-IIICG.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-F Filters",
      subtitle: "C1057-50",
      description: "For use in Zymo Research environmental purification kits.",
      handle: "/products/zymo-spin-iii-f-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1057-Zymo-Spin-III-F.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-HRC Filters",
      subtitle: "C1058-50",
      description: "",
      handle: "/products/zymo-spin-iii-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1058-Zymo-Spin-III-HRC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV-IR HRC Filters",
      subtitle: "C1010-50",
      description: "",
      handle: "/products/zymo-spin-iv-ir-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1010-50_Zymo-Spin-IV-IR-HRC-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "Zymo-Spin III-P Column Assembly w/ 15 ml and 50 ml Reservoir (5 Pack)",
      subtitle: "C1040-5",
      description: "",
      handle:
        "/products/zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1040-5-Zymo-Spin-III-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-S Columns w/ LuerLock Caps and 15 ml Reservoir",
      subtitle: "C1049-25",
      description: "",
      handle:
        "/products/zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/(3) Zymo Spin IIIS.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV Columns",
      subtitle: "C1007-250, C1007-50",
      description: "",
      handle: "/products/zymo-spin-iv-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/c1007-50-zymo-spin-iv.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns",
      subtitle: "C1012-25, C1012-50",
      description:
        "Column for purifying up to 100 &micro;g  DNA or RNA in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1012-25-Zymo-Spin-V.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns w/ Reservoir",
      subtitle: "C1016-25, C1016-50",
      description:
        "Assembly for purifying DNA/RNA from &le; 15 ml sample in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1016-25-Zymo-Spin-V-with-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-P Column Assembly w/ 15 ml and 50 ml Reservoir",
      subtitle: "C1042-5",
      description:
        "The Zymo-Spin V-P can be used in centrifuges or on-vacuum manifolds to purify plasmid DNA.",
      handle:
        "/products/zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1042-5--Zymo-Spin-V-P-with-15-ml-and-50-ml-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-E Columns",
      subtitle: "C1021-25, C1024-25, C1024-50, C1029-25",
      description:
        "The Zymo-Spin V-E columns can be used in microcentrifuges, centrifuges, or on vacuum manifolds",
      handle: "/products/zymo-spin-v-e-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1024-25-Zymo-Spin-VE.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns",
      subtitle: "C1013-10, C1013-20",
      description:
        "Column for recovery of up to 500 &micro;g  DNA or RNA in &ge; 2 ml.",
      handle: "/products/zymo-spin-vi-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1013-10-Zymo-Spin-VI.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Reservoir",
      subtitle: "C1018-10, C1018-20",
      description:
        "Column assembly for recovery of DNA/RNA from large volumes.",
      handle: "/products/zymo-spin-vi-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1018-Zymo-Spin-VI-with-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Zymo-Maxi Filter",
      subtitle: "C1017-10, C1017-20",
      description:
        "Column-filter assembly for purifying DNA/RNA from &le; 75 ml sample",
      handle: "/products/zymo-spin-vi-columns-w-zymo-maxi-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1017-10-Zymo-Spin-VI-with-maxi-filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI-P Columns",
      subtitle: "C1044-5",
      description:
        "Zymo-Spin VI-P can be used in centrifuges or on vacuum manifolds for the purification of plasmid DNA.",
      handle: "/products/zymo-spin-vi-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1044-5-Zymo-Spin-VI-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96 Plate",
      subtitle: "C2004, C2004-SW",
      description:
        "Deep-well (96) plate purification of DNA/RNA in &ge; 10 &micro;l elution.",
      handle: "/products/zymo-spin-i-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2004-Zymo-Spin-I-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96-XL Plates",
      subtitle: "C2010",
      description:
        "Deep-well (96) plate purification of large DNA in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-i-96-xl-plates",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2010-Zymo-Spin-III-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A Plate",
      subtitle: "C2001",
      description:
        "Shallow-well (96) plate purification of DNA/RNA in &ge; 30 &micro;l.",
      handle: "/products/silicon-a-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-Silicon-A-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB-96 Plate",
      subtitle: "C2006",
      description:
        "Deep-well (96) plate for DNA clean-up & dye removal in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-ib-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2006-Zymo-Spin-IB-96-plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A-HRC Plate",
      subtitle: "C2009",
      description: "",
      handle: "/products/silicon-a-hrc-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2009-Silicon-A-HRC-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Plate",
      subtitle: "C2002",
      description:
        "1.2 ml, round bottom, 96-well plate for use with spin plate.",
      handle: "/products/collection-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2002-Collection-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Elution Plate",
      subtitle: "C2003",
      description:
        "90 &micro;l, V-bottom, 96-well plate for use with spin plate.",
      handle: "/products/elution-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2003-Elution-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-1, S6002-96-2, S6002-96-3",
      description: "ZR BashingBeads in 96 impact resistant tube rack.",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6002-96-2-ZR-Bashing-Bead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block",
      subtitle: "P1001-10, P1001-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1001-2-96-well-block.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Conversion Plate w/ Cover Foil",
      subtitle: "C2005",
      description: "96-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/conversion-plate-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2005-C2008-96-Well-Conversion-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block w/ Cover Foil",
      subtitle: "P1002-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1002-2-96-Well-block-with-cover-foil.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Plate Cover Foil",
      subtitle: "C2007-12, C2007-2, C2007-24, C2007-4, C2007-6, C2007-8",
      description: "Pierceable aluminum foil with strong adhesive for sealing.",
      handle: "/products/96-well-plate-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2007_96-well Cover Foils.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MagBinding Beads",
      subtitle:
        "D4100-2-12, D4100-2-16, D4100-2-24, D4100-2-3, D4100-2-6, D4100-2-8",
      description:
        "For use with Zymo Research magnetic bead-based purification kits.",
      handle: "/products/magbinding-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Syringe Filters",
      subtitle: "C1036-5",
      description:
        "The ZymoPURE Syringe Filter features rapid clarification of up to 60 ml of neutralized lysate",
      handle: "/products/zymopure-syringe-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1036-5-Syringe-Filters.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Giga Filter",
      subtitle: "C1038-1",
      description: "",
      handle: "/products/zymopure-giga-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1038-1-ZymoPure-Giga-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Spin-Away Filters",
      subtitle: "C1006-250-F, C1006-50-F",
      description: "For use with Zymo Research purification kits",
      handle: "/products/spin-away-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-F-Spin-Away-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZRC GF Filter",
      subtitle: "C1009-20, C1009-50",
      description:
        "Filter for separating cellular components from biological fluids.",
      handle: "/products/zrc-gf-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1009-20-ZRC-GF-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "15 ml Conical Reservoir",
      subtitle: "C1031-25",
      description: "",
      handle: "/products/15-ml-conical-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/15ml reservoir.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "25 ml Reservoir for Spin-Away Filters and Zymo-Spin IIICG",
      subtitle: "C1039-25",
      description: "",
      handle:
        "/products/25-ml-reservoir-for-spin-away-filters-and-zymo-spin-iiicg",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1039-25_Reservoir - 25 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "50 ml Conical Reservoir",
      subtitle: "C1032-25",
      description:
        "The 50 ml Reservoir can be used with vacuum manifolds for the purification of DNA and/or RNA",
      handle: "/products/50-ml-conical-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1032-25-50ml-Conical-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "600 ml Reservoir",
      subtitle: "C1033-5",
      description:
        "The 600 ml Reservoir, used with vacuum manifolds for the purification of DNA/RNA",
      handle: "/products/600-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1033-5-600-ml-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Tubes",
      subtitle: "C1001-1000, C1001-50, C1001-500",
      description:
        "Durable polypropylene collection tubes used in conjunction with Zymo-Spin columns",
      handle: "/products/collection-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1001-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase/RNase-Free Tubes",
      subtitle: "C2001-100, C2001-50",
      description:
        "DNase/RNase-free 1.5 ml microcentrifuge tubes made of durable polypropylene construction.",
      handle: "/products/dnase-rnase-free-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-100-DNase-RNase-free-tubes.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Clear Tubes, with caps",
      subtitle: "C1025-50, C1025-500, C1027-50, C1027-500",
      description:
        "Clear 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-clear-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1025-Clear-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Amber Tubes, with caps",
      subtitle: "C1026-50, C1026-500, C1028-50, C1028-500",
      description:
        "Amber 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-amber-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1026-50-Amber-Tube-with-cap-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR Bashing Bead Lysis Tubes",
      subtitle: "S6003-50",
      description: "2.0 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashing-bead-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
      subtitle: "S6014-50",
      description: "",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zr_bashingbead_lysis_tubes_2.0_mm_s6003-50__1.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
      subtitle: "S6012-50",
      description:
        "0.1 & 0.5 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/S6012-50_ZR-BashingBead-Lysis-Tubes.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Squisher-Single",
      subtitle: "H1001, H1001-50",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-single",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/H1001-Squisher-Single.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Squisher-8 w/ 96-Well Block",
      subtitle: "H1002-5, H1002-20",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-8-w-96-well-block",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/H1002-5-Squisher-8.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Squisher-96 w/ 96-Well Block",
      subtitle: "H1004-2, H1004-5",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-96-w-96-well-block",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/H1004-2-Squisher-96.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zymo-Spin IICR Columns",
      subtitle: "C1078-50, C1078-250",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iicr-columns",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/C1078_Zymo-Spin IICR Columns.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-4, S6002-96-5",
      description:
        "96-well microbial cell lysis rack for high throughput/automated bead beating",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/s6002_96_lysis_rack.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Select-a-Size MagBead Set",
      subtitle: "D4084-10, D4084-50",
      description: "For use in Select-a-Size DNA Clean & Concentrator Magbead kit.",
      handle: "/products/select-a-size-magbead-set",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4084-1-50_Select-A-Size-MagBeads-50-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBinding Beads",
      subtitle: "D4302-6-12, D4302-6-6",
      description:
        "For use in ZymoBIOMICS magnetic bead-based purification kits.",
      handle: "/products/zymobiomics-magbinding-beads",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4302-6-12_ZymoBIOMICS-MagBinding-Beads-12-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-Methylation Magprep Beads",
      subtitle:
        "D4100-5-4, D4100-5-8, D4100-5-16",
      description:
        "For use in EZ-DNA Methylation Magprep bead-based purification kits.",
      handle: "/products/ez-methylation-magprep-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MagBead J",
      subtitle:
        "D4100-3-3, D4100-3-50, D4100-3-100",
      description:
        "Optimized for low reaction volume workflows and high-throughput automation.",
      handle: "/products/magbead-j",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Wash Plate",
      subtitle: "C2024, C2024-1",
      description:
        "96-well plate for minimizing cross-contamination during high-throughput processing.",
      handle: "/products/wash-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2024_Wash-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96-Well 2.0 mL Deep Well Plate",
      subtitle: "C2015, C2015-50",
      description:
        "96-Well Plate for Liquid Handling Robots",
      handle: "/products/96-well-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2015-2_96-Well-2.0-ml-Deep-Well-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Deep Well Plate (V-Bottom, 2.2ml)",
      subtitle: "C2018-5, C2018-50",
      description:
        "96-Well Polypropylene plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-deep-well-plate-v-bottom-2-2ml",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2018_ZRC_2164.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96 Tip Combs (For V-Bottom Deep Well Plate)",
      subtitle: "C2019, C2019-100",
      description:
        "96 Tip Comb for Magnetic Bead Moving Instruments",
      handle: "/products/96-tip-combs-for-v-bottom-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2019_ZRC_2146.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-µHRC Filters",
      subtitle: "C1059-50",
      description: "For use with Zymo Research products.",
      handle: "/products/zymo-spin-ii-µhrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1059_Zymo Spin II-HRC.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-F Filters",
      subtitle: "C1057-50",
      description: "For use in Zymo Research environmental purification kits.",
      handle: "/products/zymo-spin-iii-f-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1057-Zymo-Spin-III-F.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-HRC Filters",
      subtitle: "C1058-50",
      description: "Component used in the OneStep< PCR Inhibitor Removal kit (Cat. #D6030).",
      handle: "/products/zymo-spin-iii-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1058-Zymo-Spin-III-HRC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV-IR HRC Filters",
      subtitle: "C1010-50",
      description: "",
      handle: "/products/zymo-spin-iv-ir-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1010-50_Zymo-Spin-IV-IR-HRC-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A Plate",
      subtitle: "C2001",
      description:
        "Shallow-well (96) plate purification of DNA/RNA in &ge; 30 &micro;l.",
      handle: "/products/silicon-a-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-Silicon-A-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A-HRC Plate",
      subtitle: "C2009",
      description: "",
      handle: "/products/silicon-a-hrc-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2009-Silicon-A-HRC-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Plate",
      subtitle: "C2002",
      description:
        "1.2 ml, round bottom, 96-well plate for use with spin plate.",
      handle: "/products/collection-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2002-Collection-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Elution Plate",
      subtitle: "C2003",
      description:
        "90 &micro;l, V-bottom, 96-well plate for use with spin plate.",
      handle: "/products/elution-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2003-Elution-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-1, S6002-96-2, S6002-96-3",
      description: "ZR BashingBeads in 96 impact resistant tube rack.",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6002-96-2-ZR-Bashing-Bead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block",
      subtitle: "P1001-10, P1001-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1001-2-96-well-block.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Conversion Plate w/ Cover Foil",
      subtitle: "C2005",
      description: "96-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/conversion-plate-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2005-C2008-96-Well-Conversion-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block w/ Cover Foil",
      subtitle: "P1002-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1002-2-96-Well-block-with-cover-foil.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Plate Cover Foil",
      subtitle: "C2007-12, C2007-2, C2007-24, C2007-4, C2007-6, C2007-8",
      description: "Pierceable aluminum foil with strong adhesive for sealing.",
      handle: "/products/96-well-plate-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2007_96-well Cover Foils.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Syringe Filters",
      subtitle: "C1036-5",
      description:
        "The ZymoPURE Syringe Filter features rapid clarification of up to 60 ml of neutralized lysate",
      handle: "/products/zymopure-syringe-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1036-5-Syringe-Filters.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Giga Filter",
      subtitle: "C1038-1",
      description: "",
      handle: "/products/zymopure-giga-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1038-1-ZymoPure-Giga-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Spin-Away Filters",
      subtitle: "C1006-250-F, C1006-50-F",
      description: "For use with Zymo Research purification kits",
      handle: "/products/spin-away-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-F-Spin-Away-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZRC GF Filter",
      subtitle: "C1009-20, C1009-50",
      description:
        "Filter for separating cellular components from biological fluids.",
      handle: "/products/zrc-gf-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1009-20-ZRC-GF-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "15 ml Conical Reservoir",
      subtitle: "C1031-25",
      description: "",
      handle: "/products/15-ml-conical-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/15ml reservoir.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "25 ml Reservoir for Spin-Away Filters and Zymo-Spin IIICG",
      subtitle: "C1039-25",
      description: "",
      handle:
        "/products/25-ml-reservoir-for-spin-away-filters-and-zymo-spin-iiicg",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1039-25_Reservoir - 25 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "50 ml Conical Reservoir",
      subtitle: "C1032-25",
      description:
        "The 50 ml Reservoir can be used with vacuum manifolds for the purification of DNA and/or RNA",
      handle: "/products/50-ml-conical-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1032-25-50ml-Conical-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "600 ml Reservoir",
      subtitle: "C1033-5",
      description:
        "The 600 ml Reservoir, used with vacuum manifolds for the purification of DNA/RNA",
      handle: "/products/600-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1033-5-600-ml-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Tubes",
      subtitle: "C1001-1000, C1001-50, C1001-500",
      description:
        "Durable polypropylene collection tubes used in conjunction with Zymo-Spin columns",
      handle: "/products/collection-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1001-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase/RNase-Free Tubes",
      subtitle: "C2001-100, C2001-50",
      description:
        "DNase/RNase-free 1.5 ml microcentrifuge tubes made of durable polypropylene construction.",
      handle: "/products/dnase-rnase-free-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-100-DNase-RNase-free-tubes.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Clear Tubes, with caps",
      subtitle: "C1025-50, C1025-500, C1027-50, C1027-500",
      description:
        "Clear 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-clear-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1025-Clear-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Amber Tubes, with caps",
      subtitle: "C1026-50, C1026-500, C1028-50, C1028-500",
      description:
        "Amber 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-amber-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1026-50-Amber-Tube-with-cap-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR Bashing Bead Lysis Tubes",
      subtitle: "S6003-50",
      description: "2.0 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashing-bead-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
      subtitle: "S6014-50",
      description: "",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zr_bashingbead_lysis_tubes_2.0_mm_s6003-50__1.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
      subtitle: "S6012-50",
      description:
        "0.1 & 0.5 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/S6012-50_ZR-BashingBead-Lysis-Tubes.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-4, S6002-96-5",
      description:
        "96-well microbial cell lysis rack for high throughput/automated bead beating",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/s6002_96_lysis_rack.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ-Vac 96 Vacuum Manifold",
      subtitle: "S7003",
      description:
        "The EZ-Vac 96 Vacuum Manifold is designed for the high-throughput, rapid parallel manual purification of nucleic acid using the ZymoPURE 96 Plasmid Miniprep Kit.",
      handle: "/products/ez-vac-96-vacuum-manifold",
      isKit: false,
      ribbon: true,
      image_url:
        "https://files.zymoresearch.com/product-images/s7003_ez-vac_96_vacuum_manifold.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-Vac Vacuum Manifold",
      subtitle: "S7000",
      description:
        "The EZ-Vac Vacuum Manifold is capable of processing up to 20 samples using vacuum pressure.",
      handle: "/products/ez-vac-vacuum-manifold",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/S7000-Vacuum-Manifold.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "One-Way Leur-Lock Clear Stopcock",
      subtitle: "S7001",
      description:
        "Component for S7000: EZ-Vac Vacuum Manifold.",
      handle: "/products/one-way-luer-lock-clear-stopcock",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/S7001_One-way%20%20Luer-Lock%20Clear%20Stopcock.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Neoprene Stopper",
      subtitle: "S7002",
      description:
        "Component for S7000: EZ-Vac Vacuum Manifold.",
      handle: "/products/neoprene-stopper",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/S7002_Neoprene%20Stopper.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Elbow Hose Connector",
      subtitle: "S7004",
      description:
        "Component for S7000: EZ-Vac Vacuum Manifold.",
      handle: "/products/elbow-hose-connector",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/S7004-Black-Elbow-Hose-Connector.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Vortex-Genie<sup>&reg;</sup> 2",
      subtitle: "S5001, S5002",
      description:
        "Offers variable speed for precise mixing from gentle to vigorous has hands-free or touch-on control",
      handle: "/products/vortex-genie-2",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/vortex-genie-2_1_1.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Digital Vortex-Genie<sup>&reg;</sup> 2",
      subtitle: "S5003, S5004",
      description:
        "The Digital Vortex Genie 2 offers variable speed for precise mixing from gentle to vigorous .",
      handle: "/products/digital-vortex-genie-2",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Digital Vortex-Genie.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Digital MicroPlate Genie<sup>&reg;</sup> Pulse",
      subtitle: "S5012, S5013",
      description: "Exclusive precise vortex orbit guarantees true vortexing action in each well of the microplate, at all times.",
      handle: "/products/microplate-genie-pulse",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/s5012-digital_microplate_genie_pulse.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Roto-Shake Genie<sup>&reg;</sup>",
      subtitle: "S5007, S5008",
      description:
        "Combines rotating and rocking in one compact unit, the magnetic platform.",
      handle: "/products/roto-shake-genie",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Roto-Shake Genie.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RotaPrep MonoLyser",
      subtitle: "S6021",
      description:
        "Homogenization and grinding system for life sciences applications",
      handle: "/products/rotaprep-monolyser",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/RotaPrep MonoLyser.jpg",
      searchWeight: 0,
      tags: [],
    },
    // {
    //   title: "Precellys® Evolution",
    //   subtitle: "S6009-3",
    //   description:
    //     "The Precellys® Evolution is a high-throughput homogenizer capable of processing up to 24 samples in as little as 30 seconds. Designed to be used with 6 different tube sizes.",
    //   handle: "/products/precellys-evolution",
    //   isKit: false,
    //   image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-3_600x.jpg?v=1660255305",
    //   searchWeight: 0,
    //   tags: [],
    // },
    {
      title: "Precellys® 24 Touch",
      subtitle: "S6009-4",
      description:
        "The Precellys® 24 Touch is a high-throughput tissue homogenizer capable of processing up to 24 samples in as little as 30 seconds. Designed to be used with 0.5 ml or 2.0 mL microtubes.",
      handle: "/products/precellys-24-touch",
      isKit: false,
      image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-4_600x.jpg?v=1660254499",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Cryolys® Evolution",
      subtitle: "S6009-5",
      description:
        "The Cryolys® Evolution unit is designed to be used with the Precellys® Evolution (Cat. No. S6004-3) to keep the temperature of samples between 0 °C and 10 °C during homogenization. Works with dry ice.",
      handle: "/products/cryolys-evolution",
      isKit: false,
      image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-5_600x.jpg?v=1660255702",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "FastPrep-96",
      subtitle: "S6008",
      description: "",
      handle: "/products/fastprep-96",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6008.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2010 Geno/Grinder",
      subtitle: "S6006",
      description: "",
      handle: "/products/2010-geno-grinder",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6006l.jpg",
      searchWeight: 0,
      tags: ["US Only"],
    },
    {
      title: "FastPrep<sup>&reg;</sup> 24",
      subtitle: "S6005, S6005-1, S6005-2, S6005-3, S6005-4, S6005-5, S6005-6",
      description:
        "High-speed benchtop homogenizer that employs a powerful proprietary technology",
      handle: "/products/fastprep-24",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6005ll.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MagStir Genie<sup>&reg;</sup>",
      subtitle: "S5009, S5010",
      description:
        "The MagStir Genie<sup>&reg;</sup> allows programmable high/low speed stirring.",
      handle: "/products/magstir-genie-sup-reg-sup",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s5009l.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "High-Throughput Solutions & Automation": [
    {
      title: "DNA Purification",
      subtitle: "DNA",
      description: "Choose from a variety of high-throughput products, kits and free samples for automated DNA isolation and clean-up.",
      handle: "/pages/dna-automated-high-throughput",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RNA Purification",
      subtitle: "RNA",
      description: "Choose from a variety of high-throughput products, kits and free samples for automated RNA isolation and clean-up.",
      handle: "/pages/rna-extraction-kits?tags=high-throughput",
      isKit: false,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/products/R2054_Direct-zol-96-RNA_No-TRI-Reagent_600x.jpg?v=1588502264",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Total Nucleic Acid Purification",
      subtitle: "Nucleic Acid",
      description: "Choose from a variety of high-throughput products, kits and free samples for automated Nucleic Acid isolation and clean-up.",
      handle: "/pages/dna-rna-co-extraction-kits?tags=high-throughput",
      isKit: false,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/products/R2054_Direct-zol-96-RNA_No-TRI-Reagent_600x.jpg?v=1588502264",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Bisulfite Conversion",
      subtitle: "Epigenetics",
      description: "High throughput epigenetics kits for fast, easy automated bisulfite conversion. Try a kit today.",
      handle: "/pages/epigenetics-high-throughput-automated-isolation",
      isKit: false,
      image_url:
        "https://stage.zymoresearch.com/cdn/shop/products/D5003-EZ-96-DNA-Methylation-Kit---shallow-well_600x.png?v=1628532406",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "NGS Library Preparation",
      subtitle: "Epigenetics",
      description: "Simple NGS Library Prep Kits. Zymo Research's unique NGS library prep kits feature easy-to-use, streamlined workflows to generate ready-to-sequence libraries.",
      handle: "/pages/ngs-library-prep-kits",
      isKit: false,
      image_url:
        "https://stage.zymoresearch.com/cdn/shop/products/D5458-Zymo-Seq-ATAC-Library-Kit_2365_002_ProductPhoto_600x.jpg?v=1677624838",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Yeast Reagents and Enzymes": [
    {
      title: "Zymolyase",
      subtitle: "E1004, E1005, E1006",
      description:
        "Yeast lytic enzyme for simple and effective digestion of fungal cell walls.",
      handle: "/products/zymolyase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1005_Zymolayse-2000-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-Fluoroorotic Acid (5-FOA)",
      subtitle: "F9001-1, F9001-5, F9003",
      description: "Convenient yeast genetic counter-selection agent.",
      handle: "/products/5-fluoroorotic-acid",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/F9001-1_5-Fluoroorotic-Acid-1-g.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Alpha-Factor Mating Pheromone",
      subtitle: "Y1001",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle.",
      handle: "/products/alpha-factor-mating-pheromone",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1001_Alpha-Factor-Mating-Pheromone.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Yeast Protein Kit",
      subtitle: "Y1002",
      description:
        "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
      handle: "/products/yeast-protein-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "a-Factor Mating Pheromone",
      subtitle: "Y1004-500",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle. Opposite to the alpha-factor mating pheromone.",
      handle: "/products/a-factor-mating-pheromone",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1004_a-Factor-Mating-Pheromone-A-Factor-500-ul.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "YPD Plus",
      subtitle: "Y1003-100, Y1003-50",
      description:
        "Specialized medium for yeast outgrowth to increase yeast transformation efficiencies.",
      handle: "/products/ypd-plus",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Y1003-50-YPD-Plus.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Yeast Plasmid": [
    {
      title: "Zymoprep Yeast Plasmid Miniprep Kits",
      subtitle: "Yeast",
      description:
        "The fastest and simplest solutions for purifying the highest quality plasmid DNA from yeast.",
      handle: "/collections/zymoprep-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Yeast Plasmid and DNA Purification": [
    {
      title: "Zymoprep Yeast Plasmid Miniprep Kits",
      subtitle: "Yeast",
      description:
        "The fastest and simplest solutions for purifying the highest quality plasmid DNA from yeast.",
      handle: "/collections/zymoprep-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "DNA",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Devices & Instruments": [
    {
      title: "EZ-Vac 96 Vacuum Manifold",
      subtitle: "S7003",
      description:
        "The EZ-Vac 96 Vacuum Manifold is designed for the high-throughput, rapid parallel manual purification of nucleic acid using the ZymoPURE 96 Plasmid Miniprep Kit.",
      handle: "/products/ez-vac-96-vacuum-manifold",
      isKit: false,
      ribbon: true,
      image_url:
        "https://files.zymoresearch.com/product-images/s7003_ez-vac_96_vacuum_manifold.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-Vac Vacuum Manifold",
      subtitle: "S7000",
      description:
        "The EZ-Vac Vacuum Manifold is capable of processing up to 20 samples using vacuum pressure.",
      handle: "/products/ez-vac-vacuum-manifold",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/S7000-Vacuum-Manifold.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "One-Way Leur-Lock Clear Stopcock",
      subtitle: "S7001",
      description:
        "Component for S7000: EZ-Vac Vacuum Manifold.",
      handle: "/products/one-way-luer-lock-clear-stopcock",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/S7001_One-way  Luer-Lock Clear Stopcock.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Neoprene Stopper",
      subtitle: "S7002",
      description:
        "Component for S7000: EZ-Vac Vacuum Manifold.",
      handle: "/products/neoprene-stopper",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/S7002_Neoprene%20Stopper.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Elbow Hose Connector",
      subtitle: "S7004",
      description:
        "Component for S7000: EZ-Vac Vacuum Manifold.",
      handle: "/products/elbow-hose-connector",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/S7004-Black-Elbow-Hose-Connector.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Vortex-Genie<sup>&reg;</sup> 2",
      subtitle: "S5001, S5002",
      description:
        "Offers variable speed for precise mixing from gentle to vigorous has hands-free or touch-on control",
      handle: "/products/vortex-genie-2",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/vortex-genie-2_1_1.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Digital Vortex-Genie<sup>&reg;</sup> 2",
      subtitle: "S5003, S5004",
      description:
        "The Digital Vortex Genie 2 offers variable speed for precise mixing from gentle to vigorous .",
      handle: "/products/digital-vortex-genie-2",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Digital Vortex-Genie.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Digital MicroPlate Genie<sup>&reg;</sup> Pulse",
      subtitle: "S5012, S5013",
      description: "Exclusive precise vortex orbit guarantees true vortexing action in each well of the microplate, at all times.",
      handle: "/products/microplate-genie-pulse",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/s5012-digital_microplate_genie_pulse.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Roto-Shake Genie<sup>&reg;</sup>",
      subtitle: "S5007, S5008",
      description:
        "Combines rotating and rocking in one compact unit, the magnetic platform.",
      handle: "/products/roto-shake-genie",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Roto-Shake Genie.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RotaPrep MonoLyser",
      subtitle: "S6021",
      description:
        "Homogenization and grinding system for life sciences applications",
      handle: "/products/rotaprep-monolyser",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/RotaPrep MonoLyser.jpg",
      searchWeight: 0,
      tags: [],
    },
    // {
    //   title: "Precellys® Evolution",
    //   subtitle: "S6009-3",
    //   description:
    //     "The Precellys® Evolution is a high-throughput homogenizer capable of processing up to 24 samples in as little as 30 seconds. Designed to be used with 6 different tube sizes.",
    //   handle: "/products/precellys-evolution",
    //   isKit: false,
    //   image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-3_600x.jpg?v=1660255305",
    //   searchWeight: 0,
    //   tags: [],
    // },
    {
      title: "Precellys® 24 Touch",
      subtitle: "S6009-4",
      description:
        "The Precellys® 24 Touch is a high-throughput tissue homogenizer capable of processing up to 24 samples in as little as 30 seconds. Designed to be used with 0.5 ml or 2.0 mL microtubes.",
      handle: "/products/precellys-24-touch",
      isKit: false,
      image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-4_600x.jpg?v=1660254499",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Cryolys® Evolution",
      subtitle: "S6009-5",
      description:
        "The Cryolys® Evolution unit is designed to be used with the Precellys® Evolution (Cat. No. S6004-3) to keep the temperature of samples between 0 °C and 10 °C during homogenization. Works with dry ice.",
      handle: "/products/cryolys-evolution",
      isKit: false,
      image_url: "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S6009-5_600x.jpg?v=1660255702",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "FastPrep-96",
      subtitle: "S6008",
      description: "",
      handle: "/products/fastprep-96",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6008.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2010 Geno/Grinder",
      subtitle: "S6006",
      description: "",
      handle: "/products/2010-geno-grinder",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6006l.jpg",
      searchWeight: 0,
      tags: ["US Only"],
    },
    {
      title: "FastPrep<sup>&reg;</sup> 24",
      subtitle: "S6005, S6005-1, S6005-2, S6005-3, S6005-4, S6005-5, S6005-6",
      description:
        "High-speed benchtop homogenizer that employs a powerful proprietary technology",
      handle: "/products/fastprep-24",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s6005ll.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MagStir Genie<sup>&reg;</sup>",
      subtitle: "S5009, S5010",
      description:
        "The MagStir Genie<sup>&reg;</sup> allows programmable high/low speed stirring.",
      handle: "/products/magstir-genie-sup-reg-sup",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/s5009l.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Vacuum Manifolds": [
    {
      title: "EZ-Vac 96 Vacuum Manifold",
      subtitle: "S7003",
      description:
        "The EZ-Vac 96 Vacuum Manifold is designed for the high-throughput, rapid parallel manual purification of nucleic acid using the ZymoPURE 96 Plasmid Miniprep Kit.",
      handle: "/products/ez-vac-96-vacuum-manifold",
      isKit: false,
      ribbon: true,
      image_url:
        "https://files.zymoresearch.com/product-images/s7003_ez-vac_96_vacuum_manifold.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-Vac Vacuum Manifold",
      subtitle: "S7000",
      description:
        "The EZ-Vac Vacuum Manifold is capable of processing up to 20 samples using vacuum pressure.",
      handle: "/products/ez-vac-vacuum-manifold",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/S7000-Vacuum-Manifold.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Shakers: [
    {
      title: "Digital MicroPlate Genie<sup>&reg;</sup> Pulse",
      subtitle: "S5012, S5013",
      description: "Exclusive precise vortex orbit guarantees true vortexing action in each well of the microplate, at all times.",
      handle: "/products/microplate-genie-pulse",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/s5012-digital_microplate_genie_pulse.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Roto-Shake Genie<sup>&reg;</sup>",
      subtitle: "S5007, S5008",
      description:
        "Combines rotating and rocking in one compact unit, the magnetic platform.",
      handle: "/products/roto-shake-genie",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Roto-Shake Genie.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Microbiomics Library Prep Kits": [
    {
      title: "<i>Quick</i>-16S NGS Library Prep Kit",
      subtitle: "D6400",
      description:
        "A streamlined solution to convert up to 96 DNA samples to a single, ready-to-sequence 16S library.",
      handle: "/products/quick-16s-ngs-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6400_Quick-16S NGS Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V4)",
      subtitle: "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
      description:
        "Fastest, normalization-free 16S library prep",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v4",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
        subtitle: "D6421-PS1 - D6421-PS8",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6421-quick_16s_plus_ngs_library_prep_kit_udi.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
      },
  ],
  "Microbial Isolation": [
    {
      title: "ZymoBIOMICS DNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Fecal/Soil Microbe kits are affordable fecal and soil DNA extraction kits for fast, easy isolation of inhibitor-free, PCR-quality host cell and microbial DNA from a variety of sample sources.",
      handle: "/collections/quick-dna-fecal-soil-microbe-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010_Quick-DNA-Fecal-Soil-Microbe-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS RNA Miniprep Kit",
      subtitle: "R2001",
      description:
        "Purification of microbial RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Miniprep Kit",
      subtitle: "R2002",
      description:
        "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-dna-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
      subtitle: "R2040",
      description:
        "The Quick-RNA Fecal/Soil Microbe Microprep Kit is an affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
      handle: "/products/quick-rna-fecal-soil-microbe-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2040_Quick-RNA-Fecal-Soil-Microbe-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Microbial DNA/RNA Isolation": [
    {
      title: "ZymoBIOMICS DNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS RNA Miniprep Kit",
      subtitle: "R2001",
      description:
        "Purification of microbial RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Miniprep Kit",
      subtitle: "R2002",
      description:
        "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-dna-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "PCR and Quantification Kits": [
    {
      title: "Femto DNA Quantification Kits",
      subtitle: "DNA",
      description:
        "Detect and quantify human, bacterial, and fungal DNA with high specificity and sensitivity. ",
      handle: "/collections/femto-dna-quantification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2005_Femto-Human-DNA-Quantification-Kit.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>Quick</i>-16S NGS Library Prep Kit",
      subtitle: "D6400",
      description:
        "A streamlined solution to convert up to 96 DNA samples to a single, ready-to-sequence 16S library.",
      handle: "/products/quick-16s-ngs-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6400_Quick-16S NGS Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Microbial & Environmental DNA Isolation": [
    {
      title: "ZymoBIOMICS DNA Kits",
      subtitle: "Microbiomics",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "DNA",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Fecal/Soil Microbe kits are affordable fecal and soil DNA extraction kits for fast, easy isolation of inhibitor-free, PCR-quality host cell and microbial DNA from a variety of sample sources.",
      handle: "/collections/quick-dna-fecal-soil-microbe-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010_Quick-DNA-Fecal-Soil-Microbe-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Tissue/Insect Kits",
      subtitle: "DNA",
      description:
        "Simple and rapid isolation of DNA from fresh, frozen, or stored insect specimens.",
      handle: "/collections/quick-dna-tissue-insect-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6015_Quick-DNA-Tissue-Insect-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Plant/Seed Kits",
      subtitle: "DNA",
      description:
        "Simple, rapid isolation of inhibitor-free, PCR-quality DNA from a variety of plant sample sources.",
      handle: "/collections/quick-dna-plant-seed-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6020_Quick-DNA-Plant-Seed-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Microbiomics High-Throughput/Automated Isolation": [
    {
      title: "ZymoBIOMICS 96 DNA Kit",
      subtitle: "D4303, D4307, D4309",
      description:
        "Inhibitor-free microbial DNA from any sample validated for microbiome and metagenomic analyses",
      handle: "/products/zymobiomics-96-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS 96 MagBead Kit",
      subtitle: "D4302, D4306, D4308",
      description:
        "Inhibitor-free microbial DNA from any sample validated for microbiome and metagenomic analyses",
      handle: "/products/zymobiomics-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Solid & FFPE Tissue RNA": [
    {
      title: "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      subtitle: "R1009",
      description: "DNA and RNA from FFPE tissue",
      handle: "/products/quick-dna-rna-ffpe-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pinpoint Slide RNA Isolation System",
      subtitle: "R1003, R1007",
      description: "RNA from tissue sections on glass slides",
      handle: "/products/pinpoint-slide-rna-isolation-system",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1003_Pinpoint-Slide-RNA-Isolation-System-I-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA FFPE Miniprep",
      subtitle: "R1008",
      description: "Isolate RNA and small/miRNA from FFPE tissue.",
      handle: "/products/quick-rna-ffpe-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1008_Quick-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "High-Throughput/Automated": [
    {
      title: "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      subtitle: "D7022, D7023",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator MagBead",
      subtitle: "R1081, R1082",
      description:
        "The RNA Clean & Concentrator kits are RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality NGS and RT-qPCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1082_RNA-Clean-and-Concentrator-Magbead-Kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral MagBead",
      subtitle: "R2140, R2141",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Load N’ Go DNA/RNA Viral Kit",
      subtitle: "R2143",
      description: "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      handle: "/products/load-n-go-dna-rna-viral-kit",
      isKit: true,
      ribbon: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      subtitle: "R2145, R2146",
      description:
        "Pathogen DNA/RNA isolation from vectors, tissue and biological samples.",
      handle: "/products/quick-dna-rna-pathogen-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Microbiomics 96-well Magnetic Bead Isolation": [
    {
      title: "ZymoBIOMICS 96 MagBead Kit",
      subtitle: "D4302, D4306, D4308",
      description:
        "Inhibitor-free microbial DNA from any sample validated for microbiome and metagenomic analyses",
      handle: "/products/zymobiomics-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead RNA",
      subtitle: "R2137, R2138",
      description:
        "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
      handle: "/products/zymobiomics-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2137_zymobiomics-magbead-rna-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Protein Buffers and Reagents": [],
  "Modifying Enzymes": [
    {
      title: "CpG Methylase (M. Sssl)",
      subtitle: "E2010, E2011",
      description:
        "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
      handle: "/products/cpg-methylase-m-sssl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2010_CpG-Methylase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-hmC Glucosyltransferase",
      subtitle: "E2026, E2027",
      description: "5-hmC detection; 5-hmC enrichment",
      handle: "/products/5-hmc-glucosyltransferase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2026_5-hmC-Glucosyltransferase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Protein Purification": [
    {
      title: "Yeast Protein Kit",
      subtitle: "Y1002",
      description:
        "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
      handle: "/products/yeast-protein-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "His-Spin Protein Miniprep",
      subtitle: "P2001, P2002",
      description:
        "Fast and simple spin-column method for purifying His-tagged proteins from cell lysates.",
      handle: "/products/his-spin-protein-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P2002_His-Spin-Protein-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "His-tagged protein purification": [
    {
      title: "His-Spin Protein Miniprep",
      subtitle: "P2001, P2002",
      description:
        "Fast and simple spin-column method for purifying His-tagged proteins from cell lysates.",
      handle: "/products/his-spin-protein-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P2002_His-Spin-Protein-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Epigenetics": [
    {
      title: "Zymo-Seq Trio WGBS Library Kit",
      subtitle: "D5462, D5463",
      description:
          "Provides a reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation.",
      handle: "/products/zymo-seq-trio-wgbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq ATAC Library Kit",
      subtitle: "D5458",
      description:
        "The Zymo-Seq ATAC Library Kit features pre assembled buffers offering the quickest and highest quality ATAC-Seq library production.",
      handle: "/products/zymo-seq-atac-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5458-Zymo-Seq-ATAC-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq WGBS Library Kit",
      subtitle: "D5465",
      description: "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. Zymo-Seq WGBS Library Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-ups steps required by conventional, ligation-based library preparation methods.",
      handle: "/products/zymo-seq-wgbs-library-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/d5465-zymo_seq_wgbs_library_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Bisulfite Conversion Kits",
      subtitle: "Epigenetics",
      description:
        "Streamlined, simplified, and proven procedures for bisulfite conversion of DNA. Recommended by Illumina’s Golden Gate and Infinium Assays.",
      handle: "/pages/bisulfite-conversion-kits",
      isKit: true,
      image_url:
        "http://files.zymoresearch.com/images/D5001_EZ-DNA-Methylation-Kit.jpg",
      searchWeight: 4,
      tags: [],
    },
    {
      title: "Pico Methyl-Seq Library Prep Kit",
      subtitle: "D5455, D5456",
      description:
        "All-inclusive kit for bisulfite conversion followed by Whole Genome Bisulfite Sequencing (WGBS) library preparation.",
      handle: "/products/pico-methyl-seq-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d5456_pico-methyl-seq-library-prep-kit_1.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Zymo-Seq RRBS Library Kit",
      subtitle: "D5460, D5461",
      description:
        "The Zymo-Seq RRBS Library Kit is an all-inclusive library prep kit for low-input library preparation of Reduced Representation of Bisulfite Sequencing (RRBS) to profile genome-wide DNA methylation.",
      handle: "/products/zymo-seq-rrbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5460_ez_dna_methylation_rrbs_library_prep_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Total RNA Library Kit",
      subtitle: "R3000, R3003",
      description:
        "The fastest and easiest kit for stranded total RNA-seq libraries with RiboFree Universal Depletion for any sample and species",
      handle: "/products/zymo-seq-ribofree-total-rna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3000_zymo-seq_ribofree_tota_rna_library_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Universal cDNA Kit",
      subtitle: "R3001",
      description:
        "This universal rRNA and globin depletion kit is probe-free and produces RiboFree single-stranded cDNA with minimal hands-on time.",
      handle: "/products/zymo-seq-ribofree-universal-cdna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3001_zymo-seq_ribofree_universal_cdna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Human Methylated & Non-methylated DNA Set",
      subtitle: "D5014, D5014-1, D5014-2",
      description:
        "Methylated and non-methylated DNA controls with primer sets to assess bisulfite conversion efficiency and for DNA methylation quantification.",
      handle: "/products/human-methylated-non-methylated-dna-set-dna-w-primers",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5014_Human-Methylated-and-Non-Methylated-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-mC DNA ELISA Kit",
      subtitle: "D5325, D5326",
      description: "Global 5-mC detection and quantitation.",
      handle: "/products/5-mc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5325_5-mC DNA ELISA Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Quest 5-hmC DNA ELISA Kit",
      subtitle: "D5425, D5426",
      description: "Global 5-hmC detection and quantitation.",
      handle: "/products/quest-5-hmc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5425_Quest 5-hmC DNA ELISA Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RRHP 5-hmC Library Prep Kit",
      subtitle: "D5450, D5451",
      description:
        "Innovative 5-hmC library preparation kit for strand-specific mapping of 5-hmC in DNA.",
      handle: "/products/rrhp-5-hmc-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5450_RRHP 5-hmC Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "ZymoTaq Polymerase",
      subtitle: "Buffers",
      description:
        "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
      handle: "/collections/zymotaq-polymerase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2001_ZymoTaq-Polymerase.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "Zymo-Spin ChIP Kit",
      subtitle: "D5209, D5210",
      description:
        "The Zymo-Spin ChIP Kit is a ChIP kit that provides a streamlined ChIP procedure for investigating protein-DNA interactions.",
      handle: "/products/zymo-spin-chip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5209_Zymo-Spin-ChIP-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ChIP DNA Clean & Concentrator",
      subtitle: "D5201, D5205",
      description:
        "The Chromatin Immunoprecipitation (ChIP) DNA Clean & Concentrator is a simple ChIP kit that provides a hassle-free method for the rapid purification and concentration of high-quality DNA from any step in a standard ChIP protocol.",
      handle: "/products/chip-dna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5201_ChIP-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 ChIP DNA Clean & Concentrator",
      subtitle: "D5206, D5207",
      description:
        "The ZR-96 ChIP DNA Clean & Concentrator is a high-throughput (96-well) DNA ChIP kit for seamless purification from any step of a ChIP assay.",
      handle: "/products/zr-96-chip-dna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5206_ZR-96-ChIP-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ Nucleosomal DNA Prep Kit",
      subtitle: "D5220",
      description:
        "The EZ Nucleosomal DNA Prep Kit is a streamlined procedure for the isolation of nucleosome-associated DNA, making it ideal for nucleosome mapping studies.",
      handle: "/products/ez-nucleosomal-dna-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5220_EZ-Nucleosomal-DNA-Prep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "dsDNA Shearase Plus",
      subtitle: "E2018-200, E2018-50",
      description:
        "Simply control fragment size of dsDNA by adjusting the concentration of dsDNA Shearase Plus.",
      handle: "/products/dsdna-shearase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2018-50_dsDNA-Shearase-Plus-50-U.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated-DNA IP Kit",
      subtitle: "D5101",
      description:
        "Kit for immunoprecipitation of methylated DNA in only a few hours. Recovered DNA is suitable for microarray, PCR, bisulfite treatment, etc.",
      handle: "/products/methylated-dna-ip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5101_Methylated-DNA-IP-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)",
      subtitle: "A3002-15, A3002-200, A3002-30, A3002-50",
      description:
        "Anti-5mC antibody for immunoprecipitation of methylated DNA, ELISA, immunoblotting, immunofluorescence",
      handle: "/products/anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A3002-50_Anit Methylation - 1:2ul.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Anti-5-Hydroxymethylcytosine Polyclonal Antibody",
      subtitle: "A4001-200, A4001-25, A4001-50",
      description:
        "Immunoprecipitation for 5-hmC DNA, ELISA, immunoblotting, immunoflourescence",
      handle: "/products/anti-5-hydroxymethylcytosine-polyclonal-antibody",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A4001-25_Anti-5-Hydroxymethylcytosine Polyclonal Antibody - 25 ug.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Universal Methylated DNA Standard",
      subtitle: "D5011, D5012",
      description:
        "Control DNA for bisulfite conversion and DNA methylation quantitation.",
      handle: "/products/universal-methylated-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5011_Universal-Methylated-Human-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Bisulfite-Converted Universal Methylated Human DNA Standard",
      subtitle: "D5015",
      description: "Control DNA for DNA methylation quantitation.",
      handle:
        "/products/bisulfite-converted-universal-methylated-human-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5015_Bisulfite-Converted-Universal-Methylated-HUman-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Human Methylated & Non-Methylated (WGA) DNA Set",
      subtitle: "D5013, D5013-1, D5013-2",
      description:
        "This control set is generated from HCT116 DKO cell genomic DNA using whole-genome amplification (WGA) technology. This standard is ideal for studying loci with ultra-low methylation levels.",
      handle:
        "/products/human-methylated-non-methylated-wga-dna-set-dna-w-primers",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5013_Human-WGA-Methylated-and-Non-Methylated-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set",
      subtitle: "D5405",
      description:
        "Ideal control for cytosine modification studies including HPLC; LC/MS; TLC",
      handle:
        "/products/5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5405_5-mC & 5-hmC DNA Standard Set.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>E. coli</i> Non-Methylated Genomic DNA",
      subtitle: "D5016",
      description:
        "Control for bisulfite conversion and DNA methylation quantitation",
      handle: "/products/e-coli-non-methylated-genomic-dna",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5016_E-Coli-Non-Methylated-Genomic-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated & Non-methylated pUC19 DNA Set",
      subtitle: "D5017",
      description:
        "Control for bisulfite conversion and DNA methylation quantitation",
      handle: "/products/methylated-non-methylated-puc19-dna-set",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5017_Methylated-and-Non-Methylated-pUC19-DNA-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Human Matched DNA Set",
      subtitle: "D5018, D5018-1, D5018-2",
      description:
        "Control for Bisulfite conversion and DNA methylation quantitation",
      handle: "/products/human-matched-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5018_Human-Matched-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Mouse 5-hmC & 5-mC DNA Set",
      subtitle: "D5019, D5019-1, D5019-2, D5019-3, D5019-4",
      description:
        "Mouse DNA controls for bisulfite conversion and DNA methylation and hydroxymethylation quantitation.",
      handle: "/products/mouse-5hmc-5mc-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5019_Mouse-hmC-and-5-mC-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "CpG Methylase (M. Sssl)",
      subtitle: "E2010, E2011",
      description:
        "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
      handle: "/products/cpg-methylase-m-sssl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2010_CpG-Methylase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-hmC Glucosyltransferase",
      subtitle: "E2026, E2027",
      description: "5-hmC detection; 5-hmC enrichment",
      handle: "/products/5-hmc-glucosyltransferase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2026_5-hmC-Glucosyltransferase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Atlantis dsDNase",
      subtitle: "E2030",
      description:
        "Atlantis dsDNase ensures digestion of dsDNA to yield homogeneous populations of core nucleosomes.",
      handle: "/products/atlantis-ds-dnase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030_Atlantis-dsDNase-12.5-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNA Degradase",
      subtitle: "E2016, E2017",
      description: "Complete digestion of DNA into individual nucleotides",
      handle: "/products/dna-degradase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2016_DNA-Degradase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated & Hydroxymethylated Nucleotides",
      subtitle: "Epigenetics",
      description:
        "High-quality methylated and hydroxymethylated nucleotides that can be used in many applications including the study of binding and interacting proteins.",
      handle: "/collections/methylated-hydroxymethylated-nucleotides",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "dNTP Solutions",
      subtitle: "Epigenetics",
      description:
        "Convenient and ready-to-use dNTPs for use in a variety of molecular biology applications including long-range PCR, cDNA synthesis, RT-PCR, real-time PCR, standard PCR, and high-fidelity PCR. ",
      handle: "/collections/dntp-solutions",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/D1005_dATP.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Modification Enzymes for Epigenetics": [
    {
      title: "CpG Methylase (M. Sssl)",
      subtitle: "E2010, E2011",
      description:
        "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
      handle: "/products/cpg-methylase-m-sssl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2010_CpG-Methylase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-hmC Glucosyltransferase",
      subtitle: "E2026, E2027",
      description: "5-hmC detection; 5-hmC enrichment",
      handle: "/products/5-hmc-glucosyltransferase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2026_5-hmC-Glucosyltransferase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Antibodies & Immunoprecipitation": [
    {
      title: "Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)",
      subtitle: "A3002-15, A3002-200, A3002-30, A3002-50",
      description:
        "Anti-5mC antibody for immunoprecipitation of methylated DNA, ELISA, immunoblotting, immunofluorescence",
      handle: "/products/anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A3002-50_Anit Methylation - 1:2ul.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Anti-5-Hydroxymethylcytosine Polyclonal Antibody",
      subtitle: "A4001-200, A4001-25, A4001-50",
      description:
        "Immunoprecipitation for 5-hmC DNA, ELISA, immunoblotting, immunoflourescence",
      handle: "/products/anti-5-hydroxymethylcytosine-polyclonal-antibody",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A4001-25_Anti-5-Hydroxymethylcytosine Polyclonal Antibody - 25 ug.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated-DNA IP Kit",
      subtitle: "D5101",
      description:
        "Kit for immunoprecipitation of methylated DNA in only a few hours. Recovered DNA is suitable for microarray, PCR, bisulfite treatment, etc.",
      handle: "/products/methylated-dna-ip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5101_Methylated-DNA-IP-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Zymo-Spin ChIP Kit",
      subtitle: "D5209, D5210",
      description:
        "The Zymo-Spin ChIP Kit is a ChIP kit that provides a streamlined ChIP procedure for investigating protein-DNA interactions.",
      handle: "/products/zymo-spin-chip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5209_Zymo-Spin-ChIP-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-mC DNA ELISA Kit",
      subtitle: "D5325, D5326",
      description: "Global 5-mC detection and quantitation.",
      handle: "/products/5-mc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5325_5-mC DNA ELISA Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Quest 5-hmC DNA ELISA Kit",
      subtitle: "D5425, D5426",
      description: "Global 5-hmC detection and quantitation.",
      handle: "/products/quest-5-hmc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5425_Quest 5-hmC DNA ELISA Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "dsDNA Shearase Plus (Includes Matching DCC-5 Kit)",
      subtitle: "E2019-200, E2019-50",
      description:
        "Simply control fragment size of dsDNA by adjusting the concentration of dsDNA Shearase Plus and purify the fragments using the included DCC-5 kit.",
      handle: "/products/dsdna-shearase-plus-includes-matching-dcc-5-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2019-50_DSDNA-Shearase-Plus-50-U.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  
  "Protein Expression & Purification": [
    {
      title: "<i>Mix & Go</i> Competent Cells",
      subtitle: "<i>E. coli</i>",
      description:
        "<i>Mix & Go</i> Competent Cells are chemically competent cells for simple, high-efficiency transformations without heat shock and lengthy incubations.",
      handle: "/collections/mix-go-competent-cells",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3013_Mix-and-Go-Competent-Cells-HB101.jpg",
      searchWeight: 3,
      tags: ["DRY ICE"],
    },
    {
      title: "XJ Autolysis <i>E. coli</i> strains",
      subtitle: "<i>E. coli</i>",
      description:
        "Chemically competent cells that offer a new alternative for bacterial transformation and lysis that simplify protein expression and purification.",
      handle: "/collections/xj-autolysis-e-coli-strains",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3051_XJb DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 3,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Clean & Concentrator Kits (DCC)",
      subtitle: "DNA",
      description:
        "DNA Clean & Concentrator Kits are PCR purification kits that provide purification of DNA from PCR and other enzymatic reactions in as little as 2 minutes. Free PCR purification kits sample.\n",
      handle: "/collections/dcc-pcr-purification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Zymoclean Gel DNA Recovery Kits",
      subtitle: "DNA",
      description:
        "Gel DNA extraction kits that provide highly efficient DNA purification from agarose gels. Get a free gel DNA extraction kits sample with free shipping.\n",
      handle: "/collections/zymoclean-gel-dna-recovery-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "ZymoPURE Plasmid Kits",
      subtitle: "Plasmid Purification",
      description:
        "ZymoPURE II Plasmid Kits provide the fastest, simplest method to isolate transfection quality DNA from E. coli. Free samples of plasmid kits get free shipping.",
      handle: "/collections/zymopure-plasmid-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zyppy Plasmid Kits",
      subtitle: "Plasmid Purification",
      description:
        "The Zyppy Plasmid Kits are plasmid DNA kits that provide pellet-free high-quality plasmid DNA in only 8 minutes. Get a free plasmid DNA kits sample with free shipping. ",
      handle: "/collections/zyppy-plasmid-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zymoprep Yeast Plasmid Miniprep Kits",
      subtitle: "D2001, D2004, D2005, D2006, D2007",
      description:
        "The fastest and simplest solutions for purifying the highest quality plasmid DNA from yeast.",
      handle: "/collections/zymoprep-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Frozen-EZ Yeast Transformation II Kit",
      subtitle: "T2001",
      description:
        "Quickly and simply make competent yeast cells for highly efficient transformations.",
      handle: "/products/frozen-ez-yeast-transformation-ii-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T2001_Frozen-EZ-Yeast-Transformation-II-Kit.jpg",
      searchWeight: 0,
      tags: ["No Ground Shipping"],
    },
    {
      title: "Yeast Protein Kit",
      subtitle: "Y1002",
      description:
        "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
      handle: "/products/yeast-protein-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "His-Spin Protein Miniprep",
      subtitle: "P2001, P2002",
      description:
        "Fast and simple spin-column method for purifying His-tagged proteins from cell lysates.",
      handle: "/products/his-spin-protein-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P2002_His-Spin-Protein-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Dual Media Set",
      subtitle: "M3011",
      description:
        "Simple, reliable method for high level recombinant protein expression in <i>E. coli</i>.",
      handle: "/products/dual-media-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3011_Dual-Media-Set-100-mL-EB-500-mL-OB.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Nucleic Acid Purification": [
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "D6007, D6005, D6105, D6006",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep Yeast Plasmid Miniprep Kits",
      subtitle: "D2001, D2004, D2005, D2006, D2007",
      description:
        "The fastest and simplest solutions for purifying the highest quality plasmid DNA from yeast.",
      handle: "/collections/zymoprep-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fungal/Bacterial Kits",
      subtitle: "R2010, R2014",
      description:
        "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-rna-fungal-bacterial-kit",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "YeaStar RNA Kit",
      subtitle: "R1002",
      description:
        "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      handle: "/products/yeastar-rna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Genomic DNA": [
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "D6007, D6005, D6105, D6006",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Enzymes & Protein Expression": [
    {
      title: "Endura Tn5 Transposase",
      subtitle: "E1024-20, E1024-100, E1024-4-5, E1025-20, E1025-100",
      description: "Highly Stable & Compatible with Any Adapter.",
      handle: "/products/endura-tn5-transposase-unloaded",
      isKit: false,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/photo1_600x.webp?v=1750810168",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "PureRec RNase A (Recombinant)",
      subtitle: "E1019T, E1019-5, E1019-20",
      description: "Recombinant, DNase-free & Animal-free.",
      handle: "/products/purerec-rnase-a-animal-free",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1019T_purerec_rnase_a_1mg.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase I Set",
      subtitle: "E1010",
      description:
        "Enzyme and digestion buffer used for cutting both double stranded and single-stranded DNA.",
      handle: "/products/dnase-i-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E1010_DNase-I-Set-lyophilized.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RNase A",
      subtitle: "E1008-24, E1008-30, E1008-8",
      description:
        "Used for RNA hydrolysis and compatible with a variety of applications.",
      handle: "/products/rnase-a",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1008-8-RNase A - 8 mg.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Micrococcal Nuclease",
      subtitle: "D5220-1",
      description: "Cleaves single-stranded and double-stranded DNA and RNA. Complete digestion with Micrococcal Nuclease yields mono- and oligonucleotides with 3'-phosphates.",
      handle: "/products/micrococcal-nuclease",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5220-1_Micrococcal-Nuclease.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase Plus",
      subtitle: "E2020, E2021",
      description: "Complete digestion of DNA into individual nucleosides.",
      handle: "/products/dna-degradase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2020_DNA-Degradase-Plus.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dsDNA Shearase Plus",
      subtitle: "E2018-200, E2018-50",
      description:
        "Simply control fragment size of dsDNA by adjusting the concentration of dsDNA Shearase Plus.",
      handle: "/products/dsdna-shearase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2018-50_dsDNA-Shearase-Plus-50-U.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Atlantis dsDNase",
      subtitle: "E2030",
      description:
        "Atlantis dsDNase ensures digestion of dsDNA to yield homogeneous populations of core nucleosomes.",
      handle: "/products/atlantis-ds-dnase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030_Atlantis-dsDNase-12.5-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNA Degradase",
      subtitle: "E2016, E2017",
      description: "Complete digestion of DNA into individual nucleotides",
      handle: "/products/dna-degradase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2016_DNA-Degradase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "PureRec Duplex-Specific Nuclease (DSN)",
      subtitle: "E1020-200, E1020-1000",
      description: "Highly selective for dsDNA. RNase-free and protease-free.",
      handle: "/products/purerec-duplex-specific-nuclease-dsn",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/e1020-200_9182b.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Proteinase K with Storage Buffer Set",
      subtitle: "D3001-2-20, D3001-2-5",
      description:
        "Proteinase K is a stable serine protease with broad substrate specificity and will degrade many proteins in their native conformation even in the presence of detergents (e.g., SDS).",
      handle: "/products/proteinase-k-w-storage-buffer-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001-2-20_Proteinase-K-lyophilized-20-mg.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymolyase Ultra",
      subtitle: "E1007T, E1007-2, E1007-10",
      description: "Ultra fast & Ultra clean.",
      handle: "/products/zymolyase-ultra",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1007T-Zymolyase-Ultra-100-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymolyase",
      subtitle: "E1004, E1005, E1006",
      description:
        "Yeast lytic enzyme for simple and effective digestion of fungal cell walls.",
      handle: "/products/zymolyase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1005_Zymolayse-2000-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoTaq Polymerase",
      subtitle: "Buffers",
      description:
        "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
      handle: "/collections/zymotaq-polymerase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2001_ZymoTaq-Polymerase.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "CpG Methylase (M. Sssl)",
      subtitle: "E2010, E2011",
      description:
        "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
      handle: "/products/cpg-methylase-m-sssl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2010_CpG-Methylase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-hmC Glucosyltransferase",
      subtitle: "E2026, E2027",
      description: "5-hmC detection; 5-hmC enrichment",
      handle: "/products/5-hmc-glucosyltransferase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2026_5-hmC-Glucosyltransferase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated Nucleotides",
      subtitle: "Epigenetics",
      description:
        "High-quality methylated and hydroxymethylated nucleotides that can be used in many applications including the study of binding and interacting proteins.",
      handle: "/collections/methylated-nucleotides",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "dNTP Solutions",
      subtitle: "Epigenetics",
      description:
        "Convenient and ready-to-use dNTPs for use in a variety of molecular biology applications including long-range PCR, cDNA synthesis, RT-PCR, real-time PCR, standard PCR, and high-fidelity PCR. ",
      handle: "/collections/dntp-solutions",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/D1005_dATP.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - DH5 Alpha",
      subtitle: "T3007, T3009, T3010",
      description:
        "Premade <i>E. coli</i> DH5 alpha competent cells for simple and highly efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-dh5-alpha",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3009_Mix-and-Go-Competent-Cells-Xymo-5a.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - Zymo 10B",
      subtitle: "T3019, T3020",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-zymo-10b",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3020_Mix-and-Go-Competent-Cells-Zymo-10B.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - JM109",
      subtitle: "T3003, T3005",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-jm109",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3005_Mix-and-Go-Competent-Cells-JM109.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> Competent Cells - HB101",
      subtitle: "T3011, T3013",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-hb101",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3013_Mix-and-Go-Competent-Cells-HB101.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> Competent Cells - TG1",
      subtitle: "T3017",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-tg1",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3017_Mix & Go Competent Cells - TG1 Tubes x10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJb (DE3) Autolysis Competent Cells",
      subtitle: "T3051",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjbde3-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3051_XJb DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJb Autolysis Competent Cells",
      subtitle: "T3041",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjb-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3041_XJb Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "XJb Autolysis Glycerol Stock",
      subtitle: "T5041",
      description:
        "Simple, fast, and controlled autolysis of <i>E. coli</i> for protein expression and purification.",
      handle: "/products/xjb-autolysis-glycerol-stock",
      isKit: false,
      image_url:
        "https://stage.zymoresearch.com/cdn/shop/products/T5041_XJb_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_5760x5760.png?v=1628532396",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJa Autolysis Competent Cells",
      subtitle: "T3021",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xja-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3021_XJa Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "XJa Autolysis Glycerol Stock",
      subtitle: "T5021",
      description:
        "Simple, fast, and controlled autolysis of <i>E. coli</i> for protein expression and purification.",
      handle: "/products/xja-autolysis-glycerol-stock",
      isKit: false,
      image_url:
        "https://stage.zymoresearch.com/cdn/shop/products/T5021_XJa_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_5760x5760.png?v=1628532404",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJa (DE3) Autolysis Competent Cells",
      subtitle: "T3031",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjade3-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3031_XJa DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "XJa (DE3) Autolysis Glycerol Stock",
      subtitle: "T5031",
      description:
        "Simple, fast, and controlled autolysis of <i>E. coli</i> for protein expression and purification.",
      handle: "/products/xjade3-autolysis-glycerol-stock",
      isKit: true,
      image_url:
        "https://stage.zymoresearch.com/cdn/shop/products/T5031_XJa_20DE3_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_5760x5760.png?v=1628532406",
      searchWeight: 2,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> <i>E. coli</i> Transformation Kit and Buffer Set",
      subtitle: "T3001, T3002",
      description:
        "Convenient preparation of competent <i>E. coli</i> cells for simple and highly efficient DNA transformation, skipping heat shocking and related procedures.",
      handle: "/products/mix-and-go-e-coli-transformation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3002_Mix-and-Go-E-Coli-Transformation-Buffer-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Frozen-EZ Yeast Transformation II Kit",
      subtitle: "T2001",
      description:
        "Quickly and simply make competent yeast cells for highly efficient transformations.",
      handle: "/products/frozen-ez-yeast-transformation-ii-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T2001_Frozen-EZ-Yeast-Transformation-II-Kit.jpg",
      searchWeight: 0,
      tags: ["No Ground Shipping"],
    },
    {
      title: "Yeast Protein Kit",
      subtitle: "Y1002",
      description:
        "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
      handle: "/products/yeast-protein-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "His-Spin Protein Miniprep",
      subtitle: "P2001, P2002",
      description:
        "Fast and simple spin-column method for purifying His-tagged proteins from cell lysates.",
      handle: "/products/his-spin-protein-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P2002_His-Spin-Protein-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Dual Media Set",
      subtitle: "M3011",
      description:
        "Simple, reliable method for high level recombinant protein expression in <i>E. coli</i>.",
      handle: "/products/dual-media-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3011_Dual-Media-Set-100-mL-EB-500-mL-OB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      "title": "DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4012",
      "description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4012_DNA-Clean-%26-Concentrator-Magbead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-5",
      "subtitle": "D4003, D4003T, D4004, D4013, D4014",
      "description": "Purify up to 5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources in just 2 minutes.",
      "handle": "/products/dna-clean-concentrator-5",
      "image_url": "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "ZR-96 DNA Clean-Up Kit",
      subtitle: "D4017, D4018",
      description:
        "Clean-up PCR and other enzymatic reactions at large scale in as little as 20 minutes",
      handle: "/products/zr-96-dna-clean-up-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4017_ZR-96-DNA-Clean-up-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      "title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
      "subtitle": "D4023, D4024",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
      "image_url": "https://files.zymoresearch.com/product-images/D4023-ZR-96-DNA-Clean-_-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4001, D4001T, D4002, D4007, D4008",
      "description": "Quickly recover ultra-pure DNA from agarose gels.",
      "handle": "/products/zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4021, D4022",
      "description": "Convenient high-throughput purification of ultra-pure DNA from agarose gels.",
      "handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Large Fragment DNA Recovery",
      "subtitle": "D4045, D4046",
      "description": "Rapid purification of ultra-pure high molecular weight DNA from agarose gels.",
      "handle": "/products/zymoclean-large-fragment-dna-recovery",
      "image_url": "https://files.zymoresearch.com/product-images/D4045-Zymoclean-Large-Fragment-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "ZymoPURE II Plasmid Midiprep Kit",
      subtitle: "D4200, D4201",
      description: "Vaccine/transfection grade plasmid DNA in &le; 20 minutes",
      handle: "/products/zymopure-ii-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE 96 Plasmid Miniprep Kit",
      subtitle: "D4214, D4215",
      description:
        "High-throughput purification of transfection-grade plasmid DNA from up to 5 ml of overnight E. coli culture.",
      handle: "/products/zymopure-96-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4214_D4215_ZymoPURE_96_Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Maxiprep Kit",
      subtitle: "D4202, D4203",
      description: "Endotoxin-Free/Transfection-grade plasmid DNA in &le; 20 min.",
      handle: "/products/zymopure-ii-plasmid-maxiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Plasmid Miniprep Kit",
      subtitle: "D4208T, D4209, D4210, D4211, D4212",
      description:
        "Fastest and simplest method to isolate endotoxin-free plasmid DNA",
      handle: "/products/zymopure-ii-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Gigaprep Kit",
      subtitle: "D4204",
      description:
        "Large-Scale, vaccine/transfection grade plasmid DNA purification",
      handle: "/products/zymopure-ii-plasmid-gigaprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit-2.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE - Express Plasmid Midiprep Kit",
      subtitle: "D4213",
      description:
        "A fast, pellet-free method to isolate transfection-grade plasmid DNA. No large centrifuge required!",
      handle: "/products/zymopure-express-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4213_ZymoPURE%20Express%20Plasmid%20Midiprep%20Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      "title": "Zyppy Plasmid Miniprep Kit",
      "subtitle": "D4019, D4020, D4036, D4037",
      "description": "Pellet-free, high-quality plasmid DNA in only 8 minutes.",
      "handle": "/products/zyppy-plasmid-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "Zyppy-96 Plasmid Kit",
      subtitle: "D4041, D4042, D4043",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes",
      handle: "/products/zyppy-96-plasmid-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4041_Zyppy-96-Plasmid-Miniprep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zyppy-96 Plasmid MagPrep Kit",
      subtitle: "D4100, D4101, D4102",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes",
      handle: "/products/zyppy-96-plasmid-magprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR Plasmid Miniprep - Classic",
      subtitle: "D4015, D4016, D4054",
      description:
        "Easy traditional method for isolating high-quality plasmid DNA from <i>E. coli</i>",
      handle: "/products/zr-plasmid-miniprep-classic",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4015_ZR-Plasmid-Miniprep-Classic-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BAC DNA Miniprep Kit",
      subtitle: "D4048, D4049",
      description:
        "Quickly isolate large constructs (≤200 kb) from <i>E. coli</i> using a spin-column",
      handle: "/products/zr-bac-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep Yeast Plasmid Miniprep II",
      subtitle: "D2004",
      description:
        "Simple spin-column solution for yeast plasmid DNA isolation using Zymolyase",
      handle: "/products/zymoprep-yeast-plasmid-miniprep-ii",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep Yeast Plasmid Miniprep I",
      subtitle: "D2001",
      description:
        "Simple precipitation based solution for yeast plasmid DNA isolation using Zymolyase",
      handle: "/products/zymoprep-yeast-plasmid-miniprep-i",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep-96 Yeast Plasmid Miniprep",
      subtitle: "D2005, D2006, D2007",
      description:
        "The fastest and simplest high-throughput procedure for purifying the highest quality plasmid DNA from yeast.",
      handle: "/products/zymoprep-96-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Epigenetic Enzymes & Reagents": [
    {
      title: "Micrococcal Nuclease",
      subtitle: "D5220-1",
      description: "Cleaves single-stranded and double-stranded DNA and RNA. Complete digestion with Micrococcal Nuclease yields mono- and oligonucleotides with 3'-phosphates.",
      handle: "/products/micrococcal-nuclease",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5220-1_Micrococcal-Nuclease.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "ZymoTaq Polymerase",
      subtitle: "Buffers",
      description:
        "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
      handle: "/collections/zymotaq-polymerase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2001_ZymoTaq-Polymerase.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase Plus",
      subtitle: "E2020, E2021",
      description: "Complete digestion of DNA into individual nucleosides.",
      handle: "/products/dna-degradase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2020_DNA-Degradase-Plus.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dsDNA Shearase Plus",
      subtitle: "E2018-200, E2018-50",
      description:
        "Simply control fragment size of dsDNA by adjusting the concentration of dsDNA Shearase Plus.",
      handle: "/products/dsdna-shearase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2018-50_dsDNA-Shearase-Plus-50-U.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "CpG Methylase (M. Sssl)",
      subtitle: "E2010, E2011",
      description:
        "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
      handle: "/products/cpg-methylase-m-sssl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2010_CpG-Methylase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-hmC Glucosyltransferase",
      subtitle: "E2026, E2027",
      description: "5-hmC detection; 5-hmC enrichment",
      handle: "/products/5-hmc-glucosyltransferase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2026_5-hmC-Glucosyltransferase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Atlantis dsDNase",
      subtitle: "E2030",
      description:
        "Atlantis dsDNase ensures digestion of dsDNA to yield homogeneous populations of core nucleosomes.",
      handle: "/products/atlantis-ds-dnase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030_Atlantis-dsDNase-12.5-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNA Degradase",
      subtitle: "E2016, E2017",
      description: "Complete digestion of DNA into individual nucleotides",
      handle: "/products/dna-degradase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2016_DNA-Degradase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated Nucleotides",
      subtitle: "Epigenetics",
      description:
        "High-quality methylated and hydroxymethylated nucleotides that can be used in many applications including the study of binding and interacting proteins.",
      handle: "/collections/methylated-nucleotides",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "dNTP Solutions",
      subtitle: "Epigenetics",
      description:
        "Convenient and ready-to-use dNTPs for use in a variety of molecular biology applications including long-range PCR, cDNA synthesis, RT-PCR, real-time PCR, standard PCR, and high-fidelity PCR. ",
      handle: "/collections/dntp-solutions",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/D1005_dATP.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Epigenetic Enzymes": [
    {
      title: "DNA Degradase Plus",
      subtitle: "E2020, E2021",
      description: "Complete digestion of DNA into individual nucleosides.",
      handle: "/products/dna-degradase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2020_DNA-Degradase-Plus.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dsDNA Shearase Plus",
      subtitle: "E2018-200, E2018-50",
      description:
        "Simply control fragment size of dsDNA by adjusting the concentration of dsDNA Shearase Plus.",
      handle: "/products/dsdna-shearase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2018-50_dsDNA-Shearase-Plus-50-U.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "CpG Methylase (M. Sssl)",
      subtitle: "E2010, E2011",
      description:
        "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
      handle: "/products/cpg-methylase-m-sssl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2010_CpG-Methylase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Atlantis dsDNase",
      subtitle: "E2030",
      description:
        "Atlantis dsDNase ensures digestion of dsDNA to yield homogeneous populations of core nucleosomes.",
      handle: "/products/atlantis-ds-dnase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030_Atlantis-dsDNase-12.5-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-hmC Glucosyltransferase",
      subtitle: "E2026, E2027",
      description: "5-hmC detection; 5-hmC enrichment",
      handle: "/products/5-hmc-glucosyltransferase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2026_5-hmC-Glucosyltransferase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase",
      subtitle: "E2016, E2017",
      description: "Complete digestion of DNA into individual nucleotides",
      handle: "/products/dna-degradase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2016_DNA-Degradase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Micrococcal Nuclease",
      subtitle: "D5220-1",
      description: "Cleaves single-stranded and double-stranded DNA and RNA. Complete digestion with Micrococcal Nuclease yields mono- and oligonucleotides with 3'-phosphates.",
      handle: "/products/micrococcal-nuclease",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5220-1_Micrococcal-Nuclease.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Epigenetics Reagents": [
    {
      title: "Methylated & Hydroxymethylated Nucleotides",
      subtitle: "Epigenetics",
      description:
        "High-quality methylated and hydroxymethylated nucleotides that can be used in many applications including the study of binding and interacting proteins.",
      handle: "/collections/methylated-hydroxymethylated-nucleotides",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "dNTP Solutions",
      subtitle: "Epigenetics",
      description:
        "Convenient and ready-to-use dNTPs for use in a variety of molecular biology applications including long-range PCR, cDNA synthesis, RT-PCR, real-time PCR, standard PCR, and high-fidelity PCR. ",
      handle: "/collections/dntp-solutions",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/D1005_dATP.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Non-Bisulfite Methods": [
    {
      title: "Methylated-DNA IP Kit",
      subtitle: "D5101",
      description:
        "Kit for immunoprecipitation of methylated DNA in only a few hours. Recovered DNA is suitable for microarray, PCR, bisulfite treatment, etc.",
      handle: "/products/methylated-dna-ip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5101_Methylated-DNA-IP-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-mC DNA ELISA Kit",
      subtitle: "D5325, D5326",
      description: "Global 5-mC detection and quantitation.",
      handle: "/products/5-mc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5325_5-mC DNA ELISA Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)",
      subtitle: "A3002-15, A3002-200, A3002-30, A3002-50",
      description:
        "Anti-5mC antibody for immunoprecipitation of methylated DNA, ELISA, immunoblotting, immunofluorescence",
      handle: "/products/anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A3002-50_Anit Methylation - 1:2ul.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "DNA Methylation Library Prep Kits": [
    {
      title: "Zymo-Seq Trio WGBS Library Kit",
      subtitle: "D5462, D5463",
      description:
          "Provides a reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation.",
      handle: "/products/zymo-seq-trio-wgbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq WGBS Library Kit",
      subtitle: "D5465",
      description: "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. Zymo-Seq WGBS Library Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-ups steps required by conventional, ligation-based library preparation methods.",
      handle: "/products/zymo-seq-wgbs-library-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/d5465-zymo_seq_wgbs_library_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq RRBS Library Kit",
      subtitle: "D5460, D5461",
      description:
        "The Zymo-Seq RRBS Library Kit is an all-inclusive library prep kit for low-input library preparation of Reduced Representation of Bisulfite Sequencing (RRBS) to profile genome-wide DNA methylation.",
      handle: "/products/zymo-seq-rrbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5460_ez_dna_methylation_rrbs_library_prep_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pico Methyl-Seq Library Prep Kit",
      subtitle: "D5455, D5456",
      description:
        "All-inclusive kit for bisulfite conversion followed by Whole Genome Bisulfite Sequencing (WGBS) library preparation.",
      handle: "/products/pico-methyl-seq-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d5456_pico-methyl-seq-library-prep-kit_1.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Zymo-Seq ATAC Library Kit",
      subtitle: "D5458",
      description:
        "The Zymo-Seq ATAC Library Kit features pre assembled buffers offering the quickest and highest quality ATAC-Seq library production.",
      handle: "/products/zymo-seq-atac-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5458-Zymo-Seq-ATAC-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
  ],
  "DNA Hydroxymethylation Library Prep Kits": [],
  "DNA Methylation Standards": [
    {
        title: "Zymo-Seq Methyl Spike-in Control",
        subtitle: "D5500",
        description:
          "Standards for DNA methylation analysis workflows.",
        handle: "/products/zymo-seq-methyl-spike-in-control",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D5500-Zymo-Seq_Methyl_Spike-in_Control.jpg",
        searchWeight: 0,
        tags: ["DRY ICE"],
    },
    {
      title: "Human Methylated & Non-methylated DNA Set",
      subtitle: "D5014, D5014-1, D5014-2",
      description:
        "Methylated and non-methylated DNA controls with primer sets to assess bisulfite conversion efficiency and for DNA methylation quantification.",
      handle: "/products/human-methylated-non-methylated-dna-set-dna-w-primers",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5014_Human-Methylated-and-Non-Methylated-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Universal Methylated DNA Standard",
      subtitle: "D5011, D5012",
      description:
        "Control DNA for bisulfite conversion and DNA methylation quantitation.",
      handle: "/products/universal-methylated-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5011_Universal-Methylated-Human-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Bisulfite-Converted Universal Methylated Human DNA Standard",
      subtitle: "D5015",
      description: "Control DNA for DNA methylation quantitation.",
      handle:
        "/products/bisulfite-converted-universal-methylated-human-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5015_Bisulfite-Converted-Universal-Methylated-HUman-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Human Methylated & Non-Methylated (WGA) DNA Set",
      subtitle: "D5013, D5013-1, D5013-2",
      description:
        "This control set is generated from HCT116 DKO cell genomic DNA using whole-genome amplification (WGA) technology. This standard is ideal for studying loci with ultra-low methylation levels.",
      handle:
        "/products/human-methylated-non-methylated-wga-dna-set-dna-w-primers",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5013_Human-WGA-Methylated-and-Non-Methylated-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set",
      subtitle: "D5405",
      description:
        "Ideal control for cytosine modification studies including HPLC; LC/MS; TLC",
      handle:
        "/products/5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5405_5-mC & 5-hmC DNA Standard Set.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Mouse 5-hmC & 5-mC DNA Set",
      subtitle: "D5019, D5019-1, D5019-2, D5019-3, D5019-4",
      description:
        "Mouse DNA controls for bisulfite conversion and DNA methylation and hydroxymethylation quantitation.",
      handle: "/products/mouse-5hmc-5mc-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5019_Mouse-hmC-and-5-mC-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>E. coli</i> Non-Methylated Genomic DNA",
      subtitle: "D5016",
      description:
        "Control for bisulfite conversion and DNA methylation quantitation",
      handle: "/products/e-coli-non-methylated-genomic-dna",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5016_E-Coli-Non-Methylated-Genomic-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated & Non-methylated pUC19 DNA Set",
      subtitle: "D5017",
      description:
        "Control for bisulfite conversion and DNA methylation quantitation",
      handle: "/products/methylated-non-methylated-puc19-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5017_Methylated-and-Non-Methylated-pUC19-DNA-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Human Matched DNA Set",
      subtitle: "D5018, D5018-1, D5018-2",
      description:
        "Control for Bisulfite conversion and DNA methylation quantitation",
      handle: "/products/human-matched-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5018_Human-Matched-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "RNA Methylation": [
    {
      title: "EZ RNA Methylation Kit",
      subtitle: "R5001, R5002",
      description:
        "Fast and reliable bisulfite conversion of RNA for methylation analysis.",
      handle: "/products/ez-rna-methylation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R5001_EZ-RNA-Methylation-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Bisulfite Conversion of DNA": [
    {
      title: "Bisulfite Conversion Kits",
      subtitle: "Epigenetics",
      description:
        "Streamlined, simplified, and proven procedures for bisulfite conversion of DNA. Recommended by Illumina’s Golden Gate and Infinium Assays.",
      handle: "/pages/bisulfite-conversion-kits",
      isKit: true,
      image_url:
        "http://files.zymoresearch.com/images/D5001_EZ-DNA-Methylation-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Lightning Kits",
      subtitle: "Epigenetics",
      description:
        "Discover citation-leading kits with the most efficient method for complete bisulfite conversion of DNA for methylation analysis. Get a free sample kit today with free shipping. ",
      handle: "/collections/ez-dna-methylation-lightning-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Direct Kits",
      subtitle: "Epigenetics",
      description:
        "Bisulfite conversion kits that feature complete DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. Get a free bisulfite conversion kits sample.",
      handle: "/collections/ez-dna-methylation-direct-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5020_EZ-DNA-Methylation-Direct-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation Kits",
      subtitle: "Epigenetics",
      description:
        "The EZ DNA Methylation&trade; Kits feature a simplified procedure that streamlines bisulfite treatment of DNA.",
      handle: "/collections/ez-dna-methylation-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Gold Kits",
      subtitle: "Epigenetics",
      description:
        "Consolidate DNA denaturation and bisulfite conversion processes into one step, resulting in a much faster bisulfite conversion",
      handle: "/collections/ez-dna-methylation-gold-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Bisulfite-Converted Universal Methylated Human DNA Standard",
      subtitle: "D5015",
      description: "Control DNA for DNA methylation quantitation.",
      handle:
        "/products/bisulfite-converted-universal-methylated-human-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5015_Bisulfite-Converted-Universal-Methylated-HUman-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "EZ DNA Methylation-Startup Kit",
      subtitle: "D5024",
      description:
        "An all-inclusive kit for bisulfite conversion of DNA directly from blood, tissues, and cells, and PCR reagents and controls to assess conversion efficiency.",
      handle: "/products/ez-dna-methylation-startup-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5024_EZ DNA Methylation-Startup Kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Bisulfite Modification": [
    {
      title: "Bisulfite Conversion Kits",
      subtitle: "Epigenetics",
      description:
        "Streamlined, simplified, and proven procedures for bisulfite conversion of DNA. Recommended by Illumina’s Golden Gate and Infinium Assays.",
      handle: "/pages/bisulfite-conversion-kits",
      isKit: true,
      image_url:
        "http://files.zymoresearch.com/images/D5001_EZ-DNA-Methylation-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Lightning Kits",
      subtitle: "Epigenetics",
      description:
        "Discover citation-leading kits with the most efficient method for complete bisulfite conversion of DNA for methylation analysis. Get a free sample kit today with free shipping. ",
      handle: "/collections/ez-dna-methylation-lightning-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Direct Kits",
      subtitle: "Epigenetics",
      description:
        "Bisulfite conversion kits that feature complete DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. Get a free bisulfite conversion kits sample.",
      handle: "/collections/ez-dna-methylation-direct-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5020_EZ-DNA-Methylation-Direct-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation Kits",
      subtitle: "Epigenetics",
      description:
        "The EZ DNA Methylation&trade; Kits feature a simplified procedure that streamlines bisulfite treatment of DNA.",
      handle: "/collections/ez-dna-methylation-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Gold Kits",
      subtitle: "Epigenetics",
      description:
        "Consolidate DNA denaturation and bisulfite conversion processes into one step, resulting in a much faster bisulfite conversion",
      handle: "/collections/ez-dna-methylation-gold-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Bisulfite-Converted Universal Methylated Human DNA Standard",
      subtitle: "D5015",
      description: "Control DNA for DNA methylation quantitation.",
      handle:
        "/products/bisulfite-converted-universal-methylated-human-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5015_Bisulfite-Converted-Universal-Methylated-HUman-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "EZ DNA Methylation-Startup Kit",
      subtitle: "D5024",
      description:
        "An all-inclusive kit for bisulfite conversion of DNA directly from blood, tissues, and cells, and PCR reagents and controls to assess conversion efficiency.",
      handle: "/products/ez-dna-methylation-startup-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5024_EZ DNA Methylation-Startup Kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "ChIP Kits": [
    {
      title: "Zymo-Spin ChIP Kit",
      subtitle: "D5209, D5210",
      description:
        "The Zymo-Spin ChIP Kit is a ChIP kit that provides a streamlined ChIP procedure for investigating protein-DNA interactions.",
      handle: "/products/zymo-spin-chip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5209_Zymo-Spin-ChIP-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ChIP DNA Clean & Concentrator",
      subtitle: "D5201, D5205",
      description:
        "The Chromatin Immunoprecipitation (ChIP) DNA Clean & Concentrator is a simple ChIP kit that provides a hassle-free method for the rapid purification and concentration of high-quality DNA from any step in a standard ChIP protocol.",
      handle: "/products/chip-dna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5201_ChIP-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 ChIP DNA Clean & Concentrator",
      subtitle: "D5206, D5207",
      description:
        "The ZR-96 ChIP DNA Clean & Concentrator is a high-throughput (96-well) DNA ChIP kit for seamless purification from any step of a ChIP assay.",
      handle: "/products/zr-96-chip-dna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5206_ZR-96-ChIP-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ Nucleosomal DNA Prep Kit",
      subtitle: "D5220",
      description:
        "The EZ Nucleosomal DNA Prep Kit is a streamlined procedure for the isolation of nucleosome-associated DNA, making it ideal for nucleosome mapping studies.",
      handle: "/products/ez-nucleosomal-dna-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5220_EZ-Nucleosomal-DNA-Prep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq ATAC Library Kit",
      subtitle: "D5458",
      description:
        "The Zymo-Seq ATAC Library Kit features pre assembled buffers offering the quickest and highest quality ATAC-Seq library production.",
      handle: "/products/zymo-seq-atac-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5458-Zymo-Seq-ATAC-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
  ],
  "DNA Methylation": [
    {
      title: "Bisulfite Conversion Kits",
      subtitle: "Epigenetics",
      description:
        "Streamlined, simplified, and proven procedures for bisulfite conversion of DNA. Recommended by Illumina’s Golden Gate and Infinium Assays.",
      handle: "/pages/bisulfite-conversion-kits",
      isKit: true,
      image_url:
        "http://files.zymoresearch.com/images/D5001_EZ-DNA-Methylation-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Lightning Kits",
      subtitle: "Epigenetics",
      description:
        "Discover citation-leading kits with the most efficient method for complete bisulfite conversion of DNA for methylation analysis. Get a free sample kit today with free shipping. ",
      handle: "/collections/ez-dna-methylation-lightning-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Direct Kits",
      subtitle: "Epigenetics",
      description:
        "Bisulfite conversion kits that feature complete DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. Get a free bisulfite conversion kits sample.",
      handle: "/collections/ez-dna-methylation-direct-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5020_EZ-DNA-Methylation-Direct-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation Kits",
      subtitle: "Epigenetics",
      description:
        "The EZ DNA Methylation&trade; Kits feature a simplified procedure that streamlines bisulfite treatment of DNA.",
      handle: "/collections/ez-dna-methylation-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Gold Kits",
      subtitle: "Epigenetics",
      description:
        "Consolidate DNA denaturation and bisulfite conversion processes into one step, resulting in a much faster bisulfite conversion",
      handle: "/collections/ez-dna-methylation-gold-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)",
      subtitle: "A3002-15, A3002-200, A3002-30, A3002-50",
      description:
        "Anti-5mC antibody for immunoprecipitation of methylated DNA, ELISA, immunoblotting, immunofluorescence",
      handle: "/products/anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A3002-50_Anit Methylation - 1:2ul.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Anti-5-Hydroxymethylcytosine Polyclonal Antibody",
      subtitle: "A4001-200, A4001-25, A4001-50",
      description:
        "Immunoprecipitation for 5-hmC DNA, ELISA, immunoblotting, immunoflourescence",
      handle: "/products/anti-5-hydroxymethylcytosine-polyclonal-antibody",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A4001-25_Anti-5-Hydroxymethylcytosine Polyclonal Antibody - 25 ug.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Bisulfite-Converted Universal Methylated Human DNA Standard",
      subtitle: "D5015",
      description: "Control DNA for DNA methylation quantitation.",
      handle:
        "/products/bisulfite-converted-universal-methylated-human-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5015_Bisulfite-Converted-Universal-Methylated-HUman-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Human Matched DNA Set",
      subtitle: "D5018, D5018-1, D5018-2",
      description:
        "Control for Bisulfite conversion and DNA methylation quantitation",
      handle: "/products/human-matched-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5018_Human-Matched-DNA-Set.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Mouse 5-hmC & 5-mC DNA Set",
      subtitle: "D5019, D5019-1, D5019-2, D5019-3, D5019-4",
      description:
        "Mouse DNA controls for bisulfite conversion and DNA methylation and hydroxymethylation quantitation.",
      handle: "/products/mouse-5hmc-5mc-dna-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5019_Mouse-hmC-and-5-mC-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "EZ DNA Methylation-Startup Kit",
      subtitle: "D5024",
      description:
        "An all-inclusive kit for bisulfite conversion of DNA directly from blood, tissues, and cells, and PCR reagents and controls to assess conversion efficiency.",
      handle: "/products/ez-dna-methylation-startup-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5024_EZ DNA Methylation-Startup Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Methylated-DNA IP Kit",
      subtitle: "D5101",
      description:
        "Kit for immunoprecipitation of methylated DNA in only a few hours. Recovered DNA is suitable for microarray, PCR, bisulfite treatment, etc.",
      handle: "/products/methylated-dna-ip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5101_Methylated-DNA-IP-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "OneStep qMethyl-Lite",
      subtitle: "D5311",
      description:
        "Bisulfite-free DNA methylation analysis; Rapid screening of single/multiple loci",
      handle: "/products/onestep-qmethyl-lite",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5310_OneStep-qMethyl.jpg",
      searchWeight: 0,
      tags: ["Epigenetics", "DNA Methylation"],
    },
    {
      title: "5-mC DNA ELISA Kit",
      subtitle: "D5325, D5326",
      description: "Global 5-mC detection and quantitation.",
      handle: "/products/5-mc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5325_5-mC DNA ELISA Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-Methylcytosine & 5-Hydroxymethylcytosine DNA Standard Set",
      subtitle: "D5405",
      description:
        "Ideal control for cytosine modification studies including HPLC; LC/MS; TLC",
      handle:
        "/products/5-methylcytosine-5-hydroxymethylcytosine-dna-standard-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5405_5-mC & 5-hmC DNA Standard Set.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Quest 5-hmC DNA ELISA Kit",
      subtitle: "D5425, D5426",
      description: "Global 5-hmC detection and quantitation.",
      handle: "/products/quest-5-hmc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5425_Quest 5-hmC DNA ELISA Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pico Methyl-Seq Library Prep Kit",
      subtitle: "D5455, D5456",
      description:
        "All-inclusive kit for bisulfite conversion followed by Whole Genome Bisulfite Sequencing (WGBS) library preparation.",
      handle: "/products/pico-methyl-seq-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d5456_pico-methyl-seq-library-prep-kit_1.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Library Prep Kits": [
    {
      title: "<i>Quick</i>-16S NGS Library Prep Kit",
      subtitle: "D6400",
      description:
        "A streamlined solution to convert up to 96 DNA samples to a single, ready-to-sequence 16S library.",
      handle: "/products/quick-16s-ngs-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6400_Quick-16S NGS Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Urine Sample Collection": [
    {
      title: "DNA/RNA Shield",
      subtitle: "Sample Collection",
      description:
        "DNA/RNA Shield products are DNA and RNA transport and storage mediums for any biological samples. Get free samples with free shipping.",
      handle: "/collections/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Urine Collection",
      subtitle: "Sample Collection",
      description: "",
      handle: "pages/sample-collection-kits?tags=urine",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3062_Urine-Collection-Kit-with-Urine-Conditioning-Buffer.png",
      searchWeight: 2,
      tags: [],
    },
  ],
  "NGS Library Prep Kits": [
    {
      title: "Green DNA/RNA Dry Transport",
      subtitle: "R1141",
      description:
        "Green DNA/RNA Dry Transport stabilizes NGS libraries for room temperature transportation with any carrier—no declarations needed.",
      handle: "/products/green-dna-rna-dry-transport",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/green-dna-rna-dry-transport_600x.webp?v=1745352863",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Full-Length Library Prep Kit",
      subtitle: "D6450-PS1 - D6450-PS4",
      description:
        "Delivers pooled and purified libraries ready for downstream sequencing on PacBio & Oxford Nanopore sequencing platforms in as little as 30 minutes of hands-on time",
      handle: "/products/quick-16s-full-length-library-prep-kit",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/D6450-BQuick-16SFullLengthLibraryKit_1200x.webp?v=1735842064",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq Trio WGBS Library Kit",
      subtitle: "D5462, D5463",
      description:
          "Provides a reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation.",
      handle: "/products/zymo-seq-trio-wgbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq SPLAT DNA Library Kit",
      subtitle: "D5464",
      description:
        "Versatile and unique ssDNA library preparation solution for any DNA sample.",
      handle: "/products/zymo-seq-splat-dna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5464_zymo-seq_splat_dna_library_kit_(12_prep).jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3)",
        subtitle: "D6440-PS1",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v3",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6440-quick-16s_plus_ngs_library_prep_kit_v1-v3.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2)",
        subtitle: "D6434-PS1",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v2",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6434-quick-16S_plus_ngs_library_prep_kit_v1-v2.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
    },
    {
      title: "Zymo-Seq SwitchFree 3′ mRNA Library Kit",
      subtitle: "R3008, R3009",
      description: "UMI-integrated, simple 3′ mRNA library preparation in ~4 hours with scalable sample multiplexing suitable for high-throughput protein coding gene counting.",
      handle: "/products/zymo-seq-switchfree-3-mrna-library-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3008_zymo_seq_switchfree_3_mrna_library_kit_2.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq ATAC Library Kit",
      subtitle: "D5458",
      description:
        "The Zymo-Seq ATAC Library Kit features pre assembled buffers offering the quickest and highest quality ATAC-Seq library production.",
      handle: "/products/zymo-seq-atac-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5458-Zymo-Seq-ATAC-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq WGBS Library Kit",
      subtitle: "D5465",
      description: "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. Zymo-Seq WGBS Library Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-ups steps required by conventional, ligation-based library preparation methods.",
      handle: "/products/zymo-seq-wgbs-library-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/d5465-zymo_seq_wgbs_library_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V4)",
      subtitle: "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
      description:
        "Fastest, normalization-free 16S library prep",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v4",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
      subtitle: "D6421-PS1 - D6421-PS8",
      description:
        "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6421-quick_16s_plus_ngs_library_prep_kit_udi.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-ITS Plus NGS Library Prep Kit (UDI)",
      subtitle: "D6425-PS1, D6425-PS2, D6425-PS3, D6425-PS4",
      description:
        "The fastest and simplest NGS library prep kit targeting the ITS region for mycobiome profile analysis.",
      handle: "/products/quick-its-plus-ngs-library-prep-kit-udi",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d6425-quick_its_plus_ngs_library_prep_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S NGS Library Prep Kit",
      subtitle: "D6400",
      description:
        "A streamlined solution to convert up to 96 DNA samples to a single, ready-to-sequence 16S library.",
      handle: "/products/quick-16s-ngs-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6400_Quick-16S NGS Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Pico Methyl-Seq Library Prep Kit",
      subtitle: "D5455, D5456",
      description:
        "All-inclusive NGS library prep kits for easy bisulfite conversion followed by Whole Genome Bisulfite Sequencing (WGBS) library preparation.",
      handle: "/products/pico-methyl-seq-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d5456_pico-methyl-seq-library-prep-kit_1.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "RRHP 5-hmC Library Prep Kit",
      subtitle: "D5450, D5451",
      description:
        "Innovative 5-hmC NGS library prep kits for strand-specific mapping of 5-hmC in DNA.",
      handle: "/products/rrhp-5-hmc-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5450_RRHP 5-hmC Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Zymo-Seq RiboFree Total RNA Library Kit",
      subtitle: "R3000, R3003",
      description:
        "One for all. Simplest and all-inclusive total RNA-Seq library preparation kit with universal rRNA depletion for any organism.",
      handle: "/products/zymo-seq-ribofree-total-rna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3000_zymo-seq_ribofree_tota_rna_library_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Universal cDNA Kit",
      subtitle: "R3001",
      description:
        "Simplest NGS-Grade cDNA kit with universal rRNA depletion for any organism.",
      handle: "/products/zymo-seq-ribofree-universal-cdna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3001_zymo-seq_ribofree_universal_cdna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RRBS Library Kit",
      subtitle: "D5460, D5461",
      description:
        "The Zymo-Seq RRBS Library Kit is an all-inclusive library prep kit for low-input library preparation of Reduced Representation of Bisulfite Sequencing (RRBS) to profile genome-wide DNA methylation.",
      handle: "/products/zymo-seq-rrbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5460_ez_dna_methylation_rrbs_library_prep_kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "DNA Hydroxymethylation": [
    {
      title: "Quest 5-hmC DNA ELISA Kit",
      subtitle: "D5425, D5426",
      description: "Global 5-hmC detection and quantitation.",
      handle: "/products/quest-5-hmc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5425_Quest 5-hmC DNA ELISA Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RRHP 5-hmC Library Prep Kit",
      subtitle: "D5450, D5451",
      description:
        "Innovative 5-hmC library preparation kit for strand-specific mapping of 5-hmC in DNA.",
      handle: "/products/rrhp-5-hmc-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5450_RRHP 5-hmC Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Anti-5-Hydroxymethylcytosine Polyclonal Antibody",
      subtitle: "A4001-200, A4001-25, A4001-50",
      description:
        "Immunoprecipitation for 5-hmC DNA, ELISA, immunoblotting, immunoflourescence",
      handle: "/products/anti-5-hydroxymethylcytosine-polyclonal-antibody",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A4001-25_Anti-5-Hydroxymethylcytosine Polyclonal Antibody - 25 ug.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase Plus",
      subtitle: "E2020, E2021",
      description: "Complete digestion of DNA into individual nucleosides.",
      handle: "/products/dna-degradase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E2020_DNA-Degradase-Plus.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  Nucleotides: [
    {
      title: "dNTP Mix",
      subtitle: "D1000, D1000-1",
      description:
        "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/dntp-mix",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1000_dNTPs.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dATP",
      subtitle: "D1005",
      description:
        "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/datp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1005_dATP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dTTP",
      subtitle: "D1010",
      description:
        "dTTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/dttp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1010_dTTP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dGTP",
      subtitle: "D1015",
      description:
        "dGTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/dgtp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1015_dGTP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dCTP",
      subtitle: "D1020",
      description: "PCR nucleotides and mix",
      handle: "/products/dctp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1020_dCTP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-Methylcytosine dNTP Mix",
      subtitle: "D1030",
      description:
        "dNTP mixture containing the modified deoxynucleotide 5-mC for use with PCR, mass spec, etc.",
      handle: "/products/5-methylcytosine-dntp-mix",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-Methyl dCTP",
      subtitle: "D1035",
      description: "Modified deoxynucleotide for use with PCR, mass spec, etc.",
      handle: "/products/5-methyl-dctp",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D1035_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    }
  ],
  "Epigenetics High-Throughput/Automated Isolation": [
    {
      title: "EZ-96 DNA Methylation Kit",
      subtitle: "D5003, D5004",
      description:
        "Streamlined bisulfite treatment of DNA in a 96-well plate.”",
      handle: "/products/ez-96-dna-methylation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5003-EZ-96-DNA-Methylation-Kit---shallow-well.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Gold Kit",
      subtitle: "D5007, D5008",
      description:
        "Complete bisulfite conversion of DNA in a 96-well plate in less than 3 hours.",
      handle: "/products/ez-96-dna-methylation-gold-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5007_EZ-DNA-Methylation-Gold-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Direct Kit",
      subtitle: "D5022, D5023",
      description:
        "A complete and reliable bisulfite conversion kit that eliminates cumbersome DNA precipitation steps and allows DNA bisulfite conversion directly from blood, tissue, and cells without prior DNA purification.",
      handle: "/products/ez-96-dna-methylation-direct-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5022_EZ-96-DNA-Methylatoin-Direct-Kit-Shallow-Well.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning Kit",
      subtitle: "D5032, D5033",
      description:
        "Fastest method for bisulfite conversion of DNA paired with purification on a 96-well plate for high-throughput sample processing.",
      handle: "/products/ez-96-dna-methylation-lightning-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5032_EZ-96-DAN-Methylation-Lightning-Kit-Shallow-Well.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation MagPrep",
      subtitle: "D5040, D5041",
      description: "Streamlined bisulfite treatment of DNA.",
      handle: "/products/ez-96-dna-methylation-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Gold MagPrep",
      subtitle: "D5042, D5043",
      description:
        "The EZ-96 DNA Methylation-Gold  MagPrep integrates DNA denaturation and bisulfite conversion processes into one step coupled to a magnetic bead-based clean-up for high-throughput methylation analysis.",
      handle: "/products/ez-96-dna-methylation-gold-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Direct MagPrep",
      subtitle: "D5044, D5045",
      description:
        "A complete and reliable bisulfite conversion kit that eliminates cumbersome DNA precipitation steps and allows DNA bisulfite conversion directly from blood, tissue, and cells without prior DNA purification.",
      handle: "/products/ez-96-dna-methylation-direct-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5044-EZ-96-Methylation-Lightning-Direct.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning MagPrep",
      subtitle: "D5046, D5047",
      description:
        "Discover the fastest bisulfite conversion kit with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
      handle: "/products/ez-96-dna-methylation-lightning-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5046_EZ-96-DNA-Methylation-Lightning-MagPrep.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Epigenetics 96-well Spin Plate Isolation": [
    {
      title: "EZ-96 DNA Methylation Kit",
      subtitle: "D5003, D5004",
      description:
        "Streamlined bisulfite treatment of DNA in a 96-well plate.”",
      handle: "/products/ez-96-dna-methylation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5003-EZ-96-DNA-Methylation-Kit---shallow-well.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Gold Kit",
      subtitle: "D5007, D5008",
      description:
        "Complete bisulfite conversion of DNA in a 96-well plate in less than 3 hours.",
      handle: "/products/ez-96-dna-methylation-gold-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5007_EZ-DNA-Methylation-Gold-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Direct Kit",
      subtitle: "D5022, D5023",
      description:
        "A complete and reliable bisulfite conversion kit that eliminates cumbersome DNA precipitation steps and allows DNA bisulfite conversion directly from blood, tissue, and cells without prior DNA purification.",
      handle: "/products/ez-96-dna-methylation-direct-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5022_EZ-96-DNA-Methylatoin-Direct-Kit-Shallow-Well.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning Kit",
      subtitle: "D5032, D5033",
      description:
        "Fastest method for bisulfite conversion of DNA paired with purification on a 96-well plate for high-throughput sample processing.",
      handle: "/products/ez-96-dna-methylation-lightning-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5032_EZ-96-DAN-Methylation-Lightning-Kit-Shallow-Well.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Epigenetics 96-well Magnetic Bead Isolation": [
    {
      title: "EZ-96 DNA Methylation MagPrep",
      subtitle: "D5040, D5041",
      description: "Streamlined bisulfite treatment of DNA.",
      handle: "/products/ez-96-dna-methylation-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Gold MagPrep",
      subtitle: "D5042, D5043",
      description:
        "The EZ-96 DNA Methylation-Gold  MagPrep integrates DNA denaturation and bisulfite conversion processes into one step coupled to a magnetic bead-based clean-up for high-throughput methylation analysis.",
      handle: "/products/ez-96-dna-methylation-gold-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Direct MagPrep",
      subtitle: "D5044, D5045",
      description:
        "A complete and reliable bisulfite conversion kit that eliminates cumbersome DNA precipitation steps and allows DNA bisulfite conversion directly from blood, tissue, and cells without prior DNA purification.",
      handle: "/products/ez-96-dna-methylation-direct-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5044-EZ-96-Methylation-Lightning-Direct.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning MagPrep",
      subtitle: "D5046, D5047",
      description:
        "Discover the fastest bisulfite conversion kit with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
      handle: "/products/ez-96-dna-methylation-lightning-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5046_EZ-96-DNA-Methylation-Lightning-MagPrep.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter Assemblies": [
    {
      title: "Zymo-Spin V Columns w/ Reservoir",
      subtitle: "C1016-25, C1016-50",
      description:
        "Assembly for purifying DNA/RNA from &le; 15 ml sample in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1016-25-Zymo-Spin-V-with-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "50 ml Conical Reservoir",
      subtitle: "C1032-25",
      description:
        "The 50 ml Reservoir can be used with vacuum manifolds for the purification of DNA and/or RNA",
      handle: "/products/50-ml-conical-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1032-25-50ml-Conical-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "600 ml Reservoir",
      subtitle: "C1033-5",
      description:
        "The 600 ml Reservoir, used with vacuum manifolds for the purification of DNA/RNA",
      handle: "/products/600-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1033-5-600-ml-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Syringe Filters",
      subtitle: "C1036-5",
      description:
        "The ZymoPURE Syringe Filter features rapid clarification of up to 60 ml of neutralized lysate",
      handle: "/products/zymopure-syringe-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1036-5-Syringe-Filters.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "Zymo-Spin III-P Column Assembly w/ 15 ml and 50 ml Reservoir (5 Pack)",
      subtitle: "C1040-5",
      description: "",
      handle:
        "/products/zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1040-5-Zymo-Spin-III-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-P Column Assembly w/ 15 ml and 50 ml Reservoir",
      subtitle: "C1042-5",
      description:
        "The Zymo-Spin V-P can be used in centrifuges or on-vacuum manifolds to purify plasmid DNA.",
      handle:
        "/products/zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1042-5--Zymo-Spin-V-P-with-15-ml-and-50-ml-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZRC GF Filter",
      subtitle: "C1009-20, C1009-50",
      description:
        "Filter for separating cellular components from biological fluids.",
      handle: "/products/zrc-gf-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1009-20-ZRC-GF-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Zymo-Maxi Filter",
      subtitle: "C1017-10, C1017-20",
      description:
        "Column-filter assembly for purifying DNA/RNA from &le; 75 ml sample",
      handle: "/products/zymo-spin-vi-columns-w-zymo-maxi-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1017-10-Zymo-Spin-VI-with-maxi-filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Reservoir",
      subtitle: "C1018-10, C1018-20",
      description:
        "Column assembly for recovery of DNA/RNA from large volumes.",
      handle: "/products/zymo-spin-vi-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1018-Zymo-Spin-VI-with-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Block Racks": [
    {
      title: "Silicon-A Plate",
      subtitle: "C2001",
      description:
        "Shallow-well (96) plate purification of DNA/RNA in &ge; 30 &micro;l.",
      handle: "/products/silicon-a-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-Silicon-A-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Plate",
      subtitle: "C2002",
      description:
        "1.2 ml, round bottom, 96-well plate for use with spin plate.",
      handle: "/products/collection-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2002-Collection-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Elution Plate",
      subtitle: "C2003",
      description:
        "90 &micro;l, V-bottom, 96-well plate for use with spin plate.",
      handle: "/products/elution-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2003-Elution-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96 Plate",
      subtitle: "C2004, C2004-SW",
      description:
        "Deep-well (96) plate purification of DNA/RNA in &ge; 10 &micro;l elution.",
      handle: "/products/zymo-spin-i-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2004-Zymo-Spin-I-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB-96 Plate",
      subtitle: "C2006",
      description:
        "Deep-well (96) plate for DNA clean-up & dye removal in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-ib-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2006-Zymo-Spin-IB-96-plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96-XL Plates",
      subtitle: "C2010",
      description:
        "Deep-well (96) plate purification of large DNA in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-i-96-xl-plates",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2010-Zymo-Spin-III-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block",
      subtitle: "P1001-10, P1001-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1001-2-96-well-block.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Conversion Plate w/ Cover Foil",
      subtitle: "C2005",
      description: "96-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/conversion-plate-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2005-C2008-96-Well-Conversion-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Plate Cover Foil",
      subtitle: "C2007-12, C2007-2, C2007-24, C2007-4, C2007-6, C2007-8",
      description: "Pierceable aluminum foil with strong adhesive for sealing.",
      handle: "/products/96-well-plate-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2007_96-well Cover Foils.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well PCR Conversion Plate",
      subtitle: "C2008",
      description: "6-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/96-well-pcr-conversion-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2008-96-well_pcr_conversion_plate.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A-HRC Plate",
      subtitle: "C2009",
      description: "",
      handle: "/products/silicon-a-hrc-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2009-Silicon-A-HRC-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block w/ Cover Foil",
      subtitle: "P1002-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1002-2-96-Well-block-with-cover-foil.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-1, S6002-96-2, S6002-96-3",
      description: "ZR BashingBeads in 96 impact resistant tube rack.",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6002-96-2-ZR-Bashing-Bead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "96-Well Spin Plates": [
    {
      title: "ZymoPURE Filter Plate",
      subtitle: "C2022, C2022-1",
      description:
        "High-throughput clarification of bacterial lysates.",
      handle: "/products/zymopure-filter-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2022_ZymoPURE-Filter-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Spin P-96 Plate",
      subtitle: "C2023, C2023-1",
      description:
        "High-throughput plasmid DNA purification spin-plate.",
      handle: "/products/zymo-spin-p-96-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2023_Zymo-Spin-P-96-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Wash Plate",
      subtitle: "C2024, C2024-1",
      description:
        "96-well plate for minimizing cross-contamination during high-throughput processing.",
      handle: "/products/wash-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2024_Wash-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96 Plate",
      subtitle: "C2004, C2004-SW",
      description:
        "Deep-well (96) plate purification of DNA/RNA in &ge; 10 &micro;l elution.",
      handle: "/products/zymo-spin-i-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2004-Zymo-Spin-I-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I-96-XL Plates",
      subtitle: "C2010",
      description:
        "Deep-well (96) plate purification of large DNA in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-i-96-xl-plates",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2010-Zymo-Spin-III-96-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A Plate",
      subtitle: "C2001",
      description:
        "Shallow-well (96) plate purification of DNA/RNA in &ge; 30 &micro;l.",
      handle: "/products/silicon-a-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-Silicon-A-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB-96 Plate",
      subtitle: "C2006",
      description:
        "Deep-well (96) plate for DNA clean-up & dye removal in &ge; 15 &micro;l.",
      handle: "/products/zymo-spin-ib-96-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2006-Zymo-Spin-IB-96-plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A-HRC Plate",
      subtitle: "C2009",
      description: "",
      handle: "/products/silicon-a-hrc-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2009-Silicon-A-HRC-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "96-well Magnetic Bead": [
    {
      title: "RNA Clean & Concentrator-96",
      subtitle: "R1080",
      description: "RNA clean-up from any reaction",
      handle: "/products/rna-clean-concentrator-96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Select-a-Size DNA Clean & Concentrator MagBead Kit",
      subtitle: "D4084, D4084S, D4085",
      description: "Simple size selection for your DNA sample",
      handle: "/products/select-a-size-dna-clean-concentrator-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4084_Select-A-Size-DNA-Clean-and-Concentrator-MagBead-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS 96 MagBead Kit",
      subtitle: "D4302, D4306, D4308",
      description:
        "Inhibitor-free microbial DNA from any sample validated for microbiome and metagenomic analyses",
      handle: "/products/zymobiomics-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral MagBead",
      subtitle: "R2140, R2141",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      subtitle: "R2145, R2146",
      description:
        "Pathogen DNA/RNA isolation from vectors, tissue and biological samples.",
      handle: "/products/quick-dna-rna-pathogen-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zyppy-96 Plasmid MagPrep Kit",
      subtitle: "D4100, D4101, D4102",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes",
      handle: "/products/zyppy-96-plasmid-magprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation MagPrep",
      subtitle: "D5040, D5041",
      description: "Streamlined bisulfite treatment of DNA.",
      handle: "/products/ez-96-dna-methylation-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Gold MagPrep",
      subtitle: "D5042, D5043",
      description:
        "The EZ-96 DNA Methylation-Gold  MagPrep integrates DNA denaturation and bisulfite conversion processes into one step coupled to a magnetic bead-based clean-up for high-throughput methylation analysis.",
      handle: "/products/ez-96-dna-methylation-gold-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning MagPrep",
      subtitle: "D5046, D5047",
      description:
        "Discover the fastest bisulfite conversion kit with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
      handle: "/products/ez-96-dna-methylation-lightning-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5046_EZ-96-DNA-Methylation-Lightning-MagPrep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 MagBead RNA",
      subtitle: "R2100, R2101, R2102, R2103, R2104, R2105",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Magbead Kit",
      subtitle: "D6010-FM, D6011-FM, D6012-FM",
      description:
        "Extract high quality, inhibitor-free DNA from feces, soil, water, etc.",
      handle: "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010-FM_Quick-DNA-Fecal-Soil-Microbe_96-Magbead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Magbead Plus Kit",
      subtitle: "D4081, D4082",
      description:
        "Streamlined DNA isolation from any cells, tissues, and biological fluids (Proteinase K included).",
      handle: "/products/quick-dna-magbead-plus-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4081_Quick-DNA-Magbead-Plus-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Spin Columns": [
    {
      title: "Zymo-Spin I Columns",
      subtitle: "C1003-250, C1003-50",
      description:
        "Uncapped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in &ge; 6 &micro;l.",
      handle: "/products/zymo-spin-i-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1003-Zymo-Spin-I.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC Columns",
      subtitle: "C1004-250, C1004-50",
      description:
        "Capped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in ≥ 6 &micro;l.",
      handle: "/products/zymo-spin-ic-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1004-Zymo-Spin-IC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III Columns",
      subtitle: "C1005-250, C1005-50",
      description:
        "The Zymo-Spin III features durable polypropylene construction that allows purification of up to 25 &micro;g DNA or RNA in &ge; 35 &micro;l eluate.",
      handle: "/products/zymo-spin-iii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1005-Zymo-Spin-III.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIICG Columns",
      subtitle: "C1006-250-G, C1006-50-G",
      description: "",
      handle: "/products/zymo-spin-iiicg-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-G-Zymo-Spin-IIICG.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II Columns",
      subtitle: "C1008-250, C1008-50",
      description:
        "Uncapped columns for the recovery of &le; 25 &micro;g  DNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-ii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1008-50-Zymo-Spin-II.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIC Columns",
      subtitle: "C1011-250, C1011-50",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iic-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1011-50-OPEN-CAP-Zymo-Spin-IIC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns",
      subtitle: "C1012-25, C1012-50",
      description:
        "Column for purifying up to 100 &micro;g  DNA or RNA in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1012-25-Zymo-Spin-V.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB Columns",
      subtitle: "C1014-250, C1014-50",
      description: "Columns for nucleic acid purification and dye removal.",
      handle: "/products/zymo-spin-ib-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1014-Zymo-Spin-IB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-S Columns",
      subtitle: "C1015-25, C1015-50",
      description:
        "The Zymo-Spin IC-S features durable polypropylene construction and contains a unique silica-based matrix that allows purification",
      handle: "/products/zymo-spin-ic-s-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1015-50-Zymo-Spin-IC-S.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns w/ Reservoir",
      subtitle: "C1016-25, C1016-50",
      description:
        "Assembly for purifying DNA/RNA from &le; 15 ml sample in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1016-25-Zymo-Spin-V-with-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIN Columns",
      subtitle: "C1019-250, C1019-50",
      description:
        "Uncapped columns for the recovery of &le;  25 µg  DNA in &ge; 30 &micro;l.",
      handle: "/products/zymo-spin-iin-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1019-Zymo-Spin-IIN.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-E Columns",
      subtitle: "C1021-25, C1024-25, C1024-50, C1029-25",
      description:
        "The Zymo-Spin V-E columns can be used in microcentrifuges, centrifuges, or on vacuum manifolds",
      handle: "/products/zymo-spin-v-e-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1024-25-Zymo-Spin-VE.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "25 ml Reservoir for Spin-Away Filters and Zymo-Spin IIICG",
      subtitle: "C1039-25",
      description: "",
      handle:
        "/products/25-ml-reservoir-for-spin-away-filters-and-zymo-spin-iiicg",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1039-25_Reservoir - 25 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "Zymo-Spin III-P Column Assembly w/ 15 ml and 50 ml Reservoir (5 Pack)",
      subtitle: "C1040-5",
      description: "",
      handle:
        "/products/zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1040-5-Zymo-Spin-III-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-P Column Assembly w/ 15 ml and 50 ml Reservoir",
      subtitle: "C1042-5",
      description:
        "The Zymo-Spin V-P can be used in centrifuges or on-vacuum manifolds to purify plasmid DNA.",
      handle:
        "/products/zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1042-5--Zymo-Spin-V-P-with-15-ml-and-50-ml-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI-P Columns",
      subtitle: "C1044-5",
      description:
        "Zymo-Spin VI-P can be used in centrifuges or on vacuum manifolds for the purification of plasmid DNA.",
      handle: "/products/zymo-spin-vi-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1044-5-Zymo-Spin-VI-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-S Columns w/ LuerLock Caps and 15 ml Reservoir",
      subtitle: "C1049-25",
      description: "",
      handle:
        "/products/zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/(3) Zymo Spin IIIS.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-P Columns",
      subtitle: "C1055-50",
      description: "",
      handle: "/products/zymo-spin-ii-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1055-50_Zymo-Spin II-P Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-F Filters",
      subtitle: "C1057-50",
      description: "For use in Zymo Research environmental purification kits.",
      handle: "/products/zymo-spin-iii-f-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1057-Zymo-Spin-III-F.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-HRC Filters",
      subtitle: "C1058-50",
      description: "",
      handle: "/products/zymo-spin-iii-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1058-Zymo-Spin-III-HRC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV-IR HRC Filters",
      subtitle: "C1010-50",
      description: "",
      handle: "/products/zymo-spin-iv-ir-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1010-50_Zymo-Spin-IV-IR-HRC-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-µHRC Filters",
      subtitle: "C1059-50",
      description: "For use with Zymo Research products.",
      handle: "/products/zymo-spin-ii-µhrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1059_Zymo Spin II-HRC.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XM Columns",
      subtitle: "C1103-50",
      description: "",
      handle: "/products/zymo-spin-ic-xm-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1103-50_Zymo-Spin IC-XM Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XL",
      subtitle: "C1002-25, C1002-50",
      description:
        "Capped columns for the recovery of large-sized DNA in &ge; 10 &micro;l.",
      handle: "/products/zymo-spin-ic-xl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1002-50-Zymo-Spin-IC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV Columns",
      subtitle: "C1007-250, C1007-50",
      description: "",
      handle: "/products/zymo-spin-iv-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/c1007-50-zymo-spin-iv.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns",
      subtitle: "C1013-10, C1013-20",
      description:
        "Column for recovery of up to 500 &micro;g  DNA or RNA in &ge; 2 ml.",
      handle: "/products/zymo-spin-vi-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1013-10-Zymo-Spin-VI.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Zymo-Maxi Filter",
      subtitle: "C1017-10, C1017-20",
      description:
        "Column-filter assembly for purifying DNA/RNA from &le; 75 ml sample",
      handle: "/products/zymo-spin-vi-columns-w-zymo-maxi-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1017-10-Zymo-Spin-VI-with-maxi-filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Reservoir",
      subtitle: "C1018-10, C1018-20",
      description:
        "Column assembly for recovery of DNA/RNA from large volumes.",
      handle: "/products/zymo-spin-vi-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1018-Zymo-Spin-VI-with-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin P1 Columns",
      subtitle: "P2003-1",
      description: "Columns for purification of His-tagged proteins.",
      handle: "/products/zymo-spin-p1-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zymo-spin_pi_c2003-1_.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IICR Columns",
      subtitle: "C1078-250, C1078-50",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iicr-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1011-50-OPEN-CAP-Zymo-Spin-IIC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EndoZero II Spin Columns",
      subtitle: "C1060-25",
      description: "For quick removal of endotoxins from plasmid preps.",
      handle: "/products/endozero-ii-spin-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1060-25_EndoZero II Spin Columns.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin I Columns",
      subtitle: "C1003-250, C1003-50",
      description:
        "Uncapped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in &ge; 6 &micro;l.",
      handle: "/products/zymo-spin-i-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1003-Zymo-Spin-I.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC Columns",
      subtitle: "C1004-250, C1004-50",
      description:
        "Capped columns bind up to 5 &micro;g  DNA or 10 &micro;g  RNA in ≥ 6 &micro;l.",
      handle: "/products/zymo-spin-ic-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1004-Zymo-Spin-IC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XL",
      subtitle: "C1002-25, C1002-50",
      description:
        "Capped columns for the recovery of large-sized DNA in &ge; 10 &micro;l.",
      handle: "/products/zymo-spin-ic-xl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1002-50-Zymo-Spin-IC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-XM Columns",
      subtitle: "C1103-50",
      description: "",
      handle: "/products/zymo-spin-ic-xm-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1103-50_Zymo-Spin IC-XM Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IC-S Columns",
      subtitle: "C1015-25, C1015-50",
      description:
        "The Zymo-Spin IC-S features durable polypropylene construction and contains a unique silica-based matrix that allows purification",
      handle: "/products/zymo-spin-ic-s-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1015-50-Zymo-Spin-IC-S.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IB Columns",
      subtitle: "C1014-250, C1014-50",
      description: "Columns for nucleic acid purification and dye removal.",
      handle: "/products/zymo-spin-ib-columns",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/C1014-Zymo-Spin-IB.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin P1 Columns",
      subtitle: "P2003-1",
      description: "Columns for purification of His-tagged proteins.",
      handle: "/products/zymo-spin-p1-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zymo-spin_pi_c2003-1_.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II Columns",
      subtitle: "C1008-250, C1008-50",
      description:
        "Uncapped columns for the recovery of &le; 25 &micro;g  DNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-ii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1008-50-Zymo-Spin-II.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIC Columns",
      subtitle: "C1011-250, C1011-50",
      description:
        "Capped columns for the recovery of DNA and RNA in &ge; 25 &micro;l.",
      handle: "/products/zymo-spin-iic-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1011-50-OPEN-CAP-Zymo-Spin-IIC-XL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIN Columns",
      subtitle: "C1019-250, C1019-50",
      description:
        "Uncapped columns for the recovery of &le;  25 µg  DNA in &ge; 30 &micro;l.",
      handle: "/products/zymo-spin-iin-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1019-Zymo-Spin-IIN.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-µHRC Filters",
      subtitle: "C1059-50",
      description: "For use with Zymo Research products.",
      handle: "/products/zymo-spin-ii-µhrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1059_Zymo Spin II-HRC.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-P Columns",
      subtitle: "C1055-50",
      description: "",
      handle: "/products/zymo-spin-ii-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1055-50_Zymo-Spin II-P Column.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III Columns",
      subtitle: "C1005-250, C1005-50",
      description:
        "The Zymo-Spin III features durable polypropylene construction that allows purification of up to 25 &micro;g DNA or RNA in &ge; 35 &micro;l eluate.",
      handle: "/products/zymo-spin-iii-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1005-Zymo-Spin-III.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IIICG Columns",
      subtitle: "C1006-250-G, C1006-50-G",
      description: "",
      handle: "/products/zymo-spin-iiicg-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-G-Zymo-Spin-IIICG.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-F Filters",
      subtitle: "C1057-50",
      description: "For use in Zymo Research environmental purification kits.",
      handle: "/products/zymo-spin-iii-f-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1057-Zymo-Spin-III-F.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-HRC Filters",
      subtitle: "C1058-50",
      description: "",
      handle: "/products/zymo-spin-iii-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1058-Zymo-Spin-III-HRC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV-IR HRC Filters",
      subtitle: "C1010-50",
      description: "",
      handle: "/products/zymo-spin-iv-ir-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1010-50_Zymo-Spin-IV-IR-HRC-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "Zymo-Spin III-P Column Assembly w/ 15 ml and 50 ml Reservoir (5 Pack)",
      subtitle: "C1040-5",
      description: "",
      handle:
        "/products/zymo-spin-iii-p-column-assembly-w-15-ml-and-50-ml-reservoir-5-pack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1040-5-Zymo-Spin-III-P.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-S Columns w/ LuerLock Caps and 15 ml Reservoir",
      subtitle: "C1049-25",
      description: "",
      handle:
        "/products/zymo-spin-iii-s-columns-w-luerlock-caps-and-15-ml-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/(3) Zymo Spin IIIS.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV Columns",
      subtitle: "C1007-250, C1007-50",
      description: "",
      handle: "/products/zymo-spin-iv-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/c1007-50-zymo-spin-iv.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns",
      subtitle: "C1012-25, C1012-50",
      description:
        "Column for purifying up to 100 &micro;g  DNA or RNA in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1012-25-Zymo-Spin-V.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V Columns w/ Reservoir",
      subtitle: "C1016-25, C1016-50",
      description:
        "Assembly for purifying DNA/RNA from &le; 15 ml sample in &ge; 150 &micro;l.",
      handle: "/products/zymo-spin-v-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1016-25-Zymo-Spin-V-with-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-P Column Assembly w/ 15 ml and 50 ml Reservoir",
      subtitle: "C1042-5",
      description:
        "The Zymo-Spin V-P can be used in centrifuges or on-vacuum manifolds to purify plasmid DNA.",
      handle:
        "/products/zymo-spin-v-p-column-assembly-w-15-ml-and-50-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1042-5--Zymo-Spin-V-P-with-15-ml-and-50-ml-reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin V-E Columns",
      subtitle: "C1021-25, C1024-25, C1024-50, C1029-25",
      description:
        "The Zymo-Spin V-E columns can be used in microcentrifuges, centrifuges, or on vacuum manifolds",
      handle: "/products/zymo-spin-v-e-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1024-25-Zymo-Spin-VE.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns",
      subtitle: "C1013-10, C1013-20",
      description:
        "Column for recovery of up to 500 &micro;g  DNA or RNA in &ge; 2 ml.",
      handle: "/products/zymo-spin-vi-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1013-10-Zymo-Spin-VI.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Reservoir",
      subtitle: "C1018-10, C1018-20",
      description:
        "Column assembly for recovery of DNA/RNA from large volumes.",
      handle: "/products/zymo-spin-vi-columns-w-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1018-Zymo-Spin-VI-with-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI Columns w/ Zymo-Maxi Filter",
      subtitle: "C1017-10, C1017-20",
      description:
        "Column-filter assembly for purifying DNA/RNA from &le; 75 ml sample",
      handle: "/products/zymo-spin-vi-columns-w-zymo-maxi-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1017-10-Zymo-Spin-VI-with-maxi-filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin VI-P Columns",
      subtitle: "C1044-5",
      description:
        "Zymo-Spin VI-P can be used in centrifuges or on vacuum manifolds for the purification of plasmid DNA.",
      handle: "/products/zymo-spin-vi-p-columns",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1044-5-Zymo-Spin-VI-P.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Plastics": [
    {
      title: "Wash Plate",
      subtitle: "C2024, C2024-1",
      description:
        "96-well plate for minimizing cross-contamination during high-throughput processing.",
      handle: "/products/wash-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2024_Wash-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96-Well 2.0 mL Deep Well Plate",
      subtitle: "C2015, C2015-50",
      description:
        "96-Well Plate for Liquid Handling Robots",
      handle: "/products/96-well-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/C2015-2_96-Well-2.0-ml-Deep-Well-Plate.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "96 Deep Well Plate (V-Bottom, 2.2ml)",
      subtitle: "C2018-5, C2018-50",
      description:
        "96-Well Polypropylene plate for Magnetic Bead Moving Instruments",
      handle: "/products/96-deep-well-plate-v-bottom-2-2ml",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2018_ZRC_2164.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96 Tip Combs (For V-Bottom Deep Well Plate)",
      subtitle: "C2019, C2019-100",
      description:
        "96 Tip Comb for Magnetic Bead Moving Instruments",
      handle: "/products/96-tip-combs-for-v-bottom-deep-well-plate",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/C2019_ZRC_2146.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin II-µHRC Filters",
      subtitle: "C1059-50",
      description: "For use with Zymo Research products.",
      handle: "/products/zymo-spin-ii-µhrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1059_Zymo Spin II-HRC.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-F Filters",
      subtitle: "C1057-50",
      description: "For use in Zymo Research environmental purification kits.",
      handle: "/products/zymo-spin-iii-f-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1057-Zymo-Spin-III-F.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin III-HRC Filters",
      subtitle: "C1058-50",
      description: "Component used in the OneStep PCR Inhibitor Removal kit (Cat. #D6030).",
      handle: "/products/zymo-spin-iii-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1058-Zymo-Spin-III-HRC.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Spin IV-IR HRC Filters",
      subtitle: "C1010-50",
      description: "",
      handle: "/products/zymo-spin-iv-ir-hrc-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1010-50_Zymo-Spin-IV-IR-HRC-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A Plate",
      subtitle: "C2001",
      description:
        "Shallow-well (96) plate purification of DNA/RNA in &ge; 30 &micro;l.",
      handle: "/products/silicon-a-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-Silicon-A-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Silicon-A-HRC Plate",
      subtitle: "C2009",
      description: "",
      handle: "/products/silicon-a-hrc-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2009-Silicon-A-HRC-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Plate",
      subtitle: "C2002",
      description:
        "1.2 ml, round bottom, 96-well plate for use with spin plate.",
      handle: "/products/collection-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2002-Collection-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Elution Plate",
      subtitle: "C2003",
      description:
        "90 &micro;l, V-bottom, 96-well plate for use with spin plate.",
      handle: "/products/elution-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2003-Elution-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-1, S6002-96-2, S6002-96-3",
      description: "ZR BashingBeads in 96 impact resistant tube rack.",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6002-96-2-ZR-Bashing-Bead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block",
      subtitle: "P1001-10, P1001-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1001-2-96-well-block.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Conversion Plate w/ Cover Foil",
      subtitle: "C2005",
      description: "96-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/conversion-plate-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2005-C2008-96-Well-Conversion-Plate.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block w/ Cover Foil",
      subtitle: "P1002-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1002-2-96-Well-block-with-cover-foil.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Plate Cover Foil",
      subtitle: "C2007-12, C2007-2, C2007-24, C2007-4, C2007-6, C2007-8",
      description: "Pierceable aluminum foil with strong adhesive for sealing.",
      handle: "/products/96-well-plate-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2007_96-well Cover Foils.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Syringe Filters",
      subtitle: "C1036-5",
      description:
        "The ZymoPURE Syringe Filter features rapid clarification of up to 60 ml of neutralized lysate",
      handle: "/products/zymopure-syringe-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1036-5-Syringe-Filters.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE Giga Filter",
      subtitle: "C1038-1",
      description: "",
      handle: "/products/zymopure-giga-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1038-1-ZymoPure-Giga-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Spin-Away Filters",
      subtitle: "C1006-250-F, C1006-50-F",
      description: "For use with Zymo Research purification kits",
      handle: "/products/spin-away-filters",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1006-50-F-Spin-Away-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZRC GF Filter",
      subtitle: "C1009-20, C1009-50",
      description:
        "Filter for separating cellular components from biological fluids.",
      handle: "/products/zrc-gf-filter",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1009-20-ZRC-GF-Filter.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "15 ml Conical Reservoir",
      subtitle: "C1031-25",
      description: "",
      handle: "/products/15-ml-conical-reservoir",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/15ml reservoir.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "25 ml Reservoir for Spin-Away Filters and Zymo-Spin IIICG",
      subtitle: "C1039-25",
      description: "",
      handle:
        "/products/25-ml-reservoir-for-spin-away-filters-and-zymo-spin-iiicg",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C1039-25_Reservoir - 25 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "50 ml Conical Reservoir",
      subtitle: "C1032-25",
      description:
        "The 50 ml Reservoir can be used with vacuum manifolds for the purification of DNA and/or RNA",
      handle: "/products/50-ml-conical-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1032-25-50ml-Conical-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "600 ml Reservoir",
      subtitle: "C1033-5",
      description:
        "The 600 ml Reservoir, used with vacuum manifolds for the purification of DNA/RNA",
      handle: "/products/600-ml-reservoir",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1033-5-600-ml-Reservoir.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Collection Tubes",
      subtitle: "C1001-1000, C1001-50, C1001-500",
      description:
        "Durable polypropylene collection tubes used in conjunction with Zymo-Spin columns",
      handle: "/products/collection-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1001-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase/RNase-Free Tubes",
      subtitle: "C2001-100, C2001-50",
      description:
        "DNase/RNase-free 1.5 ml microcentrifuge tubes made of durable polypropylene construction.",
      handle: "/products/dnase-rnase-free-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-100-DNase-RNase-free-tubes.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Clear Tubes, with caps",
      subtitle: "C1025-50, C1025-500, C1027-50, C1027-500",
      description:
        "Clear 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-clear-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1025-Clear-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Amber Tubes, with caps",
      subtitle: "C1026-50, C1026-500, C1028-50, C1028-500",
      description:
        "Amber 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-amber-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1026-50-Amber-Tube-with-cap-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR Bashing Bead Lysis Tubes",
      subtitle: "S6003-50",
      description: "2.0 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashing-bead-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 2.0 mm)",
      subtitle: "S6014-50",
      description: "",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-2-0-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/zr_bashingbead_lysis_tubes_2.0_mm_s6003-50__1.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
      subtitle: "S6012-50",
      description:
        "0.1 & 0.5 mm ZR BashingBeads in impact resistant 2 ml tubes.",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/S6012-50_ZR-BashingBead-Lysis-Tubes.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 BashingBead Lysis Rack",
      subtitle: "S6002-96-4, S6002-96-5",
      description:
        "96-well microbial cell lysis rack for high throughput/automated bead beating",
      handle: "/products/zr-96-bashingbead-lysis-rack",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/s6002_96_lysis_rack.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  Tubes: [
    {
      title: "Collection Tubes",
      subtitle: "C1001-1000, C1001-50, C1001-500",
      description:
        "Durable polypropylene collection tubes used in conjunction with Zymo-Spin columns",
      handle: "/products/collection-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1001-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase/RNase-Free Tubes",
      subtitle: "C2001-100, C2001-50",
      description:
        "DNase/RNase-free 1.5 ml microcentrifuge tubes made of durable polypropylene construction.",
      handle: "/products/dnase-rnase-free-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2001-100-DNase-RNase-free-tubes.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Amber Tubes, with caps",
      subtitle: "C1026-50, C1026-500, C1028-50, C1028-500",
      description:
        "Amber 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-amber-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1026-50-Amber-Tube-with-cap-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2.0 mL Clear Tubes, with caps",
      subtitle: "C1025-50, C1025-500, C1027-50, C1027-500",
      description:
        "Clear 2.0 ml skirted tubes made of durable polypropylene construction.",
      handle: "/products/2-0-ml-clear-tubes-with-caps",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C1025-Clear-Collection-Tube-2ml.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Buffers: [
    {
        title: "EZ-Methylation Magprep Beads",
        subtitle: "D4100-5-4, D4100-5-8, D4100-5-16",
        description: "EZ-Methylation Magprep Beads for use with Zymo Research magnetic bead-based purification kits. Sold separately or as part of a complete magnetic bead purification kit.",
        handle: "/products/ez-methylation-magprep-beads",
        isKit: false,
        image_url:
          "https://files.zymoresearch.com/product-images/d4100-2-3_magbinding_beads-3_ml.png",
        searchWeight: 0,
        tags: [],
      },
    {
      title: "<I>Mix &amp; Go!</i> 2X Stock Competent Buffer",
      subtitle: "T3001-3-10, T3001-3-30",
      description: "",
      handle: "/products/mix-and-go-2x-stock-competent-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/T3001-3-30_Competent-Buffer-2x-30-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Mix &amp; Go!</i> 2X Stock Wash Buffer",
      subtitle: "T3001-2-10, T3001-2-30",
      description: "",
      handle: "/products/mix-and-go-2x-stock-wash-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/T3001-2-30_Wash-Buffer-2x-30-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Mix &amp; Go!</i> Dilution Buffer",
      subtitle: "T3001-4-20, T3001-4-60",
      description: "",
      handle: "/products/mix-and-go-dilution-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/T3001-4-60_Dilution-Buffer-60-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S  Primer Set V1-V2",
      subtitle: "D6405-1-400",
      description:
        "Dramatically improves the coverage for common human-associated microbes, especially pathogens, compared to commonly-used primer sets.",
      handle: "/products/quick-16s-primer-set-v1-v2",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6405-1-400_Quick-16S-Primer-Set-V1-V2.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S  Primer Set V3-V4",
      subtitle: "D6405-2-400",
      description:
        "Compared to commonly-used primer sets, improves the coverage of several bacterial phyla and adds broad coverage for the Archaea domain.",
      handle: "/products/quick-16s-primer-set-v3-v4",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6405-2-400_Quick-16S-Primer-Set-V3-V4.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA Serum & Plasma Buffer Set",
      subtitle: "D4076-A",
      description:
        "Component set for use with the <i>Quick</i>-cfDNA Serum & Plasma Kit",
      handle: "/products/quick-cfdna-serum-plasma-buffer-set",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D4076-A-Quick-cfDNA Serum & Plasma Kit .png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA/cfRNA Binding Buffer",
      subtitle: "R1072-2-150",
      description:
        "A component for the <i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      handle: "/products/quick-cfdna-cfrna-binding-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/R1072-2-150_Quick-cfDNA-cfRNA Binding Buffer-150 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA/cfRNA Digestion Buffer",
      subtitle: "R1072-1-150",
      description:
        "A component for the <i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      handle: "/products/quick-cfdna-cfrna-digestion-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/R1072-1-150_Quick-cfDNA-cfRNA-Digestion-Buffer-150-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfRNA Binding Buffer",
      subtitle: "R1059-4-100",
      description: "A component for <i>Quick</i>-cfRNA Serum & Plasma Kit",
      handle: "/products/quick-cfrna-binding-buffer",
      isKit: false,
      image_url: null,
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfRNA Digestion Buffer",
      subtitle: "R1059-3-50",
      description: "A component for <i>Quick</i>-cfRNA Serum & Plasma Kit",
      handle: "/products/quick-cfrna-digestion-buffer",
      isKit: false,
      image_url: null,
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA MagBinding Buffer",
      subtitle: "D4077-1-150, D4077-1-250",
      description:
        "Buffer component for use with Zymo Research purification products.",
      handle: "/products/quick-dna-magbinding-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4077-1-150_Quick-DNA-MagBinding-Buffer-150-ml.jpg",
      searchWeight: 0,
      tags: [],
    },

    {
      title: "10X ELISA Buffer",
      subtitle: "D5425-2-30, D5425-2-60",
      description: "For use with Zymo Research purification products.",
      handle: "/products/10x-elisa-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D5425-2-30_10X ELISA Buffer - 30 mL .png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "2X Reaction PreMix",
      subtitle: "D5310-1, D5310-2",
      description: "For use in the OneStep qMethyl Kit",
      handle: "/products/2x-reaction-premix",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D5310-1_ 2X Test Reaction Premix 2x - 500 uL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "500x L-Arabinose Solution",
      subtitle: "A2001-1, A2001-10",
      description:
        "Premade concentrated arabinose solution for induction of XJ Autolysis <i>E. coli</i> strains.",
      handle: "/products/l-arabinose-solution",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/A2001-1_Arabinose.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-Fluoroorotic Acid (5-FOA)",
      subtitle: "F9001-1, F9001-5, F9003",
      description: "Convenient yeast genetic counter-selection agent.",
      handle: "/products/5-fluoroorotic-acid",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/F9001-1_5-Fluoroorotic-Acid-1-g.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5M NaCl",
      subtitle: "D5210-7-1",
      description: "",
      handle: "/products/5m-nacl",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5210-7-1_5M-NaCl-1-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-mC Coating Buffer",
      subtitle: "D5325-1-15, D5325-1-30",
      description: "For use with Zymo Research 5mc DNA ELISA kits",
      handle: "/products/5-mc-coating-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D5325-1-15_5-mC Coating Buffer - 15 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5-mC ELISA Buffer",
      subtitle: "D5325-2-250",
      description: "For use with Zymo Research 5mc DNA ELISA kits",
      handle: "/products/5-mc-elisa-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D5325-2-250_5-mC ELISA Buffer - 250 ml.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5X Chromatin Elution Buffer",
      subtitle: "D5210-6-10",
      description: "",
      handle: "/products/5x-chromatin-elution-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5210-6-10_5X-Chromatin-Elution-Buffer-10-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "5X MN Stop Buffer",
      subtitle: "D5220-4",
      description: "",
      handle: "/products/5x-mn-stop-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5220-4_5X-MN-Stop-Buffer-6-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "7X Lysis Buffer (Blue)",
      subtitle: "D4036-1-6, D4036-1-12, D4036-1-30, D4036-1-48, D4036-1-60",
      description: "",
      handle: "/products/7x-lysis-buffer-blue",
      isKit: false,
      image_url: null,
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ADB (Agarose Dissolving Buffer)",
      subtitle: "D4001-1-50, D4001-1-100",
      description: "",
      handle: "/products/adb-agarose-dissolving-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4001-1-100_ADB-100-ml.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "a-Factor Mating Pheromone",
      subtitle: "Y1004-500",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle. Opposite to the alpha-factor mating pheromone.",
      handle: "/products/a-factor-mating-pheromone",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/Y1004_a-Factor-Mating-Pheromone-A-Factor-500-ul.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Alpha-Factor Mating Pheromone",
      subtitle: "Y1001",
      description:
        "Convenient aqueous solution for arresting yeast in G1 of the cell cycle.",
      handle: "/products/alpha-factor-mating-pheromone",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/Y1001_Alpha-Factor-Mating-Pheromone.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Ampicillin Sodium Solution",
      subtitle: "A1001-5, A1001-25",
      description: "Ready-to-use 100 mg/ml Ampicillin Sodium Solution",
      handle: "/products/ampicillin-sodium-solution",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/A1001-5_Ampicilin - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Anti-DNA HRP Antibody (100X)",
      subtitle: "D5425-3-100, D5425-3-200",
      description: "For use with Zymo Research ELISA products",
      handle: "/products/anti-dna-hrp-antibody-100x",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D5425-3-100_Anti-DNA HRP Antibody - 100X - 100ul.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Bacterial DNA Standards and No Template Control",
      subtitle: "E2006-2",
      description: "For use with Zymo Research products.",
      handle: "/products/bacterial-dna-standards-and-no-template-control",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/E2006-2_Femto-Bacterial-DNA-Standards-and-No-Template-Control.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "BashingBead Buffer",
      subtitle: "D6001-3-40, D6001-3-150",
      description:
        "Buffer component for use with Zymo Research purification products.",
      handle: "/products/bashingbead-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6001-3-150_Bashing-Bead-Buffer_150-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "BioFluid & Cell Buffer (Red)",
      subtitle: "D4068-1-12, D4068-1-25, D4068-1-45",
      description: "",
      handle: "/products/biofluid-cell-buffer-red",
      isKit: false,
      image_url: null,
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Buffer P1 (Red)",
      subtitle:
        "D4027-1-10, D4027-1-20, D4027-1-80, D4027-1-160, D4027-1-320, D4027-1-500",
      description: "",
      handle: "/products/buffer-p1-red",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4027-1-80_Buffer-P1-80-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Buffer P3  (Yellow)",
      subtitle: "D4027-3-12, D4027-3-50, D4027-3-220, D4027-3-440",
      description: "",
      handle: "/products/buffer-p3-yellow",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D4027-3-12_P3-Buffer-12-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Cell-free Recovery Buffer",
      subtitle: "R1072-3-20",
      description: "A component for the Quick-cfDNA/cfRNA Serum & Plasma Kit",
      handle: "/products/cell-free-recovery-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/R1072-3-20_Cell-free-Recovery-Buffer-20-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ChIP DNA Binding Buffer",
      subtitle: "D5201-1-50, D5201-1-100",
      description: "",
      handle: "/products/chip-dna-binding-buffer",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5201-1-50_ChIP-DNA-Binding-Buffer-10-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Chloramphenicol Solution",
      subtitle: "A1002-5, A1002-25",
      description: "Ready-to-use 10 mg/ml Chloramphenicol Solution",
      handle: "/products/chloramphenicol-solution",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/A1002-5_Chloramphenicol - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNA/RNA Buffer HT",
      subtitle: "R2150-1-100",
      description: "Used in the Quick-DNA/RNA HT kit and is a one-step lysis and binding reagent of DNA and total RNA from any biological or clinical sample",
      handle: "/products/dna-rna-buffer-ht",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/R2150-1-100.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "DNA Polymerases": [
    {
      title: "ZymoTaq Polymerase",
      subtitle: "Buffers",
      description:
        "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
      handle: "/collections/zymotaq-polymerase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2001_ZymoTaq-Polymerase.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
  ],
  Nucleases: [
    {
      title: "PureRec Duplex-Specific Nuclease (DSN)",
      subtitle: "E1020-200, E1020-1000",
      description: "Highly selective for dsDNA. RNase-free and protease-free.",
      handle: "/products/purerec-duplex-specific-nuclease-dsn",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/e1020-200_9182b.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "PureRec RNase A (Recombinant)",
      subtitle: "E1019T, E1019-5, E1019-20",
      description: "Recombinant, DNase-free & Animal-free.",
      handle: "/products/purerec-rnase-a-recombinant",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_E1019T_purerec_rnase_a_1mg.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNase I Set",
      subtitle: "E1010",
      description:
        "Enzyme and digestion buffer used for cutting both double stranded and single-stranded DNA.",
      handle: "/products/dnase-i-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E1010_DNase-I-Set-lyophilized.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "RNase A",
      subtitle: "E1008-24, E1008-30, E1008-8",
      description:
        "Used for RNA hydrolysis and compatible with a variety of applications.",
      handle: "/products/rnase-a",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E1008-8-RNase A - 8 mg.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Micrococcal Nuclease",
      subtitle: "D5220-1",
      description: "Cleaves single-stranded and double-stranded DNA and RNA. Complete digestion with Micrococcal Nuclease yields mono- and oligonucleotides with 3'-phosphates.",
      handle: "/products/micrococcal-nuclease",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5220-1_Micrococcal-Nuclease.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase Plus",
      subtitle: "E2020, E2021",
      description: "Complete digestion of DNA into individual nucleosides.",
      handle: "/products/dna-degradase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2020_DNA-Degradase-Plus.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dsDNA Shearase Plus",
      subtitle: "E2018-200, E2018-50",
      description:
        "Simply control fragment size of dsDNA by adjusting the concentration of dsDNA Shearase Plus.",
      handle: "/products/dsdna-shearase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2018-50_dsDNA-Shearase-Plus-50-U.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Atlantis dsDNase",
      subtitle: "E2030",
      description:
        "Atlantis dsDNase ensures digestion of dsDNA to yield homogeneous populations of core nucleosomes.",
      handle: "/products/atlantis-ds-dnase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030_Atlantis-dsDNase-12.5-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNA Degradase",
      subtitle: "E2016, E2017",
      description: "Complete digestion of DNA into individual nucleotides",
      handle: "/products/dna-degradase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2016_DNA-Degradase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  Other: [
    {
      title: "CpG Methylase (M. Sssl)",
      subtitle: "E2010, E2011",
      description:
        "CpG Methylase (M. SssI) ensures complete, in vitro methylation of DNA for methylation analysis.",
      handle: "/products/cpg-methylase-m-sssl",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2010_CpG-Methylase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-hmC Glucosyltransferase",
      subtitle: "E2026, E2027",
      description: "5-hmC detection; 5-hmC enrichment",
      handle: "/products/5-hmc-glucosyltransferase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2026_5-hmC-Glucosyltransferase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Atlantis dsDNase",
      subtitle: "E2030",
      description:
        "Atlantis dsDNase ensures digestion of dsDNA to yield homogeneous populations of core nucleosomes.",
      handle: "/products/atlantis-ds-dnase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030_Atlantis-dsDNase-12.5-U.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Atlantis Digestion Buffer",
      subtitle: "E2030-1",
      description: "For use with Atlantis dsDNAse (E2030).",
      handle: "/products/atlantis-digestion-buffer",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030-1_Atlantis-Digestion-Buffer-50-mL.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "High-Throughput/Automated Isolation": [
    {
      title: "Zymoprep Yeast Plasmid Miniprep I",
      subtitle: "D2001",
      description:
        "Simple precipitation based solution for yeast plasmid DNA isolation using Zymolyase",
      handle: "/products/zymoprep-yeast-plasmid-miniprep-i",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep Yeast Plasmid Miniprep II",
      subtitle: "D2004",
      description:
        "Simple spin-column solution for yeast plasmid DNA isolation using Zymolyase",
      handle: "/products/zymoprep-yeast-plasmid-miniprep-ii",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep-96 Yeast Plasmid Miniprep",
      subtitle: "D2005, D2006, D2007",
      description:
        "The fastest and simplest high-throughput procedure for purifying the highest quality plasmid DNA from yeast.",
      handle: "/products/zymoprep-96-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 Oligo Clean & Concentrator",
      subtitle: "D4062, D4063",
      description:
        "Clean any DNA and RNA oligos in high-throughput format and elute in 10 &micro;l",
      handle: "/products/oligo-clean-concentrator-zr96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Select-a-Size DNA Clean & Concentrator MagBead Kit",
      subtitle: "D4084, D4084S, D4085",
      description: "Simple size selection for your DNA sample",
      handle: "/products/select-a-size-dna-clean-concentrator-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4084_Select-A-Size-DNA-Clean-and-Concentrator-MagBead-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS 96 MagBead Kit",
      subtitle: "D4302, D4306, D4308",
      description:
        "Inhibitor-free microbial DNA from any sample validated for microbiome and metagenomic analyses",
      handle: "/products/zymobiomics-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      subtitle: "D7022, D7023",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-96-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA MagBead",
      subtitle: "R2130, R2131",
      description: "Isolate DNA and RNA from any sample",
      handle: "/products/quick-dna-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral MagBead",
      subtitle: "R2140, R2141",
      description: "Viral DNA and RNA from all biological fluids",
      handle: "/products/quick-dna-rna-viral-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Load N’ Go DNA/RNA Viral Kit",
      subtitle: "R2143",
      description: "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      handle: "/products/load-n-go-dna-rna-viral-kit",
      isKit: true,
      ribbon: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      subtitle: "R2145, R2146",
      description:
        "Pathogen DNA/RNA isolation from vectors, tissue and biological samples.",
      handle: "/products/quick-dna-rna-pathogen-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Select-a-Size MagBeads",
      subtitle: "D4084-1-10, D4084-1-50",
      description: "Magnetic Beads Only",
      handle: "/products/select-a-size-magbeads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4084-1-50_Select-A-Size-MagBeads-50-mL.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol MagBead PreWash",
      subtitle: "R2100-2-200",
      description: "",
      handle: "/products/direct-zol-magbead-prewash",
      isKit: true,
      image_url: null,
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 MagBead RNA",
      subtitle: "R2100, R2101, R2102, R2103, R2104, R2105",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Magbead Kit",
      subtitle: "D6010-FM, D6011-FM, D6012-FM",
      description:
        "Extract high quality, inhibitor-free DNA from feces, soil, water, etc.",
      handle: "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010-FM_Quick-DNA-Fecal-Soil-Microbe_96-Magbead-Lysis-Rack.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Magbead Plus Kit",
      subtitle: "D4081, D4082",
      description:
        "Streamlined DNA isolation from any cells, tissues, and biological fluids (Proteinase K included).",
      handle: "/products/quick-dna-magbead-plus-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4081_Quick-DNA-Magbead-Plus-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well ELISA Plate",
      subtitle: "C2020",
      description: "For use with 5-mC and Quest-5hmC ELISA kits.",
      handle: "/products/96-well-elisa-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2020_96-well ELISA Plate.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block",
      subtitle: "P1001-10, P1001-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1001-2-96-well-block.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Plate Cover Foil",
      subtitle: "C2007-12, C2007-2, C2007-24, C2007-4, C2007-6, C2007-8",
      description: "Pierceable aluminum foil with strong adhesive for sealing.",
      handle: "/products/96-well-plate-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/C2007_96-well Cover Foils.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well PCR Conversion Plate",
      subtitle: "C2008",
      description: "6-well, non-skirted PCR plate with alphanumeric labels.",
      handle: "/products/96-well-pcr-conversion-plate",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/C2008-96-well_pcr_conversion_plate.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "FUGE-IT Magbead Spinner",
      subtitle: "FS1000, FS1001",
      description: "",
      handle: "/products/fuge-it-magbead-spinner",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/FS1000_Fuge-It-Spinner_Magbead-Spinner.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Squisher-8 w/ 96-Well Block",
      subtitle: "H1002-20, H1002-5",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-8-w-96-well-block",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/H1002-5-Squisher-8.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Squisher-96 w/ 96-Well Block",
      subtitle: "H1004-2, H1004-5",
      description: "Disposable, single or multi-tube homogenizer.",
      handle: "/products/squisher-96-w-96-well-block",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/H1004-2-Squisher-96.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "96-Well Block w/ Cover Foil",
      subtitle: "P1002-2",
      description: "2 ml, round bottom, 96-well block.",
      handle: "/products/96-well-block-w-cover-foil",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P1002-2-96-Well-block-with-cover-foil.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 Zymoclean Gel DNA Recovery Kit",
      subtitle: "D4021, D4022",
      description: "Highly efficient DNA purification from agarose gels.",
      handle: "/products/zr-96-zymoclean-gel-dna-recovery-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Cells and Tissue": [
    {
      title: "<i>Quick</i>-RNA Fungal/Bacterial Kit",
      subtitle: "RNA",
      description:
        "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-rna-fungal-bacterial-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS RNA Miniprep Kit",
      subtitle: "R2001",
      description:
        "Purification of microbial RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Plant Kit",
      subtitle: "R2024",
      description: "Isolate inhibitor-free RNA from plant and seed samples.",
      handle: "/products/quick-rna-plant-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2024_Quick-RNA-Plant-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
      subtitle: "R2040",
      description:
        "The Quick-RNA Fecal/Soil Microbe Microprep Kit is an affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
      handle: "/products/quick-rna-fecal-soil-microbe-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2040_Quick-RNA-Fecal-Soil-Microbe-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Cells & Tissue": [
    {
      title: "<i>Quick</i>-DNA/RNA Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "Isolation of high quality genomic DNA and total RNA from cells, tissue, blood, biological fluids, etc. ",
      handle: "/collections/quick-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      subtitle: "R1009",
      description: "DNA and RNA from FFPE tissue",
      handle: "/products/quick-dna-rna-ffpe-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Blood: [
    {
      title: "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      subtitle: "R1072",
      description:
        "Isolate cfDNA and cfRNA efficiently and easily from biological fluids",
      handle: "/products/quick-cfdna-rna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      subtitle: "D4076",
      description:
        "High efficiency recovery of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      handle: "/products/quick-cfdna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "Isolation of high quality genomic DNA and total RNA from cells, tissue, blood, biological fluids, etc. ",
      handle: "/collections/quick-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Blood Collection",
      subtitle: "Sample Collection",
      description: "DNA/RNA transport medium for whole blood",
      handle: "/pages/sample-collection-kits?tags=blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield",
      subtitle: "Sample Collection",
      description:
        "DNA/RNA Shield products are DNA and RNA transport and storage mediums for any biological samples. Get free samples with free shipping.",
      handle: "/collections/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 3,
      tags: [],
    },
  ],
  Viral: [
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "<i>Quick</i>-DNA/RNA Pathogen kits simplify purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      handle: "/collections/quick-dna-rna-pathogen-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral Kits",
      subtitle: "DNA/RNA Purification",
      description:
        "The Quick-DNA/RNA Viral kits are viral DNA/RNA purification kits that provide for rapid isolation of high-quality viral nucleic acids from a wide range of biological sources.",
      handle: "/collections/quick-dna-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Viral Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Viral Kits are viral DNA purification kits that provide for the rapid isolation of high-quality viral DNA from a wide range of biological sources.",
      handle: "/collections/quick-dna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3015_Quick-DNA-Viral-DNA-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral Kits",
      subtitle: "RNA",
      description:
        "The <i>Quick</i>- RNA Viral Kits are viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      handle: "/collections/quick-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Specialty Chemicals and Others": [
    {
      title: "<i>Quick</i>-RNA Fungal/Bacterial Kit",
      subtitle: "RNA",
      description:
        "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-rna-fungal-bacterial-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "5-Fluoroorotic Acid (5-FOA)",
      subtitle: "F9001-1, F9001-5, F9003",
      description: "Convenient yeast genetic counter-selection agent.",
      handle: "/products/5-fluoroorotic-acid",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/F9001-1_5-Fluoroorotic-Acid-1-g.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "YeaStar RNA Kit",
      subtitle: "R1002",
      description:
        "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      handle: "/products/yeastar-rna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Yeast Protein Kit",
      subtitle: "Y1002",
      description:
        "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
      handle: "/products/yeast-protein-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Chemicals: [
    {
      title: "5-Fluoroorotic Acid (5-FOA)",
      subtitle: "F9001-1, F9001-5, F9003",
      description: "Convenient yeast genetic counter-selection agent.",
      handle: "/products/5-fluoroorotic-acid",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/F9001-1_5-Fluoroorotic-Acid-1-g.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Chloramphenicol Solution",
      subtitle: "A1002-25, A1002-5",
      description: "Ready-to-use 10 mg/ml Chloramphenicol Solution",
      handle: "/products/chloramphenicol-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1002-5_Chloramphenicol - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "500x L-Arabinose Solution",
      subtitle: "A2001-1, A2001-10",
      description:
        "Premade concentrated arabinose solution for induction of XJ Autolysis <i>E. coli</i> strains.",
      handle: "/products/l-arabinose-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A2001-1_Arabinose.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "IPTG (Isopropyl-&beta;-D-thiogalactopyranoside)",
      subtitle: "I1001-25, I1001-5",
      description:
        "0.5 M Premade sterile solution for induction of gene expression under control of the lac operon.",
      handle: "/products/iptg-isopropyl-b-d-thiogalactopyranoside",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/I1001-5_IPTG 5 ml.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "His-Affinity Gel",
      subtitle: "P2003-2",
      description: "For use with His-Spin Protein Miniprep Kits",
      handle: "/products/his-affinity-gel",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/P2003-2_His-Affinity-Gel-14-mL.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "X-GAL (5-bromo-4-chloro-3-indolyl &beta;-D-galactopyranoside)",
      subtitle: "X1001-25, X1001-5",
      description:
        "Ready-to-use sterile solution for detecting β-galactosidase activity.",
      handle:
        "/products/x-gal-5-bromo-4-chloro-3-indolyl-beta-d-galactopyranoside",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/X1001-5_X-Gal-20-mG.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  Antibiotics: [
    {
      title: "Ampicillin Sodium Solution",
      subtitle: "A1001-25, A1001-5",
      description: "Ready-to-use 100 mg/ml Ampicillin Sodium Solution",
      handle: "/products/ampicillin-sodium-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1001-5_Ampicilin - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Chloramphenicol Solution",
      subtitle: "A1002-25, A1002-5",
      description: "Ready-to-use 10 mg/ml Chloramphenicol Solution",
      handle: "/products/chloramphenicol-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1002-5_Chloramphenicol - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Kanamycin Sulfate Solution",
      subtitle: "A1003-25, A1003-5",
      description: "Ready-to-use 35 mg/ml Kanamycin Sulfate Solution",
      handle: "/products/kanamycin-sulfate-solution",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A1003-5_Kanamycin Sulfate - 5 mL.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Tetracycline Hydrochloride Solution - Reagent Grade",
      subtitle: "A1004-25, A1004-5",
      description: "Ready-to-use 10 mg/ml Tetracycline Hydrochloride Solution",
      handle: "/products/tetracycline-hydrochloride-solution-reagent-grade",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/a1004-5_tetracycline_hydrochloride-5ml.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Transformation Kits & Accessories": [
    {
      title: "ZymoBroth",
      subtitle: "M3015-100, M3015-500",
      description:
        "Uniquely formulated growth medium for the preparation of highly competent <i>E. coli</i> cells.",
      handle: "/products/zymobroth",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M3015-100-ZymoBroth.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<i>Mix &amp; Go!</i> <i>E. coli</i> Transformation Kit and Buffer Set",
      subtitle: "T3001, T3002",
      description:
        "Reagents for preparing your own <i>Mix &amp; Go!</i> Competent <i>E. coli</i> cells (chemically competent cells).",
      handle: "/products/mix-and-go-e-coli-transformation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3002_Mix-and-Go-E-Coli-Transformation-Buffer-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Rattler Plating Beads",
      subtitle: "S1001, S1001-5, S1001-B",
      description: "4.5 mm glass plating beads for spreading inocula",
      handle: "/products/rattler-plating-beads",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S1001-Rattler-Plating-Beads.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Yeast Protein Purification": [
    {
      title: "Yeast Protein Kit",
      subtitle: "Y1002",
      description:
        "Rapid and thorough lysis of yeast cells for protein and DNA analysis.",
      handle: "/products/yeast-protein-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/Y1002_Yeast-Protein-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "YPD Plus",
      subtitle: "Y1003-100, Y1003-50",
      description:
        "Specialized medium for yeast outgrowth to increase yeast transformation efficiencies.",
      handle: "/products/ypd-plus",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/Y1003-50-YPD-Plus.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Cells & Tissue RNA": [
    {
      title: "Direct-zol RNA Kits",
      subtitle: "RNA",
      description:
        "Direct-zol RNA Kits are RNA purification kits that provide a streamlined method for the purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRI Reagent&#174; or similar.",
      handle: "/collections/direct-zol-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2050-Directzol-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep & Lysis Tubes",
      subtitle: "R2050, R2051, S6003-50, S6012-50, S6014-50",
      description:
        "RNA from TRIzol in 7 minutes. Use ZR BashingBead Lysis Tubes for optimal disruption and homogenization of hard-to-lyse samples in TRIzol. Unbiased, total RNA including small/miRNAs (>17 nt) with DNase I included.",
      handle: "/products/direct-zol-rna-miniprep-and-lysis-tubes",
      isKit: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0016/3731/8726/products/R2051_Direct-zol_RNA_MiniPrep_TRI_Reagent_with_BashingBead_Lysis_Tubes_172e2328-7c2f-4d06-9185-a82cf30de7c5_600x.png?v=1592516662",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS RNA Kits",
      subtitle: "Microbiomics",
      description:
        "ZymoBIOMICS RNA isolation kits are designed for the purification of microbial RNA (including small/miRNAs) from any sample input such as feces, soil, plant/seed, fungal or bacterial cells, biofilms, water, swabs, body fluids, etc.",
      handle: "/collections/zymobiomics-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes",
      subtitle: "S6003-50",
      description: "Each impact resistant 2 ml tube contains 0.7 ml dry volume 2.0 mm ZR BashingBead lysis matrix. The state of the art, ultra-high density beads are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
      handle: "/products/zr-bashing-bead-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
      subtitle: "S6012-50",
      description:
        "Each impact resistant 2 ml tube contains 0.6 ml dry volume mixed 0.5 mm and 0.1mm ZR BashingBead lysis matrix. The state of the art, ultra-high density beads are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
      isKit: true,
      image_url:
        "http://files.zymoresearch.com/product-images/S6012-50_ZR-BashingBead-Lysis-Tubes.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Kits",
      subtitle: "RNA",
      description:
        "The Quick-RNA kits are RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes. Get a free sample today with free shipping. ",
      handle: "/collections/quick-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "Isolation of high quality genomic DNA and total RNA from cells, tissue, blood, biological fluids, etc. ",
      handle: "/collections/quick-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Tissue/Insect Kit",
      subtitle: "R2030",
      description: "Isolate RNA from tough-to-lyse tissue and insects",
      handle: "/products/quick-rna-tissue-insect-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2030_Quick-RNA-Tissue-Insect-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "29th Anniversary Collection": [
    {
      title: "Zymoclean Gel DNA Recovery Kit",
      subtitle: "D4001, D4001T, D4002, D4007, D4008",
      description:
        "Quick recovery of ultra-pure DNA from agarose gels",
      handle: "/products/zymoclean-gel-dna-recovery-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "DNA Clean & Concentrator-5",
      subtitle: "D4003, D4003T, D4004, D4013, D4014",
      description:
        "DNA Clean & Concentrator Kits are PCR purification kits that provide purification of DNA from PCR and other enzymatic reactions in as little as 2 minutes. Free PCR purification kits sample. \n",
      handle: "/products/dna-clean-concentrator-5",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Zyppy Plasmid Miniprep Kit",
      subtitle: "D4019, D4020, D4036, D4037",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes.",
      handle: "/products/zyppy-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE Plasmid Miniprep Kit",
      subtitle: "D4208T, D4209, D4210, D4211, D4212",
      description:
        "Fastest and simplest method to isolate endotoxin-free plasmid DNA",
      handle: "/products/zymopure-ii-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Midiprep Kit",
      subtitle: "D4200, D4201",
      description: "Vaccine/transfection grade plasmid DNA in &le; 20 minutes",
      handle: "/products/zymopure-ii-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Maxiprep Kit",
      subtitle: "D4202, D4203",
      description: "Endotoxin-Free/Transfection-grade plasmid DNA in &le; 20 min.",
      handle: "/products/zymopure-ii-plasmid-maxiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Miniprep",
      subtitle: "D3024, D3025",
      description:
        "The ideal DNA isolation kits for easy, rapid isolation of total DNA (e.g., genomic, mitochondrial, viral) from a variety of biological sample sourcesand biological fluids.",
      handle: "/products/quick-dna-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Miniprep Plus Kit",
      subtitle: "D4068, D4068T, D4069",
      description:
        "The easiest DNA isolation kits for high yield DNA isolation from any cells, tissues, and biological fluids.",
      handle: "/products/quick-dna-miniprep-plus-dna-extraction-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4068-Quick-DNA-Miniprep-Plus-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Direct-zol RNA Microprep Kit",
      subtitle: "R2060, R2061, R2062, R2063",
      description:
        "RNA from single cell and low inputs in TRIzol. NGS-ready and concentrated in 6 &micro;l",
      handle:
        "/products/direct-zol-rna-microprep-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2060-Directzol-RNA-Microprep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep Kit",
      subtitle: "R2050, R2051, R2052, R2053",
      description:
        "RNA purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRIzol or Tri Reagent in 7 minutes",
      handle: "/products/direct-zol-rna-miniprep-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep Plus Kit",
      subtitle: "R2070, R2070T, R2071, R2072, R2073",
      description:
        "A streamlined method for the purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRI Reagent or similar.",
      handle: "/products/direct-zol-rna-miniprep-plus-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2070-Directzol-RNA-Miniprep-Plus-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Direct-zol-96 RNA Kit",
      subtitle: "R2054, R2055, R2056, R2057",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 MagBead RNA",
      subtitle: "R2100, R2101, R2102, R2103",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Microprep Kit",
      subtitle: "R1050, R1051",
      description:
        "RNA from single cell and low inputs. NGS-ready and concentrated in 6 &micro;l.",
      handle: "/products/quick-rna-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1050_Quick-RNA-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Miniprep Kit",
      subtitle: "R1054, R1055",
      description:
        "Easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      handle: "/products/quick-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Miniprep Plus Kit",
      subtitle: "R1057, R1057T, R1058",
      description:
        "RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      handle: "/products/quick-rna-miniprep-plus-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1057-Quick-RNA-Miniprep-Plus-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA MagBead",
      subtitle: "R2132, R2133",
      description:
        "High-throughput, magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
      handle: "/products/quick-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2132_quick-rna-magbead-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA 96 Kit",
      subtitle: "R1052, R1053",
      description:
        "Isolate total RNA and small/miRNA from cells and soft tissue",
      handle: "/products/quick-rna-96-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral Kit",
      subtitle: "R1034, R1035, R1034-E, R1035-E",
      description:
        "Viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      handle: "/products/quick-rna-viral-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-5",
      subtitle: "R1013, R1014, R1015, R1016",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-5",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-25",
      subtitle: "R1017, R1018",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-25",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1017_RNA-Clean-&-Concentrator-25.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-100",
      subtitle: "R1019",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-100",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1019_RNA-Clean-&-Concentrator-100.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-96",
      subtitle: "R1080",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator MagBead",
      subtitle: "R1081, R1082",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Miniprep Kit",
      subtitle: "D4300, D4300T, D4304",
      description:
        "Microbial DNA purification kits for accurate microbiome and metagenomic analyses. ",
      handle: "/products/zymobiomics-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Microprep Kit",
      subtitle: "D4301, D4305",
      description:
        "Microbial DNA purification kits for accurate microbiome and metagenomic analyses. ",
      handle: "/products/zymobiomics-dna-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4301_ZymoBIOMICS-DNA-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield",
      subtitle: "R1100-50, R1100-250, R1200-25, R1200-125",
      description: "DNA/RNA transport medium for any sample",
      handle: "/products/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield Fecal Collection Tube",
      subtitle: "R1101, R1137",
      description: "DNA/RNA transport medium for stool samples",
      handle: "/products/dna-rna-shield-fecal-collection-tube",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield Collection Tube w/ Swab",
      subtitle: "R1106, R1107, R1108, R1109",
      description:
        "Swab collection tube and transport medium for proper sample collection and stabilization",
      handle: "/products/dna-rna-shield-collection-tube-w-swab",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1106_DNA-RNA-Shield-Swab-Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield SafeCollect Swab Collection Kit",
      subtitle: "R1160, R1161, R1160-E, R1161-E",
      description:
        "User-friendly swab self-collection with unique design to prevent spillage. Collect and transport at ambient temperature, anywhere.",
      handle: "/products/dna-rna-shield-safecollect-swab-collection-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r1160-dna_rna_shield_safecollect_swab_collection_kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Gut Microbiome Standard",
      subtitle: "D6331",
      description:
        "The ZymoBIOMICS Gut Microbiome Standard is a mixture of 18 bacterial strains, 2 fungal strains, and 1 archaeal strain in staggered abundances used for gut microbiome/metagenome workflow optimization and as a positive control.",
      handle: "/products/zymobiomics-gut-microbiome-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/d6331_zymobiomics_gut_microbiome_standard-750ul.png",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Microbial Community DNA Standard",
      subtitle: "D6305, D6306",
      description:
        "Assess bias and errors in NGS-based microbial composition profiling workflows",
      handle: "/products/zymobiomics-microbial-community-dna-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6305_ZymoBIOMICS-Microbial-Community-Standard.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Fecal Reference with TruMatrix Technology",
      subtitle: "D6323",
      description:
        "This reference was made from real human fecal material and was designed to act as a reliable, single point of reference for all microbiome researchers",
      handle: "/products/zymobiomics-fecal-reference-with-trumatrix-technology",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D6323_ZymoBIOMICS-Fecal-Reference-with-TruMatrix.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Lightning Automation Kit",
      subtitle: "D5049",
      description:
        "This reference was made from real human fecal material and was designed to act as a reliable, single point of reference for all microbiome researchers",
      handle: "/products/ez-dna-methylation-lightning-automation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5049-ez_dna_methylation_lightning_automation_kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Lightning Kit",
      subtitle: "D5030, D5030T, D5030-E, D5031, D5031-E",
      description:
        "Citation-leading kits with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
      handle: "/products/ez-dna-methylation-lightning-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning Kit",
      subtitle: "D5032, D5033",
      description:
        "Fastest method for bisulfite conversion of DNA paired with purification on a 96-well plate for high-throughput sample processing.",
      handle: "/products/ez-96-dna-methylation-lightning-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5032_EZ-96-DAN-Methylation-Lightning-Kit-Shallow-Well.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning MagPrep",
      subtitle: "D5046, D5046-E, D5047, D5047-E",
      description:
        "Discover the fastest bisulfite conversion kit with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
      handle: "/products/ez-96-dna-methylation-lightning-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5046_EZ-96-DNA-Methylation-Lightning-MagPrep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Total RNA Library Kit",
      subtitle: "R3000, R3003",
      description:
        "The fastest and easiest kit for stranded total RNA-seq libraries with RiboFree Universal Depletion for any sample and species",
      handle: "/products/zymo-seq-ribofree-total-rna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3000_zymo-seq_ribofree_tota_rna_library_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Universal cDNA Kit",
      subtitle: "R3001",
      description:
        "This universal rRNA and globin depletion kit is probe-free and produces RiboFree single-stranded cDNA with minimal hands-on time.",
      handle: "/products/zymo-seq-ribofree-universal-cdna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3001_zymo-seq_ribofree_universal_cdna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> <i>E. coli</i> Transformation Kit and Buffer Set",
      subtitle: "T3001, T3002",
      description:
        "Convenient preparation of competent <i>E. coli</i> cells for simple and highly efficient DNA transformation, skipping heat shocking and related procedures.",
      handle: "/products/mix-and-go-e-coli-transformation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3002_Mix-and-Go-E-Coli-Transformation-Buffer-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - DH5 Alpha",
      subtitle: "T3007, T3009, T3010",
      description:
        "Premade <i>E. coli</i> DH5 alpha competent cells for simple and highly efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-dh5-alpha",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3009_Mix-and-Go-Competent-Cells-Xymo-5a.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - JM109",
      subtitle: "T3003, T3005",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-jm109",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3005_Mix-and-Go-Competent-Cells-JM109.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - Zymo 10B",
      subtitle: "T3019, T3020",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-zymo-10b",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3020_Mix-and-Go-Competent-Cells-Zymo-10B.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJb (DE3) Autolysis Competent Cells",
      subtitle: "T3051",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjbde3-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3051_XJb DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> Competent Cells - TG1",
      subtitle: "T3017",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-tg1",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3017_Mix & Go Competent Cells - TG1 Tubes x10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> Competent Cells - HB101",
      subtitle: "T3011, T3013",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-hb101",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3013_Mix-and-Go-Competent-Cells-HB101.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJa (DE3) Autolysis Competent Cells",
      subtitle: "T3031",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjade3-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3031_XJa DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJb Autolysis Competent Cells",
      subtitle: "T3041",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjb-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3041_XJb Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJa Autolysis Competent Cells",
      subtitle: "T3021",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xja-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3021_XJa Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS 96 MagBead Kit",
      subtitle: "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
      description:
        "Purify DNA from a variety of sample inputs for immediate microbiome or metagenome analyses.",
      handle: "/products/zymobiomics-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.png",
      searchWeight: 0,
      tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
        subtitle: "D6421-PS1 - D6421-PS8",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6421-quick_16s_plus_ngs_library_prep_kit_udi.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
    },
    {
      title: "Zymo-Seq RRBS Library Kit",
      subtitle: "D5460, D5461",
      description:
        "An all-in-one RRBS library prep kit that allows for DNA methylation profiling at single-nucleotide resolution.",
      handle: "/products/zymo-seq-rrbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5460_ez_dna_methylation_rrbs_library_prep_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq ATAC Library Kit",
      subtitle: "D5458",
      description:
        "Prepare ATAC-Seq libraries from as few as 50,000 cells in as little as 4 hours from mammalian cells and tissue input.",
      handle: "/products/zymo-seq-atac-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5458-Zymo-Seq-ATAC-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>E. coli</i> Non-Methylated Genomic DNA",
      subtitle: "D5016",
      description:
        "A negative control for DNA methylation analyses requiring DNA with absolutely no methylation.",
      handle: "/products/e-coli-non-methylated-genomic-dna",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5016_E-Coli-Non-Methylated-Genomic-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated & Non-methylated pUC19 DNA Set",
      subtitle: "D5017",
      description:
        "An ideal “spike-in” control to assess bisulfite conversion efficiency within the same reaction as the sample, or to produce known mixtures of methylated and non-methylated DNA for assay calibration",
      handle: "/products/methylated-non-methylated-puc19-dna-set",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5017_Methylated-and-Non-Methylated-pUC19-DNA-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Universal Methylated DNA Standard",
      subtitle: "D5011, D5012",
      description:
        "Positive controls to assess the efficiency of DNA bisulfite conversion in human and mouse models.",
      handle: "/products/universal-methylated-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5011_Universal-Methylated-Human-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Filter-29th-Anniversary-Collection>DNA-Purification": [
    {
      title: "Zymoclean Gel DNA Recovery Kit",
      subtitle: "D4001, D4001T, D4002, D4007, D4008",
      description:
        "Quick recovery of ultra-pure DNA from agarose gels",
      handle: "/products/zymoclean-gel-dna-recovery-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "DNA Clean & Concentrator-5",
      subtitle: "D4003, D4003T, D4004, D4013, D4014",
      description:
        "DNA Clean & Concentrator Kits are PCR purification kits that provide purification of DNA from PCR and other enzymatic reactions in as little as 2 minutes. Free PCR purification kits sample. \n",
      handle: "/products/dna-clean-concentrator-5",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Zyppy Plasmid Miniprep Kit",
      subtitle: "D4019, D4020, D4036, D4037",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes.",
      handle: "/products/zyppy-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE Plasmid Miniprep Kit",
      subtitle: "D4208T, D4209, D4210, D4211, D4212",
      description:
        "Fastest and simplest method to isolate endotoxin-free plasmid DNA",
      handle: "/products/zymopure-ii-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Midiprep Kit",
      subtitle: "D4200, D4201",
      description: "Vaccine/transfection grade plasmid DNA in &le; 20 minutes",
      handle: "/products/zymopure-ii-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Maxiprep Kit",
      subtitle: "D4202, D4203",
      description: "Endotoxin-Free/Transfection-grade plasmid DNA in &le; 20 min.",
      handle: "/products/zymopure-ii-plasmid-maxiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Miniprep",
      subtitle: "D3024, D3025",
      description:
        "The ideal DNA isolation kits for easy, rapid isolation of total DNA (e.g., genomic, mitochondrial, viral) from a variety of biological sample sourcesand biological fluids.",
      handle: "/products/quick-dna-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Miniprep Plus Kit",
      subtitle: "D4068, D4068T, D4069",
      description:
        "The easiest DNA isolation kits for high yield DNA isolation from any cells, tissues, and biological fluids.",
      handle: "/products/quick-dna-miniprep-plus-dna-extraction-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4068-Quick-DNA-Miniprep-Plus-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Filter-29th-Anniversary-Collection>RNA-Purification": [
    {
      title: "Direct-zol RNA Microprep Kit",
      subtitle: "R2060, R2061, R2062, R2063",
      description:
        "RNA from single cell and low inputs in TRIzol. NGS-ready and concentrated in 6 &micro;l",
      handle:
        "/products/direct-zol-rna-microprep-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2060-Directzol-RNA-Microprep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep Kit",
      subtitle: "R2050, R2051, R2052, R2053",
      description:
        "RNA purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRIzol or Tri Reagent in 7 minutes",
      handle: "/products/direct-zol-rna-miniprep-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep Plus Kit",
      subtitle: "R2070, R2070T, R2071, R2072, R2073",
      description:
        "A streamlined method for the purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRI Reagent or similar.",
      handle: "/products/direct-zol-rna-miniprep-plus-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2070-Directzol-RNA-Miniprep-Plus-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Direct-zol-96 RNA Kit",
      subtitle: "R2054, R2055, R2056, R2057",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 MagBead RNA",
      subtitle: "R2100, R2101, R2102, R2103",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Microprep Kit",
      subtitle: "R1050, R1051",
      description:
        "RNA from single cell and low inputs. NGS-ready and concentrated in 6 &micro;l.",
      handle: "/products/quick-rna-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1050_Quick-RNA-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Miniprep Kit",
      subtitle: "R1054, R1055",
      description:
        "Easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      handle: "/products/quick-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Miniprep Plus Kit",
      subtitle: "R1057, R1057T, R1058",
      description:
        "RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      handle: "/products/quick-rna-miniprep-plus-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1057-Quick-RNA-Miniprep-Plus-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA MagBead",
      subtitle: "R2132, R2133",
      description:
        "High-throughput, magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
      handle: "/products/quick-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2132_quick-rna-magbead-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA 96 Kit",
      subtitle: "R1052, R1053",
      description:
        "Isolate total RNA and small/miRNA from cells and soft tissue",
      handle: "/products/quick-rna-96-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral Kit",
      subtitle: "R1034, R1035, R1034-E, R1035-E",
      description:
        "Viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      handle: "/products/quick-rna-viral-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-5",
      subtitle: "R1013, R1014, R1015, R1016",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-5",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-25",
      subtitle: "R1017, R1018",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-25",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1017_RNA-Clean-&-Concentrator-25.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-100",
      subtitle: "R1019",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-100",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1019_RNA-Clean-&-Concentrator-100.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-96",
      subtitle: "R1080",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator MagBead",
      subtitle: "R1081, R1082",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 3,
      tags: [],
    },
  ],
  "Filter-29th-Anniversary-Collection>Microbiomics": [
    {
      title: "ZymoBIOMICS DNA Miniprep Kit",
      subtitle: "D4300, D4300T, D4304",
      description:
        "Microbial DNA purification kits for accurate microbiome and metagenomic analyses. ",
      handle: "/products/zymobiomics-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Microprep Kit",
      subtitle: "D4301, D4305",
      description:
        "Microbial DNA purification kits for accurate microbiome and metagenomic analyses. ",
      handle: "/products/zymobiomics-dna-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4301_ZymoBIOMICS-DNA-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Gut Microbiome Standard",
      subtitle: "D6331",
      description:
        "The ZymoBIOMICS Gut Microbiome Standard is a mixture of 18 bacterial strains, 2 fungal strains, and 1 archaeal strain in staggered abundances used for gut microbiome/metagenome workflow optimization and as a positive control.",
      handle: "/products/zymobiomics-gut-microbiome-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/d6331_zymobiomics_gut_microbiome_standard-750ul.png",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Microbial Community DNA Standard",
      subtitle: "D6305, D6306",
      description:
        "Assess bias and errors in NGS-based microbial composition profiling workflows",
      handle: "/products/zymobiomics-microbial-community-dna-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6305_ZymoBIOMICS-Microbial-Community-Standard.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Fecal Reference with TruMatrix Technology",
      subtitle: "D6323",
      description:
        "This reference was made from real human fecal material and was designed to act as a reliable, single point of reference for all microbiome researchers",
      handle: "/products/zymobiomics-fecal-reference-with-trumatrix-technology",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D6323_ZymoBIOMICS-Fecal-Reference-with-TruMatrix.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS 96 MagBead Kit",
      subtitle: "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
      description:
        "Purify DNA from a variety of sample inputs for immediate microbiome or metagenome analyses.",
      handle: "/products/zymobiomics-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.png",
      searchWeight: 0,
      tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
        subtitle: "D6421-PS1 - D6421-PS8",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6421-quick_16s_plus_ngs_library_prep_kit_udi.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
      },
  ],
  "Filter-29th-Anniversary-Collection>Sample-Collection": [
    {
      title: "DNA/RNA Shield",
      subtitle: "R1100-50, R1100-250, R1200-25, R1200-125",
      description: "DNA/RNA transport medium for any sample",
      handle: "/products/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield Fecal Collection Tube",
      subtitle: "R1101, R1137",
      description: "DNA/RNA transport medium for stool samples",
      handle: "/products/dna-rna-shield-fecal-collection-tube",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield Collection Tube w/ Swab",
      subtitle: "R1106, R1107, R1108, R1109",
      description:
        "Swab collection tube and transport medium for proper sample collection and stabilization",
      handle: "/products/dna-rna-shield-collection-tube-w-swab",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1106_DNA-RNA-Shield-Swab-Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield SafeCollect Swab Collection Kit",
      subtitle: "R1160, R1161, R1160-E, R1161-E",
      description:
        "User-friendly swab self-collection with unique design to prevent spillage. Collect and transport at ambient temperature, anywhere.",
      handle: "/products/dna-rna-shield-safecollect-swab-collection-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r1160-dna_rna_shield_safecollect_swab_collection_kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Filter-29th-Anniversary-Collection>Epigenetics-NGS": [
    {
      title: "EZ DNA Methylation-Lightning Automation Kit",
      subtitle: "D5049",
      description:
        "This reference was made from real human fecal material and was designed to act as a reliable, single point of reference for all microbiome researchers",
      handle: "/products/ez-dna-methylation-lightning-automation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5049-ez_dna_methylation_lightning_automation_kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Lightning Kit",
      subtitle: "D5030, D5030T, D5030-E, D5031, D5031-E",
      description:
        "Citation-leading kits with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
      handle: "/products/ez-dna-methylation-lightning-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning Kit",
      subtitle: "D5032, D5033",
      description:
        "Fastest method for bisulfite conversion of DNA paired with purification on a 96-well plate for high-throughput sample processing.",
      handle: "/products/ez-96-dna-methylation-lightning-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5032_EZ-96-DAN-Methylation-Lightning-Kit-Shallow-Well.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning MagPrep",
      subtitle: "D5046, D5046-E, D5047, D5047-E",
      description:
        "Discover the fastest bisulfite conversion kit with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
      handle: "/products/ez-96-dna-methylation-lightning-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5046_EZ-96-DNA-Methylation-Lightning-MagPrep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Total RNA Library Kit",
      subtitle: "R3000, R3003",
      description:
        "The fastest and easiest kit for stranded total RNA-seq libraries with RiboFree Universal Depletion for any sample and species",
      handle: "/products/zymo-seq-ribofree-total-rna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3000_zymo-seq_ribofree_tota_rna_library_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Universal cDNA Kit",
      subtitle: "R3001",
      description:
        "This universal rRNA and globin depletion kit is probe-free and produces RiboFree single-stranded cDNA with minimal hands-on time.",
      handle: "/products/zymo-seq-ribofree-universal-cdna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3001_zymo-seq_ribofree_universal_cdna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RRBS Library Kit",
      subtitle: "D5460, D5461",
      description:
        "An all-in-one RRBS library prep kit that allows for DNA methylation profiling at single-nucleotide resolution.",
      handle: "/products/zymo-seq-rrbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5460_ez_dna_methylation_rrbs_library_prep_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq ATAC Library Kit",
      subtitle: "D5458",
      description:
        "Prepare ATAC-Seq libraries from as few as 50,000 cells in as little as 4 hours from mammalian cells and tissue input.",
      handle: "/products/zymo-seq-atac-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5458-Zymo-Seq-ATAC-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>E. coli</i> Non-Methylated Genomic DNA",
      subtitle: "D5016",
      description:
        "A negative control for DNA methylation analyses requiring DNA with absolutely no methylation.",
      handle: "/products/e-coli-non-methylated-genomic-dna",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5016_E-Coli-Non-Methylated-Genomic-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated & Non-methylated pUC19 DNA Set",
      subtitle: "D5017",
      description:
        "An ideal “spike-in” control to assess bisulfite conversion efficiency within the same reaction as the sample, or to produce known mixtures of methylated and non-methylated DNA for assay calibration",
      handle: "/products/methylated-non-methylated-puc19-dna-set",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5017_Methylated-and-Non-Methylated-pUC19-DNA-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Universal Methylated DNA Standard",
      subtitle: "D5011, D5012",
      description:
        "Positive controls to assess the efficiency of DNA bisulfite conversion in human and mouse models.",
      handle: "/products/universal-methylated-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5011_Universal-Methylated-Human-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Filter-29th-Anniversary-Collection>E-coli": [
    {
      title:
        "<I>Mix &amp; Go!</i> <i>E. coli</i> Transformation Kit and Buffer Set",
      subtitle: "T3001, T3002",
      description:
        "Convenient preparation of competent <i>E. coli</i> cells for simple and highly efficient DNA transformation, skipping heat shocking and related procedures.",
      handle: "/products/mix-and-go-e-coli-transformation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3002_Mix-and-Go-E-Coli-Transformation-Buffer-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - DH5 Alpha",
      subtitle: "T3007, T3009, T3010",
      description:
        "Premade <i>E. coli</i> DH5 alpha competent cells for simple and highly efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-dh5-alpha",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3009_Mix-and-Go-Competent-Cells-Xymo-5a.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - JM109",
      subtitle: "T3003, T3005",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-jm109",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3005_Mix-and-Go-Competent-Cells-JM109.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - Zymo 10B",
      subtitle: "T3019, T3020",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-zymo-10b",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3020_Mix-and-Go-Competent-Cells-Zymo-10B.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJb (DE3) Autolysis Competent Cells",
      subtitle: "T3051",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjbde3-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3051_XJb DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> Competent Cells - TG1",
      subtitle: "T3017",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-tg1",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3017_Mix & Go Competent Cells - TG1 Tubes x10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> Competent Cells - HB101",
      subtitle: "T3011, T3013",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-hb101",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3013_Mix-and-Go-Competent-Cells-HB101.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJa (DE3) Autolysis Competent Cells",
      subtitle: "T3031",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjade3-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3031_XJa DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJb Autolysis Competent Cells",
      subtitle: "T3041",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjb-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3041_XJb Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJa Autolysis Competent Cells",
      subtitle: "T3021",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xja-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3021_XJa Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Filter-29th-Anniversary-Collection>All": [
    {
      title: "Zymoclean Gel DNA Recovery Kit",
      subtitle: "D4001, D4001T, D4002, D4007, D4008",
      description:
        "Quick recovery of ultra-pure DNA from agarose gels",
      handle: "/products/zymoclean-gel-dna-recovery-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "DNA Clean & Concentrator-5",
      subtitle: "D4003, D4003T, D4004, D4013, D4014",
      description:
        "DNA Clean & Concentrator Kits are PCR purification kits that provide purification of DNA from PCR and other enzymatic reactions in as little as 2 minutes. Free PCR purification kits sample. \n",
      handle: "/products/dna-clean-concentrator-5",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Zyppy Plasmid Miniprep Kit",
      subtitle: "D4019, D4020, D4036, D4037",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes.",
      handle: "/products/zyppy-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE Plasmid Miniprep Kit",
      subtitle: "D4208T, D4209, D4210, D4211, D4212",
      description:
        "Fastest and simplest method to isolate endotoxin-free plasmid DNA",
      handle: "/products/zymopure-ii-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Midiprep Kit",
      subtitle: "D4200, D4201",
      description: "Vaccine/transfection grade plasmid DNA in &le; 20 minutes",
      handle: "/products/zymopure-ii-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Maxiprep Kit",
      subtitle: "D4202, D4203",
      description: "Endotoxin-Free/Transfection-grade plasmid DNA in &le; 20 min.",
      handle: "/products/zymopure-ii-plasmid-maxiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Miniprep",
      subtitle: "D3024, D3025",
      description:
        "The ideal DNA isolation kits for easy, rapid isolation of total DNA (e.g., genomic, mitochondrial, viral) from a variety of biological sample sourcesand biological fluids.",
      handle: "/products/quick-dna-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA Miniprep Plus Kit",
      subtitle: "D4068, D4068T, D4069",
      description:
        "The easiest DNA isolation kits for high yield DNA isolation from any cells, tissues, and biological fluids.",
      handle: "/products/quick-dna-miniprep-plus-dna-extraction-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4068-Quick-DNA-Miniprep-Plus-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Direct-zol RNA Microprep Kit",
      subtitle: "R2060, R2061, R2062, R2063",
      description:
        "RNA from single cell and low inputs in TRIzol. NGS-ready and concentrated in 6 &micro;l",
      handle:
        "/products/direct-zol-rna-microprep-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2060-Directzol-RNA-Microprep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep Kit",
      subtitle: "R2050, R2051, R2052, R2053",
      description:
        "RNA purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRIzol or Tri Reagent in 7 minutes",
      handle: "/products/direct-zol-rna-miniprep-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep Plus Kit",
      subtitle: "R2070, R2070T, R2071, R2072, R2073",
      description:
        "A streamlined method for the purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRI Reagent or similar.",
      handle: "/products/direct-zol-rna-miniprep-plus-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2070-Directzol-RNA-Miniprep-Plus-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Direct-zol-96 RNA Kit",
      subtitle: "R2054, R2055, R2056, R2057",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol-96 MagBead RNA",
      subtitle: "R2100, R2101, R2102, R2103",
      description:
        "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      handle: "/products/direct-zol-96-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Microprep Kit",
      subtitle: "R1050, R1051",
      description:
        "RNA from single cell and low inputs. NGS-ready and concentrated in 6 &micro;l.",
      handle: "/products/quick-rna-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1050_Quick-RNA-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Miniprep Kit",
      subtitle: "R1054, R1055",
      description:
        "Easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      handle: "/products/quick-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Miniprep Plus Kit",
      subtitle: "R1057, R1057T, R1058",
      description:
        "RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      handle: "/products/quick-rna-miniprep-plus-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1057-Quick-RNA-Miniprep-Plus-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA MagBead",
      subtitle: "R2132, R2133",
      description:
        "High-throughput, magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
      handle: "/products/quick-rna-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2132_quick-rna-magbead-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA 96 Kit",
      subtitle: "R1052, R1053",
      description:
        "Isolate total RNA and small/miRNA from cells and soft tissue",
      handle: "/products/quick-rna-96-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Viral Kit",
      subtitle: "R1034, R1035, R1034-E, R1035-E",
      description:
        "Viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      handle: "/products/quick-rna-viral-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-5",
      subtitle: "R1013, R1014, R1015, R1016",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-5",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-25",
      subtitle: "R1017, R1018",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-25",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1017_RNA-Clean-&-Concentrator-25.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-100",
      subtitle: "R1019",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-100",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1019_RNA-Clean-&-Concentrator-100.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-96",
      subtitle: "R1080",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator MagBead",
      subtitle: "R1081, R1082",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Miniprep Kit",
      subtitle: "D4300, D4300T, D4304",
      description:
        "Microbial DNA purification kits for accurate microbiome and metagenomic analyses. ",
      handle: "/products/zymobiomics-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA Microprep Kit",
      subtitle: "D4301, D4305",
      description:
        "Microbial DNA purification kits for accurate microbiome and metagenomic analyses. ",
      handle: "/products/zymobiomics-dna-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4301_ZymoBIOMICS-DNA-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield",
      subtitle: "R1100-50, R1100-250, R1200-25, R1200-125",
      description: "DNA/RNA transport medium for any sample",
      handle: "/products/dna-rna-shield",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield Fecal Collection Tube",
      subtitle: "R1101, R1137",
      description: "DNA/RNA transport medium for stool samples",
      handle: "/products/dna-rna-shield-fecal-collection-tube",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield Collection Tube w/ Swab",
      subtitle: "R1106, R1107, R1108, R1109",
      description:
        "Swab collection tube and transport medium for proper sample collection and stabilization",
      handle: "/products/dna-rna-shield-collection-tube-w-swab",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1106_DNA-RNA-Shield-Swab-Tube.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA/RNA Shield SafeCollect Swab Collection Kit",
      subtitle: "R1160, R1161, R1160-E, R1161-E",
      description:
        "User-friendly swab self-collection with unique design to prevent spillage. Collect and transport at ambient temperature, anywhere.",
      handle: "/products/dna-rna-shield-safecollect-swab-collection-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r1160-dna_rna_shield_safecollect_swab_collection_kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Gut Microbiome Standard",
      subtitle: "D6331",
      description:
        "The ZymoBIOMICS Gut Microbiome Standard is a mixture of 18 bacterial strains, 2 fungal strains, and 1 archaeal strain in staggered abundances used for gut microbiome/metagenome workflow optimization and as a positive control.",
      handle: "/products/zymobiomics-gut-microbiome-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/d6331_zymobiomics_gut_microbiome_standard-750ul.png",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Microbial Community DNA Standard",
      subtitle: "D6305, D6306",
      description:
        "Assess bias and errors in NGS-based microbial composition profiling workflows",
      handle: "/products/zymobiomics-microbial-community-dna-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6305_ZymoBIOMICS-Microbial-Community-Standard.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Fecal Reference with TruMatrix Technology",
      subtitle: "D6323",
      description:
        "This reference was made from real human fecal material and was designed to act as a reliable, single point of reference for all microbiome researchers",
      handle: "/products/zymobiomics-fecal-reference-with-trumatrix-technology",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D6323_ZymoBIOMICS-Fecal-Reference-with-TruMatrix.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Lightning Automation Kit",
      subtitle: "D5049",
      description:
        "This reference was made from real human fecal material and was designed to act as a reliable, single point of reference for all microbiome researchers",
      handle: "/products/ez-dna-methylation-lightning-automation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5049-ez_dna_methylation_lightning_automation_kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Lightning Kit",
      subtitle: "D5030, D5030T, D5030-E, D5031, D5031-E",
      description:
        "Citation-leading kits with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
      handle: "/products/ez-dna-methylation-lightning-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning Kit",
      subtitle: "D5032, D5033",
      description:
        "Fastest method for bisulfite conversion of DNA paired with purification on a 96-well plate for high-throughput sample processing.",
      handle: "/products/ez-96-dna-methylation-lightning-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5032_EZ-96-DAN-Methylation-Lightning-Kit-Shallow-Well.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "EZ-96 DNA Methylation-Lightning MagPrep",
      subtitle: "D5046, D5046-E, D5047, D5047-E",
      description:
        "Discover the fastest bisulfite conversion kit with the most efficient method for complete bisulfite conversion of DNA for methylation analysis.",
      handle: "/products/ez-96-dna-methylation-lightning-magprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5046_EZ-96-DNA-Methylation-Lightning-MagPrep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Total RNA Library Kit",
      subtitle: "R3000, R3003",
      description:
        "The fastest and easiest kit for stranded total RNA-seq libraries with RiboFree Universal Depletion for any sample and species",
      handle: "/products/zymo-seq-ribofree-total-rna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3000_zymo-seq_ribofree_tota_rna_library_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Universal cDNA Kit",
      subtitle: "R3001",
      description:
        "This universal rRNA and globin depletion kit is probe-free and produces RiboFree single-stranded cDNA with minimal hands-on time.",
      handle: "/products/zymo-seq-ribofree-universal-cdna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3001_zymo-seq_ribofree_universal_cdna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> <i>E. coli</i> Transformation Kit and Buffer Set",
      subtitle: "T3001, T3002",
      description:
        "Convenient preparation of competent <i>E. coli</i> cells for simple and highly efficient DNA transformation, skipping heat shocking and related procedures.",
      handle: "/products/mix-and-go-e-coli-transformation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/T3002_Mix-and-Go-E-Coli-Transformation-Buffer-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - DH5 Alpha",
      subtitle: "T3007, T3009, T3010",
      description:
        "Premade <i>E. coli</i> DH5 alpha competent cells for simple and highly efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-dh5-alpha",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3009_Mix-and-Go-Competent-Cells-Xymo-5a.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - JM109",
      subtitle: "T3003, T3005",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-jm109",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3005_Mix-and-Go-Competent-Cells-JM109.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "<I>Mix &amp; Go!</i> Competent Cells - Zymo 10B",
      subtitle: "T3019, T3020",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-zymo-10b",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3020_Mix-and-Go-Competent-Cells-Zymo-10B.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJb (DE3) Autolysis Competent Cells",
      subtitle: "T3051",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjbde3-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3051_XJb DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> Competent Cells - TG1",
      subtitle: "T3017",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-tg1",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3017_Mix & Go Competent Cells - TG1 Tubes x10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> Competent Cells - HB101",
      subtitle: "T3011, T3013",
      description:
        "Premade, chemically competent cells for simple, efficient DNA transformation.",
      handle: "/products/mix-and-go-competent-cells-hb101",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3013_Mix-and-Go-Competent-Cells-HB101.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJa (DE3) Autolysis Competent Cells",
      subtitle: "T3031",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjade3-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3031_XJa DE3 Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJb Autolysis Competent Cells",
      subtitle: "T3041",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xjb-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3041_XJb Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<I>Mix &amp; Go!</i> XJa Autolysis Competent Cells",
      subtitle: "T3021",
      description:
        "Simple, efficient, and gentle lysis of E. coli cells.",
      handle: "/products/mix-and-go-competent-cells-xja-autolysis",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/T3021_XJa Autolysis - Glycerol Stock - 1 ml x 10.png",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoBIOMICS 96 MagBead Kit",
      subtitle: "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
      description:
        "Purify DNA from a variety of sample inputs for immediate microbiome or metagenome analyses.",
      handle: "/products/zymobiomics-96-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.png",
      searchWeight: 0,
      tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
        subtitle: "D6421-PS1 - D6421-PS8",
        description:
        "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
        isKit: true,
        image_url:
        "https://files.zymoresearch.com/product-images/D6421-quick_16s_plus_ngs_library_prep_kit_udi.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
        },
    {
      title: "Zymo-Seq RRBS Library Kit",
      subtitle: "D5460, D5461",
      description:
        "An all-in-one RRBS library prep kit that allows for DNA methylation profiling at single-nucleotide resolution.",
      handle: "/products/zymo-seq-rrbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5460_ez_dna_methylation_rrbs_library_prep_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq ATAC Library Kit",
      subtitle: "D5458",
      description:
        "Prepare ATAC-Seq libraries from as few as 50,000 cells in as little as 4 hours from mammalian cells and tissue input.",
      handle: "/products/zymo-seq-atac-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5458-Zymo-Seq-ATAC-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>E. coli</i> Non-Methylated Genomic DNA",
      subtitle: "D5016",
      description:
        "A negative control for DNA methylation analyses requiring DNA with absolutely no methylation.",
      handle: "/products/e-coli-non-methylated-genomic-dna",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5016_E-Coli-Non-Methylated-Genomic-DNA.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Methylated & Non-methylated pUC19 DNA Set",
      subtitle: "D5017",
      description:
        "An ideal “spike-in” control to assess bisulfite conversion efficiency within the same reaction as the sample, or to produce known mixtures of methylated and non-methylated DNA for assay calibration",
      handle: "/products/methylated-non-methylated-puc19-dna-set",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D5017_Methylated-and-Non-Methylated-pUC19-DNA-Set.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Universal Methylated DNA Standard",
      subtitle: "D5011, D5012",
      description:
        "Positive controls to assess the efficiency of DNA bisulfite conversion in human and mouse models.",
      handle: "/products/universal-methylated-dna-standard",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5011_Universal-Methylated-Human-DNA-Standard.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Filter-DNA_Purification>Biological_Fluids": [
    {
      title: "<i>Quick</i>-DNA Kits",
      subtitle: "DNA",
      description:
        "Streamlined DNA isolation from any cells, tissues, and biological fluids (Proteinase K included).",
      handle: "/collections/quick-dna-extraction-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4074-Quick-DNA-Microprep-Plus-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA HMW MagBead Kit",
      subtitle: "D6060",
      description:
        "Extract ultra-pure high molecular weight DNA up to 150 kb from any sample.",
      handle: "/products/quick-dna-hmw-magbead-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-DNA_Purification>Liquid_Biopsy": [
    {
      title: "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      subtitle: "D4076",
      description:
        "High efficiency recovery of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      handle: "/products/quick-cfdna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "MAGicBead™ cfDNA Isolation Kit",
      subtitle: "D4086",
      description:
        "Novel DNA binding chemistry enabling unparalleled cfDNA extraction performance",
      handle: "/products/magicbead-cfdna-isolation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D4086_magicbead_cfdna_isolation_kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
  ],
  "Filter-DNA_Purification>Urine": [
    {
      title: "<i>Quick</i>-DNA Urine Kit",
      subtitle: "D3061",
      description:
        "Extract high quality cell-free or cellular DNA from up to 40 ml of urine",
      handle: "/products/quick-dna-urine-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3061_Quick-DNA-Urine-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-DNA_Purification>Fixed_Tissue": [
    {
      title: "<i>Quick</i>-DNA FFPE Miniprep",
      subtitle: "D3067",
      description: "High-quality DNA from FFPE tissue",
      handle: "/products/quick-dna-ffpe-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3067_Quick-DNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pinpoint Slide DNA Isolation System",
      subtitle: "D3001",
      description:
        "Streamlined method for isolation of DNA from targeted areas of fresh and FFPE tissue slides",
      handle: "/products/pinpoint-slide-dna-isolation-system",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001_Pinpoint-Slide-DNA-Isolation-System-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-DNA_Purification>Microbial_Cultures": [
    {
      title: "<i>Quick</i>-DNA Fungal/Bacterial Kits",
      subtitle: "DNA",
      description:
        "Easily and quickly isolate total DNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-dna-fungal-bacterial-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "YeaStar Genomic DNA Kit",
      subtitle: "D2002",
      description:
        "Simple total DNA purification from a broad spectrum of fungal species.",
      handle: "/products/yeastar-genomic-dna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2002_YeaStar-Genomic-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-DNA_Purification>Microbial_Environmental": [
    {
      title: "<i>Quick</i>-DNA Fecal/Soil Microbe Kits",
      subtitle: "DNA",
      description:
        "The <i>Quick</i>-DNA Fecal/Soil Microbe kits are affordable fecal and soil DNA extraction kits for fast, easy isolation of inhibitor-free, PCR-quality host cell and microbial DNA from a variety of sample sources.",
      handle: "/collections/quick-dna-fecal-soil-microbe-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6010_Quick-DNA-Fecal-Soil-Microbe-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    }
  ],
  "Filter-DNA_Purification>Plant": [
    {
      title: "<i>Quick</i>-DNA Plant/Seed Kits",
      subtitle: "DNA",
      description:
        "Simple, rapid isolation of inhibitor-free, PCR-quality DNA from a variety of plant sample sources.",
      handle: "/collections/quick-dna-plant-seed-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6020_Quick-DNA-Plant-Seed-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Filter-Plasmid_Purification>Ecoli_Miniprep": [
    {
      title: "ZymoPURE Plasmid Miniprep Kit",
      subtitle: "D4208T, D4209, D4210, D4211, D4212",
      description:
        "Fastest and simplest method to isolate endotoxin-free plasmid DNA",
      handle: "/products/zymopure-ii-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Zyppy Plasmid Miniprep Kit",
      subtitle: "D4019, D4020, D4036, D4037",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes.",
      handle: "/products/zyppy-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR Plasmid Miniprep - Classic",
      subtitle: "D4015, D4016, D4054",
      description:
        "Easy traditional method for isolating high-quality plasmid DNA from <i>E. coli</i>",
      handle: "/products/zr-plasmid-miniprep-classic",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4015_ZR-Plasmid-Miniprep-Classic-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR BAC DNA Miniprep Kit",
      subtitle: "D4048, D4049",
      description:
        "Quickly isolate large constructs (≤200 kb) from <i>E. coli</i> using a spin-column",
      handle: "/products/zr-bac-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Filter-Plasmid_Purification>Ecoli_Midiprep": [
    {
      title: "ZymoPURE II Plasmid Midiprep Kit",
      subtitle: "D4200, D4201",
      description: "Vaccine/transfection grade plasmid DNA in &le; 20 minutes",
      handle: "/products/zymopure-ii-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE - Express Plasmid Midiprep Kit",
      subtitle: "D4213",
      description:
        "A fast, pellet-free method to isolate transfection-grade plasmid DNA. No large centrifuge required!",
      handle: "/products/zymopure-express-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4213_ZymoPURE%20Express%20Plasmid%20Midiprep%20Kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-Plasmid_Purification>Ecoli_Maxiprep": [
    {
      title: "ZymoPURE II Plasmid Maxiprep Kit",
      subtitle: "D4202, D4203",
      description: "Vaccine/transfection grade plasmid DNA in &le; 20 minutes",
      handle: "/products/zymopure-ii-plasmid-maxiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Gigaprep Kit",
      subtitle: "D4204",
      description:
        "Large-Scale, vaccine/transfection grade plasmid DNA purification",
      handle: "/products/zymopure-ii-plasmid-gigaprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit-2.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-Plasmid_Purification>Ecoli_High_Throughput": [
    {
      title: "Zyppy-96 Plasmid Kit",
      subtitle: "D4041, D4042, D4043",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes",
      handle: "/products/zyppy-96-plasmid-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4041_Zyppy-96-Plasmid-Miniprep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zyppy-96 Plasmid MagPrep Kit",
      subtitle: "D4100, D4101, D4102",
      description: "Pellet-free, high-quality plasmid DNA in only 8 minutes",
      handle: "/products/zyppy-96-plasmid-magprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-Plasmid_Purification>Ecoli_Bac": [
    {
      title: "ZymoPURE Plasmid Miniprep Kit",
      subtitle: "D4208T, D4209, D4210, D4211, D4212",
      description:
        "Fastest and simplest method to isolate endotoxin-free plasmid DNA",
      handle: "/products/zymopure-ii-plasmid-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Midiprep Kit",
      subtitle: "D4200, D4201",
      description: "Vaccine/transfection grade plasmid DNA in &le; 20 minutes",
      handle: "/products/zymopure-ii-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Maxiprep Kit",
      subtitle: "D4202, D4203",
      description: "Vaccine/transfection grade plasmid DNA in &le; 20 minutes",
      handle: "/products/zymopure-ii-plasmid-maxiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE II Plasmid Gigaprep Kit",
      subtitle: "D4204",
      description:
        "Large-Scale, vaccine/transfection grade plasmid DNA purification",
      handle: "/products/zymopure-ii-plasmid-gigaprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit-2.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoPURE - Express Plasmid Midiprep Kit",
      subtitle: "D4213",
      description:
        "A fast, pellet-free method to isolate transfection-grade plasmid DNA. No large centrifuge required!",
      handle: "/products/zymopure-express-plasmid-midiprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4213_ZymoPURE%20Express%20Plasmid%20Midiprep%20Kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BAC DNA Miniprep Kit",
      subtitle: "D4048, D4049",
      description:
        "Quickly isolate large constructs (≤200 kb) from <i>E. coli</i> using a spin-column",
      handle: "/products/zr-bac-dna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-Plasmid_Purification>From_Yeast": [
    {
      title: "Zymoprep Yeast Plasmid Miniprep I",
      subtitle: "D2001",
      description:
        "Simple precipitation based solution for yeast plasmid DNA isolation using Zymolyase",
      handle: "/products/zymoprep-yeast-plasmid-miniprep-i",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep Yeast Plasmid Miniprep II",
      subtitle: "D2004",
      description:
        "Simple spin-column solution for yeast plasmid DNA isolation using Zymolyase",
      handle: "/products/zymoprep-yeast-plasmid-miniprep-ii",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymoprep-96 Yeast Plasmid Miniprep",
      subtitle: "D2005, D2006, D2007",
      description:
        "The fastest and simplest high-throughput procedure for purifying the highest quality plasmid DNA from yeast.",
      handle: "/products/zymoprep-96-yeast-plasmid-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-DNA_Clean_up>PCR_ezymatic_reactions": [
    {
      title: "DNA Clean & Concentrator Kits (DCC)",
      subtitle: "DNA",
      description:
        "DNA Clean & Concentrator Kits are PCR purification kits that provide purification of DNA from PCR and other enzymatic reactions in as little as 2 minutes. Free PCR purification kits sample.\n",
      handle: "/collections/dcc-pcr-purification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Select-a-Size DNA Clean & Concentrator Kits",
      subtitle: "DNA",
      description:
        "The fastest and easiest size selection DNA kits to purify specific ranges of DNA fragments from PCR, endonuclease digestions, ligations, library preparations, adapter removal, etc. Free size selection DNA kits sample. ",
      handle: "/collections/select-a-size-dna-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Oligo Clean & Concentrator Kits (OCC)",
      subtitle: "DNA",
      description:
        "The Oligo Clean & Concentrator provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
      handle: "/collections/oligo-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ssDNA/RNA Clean & Concentrator",
      subtitle: "D7010, D7011",
      description:
        "Separation of single-stranded nucleic acids from double-stranded nucleic acids.",
      handle: "/products/ssdna-rna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "DNA Sequencing Clean-up Kits",
      subtitle: "DNA",
      description:
        "The ZR DNA & ZR-96 DNA Sequencing Clean-Up Kits provide simple and rapid (2 & 10 minute) methods for removal of post-cycle sequencing reaction contaminants from DNA extension products.",
      handle: "/collections/dna-sequencing-clean-up-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4050_ZR-DNA-Sequencing-Clean-Up-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
  ],
  "Filter-DNA_Clean_up>Agarose_Gel_Excision": [
    {
      title: "Zymoclean Gel DNA Recovery Kits",
      subtitle: "DNA",
      description:
        "Gel DNA extraction kits that provide highly efficient DNA purification from agarose gels. Get a free gel DNA extraction kits sample with free shipping.\n",
      handle: "/collections/zymoclean-gel-dna-recovery-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
  ],
  "DNA Fragmentation Enzymes": [
    {
      title: "DNA Degradase",
      subtitle: "E2016, E2017",
      description: "Complete digestion of DNA into individual nucleotides",
      handle: "/products/dna-degradase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2016_DNA-Degradase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase Plus",
      subtitle: "E2020, E2021",
      description: "Complete digestion of DNA into individual nucleosides.",
      handle: "/products/dna-degradase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2020_DNA-Degradase-Plus.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dsDNA Shearase Plus",
      subtitle: "E2018-200, E2018-50",
      description:
        "Simply control fragment size of dsDNA by adjusting the concentration of dsDNA Shearase Plus.",
      handle: "/products/dsdna-shearase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2018-50_dsDNA-Shearase-Plus-50-U.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Micrococcal Nuclease",
      subtitle: "D5220-1",
      description: "Cleaves single-stranded and double-stranded DNA and RNA. Complete digestion with Micrococcal Nuclease yields mono- and oligonucleotides with 3'-phosphates.",
      handle: "/products/micrococcal-nuclease",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5220-1_Micrococcal-Nuclease.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Atlantis dsDNase",
      subtitle: "E2030",
      description:
        "Atlantis dsDNase ensures digestion of dsDNA to yield homogeneous populations of core nucleosomes.",
      handle: "/products/atlantis-ds-dnase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2030_Atlantis-dsDNase-12.5-U.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-DNA_Clean_up>NGS_Size_Selection": [
    {
      title: "DNA Clean & Concentrator Kits (DCC)",
      subtitle: "DNA",
      description:
        "DNA Clean & Concentrator Kits are PCR purification kits that provide purification of DNA from PCR and other enzymatic reactions in as little as 2 minutes. Free PCR purification kits sample.\n",
      handle: "/collections/dcc-pcr-purification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Select-a-Size DNA Clean & Concentrator Kits",
      subtitle: "DNA",
      description:
        "The fastest and easiest size selection DNA kits to purify specific ranges of DNA fragments from PCR, endonuclease digestions, ligations, library preparations, adapter removal, etc. Free size selection DNA kits sample. ",
      handle: "/collections/select-a-size-dna-clean-concentrator-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Filter-DNA_Clean_up>Genomic_DNA_crude_lysates": [
    {
      title: "Genomic DNA Clean & Concentrator (gDCC)",
      subtitle: "DNA",
      description:
        "The Genomic DNA Clean & Concentrator kits are gDNA clean up kits that provide quick clean-up of large-sized DNA in just 5 minutes. Get free gDNA clean up kits sample today with free shipping.",
      handle: "/collections/genomic-dna-clean-concentrator-gdcc",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4011-Genomic-DNA-Clean-&-Concentrator-10.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Filter-DNA_Clean_up>PCR_Inhibitor_removal": [
    {
      title: "<i>OneStep</i> PCR Inhibitor Removal Kits",
      subtitle: "DNA",
      description: "PCR inhibitor clean up kits that contain all the components needed for efficient removal of potent PCR inhibitors - all in one step. Free PCR inhibitor clean up kits sample with free shipping!",
      handle: "/collections/onestep-pcr-inhibitor-removal-kits",
      isKit: true,
      image_url:
      "https://files.zymoresearch.com/images/D6035-OneStep-96-PCR-Inhibitor-Removal-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-DNA_RNA_Methylation>Bisulfite_Methods": [
    {
      title: "EZ DNA Methylation-Lightning Kits",
      subtitle: "Epigenetics",
      description:
        "Discover citation-leading kits with the most efficient method for complete bisulfite conversion of DNA for methylation analysis. Get a free sample kit today with free shipping.",
      handle: "/collections/ez-dna-methylation-lightning-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5030_EZ-DNA-Methylation-Lightning-Kit-Column.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Direct Kits",
      subtitle: "Epigenetics",
      description:
        "Bisulfite conversion kits that feature complete DNA bisulfite conversion directly from blood, tissue, and cells without the prerequisite for DNA purification. Get a free bisulfite conversion kits sample.\n",
      handle: "/collections/ez-dna-methylation-direct-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5020_EZ-DNA-Methylation-Direct-Kit-Column.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "EZ DNA Methylation Kits",
      subtitle: "Epigenetics",
      description:
        "The EZ DNA Methylation™ Kits feature a simplified procedure that streamlines bisulfite treatment of DNA.\n",
      handle: "/collections/ez-dna-methylation-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5040_EZ-96-DNA-Methylation-MagPrep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Gold Kits",
      subtitle: "Epigenetics",
      description:
        "Consolidate DNA denaturation and bisulfite conversion processes into one step, resulting in a much faster bisulfite conversion.\n",
      handle: "/collections/ez-dna-methylation-gold-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5042_EZ-96-DNA-Methylation-Gold-MagPrep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "EZ DNA Methylation-Startup Kit",
      subtitle: "D5024",
      description:
        "An all-inclusive kit for bisulfite conversion of DNA directly from blood, tissues, and cells, and PCR reagents and controls to assess conversion efficiency.\n",
      handle: "/products/ez-dna-methylation-startup-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5024_EZ%20DNA%20Methylation-Startup%20Kit.png",
      searchWeight: 3,
      tags: [],
    },

    {
      title: "EZ RNA Methylation Kit",
      subtitle: "R5001, R5002",
      description:
        "Fast and reliable bisulfite conversion of RNA for methylation analysis.\n",
      handle: "/products/ez-rna-methylation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R5001_EZ-RNA-Methylation-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Pico Methyl-Seq Library Prep Kit",
      subtitle: "D5455, D5456",
      description:
        "All-inclusive kit for bisulfite conversion followed by Whole Genome Bisulfite Sequencing (WGBS) library preparation.\n",
      handle: "/products/pico-methyl-seq-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d5456_pico-methyl-seq-library-prep-kit_1.jpg",
      searchWeight: 3,
      tags: [],
    },
  ],
  "Filter-DNA_RNA_Methylation>Non-Bisulfite_Methods": [
    {
      title: "OneStep PLUS qMethyl PCR Kit",
      subtitle: "D5312",
      description:
        "Enzymatic Real-Time PCR for the detection of DNA methylation.",
      handle: "/products/onestep-plus-qmethyl-pcr-kit",
      isKit: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D5312-One-STEP-PLUS-qMethyl-PCR.jpg?v=1715298345",
      searchWeight: 0,
      tags: ["DRY ICE", "BLUE ICE"],
    },
  ],
  "Filter-DNA_RNA_Methylation>Antibody_Methods": [
    {
      title: "Methylated-DNA IP Kit",
      subtitle: "D5101",
      description:
        "Kit for immunoprecipitation of methylated DNA in only a few hours. Recovered DNA is suitable for microarray, PCR, bisulfite treatment, etc.\n",
      handle: "/products/methylated-dna-ip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5101_Methylated-DNA-IP-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "5-mC DNA ELISA Kit",
      subtitle: "D5325, D5326",
      description: "Global 5-mC detection and quantitation.\n",
      handle: "/products/5-mc-dna-elisa-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5325_5-mC%20DNA%20ELISA%20Kit.png",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)",
      subtitle: "A3002-15, A3002-200, A3002-30, A3002-50",
      description:
        "Anti-5mC antibody for immunoprecipitation of methylated DNA, ELISA, immunoblotting, immunofluorescence.\n",
      handle: "/products/anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A3002-50_Anit%20Methylation%20-%201:2ul.png",
      searchWeight: 3,
      tags: [],
    },
  ],
  "Filter-NGS_Library_Prep_Kits>Transcriptomics": [
    {
      title: "Green DNA/RNA Dry Transport",
      subtitle: "R1141",
      description:
        "Green DNA/RNA Dry Transport stabilizes NGS libraries for room temperature transportation with any carrier—no declarations needed.",
      handle: "/products/green-dna-rna-dry-transport",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/green-dna-rna-dry-transport_600x.webp?v=1745352863",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Total RNA Library Kit",
      subtitle: "R3000, R3003",
      description:
        "One for all. Simplest and all-inclusive total RNA-Seq library preparation kit with universal rRNA depletion for any organism.",
      handle: "/products/zymo-seq-ribofree-total-rna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3000_zymo-seq_ribofree_tota_rna_library_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq SwitchFree 3′ mRNA Library Kit",
      subtitle: "R3008, R3009",
      description: "UMI-integrated, simple 3′ mRNA library preparation in ~4 hours with scalable sample multiplexing suitable for high-throughput protein coding gene counting.",
      handle: "/products/zymo-seq-switchfree-3-mrna-library-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3008_zymo_seq_switchfree_3_mrna_library_kit_2.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Universal cDNA Kit",
      subtitle: "R3001",
      description:
        "Simplest NGS-Grade cDNA kit with universal rRNA depletion for any organism.",
      handle: "/products/zymo-seq-ribofree-universal-cdna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3001_zymo-seq_ribofree_universal_cdna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq UDI Primer Sets",
      subtitle: "D3008, D3096, D3097, D3098",
      description: "The Zymo-Seq UDI Primer Sets contain pre-mixed Unique Dual Index (UDI) primers that can be used to barcode any library containing TruSeq® adapters.",
      handle: "/products/zymo-seq-udi-primer-sets",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d3008_zymo-seq_udi_primer_set_Indexes_1-12.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Filter-NGS_Library_Prep_Kits>Epigenomics": [
    {
      title: "Green DNA/RNA Dry Transport",
      subtitle: "R1141",
      description:
        "Green DNA/RNA Dry Transport stabilizes NGS libraries for room temperature transportation with any carrier—no declarations needed.",
      handle: "/products/green-dna-rna-dry-transport",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/green-dna-rna-dry-transport_600x.webp?v=1745352863",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq Trio WGBS Library Kit",
      subtitle: "D5462, D5463",
      description:
          "Provides a reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation.",
      handle: "/products/zymo-seq-trio-wgbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq WGBS Library Kit",
      subtitle: "D5465",
      description: "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. Zymo-Seq WGBS Library Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-ups steps required by conventional, ligation-based library preparation methods.",
      handle: "/products/zymo-seq-wgbs-library-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/d5465-zymo_seq_wgbs_library_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq RRBS Library Kit",
      subtitle: "D5460, D5461",
      description:
        "The Zymo-Seq RRBS Library Kit is an all-inclusive library prep kit for low-input library preparation of Reduced Representation of Bisulfite Sequencing (RRBS) to profile genome-wide DNA methylation.",
      handle: "/products/zymo-seq-rrbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5460_ez_dna_methylation_rrbs_library_prep_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq ATAC Library Kit",
      subtitle: "D5458",
      description:
        "The Zymo-Seq ATAC Library Kit features pre assembled buffers offering the quickest and highest quality ATAC-Seq library production.",
      handle: "/products/zymo-seq-atac-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5458-Zymo-Seq-ATAC-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Pico Methyl-Seq Library Prep Kit",
      subtitle: "D5455, D5456",
      description:
        "All-inclusive kit for bisulfite conversion followed by Whole Genome Bisulfite Sequencing (WGBS) library preparation.",
      handle: "/products/pico-methyl-seq-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d5456_pico-methyl-seq-library-prep-kit_1.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "RRHP 5-hmC Library Prep Kit",
      subtitle: "D5450, D5451",
      description:
        "Innovative 5-hmC NGS library prep kits for strand-specific mapping of 5-hmC in DNA.",
      handle: "/products/rrhp-5-hmc-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5450_RRHP 5-hmC Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Zymo-Seq UDI Primer Sets",
      subtitle: "D3008, D3096, D3097, D3098",
      description: "The Zymo-Seq UDI Primer Sets contain pre-mixed Unique Dual Index (UDI) primers that can be used to barcode any library containing TruSeq® adapters.",
      handle: "/products/zymo-seq-udi-primer-sets",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d3008_zymo-seq_udi_primer_set_Indexes_1-12.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Filter-NGS_Library_Prep_Kits>Genomics": [
    {
      title: "Green DNA/RNA Dry Transport",
      subtitle: "R1141",
      description:
        "Green DNA/RNA Dry Transport stabilizes NGS libraries for room temperature transportation with any carrier—no declarations needed.",
      handle: "/products/green-dna-rna-dry-transport",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/green-dna-rna-dry-transport_600x.webp?v=1745352863",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq SPLAT DNA Library Kit",
      subtitle: "D5464",
      description:
        "Versatile and unique ssDNA library preparation solution for any DNA sample.",
      handle: "/products/zymo-seq-splat-dna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5464_zymo-seq_splat_dna_library_kit_(12_prep).jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
  ],
  "Filter-NGS_Library_Prep_Kits>NGS_Library_Transport": [
    {
      title: "Green DNA/RNA Dry Transport",
      subtitle: "R1141",
      description:
        "Green DNA/RNA Dry Transport stabilizes NGS libraries for room temperature transportation with any carrier—no declarations needed.",
      handle: "/products/green-dna-rna-dry-transport",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/green-dna-rna-dry-transport_600x.webp?v=1745352863",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
  ],
  "16S Amplicon Sequencing": [
    {
      title: "<i>Quick</i>-16S Full-Length Library Prep Kit",
      subtitle: "D6450-PS1 - D6450-PS4",
      description:
        "Delivers pooled and purified libraries ready for downstream sequencing on PacBio & Oxford Nanopore sequencing platforms in as little as 30 minutes of hands-on time",
      handle: "/products/quick-16s-full-length-library-prep-kit",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/D6450-BQuick-16SFullLengthLibraryKit_1200x.webp?v=1735842064",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3)",
      subtitle: "D6440-PS1",
      description:
        "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v3",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6440-quick-16s_plus_ngs_library_prep_kit_v1-v3.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2)",
      subtitle: "D6434-PS1",
      description:
        "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v2",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6434-quick-16S_plus_ngs_library_prep_kit_v1-v2.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S NGS Library Prep Kit",
      subtitle: "D6400",
      description:
        "A streamlined solution to convert up to 96 DNA samples to a single, ready-to-sequence 16S library.",
      handle: "/products/quick-16s-ngs-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6400_Quick-16S NGS Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V4)",
      subtitle: "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
      description:
        "Fastest, normalization-free 16S library prep",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v4",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
      subtitle: "D6421-PS1 - D6421-PS8",
      description:
        "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6421-quick_16s_plus_ngs_library_prep_kit_udi.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Bisulfite Sequencing Library Preparation": [
    {
      title: "Zymo-Seq Trio WGBS Library Kit",
      subtitle: "D5462, D5463",
      description:
          "Provides a reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation.",
      handle: "/products/zymo-seq-trio-wgbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq WGBS Library Kit",
      subtitle: "D5465",
      description: "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. Zymo-Seq WGBS Library Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-ups steps required by conventional, ligation-based library preparation methods.",
      handle: "/products/zymo-seq-wgbs-library-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/d5465-zymo_seq_wgbs_library_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq RRBS Library Kit",
      subtitle: "D5460, D5461",
      description:
        "The Zymo-Seq RRBS Library Kit is an all-inclusive library prep kit for low-input library preparation of Reduced Representation of Bisulfite Sequencing (RRBS) to profile genome-wide DNA methylation.",
      handle: "/products/zymo-seq-rrbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d5460_ez_dna_methylation_rrbs_library_prep_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pico Methyl-Seq Library Prep Kit",
      subtitle: "D5455, D5456",
      description:
        "All-inclusive kit for bisulfite conversion followed by Whole Genome Bisulfite Sequencing (WGBS) library preparation.",
      handle: "/products/pico-methyl-seq-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d5456_pico-methyl-seq-library-prep-kit_1.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "5-mC Antibodies & Enrichment": [
    {
      title: "Methylated-DNA IP Kit",
      subtitle: "D5101",
      description:
        "Kit for immunoprecipitation of methylated DNA in only a few hours. Recovered DNA is suitable for microarray, PCR, bisulfite treatment, etc.",
      handle: "/products/methylated-dna-ip-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5101_Methylated-DNA-IP-Kit.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "Anti-5-Methylcytosine Monoclonal Antibody (Clone 7D21)",
      subtitle: "A3002-15, A3002-200, A3002-30, A3002-50",
      description:
        "Anti-5mC antibody for immunoprecipitation of methylated DNA, ELISA, immunoblotting, immunofluorescence",
      handle: "/products/anti-5-methylcytosine-monoclonal-antibody-clone-7d21",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/A3002-50_Anit Methylation - 1:2ul.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "ChIP DNA Clean-Up & Concentration": [
    {
      title: "ChIP DNA Clean & Concentrator",
      subtitle: "D5201, D5205",
      description:
        "The Chromatin Immunoprecipitation (ChIP) DNA Clean & Concentrator is a simple ChIP kit that provides a hassle-free method for the rapid purification and concentration of high-quality DNA from any step in a standard ChIP protocol.",
      handle: "/products/chip-dna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5201_ChIP-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR-96 ChIP DNA Clean & Concentrator",
      subtitle: "D5206, D5207",
      description:
        "The ZR-96 ChIP DNA Clean & Concentrator is a high-throughput (96-well) DNA ChIP kit for seamless purification from any step of a ChIP assay.",
      handle: "/products/zr-96-chip-dna-clean-concentrator",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D5206_ZR-96-ChIP-DNA-Clean-and-Concentrator-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Whole Genome Bisulfite Sequencing (WGBS)": [
    {
      title: "Zymo-Seq Trio WGBS Library Kit",
      subtitle: "D5462, D5463",
      description:
          "Provides a reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation.",
      handle: "/products/zymo-seq-trio-wgbs-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "Zymo-Seq WGBS Library Kit",
      subtitle: "D5465",
      description: "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. Zymo-Seq WGBS Library Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-ups steps required by conventional, ligation-based library preparation methods.",
      handle: "/products/zymo-seq-wgbs-library-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/d5465-zymo_seq_wgbs_library_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Pico Methyl-Seq Library Prep Kit",
      subtitle: "D5455, D5456",
      description:
        "All-inclusive kit for bisulfite conversion followed by Whole Genome Bisulfite Sequencing (WGBS) library preparation.",
      handle: "/products/pico-methyl-seq-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/d5456_pico-methyl-seq-library-prep-kit_1.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Filter-NGS_Library_Prep_Kits>Microbiomics": [
    {
      title: "Green DNA/RNA Dry Transport",
      subtitle: "R1141",
      description:
        "Green DNA/RNA Dry Transport stabilizes NGS libraries for room temperature transportation with any carrier—no declarations needed.",
      handle: "/products/green-dna-rna-dry-transport",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/green-dna-rna-dry-transport_600x.webp?v=1745352863",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Full-Length Library Prep Kit",
      subtitle: "D6450-PS1 - D6450-PS4",
      description:
        "Delivers pooled and purified libraries ready for downstream sequencing on PacBio & Oxford Nanopore sequencing platforms in as little as 30 minutes of hands-on time",
      handle: "/products/quick-16s-full-length-library-prep-kit",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/D6450-BQuick-16SFullLengthLibraryKit_1200x.webp?v=1735842064",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
      subtitle: "D6421-PS1 - D6421-PS8",
      description:
        "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6421-quick_16s_plus_ngs_library_prep_kit_udi.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V4)",
      subtitle: "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
      description:
        "Fastest, normalization-free 16S library prep",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v4",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2)",
      subtitle: "D6434-PS1",
      description:
        "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v2",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6434-quick-16S_plus_ngs_library_prep_kit_v1-v2.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3)",
        subtitle: "D6440-PS1",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v3",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6440-quick-16s_plus_ngs_library_prep_kit_v1-v3.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Total RNA Library Kit",
      subtitle: "R3000, R3003",
      description:
        "The fastest and easiest kit for stranded total RNA-seq libraries with RiboFree Universal Depletion for any sample and species",
      handle: "/products/zymo-seq-ribofree-total-rna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3000_zymo-seq_ribofree_tota_rna_library_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S NGS Library Prep Kit",
      subtitle: "D6400",
      description:
        "A streamlined solution to convert up to 96 DNA samples to a single, ready-to-sequence 16S library.",
      handle: "/products/quick-16s-ngs-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6400_Quick-16S NGS Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>Quick</i>-ITS Plus NGS Library Prep Kit (UDI)",
      subtitle: "D6425-PS1, D6425-PS2, D6425-PS3, D6425-PS4",
      description:
        "The fastest and simplest NGS library prep kit targeting the ITS region for mycobiome profile analysis.",
      handle: "/products/quick-its-plus-ngs-library-prep-kit-udi",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d6425-quick_its_plus_ngs_library_prep_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },

  ],
  "Filter-RNA>DNA_RNA_Co_Purification": [
    {
      title: "<i>Quick</i>-DNA/RNA Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "Isolation of high quality genomic DNA and total RNA from cells, tissue, blood, biological fluids, etc. ",
      handle: "/collections/quick-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral Kits",
      subtitle: "DNA/RNA Purification",
      description:
        "The Quick-DNA/RNA Viral kits are viral DNA/RNA purification kits that provide for rapid isolation of high-quality viral nucleic acids from a wide range of biological sources.",
      handle: "/collections/quick-dna-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "<i>Quick</i>-DNA/RNA Pathogen kits simplify purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      handle: "/collections/quick-dna-rna-pathogen-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "Load N’ Go DNA/RNA Viral Kit",
      subtitle: "R2143",
      description: "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      handle: "/products/load-n-go-dna-rna-viral-kit",
      isKit: true,
      ribbon: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      subtitle: "R1009",
      description: "DNA and RNA from FFPE tissue",
      handle: "/products/quick-dna-rna-ffpe-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Kits",
      subtitle: "Microbiomics",
      description:
        "Purification of microbial DNA and RNA for microbiome or metagenome analysis.",
      handle: "/collections/zymobiomics-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit_1200x@2x.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol DNA/RNA Miniprep",
      subtitle: "R2080, R2080T, R2081",
      description:
        "DNA & RNA isolation from any sample in TRIzol, TRI Reagent.",
      handle: "/products/direct-zol-dna-rna-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2080_Direct-zol-DNA-RNA-Miniprep-Kit_no-TRIzol.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      subtitle: "R1072",
      description:
        "Isolate cfDNA and cfRNA efficiently and easily from biological fluids",
      handle: "/products/quick-cfdna-rna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-RNA_Isolation>Samples": [
    {
      title: "<i>Quick</i>-DNA/RNA Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "Quick-DNA/RNA kits provide a quick method for the isolation of high quality genomic DNA and total RNA from cells, tissue, blood, biological fluids, etc. These DNA RNA isolation kits isolate both genomic DNA and a broad range of RNA species without the use of phenol.",
      handle: "/collections/quick-dna-rna-kits",
      isKit: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0016/3731/8726/products/D7003_ZR-Duet-DNA-RNA-MiniPrep-Plus-Kit_600x.jpg?v=1588501423",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "Direct-zol RNA Kits",
      subtitle: "RNA",
      description:
        "RNA purification kits that provide purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRIzol or Tri Reagent in 7 minutes. Get a free RNA purification kits sample with free shipping. ",
      handle: "/collections/direct-zol-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Kits",
      subtitle: "RNA",
      description:
        "The Quick-RNA kits are RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes. Get a free sample today with free shipping. ",
      handle: "/collections/quick-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
  ],
  "Filter-RNA_Isolation>ToughToLyse": [
    {
      title: "ZR BashingBead Lysis Tubes",
      subtitle: "S6003-50",
      description: "Each impact resistant 2 ml tube contains 0.7 ml dry volume 2.0 mm ZR BashingBead lysis matrix. The state of the art, ultra-high density beads are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
      handle: "/products/zr-bashing-bead-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/S6003-ZR-BashingBead-Lysis-Tubes-2.0-mm.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZR BashingBead Lysis Tubes (0.1 & 0.5 mm)",
      subtitle: "S6012-50",
      description:
        "Each impact resistant 2 ml tube contains 0.6 ml dry volume mixed 0.5 mm and 0.1mm ZR BashingBead lysis matrix. The state of the art, ultra-high density beads are fracture resistant, chemically inert, and ideal for disrupting tough-to-lyse biological samples.",
      handle: "/products/zr-bashingbead-lysis-tubes-0-1-0-5-mm",
      isKit: true,
      image_url:
        "http://files.zymoresearch.com/product-images/S6012-50_ZR-BashingBead-Lysis-Tubes.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Proteinase K with Storage Buffer Set",
      subtitle: "D3001-2-20, D3001-2-5",
      description:
        "Proteinase K is a stable serine protease with broad substrate specificity and will degrade many proteins in their native conformation even in the presence of detergents (e.g., SDS).",
      handle: "/products/proteinase-k-w-storage-buffer-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001-2-20_Proteinase-K-lyophilized-20-mg.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fungal/Bacterial Kit",
      subtitle: "RNA",
      description:
        "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      handle: "/collections/quick-rna-fungal-bacterial-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Tissue/Insect Kit",
      subtitle: "R2030",
      description: "Isolate RNA from tough-to-lyse tissue and insects",
      handle: "/products/quick-rna-tissue-insect-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2030_Quick-RNA-Tissue-Insect-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
      subtitle: "R2040",
      description:
        "The Quick-RNA Fecal/Soil Microbe Microprep Kit is an affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
      handle: "/products/quick-rna-fecal-soil-microbe-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2040_Quick-RNA-Fecal-Soil-Microbe-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Plant Kit",
      subtitle: "R2024",
      description: "Isolate inhibitor-free RNA from plant and seed samples.",
      handle: "/products/quick-rna-plant-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2024_Quick-RNA-Plant-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "YeaStar RNA Kit",
      subtitle: "R1002",
      description:
        "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      handle: "/products/yeastar-rna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS RNA Kits",
      subtitle: "Microbiomics",
      description:
        "Purification of microbial RNA for microbiome or metagenome analysis.",
      handle: "/collections/zymobiomics-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit_1200x@2x.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS DNA/RNA Kits",
      subtitle: "Microbiomics",
      description:
        "Purification of microbial DNA and RNA for microbiome or metagenome analysis.",
      handle: "/collections/zymobiomics-dna-rna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit_1200x@2x.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep & Lysis Tubes",
      subtitle: "R2050, R2051, S6003-50, S6012-50, S6014-50",
      description:
        "Use ZR BashingBead Lysis Tubes for tough-to-lyse samples in TRIzol prior to purifying with the Direct-zol RNA kit.",
      handle: "/products/direct-zol-rna-miniprep-and-lysis-tubes",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2050_Direct-zol-RNA-MiniPrep_No-TRI-Reagent.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-RNA_Isolation>FFPE": [
    {
      title: "<i>Quick</i>-RNA FFPE Miniprep",
      subtitle: "R1008",
      description: "Isolate RNA and small/miRNA from FFPE tissue.",
      handle: "/products/quick-rna-ffpe-miniprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1008_Quick-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      subtitle: "R1009",
      description: "DNA and RNA from FFPE tissue",
      handle: "/products/quick-dna-rna-ffpe-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Pinpoint Slide RNA Isolation System",
      subtitle: "R1003, R1007",
      description: "RNA from tissue sections on glass slides",
      handle: "/products/pinpoint-slide-rna-isolation-system",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1003_Pinpoint-Slide-RNA-Isolation-System-I-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-RNA_Isolation>Viral": [
    {
      title: "<i>Quick</i>-RNA Viral Kits",
      subtitle: "RNA",
      description:
        "The <i>Quick</i>- RNA Viral Kits are viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      handle: "/collections/quick-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Viral Kits",
      subtitle: "DNA/RNA Purification",
      description:
        "The Quick-DNA/RNA Viral kits are viral DNA/RNA purification kits that provide for rapid isolation of high-quality viral nucleic acids from a wide range of biological sources.",
      handle: "/collections/quick-dna-rna-viral-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "<i>Quick</i>-DNA/RNA Pathogen Kits",
      subtitle: "DNA/RNA Co-Purification",
      description:
        "<i>Quick</i>-DNA/RNA Pathogen kits simplify purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      handle: "/collections/quick-dna-rna-pathogen-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      searchWeight: 2,
      tags: [],
    },
  ],
  "Filter-RNA_Isolation>CellFree": [
    {
      title: "<i>Quick</i>-cfRNA Serum & Plasma Kit",
      subtitle: "R1059",
      description: "Isolate cell-free RNA from biological fluid samples.",
      handle: "/products/quick-cfrna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1059_Quick-cfRNA-Serum-Plasma-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      subtitle: "R1072",
      description:
        "Isolate cfDNA and cfRNA efficiently and easily from biological fluids",
      handle: "/products/quick-cfdna-rna-serum-plasma-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-RNA_Isolation>Blood": [
    {
      title: "<i>Quick</i>-DNA/RNA Blood Tube Kit",
      subtitle: "R1151",
      description:
        "The Quick-DNA/RNA™ Blood Tube Kit is designed for use with the DNA/RNA Shield™ - Blood Tube (R1150), enabling worry-free sample storage at ambient temperatures. The DNA and RNA isolation kits procedure uses Zymo-Spin column technology. Simply bind the sample onto the Zymo-Spin™ IIICG Column with the aid of reservoirs (vacuum compatible).",
      handle: "/products/quick-dna-rna-blood-tube-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/r1151_quick-dna-rna-blood-tube-kit_1.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Direct-zol RNA Miniprep",
      subtitle: "R2050, R2051, R2052, R2053",
      description:
        "The Direct-zol&trade; RNA MiniPrep Kits are RNA isolation kits that provide a streamlined method for the purification of up to 50 &micro;g (per prep) of high-quality RNA directly from samples in TRI Reagent&#174 or similar",
      handle: "/products/direct-zol-rna-miniprep-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R2050-Directzol-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Proteinase K with Storage Buffer Set",
      subtitle: "D3001-2-20, D3001-2-5",
      description:
        "Proteinase K is a stable serine protease with broad substrate specificity and will degrade many proteins in their native conformation even in the presence of detergents (e.g., SDS).",
      handle: "/products/proteinase-k-w-storage-buffer-set",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D3001-2-20_Proteinase-K-lyophilized-20-mg.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Whole Blood",
      subtitle: "R1201",
      description: "Isolate RNA and small/miRNA from whole blood.",
      handle: "/products/quick-rna-whole-blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1201_Quick-RNA-Whole-Blood-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Blood Collection",
      subtitle: "Sample Collection",
      description: "DNA/RNA transport medium for whole blood",
      handle: "/pages/sample-collection-kits?tags=blood",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-RNA_Isolation>Urine": [
    {
      title: "ZR Urine RNA Isolation Kit",
      subtitle: "R1038, R1039",
      description: "Isolate RNA from up to 30 ml of urine.",
      handle: "/products/zr-urine-rna-isolation-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1038_ZR-Urine-RNA-Isolation-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-RNA_Isolation>LowInput": [
    {
      title: "Direct-zol RNA Microprep Kits",
      subtitle: "RNA",
      description:
        "RNA from single cell and low inputs in TRIzol. NGS-ready and concentrated in 6 &micro;l",
      handle:
        "/collections/direct-zol-rna-kits/products/direct-zol-rna-microprep-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2060-Directzol-RNA-Microprep.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "<i>Quick</i>-RNA Microprep Kits",
      subtitle: "RNA",
      description:
        "RNA from single cell and low inputs. NGS-ready and concentrated in 6 &micro;l.",
      handle: "/collections/quick-rna-kits/products/quick-rna-microprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1050_Quick-RNA-Microprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  
  "PCR & qPCR": [
    {
      title: "ZymoTaq Polymerase",
      subtitle: "Buffers",
      description:
        "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
      handle: "/collections/zymotaq-polymerase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2001_ZymoTaq-Polymerase.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "OneStep PLUS qMethyl PCR Kit",
      subtitle: "D5312",
      description:
        "Enzymatic Real-Time PCR for the detection of DNA methylation.",
      handle: "/products/onestep-plus-qmethyl-pcr-kit",
      isKit: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D5312-One-STEP-PLUS-qMethyl-PCR.jpg?v=1715298345",
      searchWeight: 0,
      tags: ["DRY ICE", "BLUE ICE"],
    },
    {
      title: "PolStar NGS Library Prep qPCR Premix (2X)",
      subtitle: "E2070, E2071",
      description: "Hot start, high-fidelity, NGS-optimized polymerase packaged in a ready-to-use qPCR Premix. ",
      handle: "/products/polstar-ngs-library-prep-qpcr-premix-2x",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E2020_E2071.webp",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dNTP Mix",
      subtitle: "D1000, D1000-1",
      description:
        "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/dntp-mix",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1000_dNTPs.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dCTP",
      subtitle: "D1020",
      description: "PCR nucleotides and mix",
      handle: "/products/dctp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1020_dCTP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dATP",
      subtitle: "D1005",
      description:
        "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/datp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1005_dATP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "dTTP",
      subtitle: "D1010",
      description:
        "dTTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
      handle: "/products/dttp",
      isKit: true,
      image_url: "https://files.zymoresearch.com/images/D1010_dTTP.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-Methylcytosine dNTP Mix",
      subtitle: "D1030",
      description:
        "dNTP mixture containing the modified deoxynucleotide 5-mC for use with PCR, mass spec, etc.",
      handle: "/products/5-methylcytosine-dntp-mix",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-Methyl dCTP",
      subtitle: "D1035",
      description: "Modified deoxynucleotide for use with PCR, mass spec, etc.",
      handle: "/products/5-methyl-dctp",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D1035_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "PCR & Molecular Assays": [
    {
      title: "ZymoTaq Polymerase",
      subtitle: "Buffers",
      description:
        "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. This unique product is specifically designed for the amplification of bisulfite-treated DNA for methylation detection, but is applicable for conventional PCR.",
      handle: "/collections/zymotaq-polymerase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2001_ZymoTaq-Polymerase.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "OneStep PLUS qMethyl PCR Kit",
      subtitle: "D5312",
      description:
        "Enzymatic Real-Time PCR for the detection of DNA methylation.",
      handle: "/products/onestep-plus-qmethyl-pcr-kit",
      isKit: true,
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D5312-One-STEP-PLUS-qMethyl-PCR.jpg?v=1715298345",
      searchWeight: 0,
      tags: ["DRY ICE", "BLUE ICE"],
    },
    {
      title: "5-Methylcytosine dNTP Mix",
      subtitle: "D1030",
      description:
        "dNTP mixture containing the modified deoxynucleotide 5-mC for use with PCR, mass spec, etc.",
      handle: "/products/5-methylcytosine-dntp-mix",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D1030_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "5-Methyl dCTP",
      subtitle: "D1035",
      description: "Modified deoxynucleotide for use with PCR, mass spec, etc.",
      handle: "/products/5-methyl-dctp",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D1035_Methylated-and-Hydroxymethylated-Nucleotides.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "PolStar NGS Library Prep qPCR Premix (2X)",
      subtitle: "E2070, E2071",
      description: "Hot start, high-fidelity, NGS-optimized polymerase packaged in a ready-to-use qPCR Premix. ",
      handle: "/products/polstar-ngs-library-prep-qpcr-premix-2x",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/E2020_E2071.webp",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>Quick</i> SARS-CoV-2 rRT-PCR Kit",
      subtitle: "R3011",
      description:
        "Simple and sensitive detection of SARS-CoV-2 from biological samples.",
      handle: "/products/quick-sars-cov-2-rrt-pcr-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3010-quick-sars-cov-s-rrt-pcr-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "<em>Quick</em> SARS-CoV-2 Multiplex Kit",
      subtitle: "R3013, R3013-1K, R3013-10K",
      description: "The Quick SARS-CoV-2 Multiplex Kit is a real-time reverse transcription PCR (rRT-PCR) test for the qualitative detection of RNA from the severe acute respiratory syndrome coronavirus 2 (SARS-CoV-2) which is responsible for the coronavirus disease (COVID-19).",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3013-quick-sars-cov-2-multiplex-kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoScript One-Step RT-qPCR Kit",
      subtitle: "R3014",
      description: "ZymoScript One-Step RT-qPCR Kit is an optimized RT-qPCR kit that contains all the components for fast reverse transcription and robust qPCR amplification in a single tube. The One-Step RT-qPCR kit is compatible with both SYBR Green and TaqMan probe-based assays.",
      handle: "/products/zymoscript-one-step-rt-qpcr-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3014-zymoscript_onestep_rt_qpcr_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "ZymoScript RT PreMix Kit",
      subtitle: "R3012",
      description: "ZymoScript RT PreMix Kit is part of the ZymoScript family together with the ZymoScript OneStep RT-qPCR Kit (R3014). ZymoScript RT PreMix is an optimized reverse transcription kit containing all the necessary components for quick and efficient cDNA synthesis.",
      handle: "/products/zymoscript-rt-premix-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3012-zymoscript_rt_prexix_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "dNTP Solutions",
      subtitle: "Epigenetics",
      description:
        "Convenient and ready-to-use dNTPs for use in a variety of molecular biology applications including long-range PCR, cDNA synthesis, RT-PCR, real-time PCR, standard PCR, and high-fidelity PCR. ",
      handle: "/collections/dntp-solutions",
      isKit: false,
      image_url: "https://files.zymoresearch.com/product-images/D1005_dATP.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Femto DNA Quantification Kits",
      subtitle: "DNA",
      description:
        "Detect and quantify human, bacterial, and fungal DNA with high specificity and sensitivity. ",
      handle: "/collections/femto-dna-quantification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2005_Femto-Human-DNA-Quantification-Kit.jpg",
      searchWeight: 2,
      tags: ["DRY ICE"],
    },
    {
      title: "ZR 50 bp DNA Marker",
      subtitle: "M5001-50, M5001-200, M5004-50",
      description:
        "The 50 bp DNA marker consists of plasmid DNA that has been digested with endonucleases to yield 12 defined fragments.",
      handle: "/products/zr-50-bp-dna-marker",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M5001-50_ZR-50-bp-DNA-Marker-50-ug.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR 100 bp DNA Marker",
      subtitle: "M5002-50, M5002-200, M5005-50",
      description:
        "The 100 bp DNA marker consists of plasmid DNA that has been digested with endonucleases to yield 12 defined fragments.",
      handle: "/products/zr-50-bp-dna-marker",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M5002-200_ZR_20100_20bp_20DNA_20Marker_20-_20200_20ug.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "ZR 1 kb DNA Marker",
      subtitle: "M5003-50, M5003-200, M5006-50",
      description:
        "The 1 kb DNA marker consists of plasmid DNA that has been digested with endonucleases to yield 10 defined fragments.",
      handle: "/products/zr-50-bp-dna-marker",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/M5003-50_ZR-1-kb-DNA-Marker-50-ug.jpg",
      searchWeight: 2,
      tags: [],
    },
    {
      title: "DNA Methylation Standards",
      subtitle: "DNA",
      description:
        "Industry-leading DNA methylation standards for seamless quantificaction. Assess your DNA methylation workflow today!",
      handle: "/pages/dna-methylation-standards",
      image_url:
        "https://files.zymoresearch.com/images/D5014_Human-Methylated-and-Non-Methylated-DNA-Set.jpg",
      tags: [],
    },
    {
      "title": "DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4012",
      "description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4012_DNA-Clean-%26-Concentrator-Magbead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-5",
      "subtitle": "D4003, D4003T, D4004, D4013, D4014",
      "description": "Purify up to 5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources in just 2 minutes.",
      "handle": "/products/dna-clean-concentrator-5",
      "image_url": "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-25",
      "subtitle": "D4005, D4006, D4033, D4034",
      "description": "Purify up to 25 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources in just 2 minutes. ",
      "handle": "/products/dna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/D4005_DNA-Clean-and-Concentrator-25-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-100",
      "subtitle": "D4029, D4030",
      "description": "Quickly purify up to 100 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-100",
      "image_url": "https://files.zymoresearch.com/product-images/D4029_DNA-Clean-and-Concentrator-100-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-500",
      "subtitle": "D4031, D4032",
      "description": "Quickly purify up to 500 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-500",
      "image_url": "https://files.zymoresearch.com/product-images/D4031-DNA-Clean-_-Concentrator--500.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "ZR-96 DNA Clean-Up Kit",
      subtitle: "D4017, D4018",
      description:
        "Clean-up PCR and other enzymatic reactions at large scale in as little as 20 minutes",
      handle: "/products/zr-96-dna-clean-up-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4017_ZR-96-DNA-Clean-up-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      "title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
      "subtitle": "D4023, D4024",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
      "image_url": "https://files.zymoresearch.com/product-images/D4023-ZR-96-DNA-Clean-_-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
      "subtitle": "D4066, D4067",
      "description": "Simple hight-throughput method for purifying high molecular weight DNA from any enzymatic reaction or impure preparation.",
      "handle": "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
      "image_url": "https://files.zymoresearch.com/images/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Genomic DNA Clean & Concentrator-10",
      "subtitle": "D4010, D4011",
      "description": "Quickly purify up to 10 µg of high molecular weight DNA from any enzymatic reaction or impure preparation. ",
      "handle": "/products/genomic-dna-clean-concentrator-10",
      "image_url": "https://files.zymoresearch.com/product-images/D4010_Genomic-DNA-Clean-and-Concentrator-10.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Genomic DNA Clean & Concentrator-25",
      "subtitle": "D4064, D4065",
      "description": "Quickly purify up to 25 µg of high molecular weight DNA from any enzymatic reaction or impure preparation. ",
      "handle": "/products/genomic-dna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/D4064_Genomic-DNA-Clean-and-Concentrator-25.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      title: "RNA Clean & Concentrator-5",
      subtitle: "R1013, R1014, R1015, R1016",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-5",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-96",
      subtitle: "R1080",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-96",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-25",
      subtitle: "R1017, R1018",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-25",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1017_RNA-Clean-&-Concentrator-25.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator-100",
      subtitle: "R1019",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-100",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1019_RNA-Clean-&-Concentrator-100.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      title: "RNA Clean & Concentrator MagBead",
      subtitle: "R1081, R1082",
      description:
        "RNA clean up kits that provide a simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      handle: "/products/rna-clean-concentrator-magbead",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      searchWeight: 3,
      tags: [],
    },
    {
      "title": "Select-a-Size DNA Clean & Concentrator Kit",
      "subtitle": "D4080",
      "description": "Easily purify a specific range of DNA fragment sizes from library preps, PCR, ligations and other sources using a spin-column.",
      "handle": "/products/select-a-size-dna-clean-concentrator-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Select-a-Size DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4084, D4085",
      "description": "Consistently purify a specific range of DNA fragment sizes from library preps, PCR, ligations and other sources using magnetic beads. ",
      "handle": "/products/select-a-size-dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/images/D4084_Select-A-Size-DNA-Clean-and-Concentrator-MagBead-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4001, D4001T, D4002, D4007, D4008",
      "description": "Quickly recover ultra-pure DNA from agarose gels.",
      "handle": "/products/zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4021, D4022",
      "description": "Convenient high-throughput purification of ultra-pure DNA from agarose gels.",
      "handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Large Fragment DNA Recovery",
      "subtitle": "D4045, D4046",
      "description": "Rapid purification of ultra-pure high molecular weight DNA from agarose gels.",
      "handle": "/products/zymoclean-large-fragment-dna-recovery",
      "image_url": "https://files.zymoresearch.com/product-images/D4045-Zymoclean-Large-Fragment-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Oligo Clean & Concentrator",
      "subtitle": "D4060, D4061",
      "description": "Clean and concentrate Oligonucleotides in just 2 minutes.",
      "handle": "/products/oligo-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/product-images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Oligo Clean & Concentrator",
      "subtitle": "D4062, D4063",
      "description": "Streamlined high-throughput method for cleaning-up and concentrating oligonucleotides.",
      "handle": "/products/oligo-clean-concentrator-zr96",
      "image_url": "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
  ],
  "Molecular Assays": [
    {
      title: "Femto DNA Quantification Kits",
      subtitle: "DNA",
      description:
        "Detect and quantify human, bacterial, and fungal DNA with high specificity and sensitivity. ",
      handle: "/collections/femto-dna-quantification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2005_Femto-Human-DNA-Quantification-Kit.jpg",
      searchWeight: 3,
      tags: ["DRY ICE"],
    },
  ],
  "DNA Standards & Ladders": [
    {
      title: "DNA Methylation Standards",
      subtitle: "DNA",
      description:
        "Industry-leading DNA methylation standards for seamless quantificaction. Assess your DNA methylation workflow today!",
      handle: "/pages/dna-methylation-standards",
      image_url:
        "https://files.zymoresearch.com/images/D5014_Human-Methylated-and-Non-Methylated-DNA-Set.jpg",
      tags: [],
    },
    {
      title: "DNA Ladders",
      subtitle: "DNA",
      description:
        "DNA size fragments encompassing a range of sizes from 50 bp up to 10 kb.",
      handle: "/collections/zr-dna-markers",
      image_url:
        "https://cdn.shopify.com/s/files/1/0548/8830/0722/collections/M5001-200_ZR-50-bp-DNA-Marker-200-ug.jpg?v=1628532563",
      tags: [],
    },
  ],
  "DNA Degradase": [
    {
      title: "DNA Degradase",
      subtitle: "E2016, E2017",
      description: "Complete digestion of DNA into individual nucleotides",
      handle: "/products/dna-degradase",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2016_DNA-Degradase.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "DNA Degradase Plus",
      subtitle: "E2020, E2021",
      description: "Complete digestion of DNA into individual nucleosides.",
      handle: "/products/dna-degradase-plus",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2020_DNA-Degradase-Plus.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Filter-RNA_Analysis>RT_qPCR": [
    {
      title: "ZymoScript One-Step RT-qPCR Kit",
      subtitle: "R3014",
      description: "ZymoScript One-Step RT-qPCR Kit is an optimized RT-qPCR kit that contains all the components for fast reverse transcription and robust qPCR amplification in a single tube. The One-Step RT-qPCR kit is compatible with both SYBR Green and TaqMan probe-based assays.",
      handle: "/products/zymoscript-one-step-rt-qpcr-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3014-zymoscript_onestep_rt_qpcr_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "ZymoScript RT PreMix Kit",
      subtitle: "R3012",
      description: "ZymoScript RT PreMix Kit is part of the ZymoScript family together with the ZymoScript OneStep RT-qPCR Kit (R3014). ZymoScript RT PreMix is an optimized reverse transcription kit containing all the necessary components for quick and efficient cDNA synthesis.",
      handle: "/products/zymoscript-rt-premix-kit",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3012-zymoscript_rt_prexix_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>Quick</i> SARS-CoV-2 rRT-PCR Kit",
      subtitle: "R3011",
      description:
        "Simple and sensitive detection of SARS-CoV-2 from biological samples.",
      handle: "/products/quick-sars-cov-2-rrt-pcr-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3010-quick-sars-cov-s-rrt-pcr-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: ["DRY ICE"],
    },
    {
      title: "<em>Quick</em> SARS-CoV-2 Multiplex Kit",
      subtitle: "R3013, R3013-1K, R3013-10K",
      description: "The Quick SARS-CoV-2 Multiplex Kit is a real-time reverse transcription PCR (rRT-PCR) test for the qualitative detection of RNA from the severe acute respiratory syndrome coronavirus 2 (SARS-CoV-2) which is responsible for the coronavirus disease (COVID-19).",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/r3013-quick-sars-cov-2-multiplex-kit.jpg",
      searchWeight: 0,
    },
  ],
  "Filter-RNA_Analysis>RNA_Sequencing": [
    {
      title: "Zymo-Seq RiboFree Total RNA Library Kit",
      subtitle: "R3000, R3003",
      description:
        "The fastest and easiest kit for stranded total RNA-seq libraries with RiboFree Universal Depletion for any sample and species",
      handle: "/products/zymo-seq-ribofree-total-rna-library-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3000_zymo-seq_ribofree_tota_rna_library_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq RiboFree Universal cDNA Kit",
      subtitle: "R3001",
      description:
        "This universal rRNA and globin depletion kit is probe-free and produces RiboFree single-stranded cDNA with minimal hands-on time.",
      handle: "/products/zymo-seq-ribofree-universal-cdna-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r3001_zymo-seq_ribofree_universal_cdna_kit.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "Zymo-Seq UDI Primer Sets",
      subtitle: "D3008, D3096, D3097, D3098",
      description: "The Zymo-Seq UDI Primer Sets contain pre-mixed Unique Dual Index (UDI) primers that can be used to barcode any library containing TruSeq® adapters.",
      handle: "/products/zymo-seq-udi-primer-sets",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d3008_zymo-seq_udi_primer_set_Indexes_1-12.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Filter-RNA_Analysis>RNA_Ladders": [
    {
      title: "ZR small-RNA Ladder",
      subtitle: "R1090",
      description:
        "miRNA size marker for PAGE and small RNA size approximation",
      handle: "/products/zr-small-rna-ladder",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R1090_ZR-Small-RNA-Ladder-10-ug.jpg",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
  ],
  "Filter-Microbiomics>DNA_Isolation_DNA": [
    {
      title: "ZymoBIOMICS DNA Kit",
      subtitle: "DNA",
      description:
        "The ZymoBIOMICS DNA Kits are microbial DNA purification kits for microbiome and metagenomic analyses. Free microbial DNA purification kits sample.",
      handle: "/collections/zymobiomics-dna-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "HostZERO Microbial DNA Kit",
      subtitle: "D4310",
      description:
        "Streamlined host depletion and bacterial DNA isolation from mammalian samples.",
      handle: "/products/hostzero-sup-trade-sup-microbial-dna-kit-microprep",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D4310-A_HostZERO-Microbial-DNA-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-Microbiomics>DNA_Isolation_RNA": [
    {
      title: "ZymoBIOMICS RNA Miniprep Kit",
      subtitle: "R2001",
      description:
        "Purification of microbial RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead RNA",
      subtitle: "R2137, R2138",
      description:
        "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
      handle: "/products/zymobiomics-magbead-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2137_zymobiomics-magbead-rna-kit.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Filter-Microbiomics>DNA_Isolation_Purification": [
    {
      title: "ZymoBIOMICS DNA/RNA Miniprep Kit",
      subtitle: "R2002",
      description:
        "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      handle: "/products/zymobiomics-dna-rna-miniprep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS MagBead DNA/RNA",
      subtitle: "R2135, R2136",
      description:
        "A high-throughput, magnetic bead-based microbiome extraction kit designed for microbial DNA and RNA purification.",
      handle: "/products/zymobiomics-magbead-dna-rna",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-Microbiomics>Library_Preparation": [
    {
      title: "<i>Quick</i>-16S  Full-Length Library Prep Kit",
      subtitle: "D6450-PS1 - D6450-PS4",
      description:
        "Delivers pooled and purified libraries ready for downstream sequencing on PacBio & Oxford Nanopore sequencing platforms in as little as 30 minutes of hands-on time",
      handle: "/products/quick-16s-full-length-library-prep-kit",
      isKit: true,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/D6450-BQuick-16SFullLengthLibraryKit_1200x.webp?v=1735842064",
      searchWeight: 2,
      ribbon: true,
      tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3)",
        subtitle: "D6440-PS1",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v3",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6440-quick-16s_plus_ngs_library_prep_kit_v1-v3.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
    },
    {
        title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2)",
        subtitle: "D6434-PS1",
        description:
          "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
        handle: "/products/quick-16s-plus-ngs-library-prep-kit-v1-v2",
        isKit: true,
        image_url:
          "https://files.zymoresearch.com/product-images/D6434-quick-16S_plus_ngs_library_prep_kit_v1-v2.jpg",
        searchWeight: 0,
        ribbon: true,
        tags: [],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI)",
      subtitle: "D6421-PS1 - D6421-PS8",
      description:
        "The <i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4, UDI) is the fastest and simplest NGS library prep kit targeting the 16S rRNA gene for microbiome profile analysis.",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v3-v4-udi",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/D6421-quick_16s_plus_ngs_library_prep_kit_udi.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-16S NGS Library Prep Kit",
      subtitle: "D6400",
      description:
        "A streamlined solution to convert up to 96 DNA samples to a single, ready-to-sequence 16S library.",
      handle: "/products/quick-16s-ngs-library-prep-kit",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/D6400_Quick-16S NGS Library Prep Kit.png",
      searchWeight: 0,
      tags: ["DRY ICE"],
    },
    {
      title: "<i>Quick</i>-16S Plus NGS Library Prep Kit (V4)",
      subtitle: "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
      description:
        "Fastest, normalization-free 16S library prep",
      handle: "/products/quick-16s-plus-ngs-library-prep-kit-v4",
      isKit: true,
      image_url: "https://files.zymoresearch.com/product-images/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "<i>Quick</i>-ITS Plus NGS Library Prep Kit (UDI)",
      subtitle: "D6425-PS1, D6425-PS2, D6425-PS3, D6425-PS4",
      description:
        "The fastest and simplest NGS library prep kit targeting the ITS region for mycobiome profile analysis.",
      handle: "/products/quick-its-plus-ngs-library-prep-kit-udi",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/product-images/d6425-quick_its_plus_ngs_library_prep_kit.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
    {
      title: "Femto DNA Quantification Kits",
      subtitle: "DNA",
      description:
        "Detect and quantify human, bacterial, and fungal DNA with high specificity and sensitivity. ",
      handle: "/collections/femto-dna-quantification-kits",
      isKit: true,
      image_url:
        "https://files.zymoresearch.com/images/E2005_Femto-Human-DNA-Quantification-Kit.jpg",
      searchWeight: 3,
      tags: ["DRY ICE"],
    },
  ],
  "Filter-Microbiomics>Sequencing_Services": [
    {
      title: "All Microbiome Analysis Services",
      subtitle: "",
      description:
        "A complete solution for unbiased microbiome profiling with species-level resolution.",
      handle: "/pages/microbiome-analysis-services",
      image_url:
        "https://files.zymoresearch.com/product-images/3_pages_report_example.png",
      searchWeight: 0,
      ribbon: false,
      tags: [],
    },
    {
      title: "16S/ITS Amplicon Sequencing",
      subtitle: "",
      description:
        "Species-level resolution for bacteria and fungi, targeting regions of 16S & ITS.",
      handle: "/pages/16s-its-amplicon-sequencing",
      image_url:
        "https://files.zymoresearch.com/images/responsive_images/medium/available_services_16s_its_amplicon_seq.jpg",
      searchWeight: 0,
      ribbon: false,
      tags: [],
    },
    {
      title: "Full-Length 16S Sequencing",
      subtitle: "",
      description:
        "Unrivaled special level resolution with full-length 16S sequencing.",
      handle: "/pages/full-length-16s-sequencing-service",
      image_url:
        "https://files.zymoresearch.com/images/responsive_images/medium/available_services_full_read_16s.png",
      searchWeight: 0,
      ribbon: false,
      tags: [],
    },
    {
      title: "Shotgun Metagenomic Sequencing",
      subtitle: "",
      description:
        "Multiple kingdom identification & functional profiling with industry-leading sensitivity & precision.",
      handle: "/pages/shotgun-metagenomic-sequencing-service",
      image_url:
        "https://files.zymoresearch.com/images/responsive_images/medium/available_services_shotgun_meta_seq.jpg",
      searchWeight: 0,
      ribbon: false,
      tags: [],
    },
  ],
  "Filter-Microbial_Standards>Mock_Community_(Cellular)": [
    {
      title: "ZymoBIOMICS Microbial Community Standard",
      subtitle: "D6300",
      description:
        "Assess bias and errors in NGS-based microbial composition profiling workflows",
      handle: "/products/zymobiomics-microbial-community-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6300_ZymoBIOMICS-Microbial-Community-Standard.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Microbial Community Standard II (Log Distribution)",
      subtitle: "D6310",
      description:
        "Microbial standard with a log distribution used to assess the performance of microbiomics workflows.",
      handle:
        "/products/zymobiomics-microbial-community-standard-ii-log-distribution",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6310_ZymoBIOMICS-Microbial-Community-Standard-II-Log-Distribution_750-ul.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Gut Microbiome Standard",
      subtitle: "D6331",
      description:
        "The ZymoBIOMICS Gut Microbiome Standard is a mixture of 18 bacterial strains, 2 fungal strains, and 1 archaeal strain in staggered abundances used for gut microbiome/metagenome workflow optimization and as a positive control.",
      handle: "/products/zymobiomics-gut-microbiome-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/d6331_zymobiomics_gut_microbiome_standard-750ul.png",
      searchWeight: 2,
      ribbon: false,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Oral Microbiome Standard",
      subtitle: "D6332",
      description:
        "The ZymoBIOMICS Oral Microbiome Standard is a mixture of 12 bacterial strains in staggered abundances to mimic a true oral microbiome.",
      handle: "/products/zymobiomics-oral-microbiome-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/_d6332_zymobiomics_oral_microbiome_standard.jpg",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Filter-Microbial_Standards>Mock_Community_(DNA)": [
    {
      title: "ZymoBIOMICS Microbial Community DNA Standard",
      subtitle: "D6305, D6306",
      description:
        "Assess bias and errors in NGS-based microbial composition profiling workflows",
      handle: "/products/zymobiomics-microbial-community-dna-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6305_ZymoBIOMICS-Microbial-Community-Standard.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title:
        "ZymoBIOMICS Microbial Community DNA Standard II (Log Distribution)",
      subtitle: "D6311",
      description:
        "DNA standard with a log distribution used to assess the performance of microbiomics workflows.",
      handle:
        "/products/zymobiomics-microbial-community-dna-standard-ii-log-distribution",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/images/D6311_ZymoBIOMICS-Microbial-Community-Standard-II-Log-Distribution_20-ul.jpg",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS HMW DNA Standard",
      subtitle: "D6322",
      description:
        "The ZymoBIOMICS Microbial Community Standards are accurately characterized mock communities consisting of various bacteria and yeast used for microbiome/metagenome workflow optimization and as positive controls.",
      handle: "/products/zymobiomics-hmw-dna-standard",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/d6322-zymobiomics-hmw-dna-standard.png",
      searchWeight: 0,
      ribbon: true,
      tags: [],
    },
  ],
  "Filter-Microbial_Standards>True_Diversity_Reference": [
    {
      title: "ZymoBIOMICS Fecal Reference with TruMatrix Technology",
      subtitle: "D6323",
      description:
        "This reference was made from real human fecal material and was designed to act as a reliable, single point of reference for all microbiome researchers",
      handle: "/products/zymobiomics-fecal-reference-with-trumatrix-technology",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D6323_ZymoBIOMICS-Fecal-Reference-with-TruMatrix.jpg",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Filter-Microbial_Standards>Spike_In_Controls": [
    {
      title: "ZymoBIOMICS Spike-in Control I (High Microbial Load)",
      subtitle: "D6320",
      description:
        "Whole cell spike-in control to assess absolute cell number in microbiome samples.",
      handle: "/products/zymobiomics-spike-in-control-i-high-microbial-load",
      isKit: false,
      image_url: "https://files.zymoresearch.com/images/D6320.png",
      searchWeight: 0,
      tags: [],
    },
    {
      title: "ZymoBIOMICS Spike-in Control II (Low Microbial Load)",
      subtitle: "D6321, D6321-10",
      description:
        "Whole cell spike-in control with log abundance distribution for limit detection and absolute cell quantification of microbial samples.",
      handle: "/products/zymobiomics-spike-in-control-ii-low-microbial-load",
      isKit: false,
      image_url:
        "https://files.zymoresearch.com/product-images/D6321-zymobiomics_spike-in_control_ii.png",
      searchWeight: 0,
      tags: [],
    },
  ],
  "Summer of Sample Prep Collection": [
    {
      "title": "<i>Quick</i>-DNA Miniprep Plus Kit",
      "subtitle": "D4068, D4068T, D4069",
      "description": "Easily purify ultra-pure DNA from cells, tissues, and biological fluids. ",
      "handle": "/products/quick-dna-miniprep-plus-dna-extraction-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4068-Quick-DNA-Miniprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA Miniprep Kit",
      "subtitle": "D4300, D4300T, D4304",
      "description": "Efficient microbial DNA purification for accurate microbiome and metagenomic analysis.",
      "handle": "/products/zymobiomics-dna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial Miniprep Kit",
      "subtitle": "D6005",
      "description": "Rapid isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Miniprep Kit",
      "subtitle": "D6010",
      "description": "Robust purification of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-dna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6010_Quick-DNA-Fecal-Soil-Microbe-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep-96 Yeast Plasmid Miniprep",
      "subtitle": "D2005, D2006, D2007",
      "description": "Fast and simple high-throughput procedure for purifying high quality plasmid DNA from yeast.",
      "handle": "/products/zymoprep-96-yeast-plasmid-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA 96 Kit",
      "subtitle": "D3010, D3011, D3012",
      "description": "Rapid high-throughput purification of DNA from cells and biological fluids.",
      "handle": "/products/quick-dna-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D3010_Quick-DNA-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Viral Kit",
      "subtitle": "D3015, D3016",
      "description": "Quickly isolate high-quality viral DNA from a wide range of biological samples.",
      "handle": "/products/quick-dna-viral-kit",
      "image_url": "https://files.zymoresearch.com/images/D3015_Quick-DNA-Viral-DNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Viral 96 Kit",
      "subtitle": "D3017, D3018",
      "description": "Efficient high-throughput purification of high-quality viral DNA from a wide range of biological samples. ",
      "handle": "/products/quick-dna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D3017_ZR-96-Viral-DNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Microprep Kit",
      "subtitle": "D3020, D3021",
      "description": "Rapid and simple isolation of ultra-pure DNA single cells and low inputs. ",
      "handle": "/products/quick-dna-microprep",
      "image_url": "https://files.zymoresearch.com/product-images/D3020-Quick-DNA-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Miniprep",
      "subtitle": "D3024, D3025",
      "description": "Rapid and simple isolation of ultra-pure DNA from cells and biological fluids",
      "handle": "/products/quick-dna-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA FFPE Miniprep",
      "subtitle": "D3067",
      "description": "Streamlined purificaiton of high-quality DNA from FFPE tissue. ",
      "handle": "/products/quick-dna-ffpe-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D3067_Quick-DNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4001, D4001T, D4002, D4007, D4008",
      "description": "Quickly recover ultra-pure DNA from agarose gels.",
      "handle": "/products/zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4021, D4022",
      "description": "Convenient high-throughput purification of ultra-pure DNA from agarose gels.",
      "handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy-96 Plasmid Kit",
      "subtitle": "D4041, D4042, D4043",
      "description": "High-throughput pellet-free method for purifying ultra-pure plasmid DNA.",
      "handle": "/products/zyppy-96-plasmid-kit",
      "image_url": "https://files.zymoresearch.com/images/D4041_Zyppy-96-Plasmid-Miniprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Large Fragment DNA Recovery",
      "subtitle": "D4045, D4046",
      "description": "Rapid purification of ultra-pure high molecular weight DNA from agarose gels.",
      "handle": "/products/zymoclean-large-fragment-dna-recovery",
      "image_url": "https://files.zymoresearch.com/product-images/D4045-Zymoclean-Large-Fragment-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Oligo Clean & Concentrator",
      "subtitle": "D4060, D4061",
      "description": "Clean and concentrate Oligonucleotides in just 2 minutes.",
      "handle": "/products/oligo-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/product-images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Oligo Clean & Concentrator",
      "subtitle": "D4062, D4063",
      "description": "Streamlined high-throughput method for cleaning-up and concentrating oligonucleotides.",
      "handle": "/products/oligo-clean-concentrator-zr96",
      "image_url": "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
      "subtitle": "D4066, D4067",
      "description": "Simple hight-throughput method for purifying high molecular weight DNA from any enzymatic reaction or impure preparation.",
      "handle": "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
      "image_url": "https://files.zymoresearch.com/images/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA 96 Plus Kit",
      "subtitle": "D4070, D4071",
      "description": "Robust and simple high-throughput purification of ultra-pure DNA from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-96-plus-kit",
      "image_url": "https://files.zymoresearch.com/images/D4071-Quick-DNA-96-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Microprep Plus Kit",
      "subtitle": "D4074",
      "description": "Easily purify ultra-pure DNA from single cells and low inputs of tissues or biological fluids.",
      "handle": "/products/quick-dna-microprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4074-Quick-DNA-Microprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Midiprep Plus Kit",
      "subtitle": "D4075",
      "description": "Easily purify ultra-pure DNA from cells, tissues, and  biological fluids. ",
      "handle": "/products/quick-dna-midiprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4075-Quick-DNA-Midiprep-Plus-Kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      "subtitle": "D4076",
      "description": "Highly efficient isolation of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      "handle": "/products/quick-cfdna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Magbead Plus Kit",
      "subtitle": "D4081, D4082",
      "description": "Automatable DNA isolation from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-magbead-plus-kit",
      "image_url": "https://files.zymoresearch.com/images/D4081_Quick-DNA-Magbead-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "MAGicBead™ cfDNA Isolation Kit",
      "subtitle": "D4086",
      "description": "Novel DNA binding chemistry enabling unparalleled cfDNA extraction performance",
      "handle": "/products/magicbead-cfdna-isolation-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4086_magicbead_cfdna_isolation_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy-96 Plasmid MagBead Miniprep",
      "subtitle": "D4100, D4101, D4102",
      "description": "Automatable pellet-free method for purifying ultra-pure plasmid DNA.",
      "handle": "/products/zyppy-96-plasmid-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA Microprep Kit",
      "subtitle": "D4301, D4305",
      "description": "Efficient microbial DNA purification from low sample inputs for accurate microbiome and metagenomic analysis.",
      "handle": "/products/zymobiomics-dna-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4301_ZymoBIOMICS-DNA-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS 96 MagBead DNA Kit",
      "subtitle": "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
      "description": "Automatable streamlined microbial DNA purification for accurate microbiome and metagenomic analysis. ",
      "handle": "/products/zymobiomics-96-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4302-ZymoBIOMICS-96-MagBead-DNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS 96 DNA Kit",
      "subtitle": "D4303, D4307, D4309",
      "description": "Robust high-throughput DNA purification procedure for accurate microbiome and metagenomic analysis. ",
      "handle": "/products/zymobiomics-96-dna-kit",
      "image_url": "https://files.zymoresearch.com/images/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial 96 Kit",
      "subtitle": "D6006",
      "description": "Simple high-throughput isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D6006_Quick-DNA-Fungal-Bacterial-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial Microprep Kit",
      "subtitle": "D6007",
      "description": "Rapid isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6007_Quick-DNA-Fungal-Bacterial-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Magbead Kit",
      "subtitle": "D6010-FM, D6011-FM, D6012-FM",
      "description": "Automatable isolation of DNA free of PCR inhibitors from feces and soil.",
      "handle": "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
      "image_url": "https://files.zymoresearch.com/images/D6010-FM_Quick-DNA-Fecal-Soil-Microbe_96-Magbead-Lysis-Rack.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Kit",
      "subtitle": "D6011",
      "description": "High-throughput isolation of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D6011_Quick-DNA-Fecal-Soil-Microbe_96-Well.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Microprep",
      "subtitle": "D6012",
      "description": "Robust purification of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-microprep",
      "image_url": "https://files.zymoresearch.com/product-images/D6012_Quick-DNA-Fecal-Soil-Microbe_Microprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Tissue/Insect 96 Kit",
      "subtitle": "D6017",
      "description": "Easily isolate high-quality DNA from tough-to-lyse tissues and insects.",
      "handle": "/products/quick-dna-tissue-insect-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D6017_Quick-DNA-Tissue-Insect-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Plant/Seed Miniprep Kit",
      "subtitle": "D6020",
      "description": "Rapidly isolate DNA free of PCR inhibitors from leaves, stems, buds, flowers, fruit, seeds, and more. ",
      "handle": "/products/quick-dna-plant-seed-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6020_Quick-DNA-Plant-Seed-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Plant/Seed 96 Kit",
      "subtitle": "D6021",
      "description": "High-throughput purification of DNA free of PCR inhibitors from leaves, stems, buds, flowers, fruit, seeds, and more. ",
      "handle": "/products/quick-dna-plant-seed-96-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6021_Quick-DNA Plant Seed 96 Kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA HMW MagBead Kit",
      "subtitle": "D6060",
      "description": "Extract ultra-pure high molecular weight DNA from any sample. ",
      "handle": "/products/quick-dna-hmw-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial Midiprep Kit",
      "subtitle": "D6105",
      "description": "Rapid isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6105_Quick-DNA-Fungal-Bacterial-Midiprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Midiprep Kit",
      "subtitle": "D6110",
      "description": "Robust purification of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-midiprep",
      "image_url": "https://files.zymoresearch.com/product-images/D6110_Quick-DNA-Fecal-Soil-Microbe_Midiprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Miniprep",
      "subtitle": "D7001",
      "description": "Quickly and easily isolate DNA and RNA from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-rna-miniprep",
      "image_url": "https://files.zymoresearch.com/product-images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Miniprep Plus Kit",
      "subtitle": "D7003, D7003T",
      "description": "Extract ultra-pure DNA and RNA from any sample.",
      "handle": "/products/quick-dna-rna-miniprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7003_ZR-Duet-DNA-RNA-MiniPrep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Microprep Plus Kit",
      "subtitle": "D7005, D7005T",
      "description": "Extract ultra-pure DNA and RNA from any sample.",
      "handle": "/products/quick-dna-rna-microprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7005_Quick-DNA-RNA-Microprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ssDNA/RNA Clean & Concentrator",
      "subtitle": "D7010, D7011",
      "description": "Clean and concentrate single stranded DNA or RNA with a simple spin-column protocol. ",
      "handle": "/products/ssdna-rna-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral Kit",
      "subtitle": "D7020, D7021",
      "description": "Quickly recover ultra-pure DNA and RNA from plasma, serum, and other sample types.",
      "handle": "/products/quick-dna-rna-viral-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      "subtitle": "D7022, D7023",
      "description": "Rapid high-throughput purification of viral DNA and RNA from a wide range of biological sources. ",
      "handle": "/products/quick-dna-rna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      "subtitle": "R1009",
      "description": "Simple and consistent isolation of DNA and RNA from the same FFPE tissue sample.",
      "handle": "/products/quick-dna-rna-ffpe-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Pathogen Miniprep",
      "subtitle": "R1042, R1043",
      "description": "Streamlined purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      "handle": "/products/quick-dna-rna-pathogen-miniprep",
      "image_url": "https://files.zymoresearch.com/product-images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      "subtitle": "R1072",
      "description": "Isolate cfDNa and cfDNA efficiently and easily from biological fluids",
      "handle": "/products/quick-cfdna-rna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Blood Tube Kit",
      "subtitle": "R1151",
      "description": "Convenient isolation of ultra-pure DNA and RNA from blood collected using the DNA/RNA Shield - Blood Tube",
      "handle": "/products/quick-dna-rna-blood-tube-kit",
      "image_url": "https://files.zymoresearch.com/images/r1151_quick-dna-rna-blood-tube-kit_1.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
      "subtitle": "R2002",
      "description": "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      "handle": "/products/zymobiomics-dna-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA MagBead",
      "subtitle": "R2130, R2131",
      "description": "Automatable isolation of DNA and RNA from any sample type.",
      "handle": "/products/quick-dna-rna-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS MagBead DNA/RNA",
      "subtitle": "R2135, R2136",
      "description": "Automatable microbial DNA and RNA purification for accurate metagenomic and metatranscriptomic analysis. ",
      "handle": "/products/zymobiomics-magbead-dna-rna",
      "image_url": "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral MagBead",
      "subtitle": "R2140, R2140-E, R2141, R2141-E",
      "description": "Automatable purification of ultra-pure viral DNA and RNA from all biological fluids.",
      "handle": "/products/quick-dna-rna-viral-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Load N’ Go DNA/RNA Viral Kit",
      "subtitle": "R2143",
      "description": "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      "handle": "/products/load-n-go-dna-rna-viral-kit",
      "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      "subtitle": "R2145, R2146",
      "description": "Automatable pathagen DNA and RNA isolation from vectors, tissues, and other biological sample types. ",
      "handle": "/products/quick-dna-rna-pathogen-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4012",
      "description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4012_DNA-Clean-%26-Concentrator-Magbead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-5",
      "subtitle": "D4003, D4003T, D4004, D4013, D4014",
      "description": "Purify up to 5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources in just 2 minutes.",
      "handle": "/products/dna-clean-concentrator-5",
      "image_url": "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-25",
      "subtitle": "D4005, D4006, D4033, D4034",
      "description": "Purify up to 25 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources in just 2 minutes. ",
      "handle": "/products/dna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/D4005_DNA-Clean-and-Concentrator-25-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Genomic DNA Clean & Concentrator-10",
      "subtitle": "D4010, D4011",
      "description": "Quickly purify up to 10 µg of high molecular weight DNA from any enzymatic reaction or impure preparation. ",
      "handle": "/products/genomic-dna-clean-concentrator-10",
      "image_url": "https://files.zymoresearch.com/product-images/D4010_Genomic-DNA-Clean-and-Concentrator-10.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 DNA Clean-Up Kit",
      "subtitle": "D4017, D4018",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-up-kit",
      "image_url": "https://files.zymoresearch.com/images/D4017_ZR-96-DNA-Clean-up-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
      "subtitle": "D4023, D4024",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
      "image_url": "https://files.zymoresearch.com/product-images/D4023-ZR-96-DNA-Clean-_-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-100",
      "subtitle": "D4029, D4030",
      "description": "Quickly purify up to 100 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-100",
      "image_url": "https://files.zymoresearch.com/product-images/D4029_DNA-Clean-and-Concentrator-100-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-500",
      "subtitle": "D4031, D4032",
      "description": "Quickly purify up to 500 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-500",
      "image_url": "https://files.zymoresearch.com/product-images/D4031-DNA-Clean-_-Concentrator--500.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Genomic DNA Clean & Concentrator-25",
      "subtitle": "D4064, D4065",
      "description": "Quickly purify up to 25 µg of high molecular weight DNA from any enzymatic reaction or impure preparation. ",
      "handle": "/products/genomic-dna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/D4064_Genomic-DNA-Clean-and-Concentrator-25.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Select-a-Size DNA Clean & Concentrator Kit",
      "subtitle": "D4080",
      "description": "Easily purify a specific range of DNA fragment sizes from library preps, PCR, ligations and other sources using a spin-column.",
      "handle": "/products/select-a-size-dna-clean-concentrator-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Select-a-Size DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4084, D4085",
      "description": "Consistently purify a specific range of DNA fragment sizes from library preps, PCR, ligations and other sources using magnetic beads. ",
      "handle": "/products/select-a-size-dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/images/D4084_Select-A-Size-DNA-Clean-and-Concentrator-MagBead-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol RNA Miniprep Kits",
      "subtitle": "R2050, R2051, R2052, R2053",
      "description": "Isolate RNA from Trizol in 7 minutes using a simple spin-column protocol.",
      "handle": "/products/direct-zol-rna-miniprep-kits",
      "image_url": "https://files.zymoresearch.com/product-images/R2050-Directzol-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Miniprep Plus Kit",
      "subtitle": "R1057, R1057T, R1058",
      "description": "RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      "handle": "/products/quick-rna-miniprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1057-Quick-RNA-Miniprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "YeaStar RNA Kit",
      "subtitle": "R1002",
      "description": "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      "handle": "/products/yeastar-rna-kit",
      "image_url": "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Pinpoint Slide RNA Isolation System",
      "subtitle": "R1003, R1007",
      "description": "Efficient purification of high-quality RNA from tissue sections on slides. ",
      "handle": "/products/pinpoint-slide-rna-isolation-system",
      "image_url": "https://files.zymoresearch.com/images/R1003_Pinpoint-Slide-RNA-Isolation-System-I-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA FFPE Miniprep",
      "subtitle": "R1008",
      "description": "Isolate RNA and small/miRNA from FFPE tissue.",
      "handle": "/products/quick-rna-ffpe-miniprep",
      "image_url": "https://files.zymoresearch.com/images/R1008_Quick-RNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Viral Kit",
      "subtitle": "R1034, R1034-E, R1035, R1035-E",
      "description": "Viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      "handle": "/products/quick-rna-viral-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR Urine RNA Isolation Kit",
      "subtitle": "R1038, R1039",
      "description": "Isolate RNA from up to 30 ml of urine.",
      "handle": "/products/zr-urine-rna-isolation-kit",
      "image_url": "https://files.zymoresearch.com/images/R1038_ZR-Urine-RNA-Isolation-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Viral 96 Kit",
      "subtitle": "R1040, R1040-E, R1041, R1041-E",
      "description": "Isolate ultra-pure viral RNA from all biological fluids.",
      "handle": "/products/quick-rna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/R1040_Quick-RNA-Viral-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Microprep Kit",
      "subtitle": "R1050, R1051",
      "description": "RNA from single cell and low inputs. NGS-ready and concentrated in 6 &micro;l.",
      "handle": "/products/quick-rna-microprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1050_Quick-RNA-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA 96 Kit",
      "subtitle": "R1052, R1053",
      "description": "High-throughput purification of  total RNA and small/miRNA from cells and soft tissue.",
      "handle": "/products/quick-rna-96-kit",
      "image_url": "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Miniprep Kit",
      "subtitle": "R1054, R1055",
      "description": "Easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      "handle": "/products/quick-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Midiprep Kit",
      "subtitle": "R1056",
      "description": "Rapid isolation of up to 1 mg of total RNA from cells and tissues.",
      "handle": "/products/quick-rna-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1056_Quick-RNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfRNA Serum & Plasma Kit",
      "subtitle": "R1059",
      "description": "Isolate cell-free RNA from biological fluid samples.",
      "handle": "/products/quick-cfrna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1059_Quick-cfRNA-Serum-Plasma-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Whole Blood",
      "subtitle": "R1201",
      "description": "Isolate RNA and small/miRNA from whole blood.",
      "handle": "/products/quick-rna-whole-blood",
      "image_url": "https://files.zymoresearch.com/images/R1201_Quick-RNA-Whole-Blood-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS RNA Miniprep Kit",
      "subtitle": "R2001",
      "description": "Purification of microbial RNA for microbiome or metagenome analyses",
      "handle": "/products/zymobiomics-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Fungal/Bacterial Microprep Kit",
      "subtitle": "R2010",
      "description": "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-rna-fungal-bacterial-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Fungal/Bacterial Miniprep Kit",
      "subtitle": "R2014",
      "description": "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-rna-fungal-bacterial-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2014_Quick-RNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Plant Kit",
      "subtitle": "R2024",
      "description": "Isolate inhibitor-free RNA from plant and seed samples.",
      "handle": "/products/quick-rna-plant-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2024_Quick-RNA-Plant-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Tissue/Insect Kit",
      "subtitle": "R2030",
      "description": "Isolate RNA from tough-to-lyse tissue and insects.",
      "handle": "/products/quick-rna-tissue-insect-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2030_Quick-RNA-Tissue-Insect-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
      "subtitle": "R2040",
      "description": "The Quick-RNA Fecal/Soil Microbe Microprep Kit is an affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
      "handle": "/products/quick-rna-fecal-soil-microbe-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2040_Quick-RNA-Fecal-Soil-Microbe-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol-96 RNA Kits",
      "subtitle": "R2054, R2055, R2056, R2057",
      "description": "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      "handle": "/products/direct-zol-96-rna-kits",
      "image_url": "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol RNA Microprep Kits",
      "subtitle": "R2060, R2061, R2062, R2063",
      "description": "RNA from single cell and low inputs in TRIzol. NGS-ready and concentrated in 6 &micro;l",
      "handle": "/products/direct-zol-rna-microprep-kits",
      "image_url": "https://files.zymoresearch.com/images/R2060-Directzol-RNA-Microprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol RNA Miniprep Plus Kits",
      "subtitle": "R2070, R2070T, R2071, R2072, R2073",
      "description": "A streamlined method for the purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRI Reagent or similar.",
      "handle": "/products/direct-zol-rna-miniprep-plus-kits",
      "image_url": "https://files.zymoresearch.com/product-images/R2070-Directzol-RNA-Miniprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol-96 MagBead RNA",
      "subtitle": "R2100, R2101, R2102, R2103",
      "description": "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      "handle": "/products/direct-zol-96-magbead-rna",
      "image_url": "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA MagBead",
      "subtitle": "R2132, R2133",
      "description": "High-throughput, magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
      "handle": "/products/quick-rna-magbead",
      "image_url": "https://files.zymoresearch.com/product-images/r2132_quick-rna-magbead-kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS MagBead RNA",
      "subtitle": "R2137, R2138",
      "description": "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
      "handle": "/products/zymobiomics-magbead-rna",
      "image_url": "https://files.zymoresearch.com/product-images/r2137_zymobiomics-magbead-rna-kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-5",
      "subtitle": "R1013, R1014, R1015, R1016",
      "description": "Simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-5",
      "image_url": "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Gel RNA Recovery Kit",
      "subtitle": "R1011",
      "description": "Quickly recover ultra-pure RNA from agarose gels.",
      "handle": "/products/zymoclean-gel-rna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/R1011_Zymoclean-Gel-RNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-25",
      "subtitle": "R1017, R1018",
      "description": "Simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/R1017_RNA-Clean-&-Concentrator-25.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-100",
      "subtitle": "R1019",
      "description": "Simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-100",
      "image_url": "https://files.zymoresearch.com/product-images/R1019_RNA-Clean-&-Concentrator-100.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR small-RNA  PAGE Recovery Kit",
      "subtitle": "R1070",
      "description": "The ZR small-RNA PAGE Recovery Kit provides an easy and efficient method for the extraction of high quality small RNAs from polyacrylamide gels (native and/or denatured)",
      "handle": "/products/zr-small-rna-page-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/R1070_ZR-small-RNA-PAGE-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-96",
      "subtitle": "R1080",
      "description": "Quick high-throughput method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-96",
      "image_url": "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator MagBead",
      "subtitle": "R1081, R1082",
      "description": "Streamlined automatable procedure for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-magbead",
      "image_url": "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE II Plasmid Midiprep Kit",
      "subtitle": "D4200, D4201",
      "description": "Purify endotoxin-free plasmid DNA in less than 18 minutes.",
      "handle": "/products/zymopure-ii-plasmid-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE II Plasmid Maxiprep Kit",
      "subtitle": "D4202, D4203",
      "description": "Purify endotoxin-free plasmid DNA in less than 18 minutes.",
      "handle": "/products/zymopure-ii-plasmid-maxiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE Plasmid Miniprep Kit",
      "subtitle": "D4208T, D4209, D4210, D4211, D4212",
      "description": "Purify ultra-pure transfection-grade plasmid DNA using a spin-column miniprep.",
      "handle": "/products/zymopure-ii-plasmid-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep Yeast Plasmid Miniprep I",
      "subtitle": "D2001",
      "description": "Simple precipitation based solution for yeast plasmid DNA isolation using Zymolyase",
      "handle": "/products/zymoprep-yeast-plasmid-miniprep-i",
      "image_url": "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep Yeast Plasmid Miniprep II",
      "subtitle": "D2004",
      "description": "Simple spin-column solution for yeast plasmid DNA isolation using Zymolyase",
      "handle": "/products/zymoprep-yeast-plasmid-miniprep-ii",
      "image_url": "https://files.zymoresearch.com/images/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy Plasmid Miniprep Kit",
      "subtitle": "D4019, D4020, D4036, D4037",
      "description": "Pellet-free, high-quality plasmid DNA in only 8 minutes.",
      "handle": "/products/zyppy-plasmid-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR BAC DNA Miniprep Kit",
      "subtitle": "D4048, D4049",
      "description": "Quickly isolate large constructs (≤200 kb) from E. coli using a spin-column",
      "handle": "/products/zr-bac-dna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE II Plasmid Gigaprep Kit",
      "subtitle": "D4204",
      "description": "Rapidly purify endotoxin-free plasmid DNA from up to 2.5 Liters of E. coli culture.",
      "handle": "/products/zymopure-ii-plasmid-gigaprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit-2.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE - Express Plasmid Midiprep Kit",
      "subtitle": "D4213",
      "description": "Simple pellet-free method for purifying transfection-grade plasmid DNA.",
      "handle": "/products/zymopure-express-plasmid-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4213_ZymoPURE%20Express%20Plasmid%20Midiprep%20Kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Fecal Collection Tube",
      "subtitle": "R1101, R1137",
      "description": "Collect & preserve nucleic acids from stool specimens at ambient temperatures.",
      "handle": "/products/dna-rna-shield-fecal-collection-tube",
      "image_url": "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield SafeCollect Swab Collection Kit",
      "subtitle": "R1160, R1160-E, R1161-E, R1161",
      "description": "User friendly device for collecting and preserving nucleic acids from a variety of sample types at ambient temperatures using swabs.",
      "handle": "/products/dna-rna-shield-safecollect-swab-collection-kit",
      "image_url": "https://files.zymoresearch.com/product-images/r1160-dna_rna_shield_safecollect_swab_collection_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield",
      "subtitle": "R1100-50, R1100-250, R1200-25, R1200-125",
      "description": "Novel sample transport medium that preserves DNA and RNA in any sample at ambient temperatures. ",
      "handle": "/products/dna-rna-shield",
      "image_url": "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield SafeCollect Saliva Collection Kit",
      "subtitle": "R1211, R1211-E",
      "description": "User friendly device for collecting and preserving nucleic acids from saliva and sputum samples at ambient temperatures. ",
      "handle": "/products/dna-rna-shield-safecollect-saliva-collection-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1211-dna_rna_shield_safecollect_saliva_collection_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Collection Tube w/ Swab",
      "subtitle": "R1106, R1107, R1108, R1109",
      "description": "Complete solution for collecting and preserving nucleic acids from a variety of sample types at ambient temperatures using swabs.",
      "handle": "/products/dna-rna-shield-collection-tube-w-swab",
      "image_url": "https://files.zymoresearch.com/images/R1106_DNA-RNA-Shield-Swab-Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Blood Collection Tube",
      "subtitle": "R1150",
      "description": "Ready-to-use tubes for collecting and preserving DNA and RNA in whole blood at ambient temperatures. ",
      "handle": "/products/dna-rna-shield-blood-collection-tube",
      "image_url": "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Fecal Collection Tube - DX",
      "subtitle": "R1101-E",
      "description": "Specimen receptacle medical device for collecting and preserving nucleic acids from feces for molecular-based in vitro diagnostic",
      "handle": "/products/dna-rna-shield-fecal-collection-tube-dx",
      "image_url": "https://files.zymoresearch.com/product-images/R1101_DNA+RNA+Shield+Fecal+Collection+Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Bunny Wipe Fecal Sample Collector",
      "subtitle": "R1133-1, R1133-10, R1138",
      "description": "Collect stool samples easily and cleanly with a wipe in the privacy of your own bathroom",
      "handle": "/products/bunny-wipe-fecal-sample-collector",
      "image_url": "https://files.zymoresearch.com/product-images/R1133_bunny_wipe_fecal_sample_collector.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Lysis & Collection Tubes",
      "subtitle": "R1102, R1103, R1104, R1105",
      "description": "All-in-one tube for the collection, preservation, and homogenization of a variety of sample types for DNA and RNA purificaiton. ",
      "handle": "/products/dna-rna-shield-lysis-and-collection-tubes",
      "image_url": "https://files.zymoresearch.com/images/R1103-DNA-RNA-Shield-Lysis-Tube-(Microbe).jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Urine Conditioning Buffer",
      "subtitle": "D3061-1-8, D3061-1-140",
      "description": "Effective preservation of DNA and RNA in urine at ambient temperatures.",
      "handle": "/products/urine-conditioning-buffer",
      "image_url": "https://files.zymoresearch.com/images/D3061-1-140-UCB-Bottle-140ml.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield DirectDetect",
      "subtitle": "R1400, R1400-E, R1401-1, R1401-1-E",
      "description": "Uniquely formulated nucleic acid preservation reagent that allows users to go from sample collection directly to PCR",
      "handle": "/products/dna-rna-shield-directdetect",
      "image_url": "https://files.zymoresearch.com/product-images/R1400-dna_rna_shield_directdetect_reagent.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    }
  ],
  "Filter-Summer-of-Sample-Prep-Collection>All": [
    {
      "title": "<i>Quick</i>-DNA Miniprep Plus Kit",
      "subtitle": "D4068, D4068T, D4069",
      "description": "Easily purify ultra-pure DNA from cells, tissues, and biological fluids. ",
      "handle": "/products/quick-dna-miniprep-plus-dna-extraction-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4068-Quick-DNA-Miniprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA Miniprep Kit",
      "subtitle": "D4300, D4300T, D4304",
      "description": "Efficient microbial DNA purification for accurate microbiome and metagenomic analysis.",
      "handle": "/products/zymobiomics-dna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial Miniprep Kit",
      "subtitle": "D6005",
      "description": "Rapid isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Miniprep Kit",
      "subtitle": "D6010",
      "description": "Robust purification of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-dna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6010_Quick-DNA-Fecal-Soil-Microbe-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep-96 Yeast Plasmid Miniprep",
      "subtitle": "D2005, D2006, D2007",
      "description": "Fast and simple high-throughput procedure for purifying high quality plasmid DNA from yeast.",
      "handle": "/products/zymoprep-96-yeast-plasmid-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA 96 Kit",
      "subtitle": "D3010, D3011, D3012",
      "description": "Rapid high-throughput purification of DNA from cells and biological fluids.",
      "handle": "/products/quick-dna-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D3010_Quick-DNA-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Viral Kit",
      "subtitle": "D3015, D3016",
      "description": "Quickly isolate high-quality viral DNA from a wide range of biological samples.",
      "handle": "/products/quick-dna-viral-kit",
      "image_url": "https://files.zymoresearch.com/images/D3015_Quick-DNA-Viral-DNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Viral 96 Kit",
      "subtitle": "D3017, D3018",
      "description": "Efficient high-throughput purification of high-quality viral DNA from a wide range of biological samples. ",
      "handle": "/products/quick-dna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D3017_ZR-96-Viral-DNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Microprep Kit",
      "subtitle": "D3020, D3021",
      "description": "Rapid and simple isolation of ultra-pure DNA single cells and low inputs. ",
      "handle": "/products/quick-dna-microprep",
      "image_url": "https://files.zymoresearch.com/product-images/D3020-Quick-DNA-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Miniprep",
      "subtitle": "D3024, D3025",
      "description": "Rapid and simple isolation of ultra-pure DNA from cells and biological fluids",
      "handle": "/products/quick-dna-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA FFPE Miniprep",
      "subtitle": "D3067",
      "description": "Streamlined purificaiton of high-quality DNA from FFPE tissue. ",
      "handle": "/products/quick-dna-ffpe-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D3067_Quick-DNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4001, D4001T, D4002, D4007, D4008",
      "description": "Quickly recover ultra-pure DNA from agarose gels.",
      "handle": "/products/zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4021, D4022",
      "description": "Convenient high-throughput purification of ultra-pure DNA from agarose gels.",
      "handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy-96 Plasmid Kit",
      "subtitle": "D4041, D4042, D4043",
      "description": "High-throughput pellet-free method for purifying ultra-pure plasmid DNA.",
      "handle": "/products/zyppy-96-plasmid-kit",
      "image_url": "https://files.zymoresearch.com/images/D4041_Zyppy-96-Plasmid-Miniprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Large Fragment DNA Recovery",
      "subtitle": "D4045, D4046",
      "description": "Rapid purification of ultra-pure high molecular weight DNA from agarose gels.",
      "handle": "/products/zymoclean-large-fragment-dna-recovery",
      "image_url": "https://files.zymoresearch.com/product-images/D4045-Zymoclean-Large-Fragment-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Oligo Clean & Concentrator",
      "subtitle": "D4060, D4061",
      "description": "Clean and concentrate Oligonucleotides in just 2 minutes.",
      "handle": "/products/oligo-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/product-images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Oligo Clean & Concentrator",
      "subtitle": "D4062, D4063",
      "description": "Streamlined high-throughput method for cleaning-up and concentrating oligonucleotides.",
      "handle": "/products/oligo-clean-concentrator-zr96",
      "image_url": "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
      "subtitle": "D4066, D4067",
      "description": "Simple hight-throughput method for purifying high molecular weight DNA from any enzymatic reaction or impure preparation.",
      "handle": "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
      "image_url": "https://files.zymoresearch.com/images/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA  96 Plus Kit",
      "subtitle": "D4070, D4071",
      "description": "Robust and simple high-throughput purification of ultra-pure DNA from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-96-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4070_Quick-DNA-96-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Microprep Plus Kit",
      "subtitle": "D4074",
      "description": "Easily purify ultra-pure DNA from single cells and low inputs of tissues or biological fluids.",
      "handle": "/products/quick-dna-microprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4074-Quick-DNA-Microprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Midiprep Plus Kit",
      "subtitle": "D4075",
      "description": "Easily purify ultra-pure DNA from cells, tissues, and  biological fluids. ",
      "handle": "/products/quick-dna-midiprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4075-Quick-DNA-Midiprep-Plus-Kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      "subtitle": "D4076",
      "description": "Highly efficient isolation of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      "handle": "/products/quick-cfdna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Magbead Plus Kit",
      "subtitle": "D4081, D4082",
      "description": "Automatable DNA isolation from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-magbead-plus-kit",
      "image_url": "https://files.zymoresearch.com/images/D4081_Quick-DNA-Magbead-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "MAGicBead™ cfDNA Isolation Kit",
      "subtitle": "D4086",
      "description": "Novel DNA binding chemistry enabling unparalleled cfDNA extraction performance",
      "handle": "/products/magicbead-cfdna-isolation-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4086_magicbead_cfdna_isolation_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy-96 Plasmid MagBead Miniprep",
      "subtitle": "D4100, D4101, D4102",
      "description": "Automatable pellet-free method for purifying ultra-pure plasmid DNA.",
      "handle": "/products/zyppy-96-plasmid-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA Microprep Kit",
      "subtitle": "D4301, D4305",
      "description": "Efficient microbial DNA purification from low sample inputs for accurate microbiome and metagenomic analysis.",
      "handle": "/products/zymobiomics-dna-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4301_ZymoBIOMICS-DNA-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS 96 MagBead DNA Kit",
      "subtitle": "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
      "description": "Automatable streamlined microbial DNA purification for accurate microbiome and metagenomic analysis. ",
      "handle": "/products/zymobiomics-96-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4302-ZymoBIOMICS-96-MagBead-DNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS 96 DNA Kit",
      "subtitle": "D4303, D4307, D4309",
      "description": "Robust high-throughput DNA purification procedure for accurate microbiome and metagenomic analysis. ",
      "handle": "/products/zymobiomics-96-dna-kit",
      "image_url": "https://files.zymoresearch.com/images/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial 96 Kit",
      "subtitle": "D6006",
      "description": "Simple high-throughput isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D6006_Quick-DNA-Fungal-Bacterial-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial Microprep Kit",
      "subtitle": "D6007",
      "description": "Rapid isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6007_Quick-DNA-Fungal-Bacterial-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Magbead Kit",
      "subtitle": "D6010-FM, D6011-FM, D6012-FM",
      "description": "Automatable isolation of DNA free of PCR inhibitors from feces and soil.",
      "handle": "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
      "image_url": "https://files.zymoresearch.com/images/D6010-FM_Quick-DNA-Fecal-Soil-Microbe_96-Magbead-Lysis-Rack.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Kit",
      "subtitle": "D6011",
      "description": "High-throughput isolation of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D6011_Quick-DNA-Fecal-Soil-Microbe_96-Well.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Microprep",
      "subtitle": "D6012",
      "description": "Robust purification of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-microprep",
      "image_url": "https://files.zymoresearch.com/product-images/D6012_Quick-DNA-Fecal-Soil-Microbe_Microprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Tissue/Insect 96 Kit",
      "subtitle": "D6017",
      "description": "Easily isolate high-quality DNA from tough-to-lyse tissues and insects.",
      "handle": "/products/quick-dna-tissue-insect-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D6017_Quick-DNA-Tissue-Insect-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Plant/Seed Miniprep Kit",
      "subtitle": "D6020",
      "description": "Rapidly isolate DNA free of PCR inhibitors from leaves, stems, buds, flowers, fruit, seeds, and more. ",
      "handle": "/products/quick-dna-plant-seed-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6020_Quick-DNA-Plant-Seed-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Plant/Seed 96 Kit",
      "subtitle": "D6021",
      "description": "High-throughput purification of DNA free of PCR inhibitors from leaves, stems, buds, flowers, fruit, seeds, and more. ",
      "handle": "/products/quick-dna-plant-seed-96-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6021_Quick-DNA Plant Seed 96 Kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA HMW MagBead Kit",
      "subtitle": "D6060",
      "description": "Extract ultra-pure high molecular weight DNA from any sample. ",
      "handle": "/products/quick-dna-hmw-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial Midiprep Kit",
      "subtitle": "D6105",
      "description": "Rapid isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6105_Quick-DNA-Fungal-Bacterial-Midiprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Midiprep Kit",
      "subtitle": "D6110",
      "description": "Robust purification of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-midiprep",
      "image_url": "https://files.zymoresearch.com/product-images/D6110_Quick-DNA-Fecal-Soil-Microbe_Midiprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Miniprep",
      "subtitle": "D7001",
      "description": "Quickly and easily isolate DNA and RNA from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-rna-miniprep",
      "image_url": "https://files.zymoresearch.com/product-images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Miniprep Plus Kit",
      "subtitle": "D7003, D7003T",
      "description": "Extract ultra-pure DNA and RNA from any sample.",
      "handle": "/products/quick-dna-rna-miniprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7003_ZR-Duet-DNA-RNA-MiniPrep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Microprep Plus Kit",
      "subtitle": "D7005, D7005T",
      "description": "Extract ultra-pure DNA and RNA from any sample.",
      "handle": "/products/quick-dna-rna-microprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7005_Quick-DNA-RNA-Microprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ssDNA/RNA Clean & Concentrator",
      "subtitle": "D7010, D7011",
      "description": "Clean and concentrate single stranded DNA or RNA with a simple spin-column protocol. ",
      "handle": "/products/ssdna-rna-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral Kit",
      "subtitle": "D7020, D7021",
      "description": "Quickly recover ultra-pure DNA and RNA from plasma, serum, and other sample types.",
      "handle": "/products/quick-dna-rna-viral-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      "subtitle": "D7022, D7023",
      "description": "Rapid high-throughput purification of viral DNA and RNA from a wide range of biological sources. ",
      "handle": "/products/quick-dna-rna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      "subtitle": "R1009",
      "description": "Simple and consistent isolation of DNA and RNA from the same FFPE tissue sample.",
      "handle": "/products/quick-dna-rna-ffpe-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Pathogen Miniprep",
      "subtitle": "R1042, R1043",
      "description": "Streamlined purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      "handle": "/products/quick-dna-rna-pathogen-miniprep",
      "image_url": "https://files.zymoresearch.com/product-images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      "subtitle": "R1072",
      "description": "Isolate cfDNa and cfDNA efficiently and easily from biological fluids",
      "handle": "/products/quick-cfdna-rna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Blood Tube Kit",
      "subtitle": "R1151",
      "description": "Convenient isolation of ultra-pure DNA and RNA from blood collected using the DNA/RNA Shield - Blood Tube",
      "handle": "/products/quick-dna-rna-blood-tube-kit",
      "image_url": "https://files.zymoresearch.com/images/r1151_quick-dna-rna-blood-tube-kit_1.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
      "subtitle": "R2002",
      "description": "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      "handle": "/products/zymobiomics-dna-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA MagBead",
      "subtitle": "R2130, R2131",
      "description": "Automatable isolation of DNA and RNA from any sample type.",
      "handle": "/products/quick-dna-rna-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS MagBead DNA/RNA",
      "subtitle": "R2135, R2136",
      "description": "Automatable microbial DNA and RNA purification for accurate metagenomic and metatranscriptomic analysis. ",
      "handle": "/products/zymobiomics-magbead-dna-rna",
      "image_url": "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral MagBead",
      "subtitle": "R2140, R2140-E, R2141, R2141-E",
      "description": "Automatable purification of ultra-pure viral DNA and RNA from all biological fluids.",
      "handle": "/products/quick-dna-rna-viral-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Load N’ Go DNA/RNA Viral Kit",
      "subtitle": "R2143",
      "description": "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      "handle": "/products/load-n-go-dna-rna-viral-kit",
      "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      "subtitle": "R2145, R2146",
      "description": "Automatable pathagen DNA and RNA isolation from vectors, tissues, and other biological sample types. ",
      "handle": "/products/quick-dna-rna-pathogen-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4012",
      "description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4012_DNA-Clean-%26-Concentrator-Magbead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-5",
      "subtitle": "D4003, D4003T, D4004, D4013, D4014",
      "description": "Purify up to 5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources in just 2 minutes.",
      "handle": "/products/dna-clean-concentrator-5",
      "image_url": "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-25",
      "subtitle": "D4005, D4006, D4033, D4034",
      "description": "Purify up to 25 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources in just 2 minutes. ",
      "handle": "/products/dna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/D4005_DNA-Clean-and-Concentrator-25-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Genomic DNA Clean & Concentrator-10",
      "subtitle": "D4010, D4011",
      "description": "Quickly purify up to 10 µg of high molecular weight DNA from any enzymatic reaction or impure preparation. ",
      "handle": "/products/genomic-dna-clean-concentrator-10",
      "image_url": "https://files.zymoresearch.com/product-images/D4010_Genomic-DNA-Clean-and-Concentrator-10.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 DNA Clean-Up Kit",
      "subtitle": "D4017, D4018",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-up-kit",
      "image_url": "https://files.zymoresearch.com/images/D4017_ZR-96-DNA-Clean-up-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
      "subtitle": "D4023, D4024",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
      "image_url": "https://files.zymoresearch.com/product-images/D4023-ZR-96-DNA-Clean-_-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-100",
      "subtitle": "D4029, D4030",
      "description": "Quickly purify up to 100 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-100",
      "image_url": "https://files.zymoresearch.com/product-images/D4029_DNA-Clean-and-Concentrator-100-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-500",
      "subtitle": "D4031, D4032",
      "description": "Quickly purify up to 500 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-500",
      "image_url": "https://files.zymoresearch.com/product-images/D4031-DNA-Clean-_-Concentrator--500.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Genomic DNA Clean & Concentrator-25",
      "subtitle": "D4064, D4065",
      "description": "Quickly purify up to 25 µg of high molecular weight DNA from any enzymatic reaction or impure preparation. ",
      "handle": "/products/genomic-dna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/D4064_Genomic-DNA-Clean-and-Concentrator-25.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Select-a-Size DNA Clean & Concentrator Kit",
      "subtitle": "D4080",
      "description": "Easily purify a specific range of DNA fragment sizes from library preps, PCR, ligations and other sources using a spin-column.",
      "handle": "/products/select-a-size-dna-clean-concentrator-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Select-a-Size DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4084, D4085",
      "description": "Consistently purify a specific range of DNA fragment sizes from library preps, PCR, ligations and other sources using magnetic beads. ",
      "handle": "/products/select-a-size-dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/images/D4084_Select-A-Size-DNA-Clean-and-Concentrator-MagBead-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol RNA Miniprep Kits",
      "subtitle": "R2050, R2051, R2052, R2053",
      "description": "Isolate RNA from Trizol in 7 minutes using a simple spin-column protocol.",
      "handle": "/products/direct-zol-rna-miniprep-kits",
      "image_url": "https://files.zymoresearch.com/product-images/R2050-Directzol-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Miniprep Plus Kit",
      "subtitle": "R1057, R1057T, R1058",
      "description": "RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      "handle": "/products/quick-rna-miniprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1057-Quick-RNA-Miniprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "YeaStar RNA Kit",
      "subtitle": "R1002",
      "description": "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      "handle": "/products/yeastar-rna-kit",
      "image_url": "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Pinpoint Slide RNA Isolation System",
      "subtitle": "R1003, R1007",
      "description": "Efficient purification of high-quality RNA from tissue sections on slides. ",
      "handle": "/products/pinpoint-slide-rna-isolation-system",
      "image_url": "https://files.zymoresearch.com/images/R1003_Pinpoint-Slide-RNA-Isolation-System-I-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA FFPE Miniprep",
      "subtitle": "R1008",
      "description": "Isolate RNA and small/miRNA from FFPE tissue.",
      "handle": "/products/quick-rna-ffpe-miniprep",
      "image_url": "https://files.zymoresearch.com/images/R1008_Quick-RNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Viral Kit",
      "subtitle": "R1034, R1034-E, R1035, R1035-E",
      "description": "Viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      "handle": "/products/quick-rna-viral-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR Urine RNA Isolation Kit",
      "subtitle": "R1038, R1039",
      "description": "Isolate RNA from up to 30 ml of urine.",
      "handle": "/products/zr-urine-rna-isolation-kit",
      "image_url": "https://files.zymoresearch.com/images/R1038_ZR-Urine-RNA-Isolation-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Viral 96 Kit",
      "subtitle": "R1040, R1040-E, R1041, R1041-E",
      "description": "Isolate ultra-pure viral RNA from all biological fluids.",
      "handle": "/products/quick-rna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/R1040_Quick-RNA-Viral-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Microprep Kit",
      "subtitle": "R1050, R1051",
      "description": "RNA from single cell and low inputs. NGS-ready and concentrated in 6 &micro;l.",
      "handle": "/products/quick-rna-microprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1050_Quick-RNA-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA 96 Kit",
      "subtitle": "R1052, R1053",
      "description": "High-throughput purification of  total RNA and small/miRNA from cells and soft tissue.",
      "handle": "/products/quick-rna-96-kit",
      "image_url": "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Miniprep Kit",
      "subtitle": "R1054, R1055",
      "description": "Easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      "handle": "/products/quick-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Midiprep Kit",
      "subtitle": "R1056",
      "description": "Rapid isolation of up to 1 mg of total RNA from cells and tissues.",
      "handle": "/products/quick-rna-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1056_Quick-RNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfRNA Serum & Plasma Kit",
      "subtitle": "R1059",
      "description": "Isolate cell-free RNA from biological fluid samples.",
      "handle": "/products/quick-cfrna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1059_Quick-cfRNA-Serum-Plasma-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Whole Blood",
      "subtitle": "R1201",
      "description": "Isolate RNA and small/miRNA from whole blood.",
      "handle": "/products/quick-rna-whole-blood",
      "image_url": "https://files.zymoresearch.com/images/R1201_Quick-RNA-Whole-Blood-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS RNA Miniprep Kit",
      "subtitle": "R2001",
      "description": "Purification of microbial RNA for microbiome or metagenome analyses",
      "handle": "/products/zymobiomics-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Fungal/Bacterial Microprep Kit",
      "subtitle": "R2010",
      "description": "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-rna-fungal-bacterial-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Fungal/Bacterial Miniprep Kit",
      "subtitle": "R2014",
      "description": "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-rna-fungal-bacterial-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2014_Quick-RNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Plant Kit",
      "subtitle": "R2024",
      "description": "Isolate inhibitor-free RNA from plant and seed samples.",
      "handle": "/products/quick-rna-plant-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2024_Quick-RNA-Plant-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Tissue/Insect Kit",
      "subtitle": "R2030",
      "description": "Isolate RNA from tough-to-lyse tissue and insects.",
      "handle": "/products/quick-rna-tissue-insect-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2030_Quick-RNA-Tissue-Insect-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
      "subtitle": "R2040",
      "description": "The Quick-RNA Fecal/Soil Microbe Microprep Kit is an affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
      "handle": "/products/quick-rna-fecal-soil-microbe-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2040_Quick-RNA-Fecal-Soil-Microbe-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol-96 RNA Kits",
      "subtitle": "R2054, R2055, R2056, R2057",
      "description": "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      "handle": "/products/direct-zol-96-rna-kits",
      "image_url": "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol RNA Microprep Kits",
      "subtitle": "R2060, R2061, R2062, R2063",
      "description": "RNA from single cell and low inputs in TRIzol. NGS-ready and concentrated in 6 &micro;l",
      "handle": "/products/direct-zol-rna-microprep-kits",
      "image_url": "https://files.zymoresearch.com/images/R2060-Directzol-RNA-Microprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol RNA Miniprep Plus Kits",
      "subtitle": "R2070, R2070T, R2071, R2072, R2073",
      "description": "A streamlined method for the purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRI Reagent or similar.",
      "handle": "/products/direct-zol-rna-miniprep-plus-kits",
      "image_url": "https://files.zymoresearch.com/product-images/R2070-Directzol-RNA-Miniprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol-96 MagBead RNA",
      "subtitle": "R2100, R2101, R2102, R2103",
      "description": "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      "handle": "/products/direct-zol-96-magbead-rna",
      "image_url": "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA MagBead",
      "subtitle": "R2132, R2133",
      "description": "High-throughput, magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
      "handle": "/products/quick-rna-magbead",
      "image_url": "https://files.zymoresearch.com/product-images/r2132_quick-rna-magbead-kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS MagBead RNA",
      "subtitle": "R2137, R2138",
      "description": "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
      "handle": "/products/zymobiomics-magbead-rna",
      "image_url": "https://files.zymoresearch.com/product-images/r2137_zymobiomics-magbead-rna-kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-5",
      "subtitle": "R1013, R1014, R1015, R1016",
      "description": "Simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-5",
      "image_url": "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Gel RNA Recovery Kit",
      "subtitle": "R1011",
      "description": "Quickly recover ultra-pure RNA from agarose gels.",
      "handle": "/products/zymoclean-gel-rna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/R1011_Zymoclean-Gel-RNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-25",
      "subtitle": "R1017, R1018",
      "description": "Simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/R1017_RNA-Clean-&-Concentrator-25.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-100",
      "subtitle": "R1019",
      "description": "Simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-100",
      "image_url": "https://files.zymoresearch.com/product-images/R1019_RNA-Clean-&-Concentrator-100.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR small-RNA  PAGE Recovery Kit",
      "subtitle": "R1070",
      "description": "The ZR small-RNA PAGE Recovery Kit provides an easy and efficient method for the extraction of high quality small RNAs from polyacrylamide gels (native and/or denatured)",
      "handle": "/products/zr-small-rna-page-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/R1070_ZR-small-RNA-PAGE-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-96",
      "subtitle": "R1080",
      "description": "Quick high-throughput method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-96",
      "image_url": "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator MagBead",
      "subtitle": "R1081, R1082",
      "description": "Streamlined automatable procedure for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-magbead",
      "image_url": "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE II Plasmid Midiprep Kit",
      "subtitle": "D4200, D4201",
      "description": "Purify endotoxin-free plasmid DNA in less than 18 minutes.",
      "handle": "/products/zymopure-ii-plasmid-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE II Plasmid Maxiprep Kit",
      "subtitle": "D4202, D4203",
      "description": "Purify endotoxin-free plasmid DNA in less than 18 minutes.",
      "handle": "/products/zymopure-ii-plasmid-maxiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE Plasmid Miniprep Kit",
      "subtitle": "D4208T, D4209, D4210, D4211, D4212",
      "description": "Purify ultra-pure transfection-grade plasmid DNA using a spin-column miniprep.",
      "handle": "/products/zymopure-ii-plasmid-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep Yeast Plasmid Miniprep I",
      "subtitle": "D2001",
      "description": "Simple precipitation based solution for yeast plasmid DNA isolation using Zymolyase",
      "handle": "/products/zymoprep-yeast-plasmid-miniprep-i",
      "image_url": "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep Yeast Plasmid Miniprep II",
      "subtitle": "D2004",
      "description": "Simple spin-column solution for yeast plasmid DNA isolation using Zymolyase",
      "handle": "/products/zymoprep-yeast-plasmid-miniprep-ii",
      "image_url": "https://files.zymoresearch.com/images/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy Plasmid Miniprep Kit",
      "subtitle": "D4019, D4020, D4036, D4037",
      "description": "Pellet-free, high-quality plasmid DNA in only 8 minutes.",
      "handle": "/products/zyppy-plasmid-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR BAC DNA Miniprep Kit",
      "subtitle": "D4048, D4049",
      "description": "Quickly isolate large constructs (≤200 kb) from E. coli using a spin-column",
      "handle": "/products/zr-bac-dna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE II Plasmid Gigaprep Kit",
      "subtitle": "D4204",
      "description": "Rapidly purify endotoxin-free plasmid DNA from up to 2.5 Liters of E. coli culture.",
      "handle": "/products/zymopure-ii-plasmid-gigaprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit-2.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE - Express Plasmid Midiprep Kit",
      "subtitle": "D4213",
      "description": "Simple pellet-free method for purifying transfection-grade plasmid DNA.",
      "handle": "/products/zymopure-express-plasmid-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4213_ZymoPURE%20Express%20Plasmid%20Midiprep%20Kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Fecal Collection Tube",
      "subtitle": "R1101, R1137",
      "description": "Collect & preserve nucleic acids from stool specimens at ambient temperatures.",
      "handle": "/products/dna-rna-shield-fecal-collection-tube",
      "image_url": "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield SafeCollect Swab Collection Kit",
      "subtitle": "R1160, R1160-E, R1161-E, R1161",
      "description": "User friendly device for collecting and preserving nucleic acids from a variety of sample types at ambient temperatures using swabs.",
      "handle": "/products/dna-rna-shield-safecollect-swab-collection-kit",
      "image_url": "https://files.zymoresearch.com/product-images/r1160-dna_rna_shield_safecollect_swab_collection_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield",
      "subtitle": "R1100-50, R1100-250, R1200-25, R1200-125",
      "description": "Novel sample transport medium that preserves DNA and RNA in any sample at ambient temperatures. ",
      "handle": "/products/dna-rna-shield",
      "image_url": "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield SafeCollect Saliva Collection Kit",
      "subtitle": "R1211, R1211-E",
      "description": "User friendly device for collecting and preserving nucleic acids from saliva and sputum samples at ambient temperatures. ",
      "handle": "/products/dna-rna-shield-safecollect-saliva-collection-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1211-dna_rna_shield_safecollect_saliva_collection_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Collection Tube w/ Swab",
      "subtitle": "R1106, R1107, R1108, R1109",
      "description": "Complete solution for collecting and preserving nucleic acids from a variety of sample types at ambient temperatures using swabs.",
      "handle": "/products/dna-rna-shield-collection-tube-w-swab",
      "image_url": "https://files.zymoresearch.com/images/R1106_DNA-RNA-Shield-Swab-Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Blood Collection Tube",
      "subtitle": "R1150",
      "description": "Ready-to-use tubes for collecting and preserving DNA and RNA in whole blood at ambient temperatures. ",
      "handle": "/products/dna-rna-shield-blood-collection-tube",
      "image_url": "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Fecal Collection Tube - DX",
      "subtitle": "R1101-E",
      "description": "Specimen receptacle medical device for collecting and preserving nucleic acids from feces for molecular-based in vitro diagnostic",
      "handle": "/products/dna-rna-shield-fecal-collection-tube-dx",
      "image_url": "https://files.zymoresearch.com/product-images/R1101_DNA+RNA+Shield+Fecal+Collection+Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Bunny Wipe Fecal Sample Collector",
      "subtitle": "R1133-1, R1133-10, R1138",
      "description": "Collect stool samples easily and cleanly with a wipe in the privacy of your own bathroom",
      "handle": "/products/bunny-wipe-fecal-sample-collector",
      "image_url": "https://files.zymoresearch.com/product-images/R1133_bunny_wipe_fecal_sample_collector.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Lysis & Collection Tubes",
      "subtitle": "R1102, R1103, R1104, R1105",
      "description": "All-in-one tube for the collection, preservation, and homogenization of a variety of sample types for DNA and RNA purificaiton. ",
      "handle": "/products/dna-rna-shield-lysis-and-collection-tubes",
      "image_url": "https://files.zymoresearch.com/images/R1103-DNA-RNA-Shield-Lysis-Tube-(Microbe).jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Urine Conditioning Buffer",
      "subtitle": "D3061-1-8, D3061-1-140",
      "description": "Effective preservation of DNA and RNA in urine at ambient temperatures.",
      "handle": "/products/urine-conditioning-buffer",
      "image_url": "https://files.zymoresearch.com/images/D3061-1-140-UCB-Bottle-140ml.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield DirectDetect",
      "subtitle": "R1400, R1400-E, R1401-1, R1401-1-E",
      "description": "Uniquely formulated nucleic acid preservation reagent that allows users to go from sample collection directly to PCR",
      "handle": "/products/dna-rna-shield-directdetect",
      "image_url": "https://files.zymoresearch.com/product-images/R1400-dna_rna_shield_directdetect_reagent.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    }
  ],
  "Filter-Summer-of-Sample-Prep-Collection>DNA-Clean-up": [
    {
      "title": "DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4012",
      "description": "Automatable method for purifying up to 4 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4012_DNA-Clean-%26-Concentrator-Magbead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4001, D4001T, D4002, D4007, D4008",
      "description": "Quickly recover ultra-pure DNA from agarose gels.",
      "handle": "/products/zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Oligo Clean & Concentrator",
      "subtitle": "D4060, D4061",
      "description": "Clean and concentrate Oligonucleotides in just 2 minutes.",
      "handle": "/products/oligo-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/product-images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-5",
      "subtitle": "D4003, D4003T, D4004, D4013, D4014",
      "description": "Purify up to 5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources in just 2 minutes.",
      "handle": "/products/dna-clean-concentrator-5",
      "image_url": "https://files.zymoresearch.com/images/D4004-DNA-Clean-&-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-25",
      "subtitle": "D4005, D4006, D4033, D4034",
      "description": "Purify up to 25 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources in just 2 minutes. ",
      "handle": "/products/dna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/D4005_DNA-Clean-and-Concentrator-25-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Genomic DNA Clean & Concentrator-10",
      "subtitle": "D4010, D4011",
      "description": "Quickly purify up to 10 µg of high molecular weight DNA from any enzymatic reaction or impure preparation. ",
      "handle": "/products/genomic-dna-clean-concentrator-10",
      "image_url": "https://files.zymoresearch.com/product-images/D4010_Genomic-DNA-Clean-and-Concentrator-10.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 DNA Clean-Up Kit",
      "subtitle": "D4017, D4018",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-up-kit",
      "image_url": "https://files.zymoresearch.com/images/D4017_ZR-96-DNA-Clean-up-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 DNA Clean & Concentrator-5 (Deep Well)",
      "subtitle": "D4023, D4024",
      "description": "Rapid high-throughput method for purifying up to  5 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/zr-96-dna-clean-amp-concentrator-5-deep-well",
      "image_url": "https://files.zymoresearch.com/product-images/D4023-ZR-96-DNA-Clean-_-Concentrator-5.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-100",
      "subtitle": "D4029, D4030",
      "description": "Quickly purify up to 100 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-100",
      "image_url": "https://files.zymoresearch.com/product-images/D4029_DNA-Clean-and-Concentrator-100-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA Clean & Concentrator-500",
      "subtitle": "D4031, D4032",
      "description": "Quickly purify up to 500 µg of ultra-pure DNA from PCR, enzymatic reactions, and other sources.",
      "handle": "/products/dna-clean-concentrator-500",
      "image_url": "https://files.zymoresearch.com/product-images/D4031-DNA-Clean-_-Concentrator--500.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Genomic DNA Clean & Concentrator-25",
      "subtitle": "D4064, D4065",
      "description": "Quickly purify up to 25 µg of high molecular weight DNA from any enzymatic reaction or impure preparation. ",
      "handle": "/products/genomic-dna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/D4064_Genomic-DNA-Clean-and-Concentrator-25.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Select-a-Size DNA Clean & Concentrator Kit",
      "subtitle": "D4080",
      "description": "Easily purify a specific range of DNA fragment sizes from library preps, PCR, ligations and other sources using a spin-column.",
      "handle": "/products/select-a-size-dna-clean-concentrator-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4080_Select-A-Size-DNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Select-a-Size DNA Clean & Concentrator MagBead Kit",
      "subtitle": "D4084, D4085",
      "description": "Consistently purify a specific range of DNA fragment sizes from library preps, PCR, ligations and other sources using magnetic beads. ",
      "handle": "/products/select-a-size-dna-clean-concentrator-magbead-kit",
      "image_url": "https://files.zymoresearch.com/images/D4084_Select-A-Size-DNA-Clean-and-Concentrator-MagBead-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
      "subtitle": "D4066, D4067",
      "description": "Simple hight-throughput method for purifying high molecular weight DNA from any enzymatic reaction or impure preparation.",
      "handle": "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
      "image_url": "https://files.zymoresearch.com/images/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ssDNA/RNA Clean & Concentrator",
      "subtitle": "D7010, D7011",
      "description": "Clean and concentrate single stranded DNA or RNA with a simple spin-column protocol. ",
      "handle": "/products/ssdna-rna-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Oligo Clean & Concentrator",
      "subtitle": "D4062, D4063",
      "description": "Streamlined high-throughput method for cleaning-up and concentrating oligonucleotides.",
      "handle": "/products/oligo-clean-concentrator-zr96",
      "image_url": "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    }
  ],
  "Filter-Summer-of-Sample-Prep-Collection>DNA-Purification": [
    {
      "title": "<i>Quick</i>-DNA Miniprep Plus Kit",
      "subtitle": "D4068, D4068T, D4069",
      "description": "Easily purify ultra-pure DNA from cells, tissues, and biological fluids. ",
      "handle": "/products/quick-dna-miniprep-plus-dna-extraction-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4068-Quick-DNA-Miniprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA Miniprep Kit",
      "subtitle": "D4300, D4300T, D4304",
      "description": "Efficient microbial DNA purification for accurate microbiome and metagenomic analysis.",
      "handle": "/products/zymobiomics-dna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial Miniprep Kit",
      "subtitle": "D6005",
      "description": "Rapid isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6005_Quick-DNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Miniprep Kit",
      "subtitle": "D6010",
      "description": "Robust purification of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-dna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6010_Quick-DNA-Fecal-Soil-Microbe-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep-96 Yeast Plasmid Miniprep",
      "subtitle": "D2005, D2006, D2007",
      "description": "Fast and simple high-throughput procedure for purifying high quality plasmid DNA from yeast.",
      "handle": "/products/zymoprep-96-yeast-plasmid-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA 96 Kit",
      "subtitle": "D3010, D3011, D3012",
      "description": "Rapid high-throughput purification of DNA from cells and biological fluids.",
      "handle": "/products/quick-dna-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D3010_Quick-DNA-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Viral Kit",
      "subtitle": "D3015, D3016",
      "description": "Quickly isolate high-quality viral DNA from a wide range of biological samples.",
      "handle": "/products/quick-dna-viral-kit",
      "image_url": "https://files.zymoresearch.com/images/D3015_Quick-DNA-Viral-DNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Viral 96 Kit",
      "subtitle": "D3017, D3018",
      "description": "Efficient high-throughput purification of high-quality viral DNA from a wide range of biological samples. ",
      "handle": "/products/quick-dna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D3017_ZR-96-Viral-DNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Microprep Kit",
      "subtitle": "D3020, D3021",
      "description": "Rapid and simple isolation of ultra-pure DNA single cells and low inputs. ",
      "handle": "/products/quick-dna-microprep",
      "image_url": "https://files.zymoresearch.com/product-images/D3020-Quick-DNA-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Miniprep",
      "subtitle": "D3024, D3025",
      "description": "Rapid and simple isolation of ultra-pure DNA from cells and biological fluids",
      "handle": "/products/quick-dna-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D3024-Quick-DNA-Miniprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA FFPE Miniprep",
      "subtitle": "D3067",
      "description": "Streamlined purificaiton of high-quality DNA from FFPE tissue. ",
      "handle": "/products/quick-dna-ffpe-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D3067_Quick-DNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4001, D4001T, D4002, D4007, D4008",
      "description": "Quickly recover ultra-pure DNA from agarose gels.",
      "handle": "/products/zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4001_Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Zymoclean Gel DNA Recovery Kit",
      "subtitle": "D4021, D4022",
      "description": "Convenient high-throughput purification of ultra-pure DNA from agarose gels.",
      "handle": "/products/zr-96-zymoclean-gel-dna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/D4021_ZR-96-Zymoclean-Gel-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy-96 Plasmid Kit",
      "subtitle": "D4041, D4042, D4043",
      "description": "High-throughput pellet-free method for purifying ultra-pure plasmid DNA.",
      "handle": "/products/zyppy-96-plasmid-kit",
      "image_url": "https://files.zymoresearch.com/images/D4041_Zyppy-96-Plasmid-Miniprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Large Fragment DNA Recovery",
      "subtitle": "D4045, D4046",
      "description": "Rapid purification of ultra-pure high molecular weight DNA from agarose gels.",
      "handle": "/products/zymoclean-large-fragment-dna-recovery",
      "image_url": "https://files.zymoresearch.com/product-images/D4045-Zymoclean-Large-Fragment-DNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Oligo Clean & Concentrator",
      "subtitle": "D4060, D4061",
      "description": "Clean and concentrate Oligonucleotides in just 2 minutes.",
      "handle": "/products/oligo-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/product-images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Oligo Clean & Concentrator",
      "subtitle": "D4062, D4063",
      "description": "Streamlined high-throughput method for cleaning-up and concentrating oligonucleotides.",
      "handle": "/products/oligo-clean-concentrator-zr96",
      "image_url": "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Genomic DNA Clean & Concentrator-5 Kit",
      "subtitle": "D4066, D4067",
      "description": "Simple hight-throughput method for purifying high molecular weight DNA from any enzymatic reaction or impure preparation.",
      "handle": "/products/zr-96-genomic-dna-clean-concentrator-5-kit",
      "image_url": "https://files.zymoresearch.com/images/D4066_ZR-96-Genomic-DNA-Clean-and-Concentrator-5-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA  96 Plus Kit",
      "subtitle": "D4070, D4071",
      "description": "Robust and simple high-throughput purification of ultra-pure DNA from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-96-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4070_Quick-DNA-96-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Microprep Plus Kit",
      "subtitle": "D4074",
      "description": "Easily purify ultra-pure DNA from single cells and low inputs of tissues or biological fluids.",
      "handle": "/products/quick-dna-microprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4074-Quick-DNA-Microprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Midiprep Plus Kit",
      "subtitle": "D4075",
      "description": "Easily purify ultra-pure DNA from cells, tissues, and  biological fluids. ",
      "handle": "/products/quick-dna-midiprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4075-Quick-DNA-Midiprep-Plus-Kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfDNA Serum & Plasma Kit",
      "subtitle": "D4076",
      "description": "Highly efficient isolation of cell-free DNA from serum, plasma, CSF, and amniotic fluid.",
      "handle": "/products/quick-cfdna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/images/d4076_quick-cfdna-serum-and-plasma-kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Magbead Plus Kit",
      "subtitle": "D4081, D4082",
      "description": "Automatable DNA isolation from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-magbead-plus-kit",
      "image_url": "https://files.zymoresearch.com/images/D4081_Quick-DNA-Magbead-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "MAGicBead™ cfDNA Isolation Kit",
      "subtitle": "D4086",
      "description": "Novel DNA binding chemistry enabling unparalleled cfDNA extraction performance",
      "handle": "/products/magicbead-cfdna-isolation-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4086_magicbead_cfdna_isolation_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy-96 Plasmid MagBead Miniprep",
      "subtitle": "D4100, D4101, D4102",
      "description": "Automatable pellet-free method for purifying ultra-pure plasmid DNA.",
      "handle": "/products/zyppy-96-plasmid-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA Microprep Kit",
      "subtitle": "D4301, D4305",
      "description": "Efficient microbial DNA purification from low sample inputs for accurate microbiome and metagenomic analysis.",
      "handle": "/products/zymobiomics-dna-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4301_ZymoBIOMICS-DNA-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS 96 MagBead DNA Kit",
      "subtitle": "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
      "description": "Automatable streamlined microbial DNA purification for accurate microbiome and metagenomic analysis. ",
      "handle": "/products/zymobiomics-96-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4302-ZymoBIOMICS-96-MagBead-DNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS 96 DNA Kit",
      "subtitle": "D4303, D4307, D4309",
      "description": "Robust high-throughput DNA purification procedure for accurate microbiome and metagenomic analysis. ",
      "handle": "/products/zymobiomics-96-dna-kit",
      "image_url": "https://files.zymoresearch.com/images/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial 96 Kit",
      "subtitle": "D6006",
      "description": "Simple high-throughput isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D6006_Quick-DNA-Fungal-Bacterial-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial Microprep Kit",
      "subtitle": "D6007",
      "description": "Rapid isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6007_Quick-DNA-Fungal-Bacterial-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Magbead Kit",
      "subtitle": "D6010-FM, D6011-FM, D6012-FM",
      "description": "Automatable isolation of DNA free of PCR inhibitors from feces and soil.",
      "handle": "/products/quick-dna-fecal-soil-microbe-96-magbead-kit",
      "image_url": "https://files.zymoresearch.com/images/D6010-FM_Quick-DNA-Fecal-Soil-Microbe_96-Magbead-Lysis-Rack.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe 96 Kit",
      "subtitle": "D6011",
      "description": "High-throughput isolation of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D6011_Quick-DNA-Fecal-Soil-Microbe_96-Well.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Microprep",
      "subtitle": "D6012",
      "description": "Robust purification of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-microprep",
      "image_url": "https://files.zymoresearch.com/product-images/D6012_Quick-DNA-Fecal-Soil-Microbe_Microprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Tissue/Insect 96 Kit",
      "subtitle": "D6017",
      "description": "Easily isolate high-quality DNA from tough-to-lyse tissues and insects.",
      "handle": "/products/quick-dna-tissue-insect-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D6017_Quick-DNA-Tissue-Insect-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Plant/Seed Miniprep Kit",
      "subtitle": "D6020",
      "description": "Rapidly isolate DNA free of PCR inhibitors from leaves, stems, buds, flowers, fruit, seeds, and more. ",
      "handle": "/products/quick-dna-plant-seed-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6020_Quick-DNA-Plant-Seed-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Plant/Seed 96 Kit",
      "subtitle": "D6021",
      "description": "High-throughput purification of DNA free of PCR inhibitors from leaves, stems, buds, flowers, fruit, seeds, and more. ",
      "handle": "/products/quick-dna-plant-seed-96-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6021_Quick-DNA Plant Seed 96 Kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA HMW MagBead Kit",
      "subtitle": "D6060",
      "description": "Extract ultra-pure high molecular weight DNA from any sample. ",
      "handle": "/products/quick-dna-hmw-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/d6060_quick-dna_hmw_magbead_kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fungal/Bacterial Midiprep Kit",
      "subtitle": "D6105",
      "description": "Rapid isolation of ultra-pure DNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-dna-fungal-bacterial-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D6105_Quick-DNA-Fungal-Bacterial-Midiprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA Fecal/Soil Microbe Midiprep Kit",
      "subtitle": "D6110",
      "description": "Robust purification of DNA free of PCR inhibitors from feces and soil. ",
      "handle": "/products/quick-dna-fecal-soil-microbe-midiprep",
      "image_url": "https://files.zymoresearch.com/product-images/D6110_Quick-DNA-Fecal-Soil-Microbe_Midiprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Miniprep",
      "subtitle": "D7001",
      "description": "Quickly and easily isolate DNA and RNA from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-rna-miniprep",
      "image_url": "https://files.zymoresearch.com/product-images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Miniprep Plus Kit",
      "subtitle": "D7003, D7003T",
      "description": "Extract ultra-pure DNA and RNA from any sample.",
      "handle": "/products/quick-dna-rna-miniprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7003_ZR-Duet-DNA-RNA-MiniPrep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Microprep Plus Kit",
      "subtitle": "D7005, D7005T",
      "description": "Extract ultra-pure DNA and RNA from any sample.",
      "handle": "/products/quick-dna-rna-microprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7005_Quick-DNA-RNA-Microprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ssDNA/RNA Clean & Concentrator",
      "subtitle": "D7010, D7011",
      "description": "Clean and concentrate single stranded DNA or RNA with a simple spin-column protocol. ",
      "handle": "/products/ssdna-rna-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral Kit",
      "subtitle": "D7020, D7021",
      "description": "Quickly recover ultra-pure DNA and RNA from plasma, serum, and other sample types.",
      "handle": "/products/quick-dna-rna-viral-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      "subtitle": "D7022, D7023",
      "description": "Rapid high-throughput purification of viral DNA and RNA from a wide range of biological sources. ",
      "handle": "/products/quick-dna-rna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      "subtitle": "R1009",
      "description": "Simple and consistent isolation of DNA and RNA from the same FFPE tissue sample.",
      "handle": "/products/quick-dna-rna-ffpe-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Pathogen Miniprep",
      "subtitle": "R1042, R1043",
      "description": "Streamlined purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      "handle": "/products/quick-dna-rna-pathogen-miniprep",
      "image_url": "https://files.zymoresearch.com/product-images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      "subtitle": "R1072",
      "description": "Isolate cfDNa and cfDNA efficiently and easily from biological fluids",
      "handle": "/products/quick-cfdna-rna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Blood Tube Kit",
      "subtitle": "R1151",
      "description": "Convenient isolation of ultra-pure DNA and RNA from blood collected using the DNA/RNA Shield - Blood Tube",
      "handle": "/products/quick-dna-rna-blood-tube-kit",
      "image_url": "https://files.zymoresearch.com/images/r1151_quick-dna-rna-blood-tube-kit_1.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
      "subtitle": "R2002",
      "description": "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      "handle": "/products/zymobiomics-dna-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA MagBead",
      "subtitle": "R2130, R2131",
      "description": "Automatable isolation of DNA and RNA from any sample type.",
      "handle": "/products/quick-dna-rna-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS MagBead DNA/RNA",
      "subtitle": "R2135, R2136",
      "description": "Automatable microbial DNA and RNA purification for accurate metagenomic and metatranscriptomic analysis. ",
      "handle": "/products/zymobiomics-magbead-dna-rna",
      "image_url": "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral MagBead",
      "subtitle": "R2140, R2140-E, R2141, R2141-E",
      "description": "Automatable purification of ultra-pure viral DNA and RNA from all biological fluids.",
      "handle": "/products/quick-dna-rna-viral-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Load N’ Go DNA/RNA Viral Kit",
      "subtitle": "R2143",
      "description": "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      "handle": "/products/load-n-go-dna-rna-viral-kit",
      "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      "subtitle": "R2145, R2146",
      "description": "Automatable pathagen DNA and RNA isolation from vectors, tissues, and other biological sample types. ",
      "handle": "/products/quick-dna-rna-pathogen-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    }
  ],
  "Filter-Summer-of-Sample-Prep-Collection>RNA-Purification": [
    {
      "title": "Direct-zol RNA Miniprep Kits",
      "subtitle": "R2050, R2051, R2052, R2053",
      "description": "Isolate RNA from Trizol in 7 minutes using a simple spin-column protocol.",
      "handle": "/products/direct-zol-rna-miniprep-kits",
      "image_url": "https://files.zymoresearch.com/product-images/R2050-Directzol-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Miniprep Plus Kit",
      "subtitle": "R1057, R1057T, R1058",
      "description": "RNA isolation kits that provide easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      "handle": "/products/quick-rna-miniprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1057-Quick-RNA-Miniprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral MagBead",
      "subtitle": "R2140, R2140-E, R2141, R2141-E",
      "description": "Automatable purification of ultra-pure viral DNA and RNA from all biological fluids.",
      "handle": "/products/quick-dna-rna-viral-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2140-Quick-DNA-RNA-Viral-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Miniprep Plus Kit",
      "subtitle": "D7003, D7003T",
      "description": "Extract ultra-pure DNA and RNA from any sample.",
      "handle": "/products/quick-dna-rna-miniprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7003_ZR-Duet-DNA-RNA-MiniPrep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "YeaStar RNA Kit",
      "subtitle": "R1002",
      "description": "Simple spin-column solution for isolating RNA from yeast using Zymolyase.",
      "handle": "/products/yeastar-rna-kit",
      "image_url": "https://files.zymoresearch.com/images/R1002_YeaStar-RNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Pinpoint Slide RNA Isolation System",
      "subtitle": "R1003, R1007",
      "description": "Efficient purification of high-quality RNA from tissue sections on slides. ",
      "handle": "/products/pinpoint-slide-rna-isolation-system",
      "image_url": "https://files.zymoresearch.com/images/R1003_Pinpoint-Slide-RNA-Isolation-System-I-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA FFPE Miniprep",
      "subtitle": "R1008",
      "description": "Isolate RNA and small/miRNA from FFPE tissue.",
      "handle": "/products/quick-rna-ffpe-miniprep",
      "image_url": "https://files.zymoresearch.com/images/R1008_Quick-RNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Viral Kit",
      "subtitle": "R1034, R1034-E, R1035, R1035-E",
      "description": "Viral RNA purification kits that provide for rapid isolation of high-quality viral RNA from a wide range of biological sources.",
      "handle": "/products/quick-rna-viral-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1034_Quick-RNA-Viral-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR Urine RNA Isolation Kit",
      "subtitle": "R1038, R1039",
      "description": "Isolate RNA from up to 30 ml of urine.",
      "handle": "/products/zr-urine-rna-isolation-kit",
      "image_url": "https://files.zymoresearch.com/images/R1038_ZR-Urine-RNA-Isolation-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Viral 96 Kit",
      "subtitle": "R1040, R1040-E, R1041, R1041-E",
      "description": "Isolate ultra-pure viral RNA from all biological fluids.",
      "handle": "/products/quick-rna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/R1040_Quick-RNA-Viral-96-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Microprep Kit",
      "subtitle": "R1050, R1051",
      "description": "RNA from single cell and low inputs. NGS-ready and concentrated in 6 &micro;l.",
      "handle": "/products/quick-rna-microprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1050_Quick-RNA-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA 96 Kit",
      "subtitle": "R1052, R1053",
      "description": "High-throughput purification of  total RNA and small/miRNA from cells and soft tissue.",
      "handle": "/products/quick-rna-96-kit",
      "image_url": "https://files.zymoresearch.com/images/R1052_Quick-RNA-96.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Miniprep Kit",
      "subtitle": "R1054, R1055",
      "description": "Easy and reliable isolation of DNA-free RNA from most samples in just 10 minutes.",
      "handle": "/products/quick-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1054_Quick-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Midiprep Kit",
      "subtitle": "R1056",
      "description": "Rapid isolation of up to 1 mg of total RNA from cells and tissues.",
      "handle": "/products/quick-rna-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1056_Quick-RNA-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfRNA Serum & Plasma Kit",
      "subtitle": "R1059",
      "description": "Isolate cell-free RNA from biological fluid samples.",
      "handle": "/products/quick-cfrna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1059_Quick-cfRNA-Serum-Plasma-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Whole Blood",
      "subtitle": "R1201",
      "description": "Isolate RNA and small/miRNA from whole blood.",
      "handle": "/products/quick-rna-whole-blood",
      "image_url": "https://files.zymoresearch.com/images/R1201_Quick-RNA-Whole-Blood-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS RNA Miniprep Kit",
      "subtitle": "R2001",
      "description": "Purification of microbial RNA for microbiome or metagenome analyses",
      "handle": "/products/zymobiomics-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Fungal/Bacterial Microprep Kit",
      "subtitle": "R2010",
      "description": "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-rna-fungal-bacterial-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2010_Quick-RNA-Fungal-Bacterial-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Fungal/Bacterial Miniprep Kit",
      "subtitle": "R2014",
      "description": "Easily and quickly isolate total RNA from tough-to-lyse fungi and bacteria.",
      "handle": "/products/quick-rna-fungal-bacterial-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2014_Quick-RNA-Fungal-Bacterial-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Plant Kit",
      "subtitle": "R2024",
      "description": "Isolate inhibitor-free RNA from plant and seed samples.",
      "handle": "/products/quick-rna-plant-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2024_Quick-RNA-Plant-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Tissue/Insect Kit",
      "subtitle": "R2030",
      "description": "Isolate RNA from tough-to-lyse tissue and insects.",
      "handle": "/products/quick-rna-tissue-insect-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2030_Quick-RNA-Tissue-Insect-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA Fecal/Soil Microbe Microprep Kit",
      "subtitle": "R2040",
      "description": "The Quick-RNA Fecal/Soil Microbe Microprep Kit is an affordable fecal and soil RNA extraction kit designed for fast, easy isolation of total RNA including small RNAs from soil, sludge, sediment and fecal samples.",
      "handle": "/products/quick-rna-fecal-soil-microbe-microprep-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R2040_Quick-RNA-Fecal-Soil-Microbe-Microprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol-96 RNA Kits",
      "subtitle": "R2054, R2055, R2056, R2057",
      "description": "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      "handle": "/products/direct-zol-96-rna-kits",
      "image_url": "https://files.zymoresearch.com/images/R2054_Direct-zol-96-RNA_No-TRI-Reagent.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol RNA Microprep Kits",
      "subtitle": "R2060, R2061, R2062, R2063",
      "description": "RNA from single cell and low inputs in TRIzol. NGS-ready and concentrated in 6 &micro;l",
      "handle": "/products/direct-zol-rna-microprep-kits",
      "image_url": "https://files.zymoresearch.com/images/R2060-Directzol-RNA-Microprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol RNA Miniprep Plus Kits",
      "subtitle": "R2070, R2070T, R2071, R2072, R2073",
      "description": "A streamlined method for the purification of up to 100 µg (per prep) of high-quality RNA directly from samples in TRI Reagent or similar.",
      "handle": "/products/direct-zol-rna-miniprep-plus-kits",
      "image_url": "https://files.zymoresearch.com/product-images/R2070-Directzol-RNA-Miniprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Direct-zol-96 MagBead RNA",
      "subtitle": "R2100, R2101, R2102, R2103",
      "description": "Isolate total RNA and small/miRNA from TRIzol&reg; without phase separation",
      "handle": "/products/direct-zol-96-magbead-rna",
      "image_url": "https://files.zymoresearch.com/images/R2100-Direct-zol-96-MagBead-RNA.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-RNA MagBead",
      "subtitle": "R2132, R2133",
      "description": "High-throughput, magnetic bead-based purification of total RNA (including small/miRNAs) from any sample.",
      "handle": "/products/quick-rna-magbead",
      "image_url": "https://files.zymoresearch.com/product-images/r2132_quick-rna-magbead-kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS MagBead RNA",
      "subtitle": "R2137, R2138",
      "description": "High-throughput, magnetic bead-based microbiome extraction kit designed for microbial RNA purification.",
      "handle": "/products/zymobiomics-magbead-rna",
      "image_url": "https://files.zymoresearch.com/product-images/r2137_zymobiomics-magbead-rna-kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Oligo Clean & Concentrator",
      "subtitle": "D4060, D4061",
      "description": "Clean and concentrate Oligonucleotides in just 2 minutes.",
      "handle": "/products/oligo-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/product-images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Oligo Clean & Concentrator",
      "subtitle": "D4062, D4063",
      "description": "Streamlined high-throughput method for cleaning-up and concentrating oligonucleotides.",
      "handle": "/products/oligo-clean-concentrator-zr96",
      "image_url": "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Miniprep",
      "subtitle": "D7001",
      "description": "Quickly and easily isolate DNA and RNA from cells, tissues, and biological fluids.",
      "handle": "/products/quick-dna-rna-miniprep",
      "image_url": "https://files.zymoresearch.com/product-images/D7001_Quick-DNA-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Microprep Plus Kit",
      "subtitle": "D7005, D7005T",
      "description": "Extract ultra-pure DNA and RNA from any sample.",
      "handle": "/products/quick-dna-rna-microprep-plus-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7005_Quick-DNA-RNA-Microprep-Plus-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ssDNA/RNA Clean & Concentrator",
      "subtitle": "D7010, D7011",
      "description": "Clean and concentrate single stranded DNA or RNA with a simple spin-column protocol. ",
      "handle": "/products/ssdna-rna-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral Kit",
      "subtitle": "D7020, D7021",
      "description": "Quickly recover ultra-pure DNA and RNA from plasma, serum, and other sample types.",
      "handle": "/products/quick-dna-rna-viral-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D7020_Quick-DNA-RNA-Viral-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Viral 96 Kit",
      "subtitle": "D7022, D7023",
      "description": "Rapid high-throughput purification of viral DNA and RNA from a wide range of biological sources. ",
      "handle": "/products/quick-dna-rna-viral-96-kit",
      "image_url": "https://files.zymoresearch.com/images/D7022_ZR-96-Viral-DNA-RNA-kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA FFPE Miniprep Kit",
      "subtitle": "R1009",
      "description": "Simple and consistent isolation of DNA and RNA from the same FFPE tissue sample.",
      "handle": "/products/quick-dna-rna-ffpe-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R1009_Quick-DNA-RNA-FFPE-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Pathogen Miniprep",
      "subtitle": "R1042, R1043",
      "description": "Streamlined purification of pathogen DNA and RNA from a wide variety of vectors and tissue types.",
      "handle": "/products/quick-dna-rna-pathogen-miniprep",
      "image_url": "https://files.zymoresearch.com/product-images/R1042_Quick-DNA-RNA-Pathogen-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
      "subtitle": "R1072",
      "description": "Isolate cfDNa and cfDNA efficiently and easily from biological fluids",
      "handle": "/products/quick-cfdna-rna-serum-plasma-kit",
      "image_url": "https://files.zymoresearch.com/images/R1072_Quick-cfDNA-cfRNA-Serum-adn-Plasma-Kit_Green-Label.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Blood Tube Kit",
      "subtitle": "R1151",
      "description": "Convenient isolation of ultra-pure DNA and RNA from blood collected using the DNA/RNA Shield - Blood Tube",
      "handle": "/products/quick-dna-rna-blood-tube-kit",
      "image_url": "https://files.zymoresearch.com/images/r1151_quick-dna-rna-blood-tube-kit_1.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
      "subtitle": "R2002",
      "description": "Purification of microbial DNA/RNA for microbiome or metagenome analyses",
      "handle": "/products/zymobiomics-dna-rna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA MagBead",
      "subtitle": "R2130, R2131",
      "description": "Automatable isolation of DNA and RNA from any sample type.",
      "handle": "/products/quick-dna-rna-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2131-Quick-DNA-RNA-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoBIOMICS MagBead DNA/RNA",
      "subtitle": "R2135, R2136",
      "description": "Automatable microbial DNA and RNA purification for accurate metagenomic and metatranscriptomic analysis. ",
      "handle": "/products/zymobiomics-magbead-dna-rna",
      "image_url": "https://files.zymoresearch.com/product-images/r2135_zymobiomics_96_magbead_dna_rna_kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Load N’ Go DNA/RNA Viral Kit",
      "subtitle": "R2143",
      "description": "Pre-loaded laboratory automation-ready reagent plates for viral DNA and RNA isolation.",
      "handle": "/products/load-n-go-dna-rna-viral-kit",
      "image_url": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2143_Quick-DNA-RNA-Viral-Automation-Kit-Photo-for-Flyer_600x.jpg?v=1667426568",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "<i>Quick</i>-DNA/RNA Pathogen MagBead",
      "subtitle": "R2145, R2146",
      "description": "Automatable pathagen DNA and RNA isolation from vectors, tissues, and other biological sample types. ",
      "handle": "/products/quick-dna-rna-pathogen-magbead",
      "image_url": "https://files.zymoresearch.com/images/R2145-Quick-DNA-RNA-Pathogen-MagBead.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    }
  ],
  "Filter-Summer-of-Sample-Prep-Collection>RNA-Clean-up": [
    {
      "title": "RNA Clean & Concentrator-5",
      "subtitle": "R1013, R1014, R1015, R1016",
      "description": "Simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-5",
      "image_url": "https://files.zymoresearch.com/images/R1013_RNA-Clean-and-Concentrator-5-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Oligo Clean & Concentrator",
      "subtitle": "D4060, D4061",
      "description": "Clean and concentrate Oligonucleotides in just 2 minutes.",
      "handle": "/products/oligo-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/product-images/D4060_Oligo-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoclean Gel RNA Recovery Kit",
      "subtitle": "R1011",
      "description": "Quickly recover ultra-pure RNA from agarose gels.",
      "handle": "/products/zymoclean-gel-rna-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/R1011_Zymoclean-Gel-RNA-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-25",
      "subtitle": "R1017, R1018",
      "description": "Simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-25",
      "image_url": "https://files.zymoresearch.com/product-images/R1017_RNA-Clean-&-Concentrator-25.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-100",
      "subtitle": "R1019",
      "description": "Simple and reliable method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-100",
      "image_url": "https://files.zymoresearch.com/product-images/R1019_RNA-Clean-&-Concentrator-100.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR small-RNA  PAGE Recovery Kit",
      "subtitle": "R1070",
      "description": "The ZR small-RNA PAGE Recovery Kit provides an easy and efficient method for the extraction of high quality small RNAs from polyacrylamide gels (native and/or denatured)",
      "handle": "/products/zr-small-rna-page-recovery-kit",
      "image_url": "https://files.zymoresearch.com/images/R1070_ZR-small-RNA-PAGE-Recovery-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator-96",
      "subtitle": "R1080",
      "description": "Quick high-throughput method for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-96",
      "image_url": "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "RNA Clean & Concentrator MagBead",
      "subtitle": "R1081, R1082",
      "description": "Streamlined automatable procedure for the rapid preparation of high-quality RT-PCR-ready, DNA-free RNA.",
      "handle": "/products/rna-clean-concentrator-magbead",
      "image_url": "https://files.zymoresearch.com/product-images/R1080_ZR-96-RNA-Clean-and-Concentrator.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR-96 Oligo Clean & Concentrator",
      "subtitle": "D4062, D4063",
      "description": "Streamlined high-throughput method for cleaning-up and concentrating oligonucleotides.",
      "handle": "/products/oligo-clean-concentrator-zr96",
      "image_url": "https://files.zymoresearch.com/images/D4062_ZR-96-Oligo-Clean-Concentrator.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ssDNA/RNA Clean & Concentrator",
      "subtitle": "D7010, D7011",
      "description": "Clean and concentrate single stranded DNA or RNA with a simple spin-column protocol. ",
      "handle": "/products/ssdna-rna-clean-concentrator",
      "image_url": "https://files.zymoresearch.com/images/D7010_ssDNA-RNA-Clean-and-Concentrator-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    }
  ],
  "Filter-Summer-of-Sample-Prep-Collection>Plasmid-Prep": [
    {
      "title": "ZymoPURE II Plasmid Midiprep Kit",
      "subtitle": "D4200, D4201",
      "description": "Purify endotoxin-free plasmid DNA in less than 18 minutes.",
      "handle": "/products/zymopure-ii-plasmid-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4200-ZymoPURE-Plasmid-Midiprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE II Plasmid Maxiprep Kit",
      "subtitle": "D4202, D4203",
      "description": "Purify endotoxin-free plasmid DNA in less than 18 minutes.",
      "handle": "/products/zymopure-ii-plasmid-maxiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4202-ZymoPURE-II-Plasmid-Maxiprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE Plasmid Miniprep Kit",
      "subtitle": "D4208T, D4209, D4210, D4211, D4212",
      "description": "Purify ultra-pure transfection-grade plasmid DNA using a spin-column miniprep.",
      "handle": "/products/zymopure-ii-plasmid-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4209-ZymoPURE-Plasmid-Miniprep Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy Plasmid Miniprep Kit",
      "subtitle": "D4019, D4020, D4036, D4037",
      "description": "Pellet-free, high-quality plasmid DNA in only 8 minutes.",
      "handle": "/products/zyppy-plasmid-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4019-Zyppy-Plasmid-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep Yeast Plasmid Miniprep I",
      "subtitle": "D2001",
      "description": "Simple precipitation based solution for yeast plasmid DNA isolation using Zymolyase",
      "handle": "/products/zymoprep-yeast-plasmid-miniprep-i",
      "image_url": "https://files.zymoresearch.com/images/D2001_Zymoprep-Yeast-Plasmid-Miniprep-I-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep Yeast Plasmid Miniprep II",
      "subtitle": "D2004",
      "description": "Simple spin-column solution for yeast plasmid DNA isolation using Zymolyase",
      "handle": "/products/zymoprep-yeast-plasmid-miniprep-ii",
      "image_url": "https://files.zymoresearch.com/images/D2004_Zymoprep-Yeast-Plasmid-MiniPrep-II-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZR BAC DNA Miniprep Kit",
      "subtitle": "D4048, D4049",
      "description": "Quickly isolate large constructs (≤200 kb) from E. coli using a spin-column",
      "handle": "/products/zr-bac-dna-miniprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4048_ZR-BAC-DNA-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE II Plasmid Gigaprep Kit",
      "subtitle": "D4204",
      "description": "Rapidly purify endotoxin-free plasmid DNA from up to 2.5 Liters of E. coli culture.",
      "handle": "/products/zymopure-ii-plasmid-gigaprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4204_ZymoPURE-II-Plasmid-Gigaprep-Kit-2.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "ZymoPURE - Express Plasmid Midiprep Kit",
      "subtitle": "D4213",
      "description": "Simple pellet-free method for purifying transfection-grade plasmid DNA.",
      "handle": "/products/zymopure-express-plasmid-midiprep-kit",
      "image_url": "https://files.zymoresearch.com/images/D4213_ZymoPURE%20Express%20Plasmid%20Midiprep%20Kit.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zymoprep-96 Yeast Plasmid Miniprep",
      "subtitle": "D2005, D2006, D2007",
      "description": "Fast and simple high-throughput procedure for purifying high quality plasmid DNA from yeast.",
      "handle": "/products/zymoprep-96-yeast-plasmid-miniprep",
      "image_url": "https://files.zymoresearch.com/images/D2007_Zymoprep-96-Yeast-Plasmid-Miniprep-Kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy-96 Plasmid Kit",
      "subtitle": "D4041, D4042, D4043",
      "description": "High-throughput pellet-free method for purifying ultra-pure plasmid DNA.",
      "handle": "/products/zyppy-96-plasmid-kit",
      "image_url": "https://files.zymoresearch.com/images/D4041_Zyppy-96-Plasmid-Miniprep.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Zyppy-96 Plasmid MagBead Miniprep",
      "subtitle": "D4100, D4101, D4102",
      "description": "Automatable pellet-free method for purifying ultra-pure plasmid DNA.",
      "handle": "/products/zyppy-96-plasmid-magbead-kit",
      "image_url": "https://files.zymoresearch.com/product-images/D4100_Zyppy-96-Plasmid-MagBead-Miniprep.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    }
  ],
  "Filter-Summer-of-Sample-Prep-Collection>Sample-Collection": [
    {
      "title": "DNA/RNA Shield Fecal Collection Tube",
      "subtitle": "R1101, R1137",
      "description": "Collect & preserve nucleic acids from stool specimens at ambient temperatures.",
      "handle": "/products/dna-rna-shield-fecal-collection-tube",
      "image_url": "https://files.zymoresearch.com/images/R1101_DNA RNA Shield Fecal Collection Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield SafeCollect Swab Collection Kit",
      "subtitle": "R1160, R1160-E, R1161-E, R1161",
      "description": "User friendly device for collecting and preserving nucleic acids from a variety of sample types at ambient temperatures using swabs.",
      "handle": "/products/dna-rna-shield-safecollect-swab-collection-kit",
      "image_url": "https://files.zymoresearch.com/product-images/r1160-dna_rna_shield_safecollect_swab_collection_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield",
      "subtitle": "R1100-50, R1100-250, R1200-25, R1200-125",
      "description": "Novel sample transport medium that preserves DNA and RNA in any sample at ambient temperatures. ",
      "handle": "/products/dna-rna-shield",
      "image_url": "https://files.zymoresearch.com/images/R1100-50-DNA-RNA-Shield-Reagent-50ml.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield SafeCollect Saliva Collection Kit",
      "subtitle": "R1211, R1211-E",
      "description": "User friendly device for collecting and preserving nucleic acids from saliva and sputum samples at ambient temperatures. ",
      "handle": "/products/dna-rna-shield-safecollect-saliva-collection-kit",
      "image_url": "https://files.zymoresearch.com/product-images/R1211-dna_rna_shield_safecollect_saliva_collection_kit.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Collection Tube w/ Swab",
      "subtitle": "R1106, R1107, R1108, R1109",
      "description": "Complete solution for collecting and preserving nucleic acids from a variety of sample types at ambient temperatures using swabs.",
      "handle": "/products/dna-rna-shield-collection-tube-w-swab",
      "image_url": "https://files.zymoresearch.com/images/R1106_DNA-RNA-Shield-Swab-Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Blood Collection Tube",
      "subtitle": "R1150",
      "description": "Ready-to-use tubes for collecting and preserving DNA and RNA in whole blood at ambient temperatures. ",
      "handle": "/products/dna-rna-shield-blood-collection-tube",
      "image_url": "https://files.zymoresearch.com/images/R1150-DNA-RNA-Shield-Blood-Collection-Tube.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Fecal Collection Tube - DX",
      "subtitle": "R1101-E",
      "description": "Specimen receptacle medical device for collecting and preserving nucleic acids from feces for molecular-based in vitro diagnostic",
      "handle": "/products/dna-rna-shield-fecal-collection-tube-dx",
      "image_url": "https://files.zymoresearch.com/product-images/R1101_DNA+RNA+Shield+Fecal+Collection+Tube.png",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Bunny Wipe Fecal Sample Collector",
      "subtitle": "R1133-1, R1133-10, R1138",
      "description": "Collect stool samples easily and cleanly with a wipe in the privacy of your own bathroom",
      "handle": "/products/bunny-wipe-fecal-sample-collector",
      "image_url": "https://files.zymoresearch.com/product-images/R1133_bunny_wipe_fecal_sample_collector.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield Lysis & Collection Tubes",
      "subtitle": "R1102, R1103, R1104, R1105",
      "description": "All-in-one tube for the collection, preservation, and homogenization of a variety of sample types for DNA and RNA purificaiton. ",
      "handle": "/products/dna-rna-shield-lysis-and-collection-tubes",
      "image_url": "https://files.zymoresearch.com/images/R1103-DNA-RNA-Shield-Lysis-Tube-(Microbe).jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "Urine Conditioning Buffer",
      "subtitle": "D3061-1-8, D3061-1-140",
      "description": "Effective preservation of DNA and RNA in urine at ambient temperatures.",
      "handle": "/products/urine-conditioning-buffer",
      "image_url": "https://files.zymoresearch.com/images/D3061-1-140-UCB-Bottle-140ml.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    },
    {
      "title": "DNA/RNA Shield DirectDetect",
      "subtitle": "R1400, R1400-E, R1401-1, R1401-1-E",
      "description": "Uniquely formulated nucleic acid preservation reagent that allows users to go from sample collection directly to PCR",
      "handle": "/products/dna-rna-shield-directdetect",
      "image_url": "https://files.zymoresearch.com/product-images/R1400-dna_rna_shield_directdetect_reagent.jpg",
      "tags": [],
      "isKit": false,
      "searchWeight": 0
    }
  ],
  "Clinical and Diagnostics": [
    {
      "title": "<i>Quick</i>-DNA/RNA HT",
      "subtitle": "R2150, R2151, R2150-E, R2151-E",
      "description": "The Quick-DNA/RNA HT kit is intended for rapid, high-throughput nucleic acid extraction (automated or manual) from any biological or clinical sample.",
      "handle": "/products/quick-dna-rna-ht",
      "image_url": "https://files.zymoresearch.com/product-images/r2150_e_r2151_e_quick_dna_rna_ht_dx.jpg",
      "tags": [],
      "isKit": true,
      "searchWeight": 0
    }
  ],
    "Transposases": [
    {
      title: "Endura Tn5 Transposase",
      subtitle: "E1024-20, E1024-100, E1024-4-5, E1025-20, E1025-100",
      description: "Highly Stable & Compatible with Any Adapter.",
      handle: "/products/endura-tn5-transposase-unloaded",
      isKit: false,
      image_url:
        "https://www.zymoresearch.com/cdn/shop/files/photo1_600x.webp?v=1750810168",
      searchWeight: 0,
      tags: [],
    },
  ],
};
